import * as i0 from '@angular/core';
import { Directive, EventEmitter, Input, Output, ContentChildren, Injectable, Component, Optional, Host, NgModule, ChangeDetectionStrategy, ViewEncapsulation, ContentChild, forwardRef, ViewChild, Inject, HostListener, TemplateRef, Injector, Self, InjectionToken, inject, LOCALE_ID, SkipSelf, isDevMode, ElementRef, Attribute } from '@angular/core';
import { Observable, Subject, fromEvent, EMPTY, of, timer, race, Subscription, merge } from 'rxjs';
import { trigger, state, style, transition, animate } from '@angular/animations';
import * as i1 from '@angular/common';
import { CommonModule, DOCUMENT } from '@angular/common';
import * as i2 from '@angular/router';
import { RouterModule } from '@angular/router';
import * as i1$1 from '@angular/forms';
import { NG_VALUE_ACCESSOR, ReactiveFormsModule, FormsModule, NG_VALIDATORS, Validators } from '@angular/forms';
import { takeUntil, map, filter, withLatestFrom, endWith, take, mergeMap, tap, switchMap, startWith } from 'rxjs/operators';

let nextId$6 = 0;
/**
 * A directive that wraps the accordion panel content.
 */
class UsaAccordionContent {
    templateRef;
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaAccordionContent, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.2", type: UsaAccordionContent, selector: "ng-template[UsaAccordionContent]", ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaAccordionContent, decorators: [{
            type: Directive,
            args: [{ selector: 'ng-template[UsaAccordionContent]' }]
        }], ctorParameters: () => [{ type: i0.TemplateRef }] });
/**
 * A directive that wraps the accordion header content.
 */
class UsaAccordionHeader {
    templateRef;
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaAccordionHeader, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.2", type: UsaAccordionHeader, selector: "ng-template[UsaAccordionHeader]", ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaAccordionHeader, decorators: [{
            type: Directive,
            args: [{
                    selector: 'ng-template[UsaAccordionHeader]',
                }]
        }], ctorParameters: () => [{ type: i0.TemplateRef }] });
/**
 * A directive that wraps an individual accordion panel with title and collapsible content.
 */
class UsaAccordionItem {
    /**
     *  If `true`, the panel is disabled an can't be toggled.
     */
    disabled = false;
    /**
     *  An optional id for the panel that must be unique on the page.
     *
     *  If not provided, it will be auto-generated in the `usa-panel-xxx` format.
     */
    id = `usa-accordion-item-${nextId$6++}`;
    /** Defines whether the accordion is in expanded or collapsed state */
    expanded = false;
    /** A flag to specified that the transition panel classes have been initialized */
    initClassDone = false;
    /**
     *  The panel header.
     */
    header;
    /**
     * An optional class applied to the accordion card element that wraps both panel title and content.
     *
     * @since 5.3.0
     */
    cardClass;
    /**
     * Defines the aria label for accordion header button. Generally if the header is a text, then this is
     * not needed as screen readers can announce the text. However, if the header is a custom template
     * with items that screen readers cannot compute (icons / images), then having a descriptive label can
     * help
     */
    ariaLabel;
    /**
     * An event emitted when the panel is shown, after the transition. It has no payload.
     *
     * @since 8.0.0
     */
    shown = new EventEmitter();
    /**
     * An event emitted when the panel is hidden, after the transition. It has no payload.
     *
     * @since 8.0.0
     */
    hidden = new EventEmitter();
    /** Provided template for Accordion header */
    headerTpl;
    /** Provided template for Accordion content */
    contentTpl;
    headerTpls;
    contentTpls;
    constructor() { }
    ngAfterContentChecked() {
        // We are using @ContentChildren instead of @ContentChild as in the Angular version being used
        // only @ContentChildren allows us to specify the {descendants: false} option.
        // Without {descendants: false} there are issues when accordions are wrapped inside accordions
        this.headerTpl = this.headerTpls.first;
        this.contentTpl = this.contentTpls.first;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaAccordionItem, deps: [], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.2", type: UsaAccordionItem, selector: "usa-accordion-item", inputs: { disabled: "disabled", id: "id", expanded: "expanded", header: "header", cardClass: "cardClass", ariaLabel: "ariaLabel" }, outputs: { shown: "shown", hidden: "hidden" }, queries: [{ propertyName: "headerTpls", predicate: UsaAccordionHeader }, { propertyName: "contentTpls", predicate: UsaAccordionContent }], ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaAccordionItem, decorators: [{
            type: Directive,
            args: [{ selector: 'usa-accordion-item' }]
        }], ctorParameters: () => [], propDecorators: { disabled: [{
                type: Input
            }], id: [{
                type: Input
            }], expanded: [{
                type: Input
            }], header: [{
                type: Input
            }], cardClass: [{
                type: Input
            }], ariaLabel: [{
                type: Input
            }], shown: [{
                type: Output
            }], hidden: [{
                type: Output
            }], headerTpls: [{
                type: ContentChildren,
                args: [UsaAccordionHeader, { descendants: false }]
            }], contentTpls: [{
                type: ContentChildren,
                args: [UsaAccordionContent, { descendants: false }]
            }] } });

var Key;
(function (Key) {
    Key["Tab"] = "Tab";
    Key["Enter"] = "Enter";
    Key["Escape"] = "Escape";
    Key["Space"] = "Space";
    Key["PageUp"] = "PageUp";
    Key["PageDown"] = "PageDown";
    Key["End"] = "End";
    Key["Home"] = "Home";
    Key["ArrowLeft"] = "ArrowLeft";
    Key["ArrowUp"] = "ArrowUp";
    Key["ArrowRight"] = "ArrowRight";
    Key["ArrowDown"] = "ArrowDown";
})(Key || (Key = {}));
// Key values in IE/EDGE
var MicrosfotKeys;
(function (MicrosfotKeys) {
    MicrosfotKeys["Tab"] = "Tab";
    MicrosfotKeys["Enter"] = "Enter";
    MicrosfotKeys["Escape"] = "Esc";
    MicrosfotKeys["Space"] = "Spacebar";
    MicrosfotKeys["PageUp"] = "PageUp";
    MicrosfotKeys["PageDown"] = "PageDown";
    MicrosfotKeys["End"] = "End";
    MicrosfotKeys["Home"] = "Home";
    MicrosfotKeys["ArrowLeft"] = "Left";
    MicrosfotKeys["ArrowUp"] = "Up";
    MicrosfotKeys["ArrowRight"] = "Right";
    MicrosfotKeys["ArrowDown"] = "Down";
})(MicrosfotKeys || (MicrosfotKeys = {}));
// Deprecated ascii values
var KeyCode;
(function (KeyCode) {
    KeyCode[KeyCode["Tab"] = 9] = "Tab";
    KeyCode[KeyCode["Enter"] = 13] = "Enter";
    KeyCode[KeyCode["Escape"] = 27] = "Escape";
    KeyCode[KeyCode["Space"] = 32] = "Space";
    KeyCode[KeyCode["PageUp"] = 33] = "PageUp";
    KeyCode[KeyCode["PageDown"] = 34] = "PageDown";
    KeyCode[KeyCode["End"] = 35] = "End";
    KeyCode[KeyCode["Home"] = 36] = "Home";
    KeyCode[KeyCode["ArrowLeft"] = 37] = "ArrowLeft";
    KeyCode[KeyCode["ArrowUp"] = 38] = "ArrowUp";
    KeyCode[KeyCode["ArrowRight"] = 39] = "ArrowRight";
    KeyCode[KeyCode["ArrowDown"] = 40] = "ArrowDown";
})(KeyCode || (KeyCode = {}));
function isArrowDown(event) {
    return event.key === Key.ArrowDown || event.key === MicrosfotKeys.ArrowDown || event.keyCode === KeyCode.ArrowDown;
}
function isArrowUp(event) {
    return event.key === Key.ArrowUp || event.key === MicrosfotKeys.ArrowUp || event.keyCode === KeyCode.ArrowUp;
}
function isArrowRight(event) {
    return event.key === Key.ArrowRight || event.key === MicrosfotKeys.ArrowRight || event.keyCode === KeyCode.ArrowRight;
}
function isArrowLeft(event) {
    return event.key === Key.ArrowLeft || event.key === MicrosfotKeys.ArrowLeft || event.keyCode === KeyCode.ArrowLeft;
}
function isHome(event) {
    return event.key === Key.Home || event.key === MicrosfotKeys.Home || event.keyCode === KeyCode.Home;
}
function isEnd$1(event) {
    return event.key === Key.End || event.key === MicrosfotKeys.End || event.keyCode === KeyCode.End;
}
function isEscape(event) {
    return event.key === Key.Escape || event.key === MicrosfotKeys.Escape || event.keyCode === KeyCode.Escape;
}
function isPageDown(event) {
    return event.key === Key.PageDown || event.key === MicrosfotKeys.PageDown || event.keyCode === KeyCode.PageDown;
}
function isPageUp(event) {
    return event.key === Key.PageUp || event.key === MicrosfotKeys.PageUp || event.keyCode === KeyCode.PageUp;
}
function isEnter(event) {
    return event.key === Key.Enter || event.key === MicrosfotKeys.Enter || event.keyCode === KeyCode.Enter;
}
function isTab(event) {
    return !hasModifierKey(event) && (event.key === Key.Tab || event.key === MicrosfotKeys.Tab || event.keyCode === KeyCode.Tab);
}
function isSpace(event) {
    return event.key === Key.Space || event.key === MicrosfotKeys.Space || event.keyCode === KeyCode.Space;
}
/**
 * Checks whether a modifier key is pressed.
 * @param event Event to be checked.
 */
function hasModifierKey(event, ...modifiers) {
    if (modifiers.length) {
        return modifiers.some(modifier => event[modifier]);
    }
    return event.altKey || event.shiftKey || event.ctrlKey || event.metaKey;
}

function toInteger(value) {
    return parseInt(`${value}`, 10);
}
function toString(value) {
    return (value !== undefined && value !== null) ? `${value}` : '';
}
function getValueInRange(value, max, min = 0) {
    return Math.max(Math.min(value, max), min);
}
function isString(value) {
    return typeof value === 'string';
}
function isNumber(value) {
    return !isNaN(toInteger(value));
}
function isInteger(value) {
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
}
function isDefined(value) {
    return value !== undefined && value !== null;
}
function padNumber(value) {
    if (isNumber(value)) {
        return `0${value}`.slice(-2);
    }
    else {
        return '';
    }
}
function regExpEscape(text) {
    return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}
function hasClassName(element, className) {
    return element && element.className && element.className.split &&
        element.className.split(/\s+/).indexOf(className) >= 0;
}
if (typeof Element !== 'undefined' && !Element.prototype.closest) {
    // Polyfill for ie10+
    if (!Element.prototype.matches) {
        // IE uses the non-standard name: msMatchesSelector
        Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
    }
    Element.prototype.closest = function (s) {
        let el = this;
        if (!document.documentElement.contains(el)) {
            return null;
        }
        do {
            if (el.matches(s)) {
                return el;
            }
            el = el.parentElement || el.parentNode;
        } while (el !== null && el.nodeType === 1);
        return null;
    };
}
function closest(element, selector) {
    if (!selector) {
        return null;
    }
    /*
     * In certain browsers (e.g. Edge 44.18362.449.0) HTMLDocument does
     * not support `Element.prototype.closest`. To emulate the correct behaviour
     * we return null when the method is missing.
     *
     * Note that in evergreen browsers `closest(document.documentElement, 'html')`
     * will return the document element whilst in Edge null will be returned. This
     * compromise was deemed good enough.
     */
    if (typeof element.closest === 'undefined') {
        return null;
    }
    return element.closest(selector);
}
/**
 * Force a browser reflow
 * @param element element where to apply the reflow
 */
function reflow(element) {
    return (element || document.body).getBoundingClientRect();
}
/**
 * Creates an observable where all callbacks are executed inside a given zone
 *
 * @param zone
 */
function runInZone(zone) {
    return (source) => {
        return new Observable(observer => {
            const onNext = (value) => zone.run(() => observer.next(value));
            const onError = (e) => zone.run(() => observer.error(e));
            const onComplete = () => zone.run(() => observer.complete());
            return source.subscribe(onNext, onError, onComplete);
        });
    };
}
function removeAccents(str) {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}
/**
* Returns the the last element in the array where predicate is true, and null
* otherwise.
* @param array The source array to search in
* @param predicate find calls predicate once for each element of the array, in descending
* order, until it finds one where predicate returns true. If such an element is found,
* findLast immediately returns that element. Otherwise, findLast returns null.
*/
function findLast(array, predicate) {
    let l = array.length;
    while (l--) {
        if (predicate(array[l], l, array))
            return array[l];
    }
    return null;
}
/**
* Returns the the last element's index in the array where predicate is true, and null
* otherwise.
* @param array The source array to search in
* @param predicate calls predicate once for each element of the array, in descending
* order, until it finds one where predicate returns true. If such an element is found,
* findLastIndex immediately returns that element's index. Otherwise, findLast returns -1.
*/
function findLastIndex(array, predicate) {
    let l = array.length;
    while (l--) {
        if (predicate(array[l], l, array))
            return l;
    }
    return -1;
}
/**
 * Gets the next focusable item in a list. It is expected that the items in the given list contain
 * a disabled property such that disabled items are skipped when calculating next focusable item.
 * @param currentIndex - Starting point from where to start checking
 * @param allItems - all items in list
 * @param delta - either 1 to get next item in positive direction or -1 to get next item in previous direction
 * @returns next item
 */
function getNextItemInList(currentIndex, allItems, delta) {
    let nextItemIndex = ((currentIndex + delta) + allItems.length) % allItems.length;
    while (nextItemIndex != currentIndex) {
        if (!allItems[nextItemIndex].disabled) {
            break;
        }
        nextItemIndex = ((nextItemIndex + delta) + allItems.length) % allItems.length;
    }
    return allItems[nextItemIndex];
}
/**
 * Gets the next focusable item's index in a list. It is expected that the items in the given list contain
 * a disabled property such that disabled items are skipped when calculating next focusable item.
 * @param currentIndex - Starting point from where to start checking
 * @param allItems - all items in list
 * @param delta - either 1 to get next item in positive direction or -1 to get next item in previous direction
 * @returns next focusable item's index
 */
function getNextItemIndexInList(currentIndex, allItems, delta) {
    let nextItemIndex = ((currentIndex + delta) + allItems.length) % allItems.length;
    while (nextItemIndex != currentIndex) {
        if (!allItems[nextItemIndex].disabled) {
            break;
        }
        nextItemIndex = ((nextItemIndex + delta) + allItems.length) % allItems.length;
    }
    return nextItemIndex;
}
/**
 * Coerces a value to an array of trimmed non-empty strings.
 * Any input that is not an array, `null` or `undefined` will be turned into a string
 * via `toString()` and subsequently split with the given separator.
 * `null` and `undefined` will result in an empty array.
 * This results in the following outcomes:
 * - `null` -&gt; `[]`
 * - `[null]` -&gt; `["null"]`
 * - `["a", "b ", " "]` -&gt; `["a", "b"]`
 * - `[1, [2, 3]]` -&gt; `["1", "2,3"]`
 * - `[{ a: 0 }]` -&gt; `["[object Object]"]`
 * - `{ a: 0 }` -&gt; `["[object", "Object]"]`
 *
 * Useful for defining CSS classes or table columns.
 * @param value the value to coerce into an array of strings
 * @param separator split-separator if value isn't an array
 */
function coerceStringArray(value, separator = /\s+/) {
    const result = [];
    if (value != null) {
        const sourceValues = Array.isArray(value) ? value : `${value}`.split(separator);
        for (const sourceValue of sourceValues) {
            const trimmedString = `${sourceValue}`.trim();
            if (trimmedString) {
                result.push(trimmedString);
            }
        }
    }
    return result;
}

/** Time and timing curve for accordion item animations. */
const ACCORDION_ITEM_ANIMATION_TIMING = '150ms linear';
const UsaExpansionAnimations = {
    /** Animation that expands and collapses the accordion item content. */
    bodyExpansion: trigger('bodyExpansion', [
        state('collapsed, void', style({ height: '0px', display: 'none', 'padding-top': 0, 'padding-bottom': 0 })),
        state('expanded', style({ height: '*' })),
        transition('expanded <=> collapsed, void => collapsed', animate(ACCORDION_ITEM_ANIMATION_TIMING)),
    ])
};

/**
 * A configuration service for the UsaAccordion component.
 *
 * You can inject this service, typically in your root component, and customize its properties
 * to provide default values for all accordions used in the application.
 */
class UsaAccordionConfig {
    singleSelect = false;
    bordered;
    headerLevel = 4;
    _animation = true;
    get animation() { return this._animation; }
    set animation(animation) { this._animation = animation; }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaAccordionConfig, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaAccordionConfig, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaAccordionConfig, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

class UsaAccordionComponent {
    _element;
    _renderer;
    panels;
    /**
     * If `true`, accordion will be animated.
     * @default true
     */
    animation = true;
    /**
     * An array or comma separated strings of panel ids that should be opened **initially**.
     *
     * For subsequent changes use methods like `expand()`, `collapse()`, etc. and
     * the `(panelChange)` event.
     */
    activeIds = [];
    /**
     *  If `true`, only one panel could be opened at a time.
     *
     *  Opening a new panel will close others.
     */
    singleSelect;
    /**
     * Type of panels.
     *
     * Bootstrap provides styles for the following types: `'success'`, `'info'`, `'warning'`, `'danger'`, `'primary'`,
     * `'secondary'`, `'light'` and `'dark'`.
     */
    bordered;
    /**
     * Heading level to use for accordion headers - possible inputs are anywhere from heading level 2 to 6.
     */
    headerLevel = 4;
    /**
     * Event emitted right before the panel toggle happens.
     */
    panelChange = new EventEmitter();
    /**
     * An event emitted when the expanding animation is finished on the panel. The payload is the panel id.
     */
    shown = new EventEmitter();
    /**
     * An event emitted when the collapsing animation is finished on the panel, and before the panel element is removed.
     * The payload is the panel id.
     *
     * @since 8.0.0
     */
    hidden = new EventEmitter();
    constructor(config, _element, _renderer) {
        this._element = _element;
        this._renderer = _renderer;
        this.animation = config.animation;
        this.bordered = config.bordered;
        this.singleSelect = config.singleSelect;
        this.headerLevel = config.headerLevel;
    }
    /**
     * Checks if a panel with a given id is expanded.
     */
    isExpanded(panelId) { return this.activeIds.indexOf(panelId) > -1; }
    /**
     * Expands a panel with a given id.
     *
     * Has no effect if the panel is already expanded or disabled.
     */
    expand(panelId) { this._changeOpenState(this._findPanelById(panelId), true); }
    /**
     * Expands all panels, if `[closeOthers]` is `false`.
     *
     * If `[closeOthers]` is `true`, it will expand the first panel, unless there is already a panel opened.
     */
    expandAll() {
        if (this.singleSelect) {
            if (this.activeIds.length === 0 && this.panels.length) {
                this._changeOpenState(this.panels.first, true);
            }
        }
        else {
            this.panels.forEach(panel => this._changeOpenState(panel, true));
        }
    }
    /**
     * Collapses a panel with the given id.
     *
     * Has no effect if the panel is already collapsed or disabled.
     */
    collapse(panelId) { this._changeOpenState(this._findPanelById(panelId), false); }
    /**
     * Collapses all opened panels.
     */
    collapseAll() {
        this.panels.forEach((panel) => { this._changeOpenState(panel, false); });
    }
    /**
     * Toggles a panel with the given id.
     *
     * Has no effect if the panel is disabled.
     */
    toggle(panelId) {
        const panel = this._findPanelById(panelId);
        if (panel) {
            this._changeOpenState(panel, !panel.expanded);
        }
    }
    /** Gets the expanded state string. */
    _getExpandedState(panel) {
        return panel.expanded ? 'expanded' : 'collapsed';
    }
    ngAfterContentChecked() {
        // active id updates
        if (isString(this.activeIds)) {
            this.activeIds = this.activeIds.split(/\s*,\s*/);
        }
        // update panels open states
        this.panels.forEach(panel => {
            panel.expanded = panel.expanded || (!panel.disabled && this.activeIds.indexOf(panel.id) > -1);
        });
        // closeOthers updates
        if (this.activeIds.length > 1 && this.singleSelect) {
            this._closeOthers(this.activeIds[0]);
            this._updateActiveIds();
        }
    }
    onKeyDown($event, panel) {
        const keyPressed = $event.key || $event.keyCode;
        switch (keyPressed) {
            case Key.ArrowDown:
            case MicrosfotKeys.ArrowDown:
            case KeyCode.ArrowDown:
                this._getPanelElementHeaderButton(this._getNextAccordion(panel, 1).id).focus();
                $event.preventDefault();
                break;
            case Key.ArrowUp:
            case MicrosfotKeys.ArrowUp:
            case KeyCode.ArrowUp:
                this._getPanelElementHeaderButton(this._getNextAccordion(panel, -1).id).focus();
                $event.preventDefault();
                break;
            case Key.Home:
            case MicrosfotKeys.Home:
            case KeyCode.Home:
                const firstPanel = this.panels.find(panel => !panel.disabled);
                if (firstPanel) {
                    this._getPanelElementHeaderButton(firstPanel.id).focus();
                }
                $event.preventDefault();
                break;
            case Key.End:
            case MicrosfotKeys.End:
            case KeyCode.End:
                const lastFocusablePanel = findLast(this.panels.toArray(), (panel => !panel.disabled));
                if (lastFocusablePanel) {
                    this._getPanelElementHeaderButton(lastFocusablePanel.id).focus();
                }
                $event.preventDefault();
                break;
        }
    }
    onBodyExpansionStart(event, panel) {
        if (event.fromState === 'collapsed' && event.toState === 'expanded') {
            this._renderer.removeStyle(panel, 'display');
        }
    }
    onBodyExpansionEnd(event, panel) {
        if (event.fromState !== 'void') {
            if (event.toState === 'expanded') {
                this.shown.emit(panel.id);
            }
            else if (event.toState === 'collapsed') {
                this._renderer.setStyle(panel, 'display', 'none');
                this.hidden.emit(panel.id);
            }
        }
    }
    _getNextAccordion(currentPanel, delta) {
        const allPanels = this.panels.toArray();
        const currentIndex = allPanels.indexOf(currentPanel);
        const nextPanel = getNextItemInList(currentIndex, allPanels, delta);
        return nextPanel;
    }
    _changeOpenState(panel, nextState) {
        if (panel != null && !panel.disabled) {
            let defaultPrevented = false;
            this.panelChange.emit({ panelId: panel.id, nextState: nextState, preventDefault: () => { defaultPrevented = true; } });
            if (!defaultPrevented) {
                panel.expanded = nextState;
                if (nextState && this.singleSelect) {
                    this._closeOthers(panel.id);
                }
                this._updateActiveIds();
            }
        }
    }
    _closeOthers(panelId) {
        this.panels.forEach(panel => {
            if (panel.id !== panelId && panel.expanded) {
                panel.expanded = false;
            }
        });
    }
    _findPanelById(panelId) { return this.panels.find(p => p.id === panelId) || null; }
    _updateActiveIds() {
        this.activeIds = this.panels.filter(panel => panel.expanded && !panel.disabled).map(panel => panel.id);
    }
    _getPanelElementHeaderButton(panelId) {
        return this._element.nativeElement.querySelector('#' + panelId + '-header button');
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaAccordionComponent, deps: [{ token: UsaAccordionConfig }, { token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.2", type: UsaAccordionComponent, selector: "usa-accordion", inputs: { animation: "animation", activeIds: "activeIds", singleSelect: "singleSelect", bordered: "bordered", headerLevel: "headerLevel" }, outputs: { panelChange: "panelChange", shown: "shown", hidden: "hidden" }, host: { properties: { "class.usa-accordion--bordered": "bordered", "attr.aria-multiselectable": "singleSelect ? true : undefined" }, classAttribute: "usa-accordion" }, queries: [{ propertyName: "panels", predicate: UsaAccordionItem }], exportAs: ["usaAccordion"], ngImport: i0, template: "<ng-template ngFor let-panel [ngForOf]=\"panels\">\n    <div role=\"heading\" id=\"{{panel.id}}-header\" class=\"usa-accordion__heading\" [attr.aria-level]=\"headerLevel\">\n      <button class=\"usa-accordion__button\"\n        [UsaAccordionToggle]=\"panel\"\n        (keydown)=\"onKeyDown($event, panel)\" \n        >\n        {{panel.header}}\n        <ng-template [ngTemplateOutlet]=\"panel.headerTpl?.templateRef\"></ng-template>\n      </button>\n    </div>\n    <section #panelContent id=\"{{panel.id}}\" class=\"usa-accordion__content overflow-hidden\"\n      [@.disabled]=\"!animation\"\n      [@bodyExpansion]=\"panel.expanded ? 'expanded' : 'collapsed'\"\n      (@bodyExpansion.start)=\"onBodyExpansionStart($event, panelContent)\"\n      (@bodyExpansion.done)=\"onBodyExpansionEnd($event, panelContent)\"\n      [attr.aria-labelledby]=\"panel.id + '-header'\">\n        <ng-template [ngTemplateOutlet]=\"panel.contentTpl?.templateRef || null\"></ng-template>\n    </section>\n</ng-template>\n", dependencies: [{ kind: "directive", type: i0.forwardRef(() => i1.NgForOf), selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i0.forwardRef(() => i1.NgTemplateOutlet), selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i0.forwardRef(() => UsaAccordionToggle), selector: "button[UsaAccordionToggle]", inputs: ["UsaAccordionToggle"] }], animations: [UsaExpansionAnimations.bodyExpansion] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaAccordionComponent, decorators: [{
            type: Component,
            args: [{ selector: 'usa-accordion', exportAs: 'usaAccordion', animations: [UsaExpansionAnimations.bodyExpansion], host: {
                        'class': 'usa-accordion',
                        '[class.usa-accordion--bordered]': 'bordered',
                        '[attr.aria-multiselectable]': 'singleSelect ? true : undefined',
                    }, template: "<ng-template ngFor let-panel [ngForOf]=\"panels\">\n    <div role=\"heading\" id=\"{{panel.id}}-header\" class=\"usa-accordion__heading\" [attr.aria-level]=\"headerLevel\">\n      <button class=\"usa-accordion__button\"\n        [UsaAccordionToggle]=\"panel\"\n        (keydown)=\"onKeyDown($event, panel)\" \n        >\n        {{panel.header}}\n        <ng-template [ngTemplateOutlet]=\"panel.headerTpl?.templateRef\"></ng-template>\n      </button>\n    </div>\n    <section #panelContent id=\"{{panel.id}}\" class=\"usa-accordion__content overflow-hidden\"\n      [@.disabled]=\"!animation\"\n      [@bodyExpansion]=\"panel.expanded ? 'expanded' : 'collapsed'\"\n      (@bodyExpansion.start)=\"onBodyExpansionStart($event, panelContent)\"\n      (@bodyExpansion.done)=\"onBodyExpansionEnd($event, panelContent)\"\n      [attr.aria-labelledby]=\"panel.id + '-header'\">\n        <ng-template [ngTemplateOutlet]=\"panel.contentTpl?.templateRef || null\"></ng-template>\n    </section>\n</ng-template>\n" }]
        }], ctorParameters: () => [{ type: UsaAccordionConfig }, { type: i0.ElementRef }, { type: i0.Renderer2 }], propDecorators: { panels: [{
                type: ContentChildren,
                args: [UsaAccordionItem]
            }], animation: [{
                type: Input
            }], activeIds: [{
                type: Input
            }], singleSelect: [{
                type: Input
            }], bordered: [{
                type: Input
            }], headerLevel: [{
                type: Input
            }], panelChange: [{
                type: Output
            }], shown: [{
                type: Output
            }], hidden: [{
                type: Output
            }] } });
class UsaAccordionToggle {
    accordion;
    panel;
    static ngAcceptInputType_UsaAccordionToggle;
    set UsaAccordionToggle(panel) {
        if (panel) {
            this.panel = panel;
        }
    }
    constructor(accordion, panel) {
        this.accordion = accordion;
        this.panel = panel;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaAccordionToggle, deps: [{ token: UsaAccordionComponent }, { token: UsaAccordionItem, host: true, optional: true }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.2", type: UsaAccordionToggle, selector: "button[UsaAccordionToggle]", inputs: { UsaAccordionToggle: "UsaAccordionToggle" }, host: { attributes: { "type": "button" }, listeners: { "click": "accordion.toggle(panel.id)" }, properties: { "disabled": "panel.disabled", "class.collapsed": "!panel.expanded", "attr.aria-expanded": "panel.expanded", "attr.aria-controls": "panel.expanded ? panel.id : undefined", "attr.aria-disabled": "panel.disabled && panel.expanded ? true : undefined", "attr.aria-label": "panel.ariaLabel" }, classAttribute: "usa-accordion__button" }, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaAccordionToggle, decorators: [{
            type: Directive,
            args: [{
                    selector: 'button[UsaAccordionToggle]',
                    host: {
                        'type': 'button',
                        '[disabled]': 'panel.disabled',
                        'class': 'usa-accordion__button',
                        '[class.collapsed]': '!panel.expanded',
                        '[attr.aria-expanded]': 'panel.expanded',
                        '[attr.aria-controls]': 'panel.expanded ? panel.id : undefined',
                        '[attr.aria-disabled]': 'panel.disabled && panel.expanded ? true : undefined',
                        '[attr.aria-label]': 'panel.ariaLabel',
                        '(click)': 'accordion.toggle(panel.id)',
                    }
                }]
        }], ctorParameters: () => [{ type: UsaAccordionComponent }, { type: UsaAccordionItem, decorators: [{
                    type: Optional
                }, {
                    type: Host
                }] }], propDecorators: { UsaAccordionToggle: [{
                type: Input
            }] } });

class UsaAccordionModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaAccordionModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.2", ngImport: i0, type: UsaAccordionModule, declarations: [UsaAccordionComponent,
            UsaAccordionHeader,
            UsaAccordionContent,
            UsaAccordionToggle,
            UsaAccordionItem], imports: [CommonModule], exports: [UsaAccordionComponent,
            UsaAccordionHeader,
            UsaAccordionContent,
            UsaAccordionToggle,
            UsaAccordionItem] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaAccordionModule, imports: [CommonModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaAccordionModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                    ],
                    declarations: [
                        UsaAccordionComponent,
                        UsaAccordionHeader,
                        UsaAccordionContent,
                        UsaAccordionToggle,
                        UsaAccordionItem
                    ],
                    exports: [
                        UsaAccordionComponent,
                        UsaAccordionHeader,
                        UsaAccordionContent,
                        UsaAccordionToggle,
                        UsaAccordionItem
                    ]
                }]
        }] });

class USWDSButtonGroupComponent {
    isSegmented = false;
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: USWDSButtonGroupComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.2", type: USWDSButtonGroupComponent, selector: "uswds-button-group", inputs: { isSegmented: "isSegmented" }, ngImport: i0, template: `
  <ul class="usa-button-group" [ngClass]="{'usa-button-group--segmented': isSegmented}">
    <ng-content></ng-content>
  </ul>`, isInline: true, dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: USWDSButtonGroupComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'uswds-button-group',
                    template: `
  <ul class="usa-button-group" [ngClass]="{'usa-button-group--segmented': isSegmented}">
    <ng-content></ng-content>
  </ul>`
                }]
        }], propDecorators: { isSegmented: [{
                type: Input
            }] } });

class USWDSButtonGroupItemComponent {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: USWDSButtonGroupItemComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.2", type: USWDSButtonGroupItemComponent, selector: "uswds-button-group-item", host: { classAttribute: "usa-button-group__item" }, ngImport: i0, template: `
    <ng-content></ng-content>
  `, isInline: true });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: USWDSButtonGroupItemComponent, decorators: [{
            type: Component,
            args: [{
                    selector: `uswds-button-group-item`,
                    template: `
    <ng-content></ng-content>
  `,
                    host: {
                        'class': 'usa-button-group__item'
                    }
                }]
        }] });

class USWDSButtonGroupModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: USWDSButtonGroupModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.2", ngImport: i0, type: USWDSButtonGroupModule, declarations: [USWDSButtonGroupComponent,
            USWDSButtonGroupItemComponent], imports: [CommonModule], exports: [USWDSButtonGroupComponent,
            USWDSButtonGroupItemComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: USWDSButtonGroupModule, imports: [CommonModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: USWDSButtonGroupModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [
                        USWDSButtonGroupComponent,
                        USWDSButtonGroupItemComponent
                    ],
                    exports: [
                        USWDSButtonGroupComponent,
                        USWDSButtonGroupItemComponent,
                    ]
                }]
        }] });
;

var UsaNavigationMode;
(function (UsaNavigationMode) {
    /**
     * Navigation within a known route of the application. Navigation will be done through
     * Angular's routerLink directive
     */
    UsaNavigationMode[UsaNavigationMode["INTERNAL"] = 0] = "INTERNAL";
    /**
     * Navigation to external url outside of the application. Navigation will be done through href attribute
     */
    UsaNavigationMode[UsaNavigationMode["EXTERNAL"] = 1] = "EXTERNAL";
    /**
     * No Navigation should occur. Only an event will be emitted when use clicks on a navigation item with this mode
     */
    UsaNavigationMode[UsaNavigationMode["EVENT"] = 2] = "EVENT";
    /**
     * No Navigation and no event on user click. Link will be uninteractive
     */
    UsaNavigationMode[UsaNavigationMode["LABEL"] = 3] = "LABEL";
})(UsaNavigationMode || (UsaNavigationMode = {}));

class UsaLinkTemplateComponent {
    NavigationMode = UsaNavigationMode;
    link;
    /**
     * Class to apply to anchor tag element when
     * displaying link.
     * @default - empty string
     */
    class = '';
    /**
     * Class to apply for selected item.
     * Use empty string to not apply any class for selected item
     * @default 'usa-current'
     * */
    currentClass = 'usa-current';
    linkClicked = new EventEmitter();
    /**
     * creates url from provided route and query params
     * @param item - Link to use when building url
     */
    urlBuilder(item) {
        let url = item.path;
        const queryParams = this.queryStringBuilder(item);
        if (queryParams) {
            if (url.indexOf('?') === -1) {
                url += '?' + queryParams;
            }
            else if (url.indexOf('?') === url.length - 1) {
                url += queryParams;
            }
            else {
                url += '&' + queryParams;
            }
        }
        return url;
    }
    queryStringBuilder(item) {
        const ret = [];
        let keys = [];
        if (item.queryParams) {
            keys = Object.keys(item.queryParams);
        }
        for (const d of keys) {
            ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(item.queryParams[d]));
        }
        return ret.join('&');
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaLinkTemplateComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.2", type: UsaLinkTemplateComponent, selector: "usa-link-template", inputs: { link: "link", class: "class", currentClass: "currentClass" }, outputs: { linkClicked: "linkClicked" }, ngImport: i0, template: "<ng-container [ngSwitch]=\"link.mode\">\n  <ng-container *ngSwitchCase=\"NavigationMode.EXTERNAL\">\n    <ng-container [ngTemplateOutlet]=\"sideNavExternalLinkTemplate\" [ngTemplateOutletContext]=\"{$implicit:link}\">\n    </ng-container>\n  </ng-container>\n  <ng-container *ngSwitchCase=\"NavigationMode.INTERNAL\">\n    <ng-container [ngTemplateOutlet]=\"sideNavInternalLinkTemplate\" [ngTemplateOutletContext]=\"{$implicit:link}\">\n    </ng-container>\n  </ng-container>\n  <ng-container *ngSwitchCase=\"NavigationMode.EVENT\">\n    <ng-container [ngTemplateOutlet]=\"sideNavEventLinkTemplate\" [ngTemplateOutletContext]=\"{$implicit:link}\">\n    </ng-container>\n  </ng-container>\n  <ng-container *ngSwitchCase=\"NavigationMode.LABEL\">\n    <ng-container [ngTemplateOutlet]=\"sideNavEventLabelTemplate\" [ngTemplateOutletContext]=\"{$implicit:link}\">\n    </ng-container>\n  </ng-container>\n  <ng-container *ngSwitchDefault>\n    <ng-container [ngTemplateOutlet]=\"sideNavEventLinkTemplate\" [ngTemplateOutletContext]=\"{$implicit:link}\">\n    </ng-container>\n  </ng-container>\n</ng-container>\n\n<ng-template #sideNavInternalLinkTemplate let-link>\n  <a [attr.class]=\"link.selected ? class + ' ' + currentClass : class\" [routerLink]=\"[link.path]\" \n    (click)=\"linkClicked.emit(link)\" [queryParams]=\"link.queryParams\" \n    [queryParamsHandling]=\"link.queryParamsHandling\" href=\"javascript:void(0)\">\n    <span>{{link.text}}</span>\n  </a>\n</ng-template>\n\n<ng-template #sideNavExternalLinkTemplate let-link>\n  <a [attr.class]=\"link.selected ? class + ' ' + currentClass : class\"[attr.href]=\"urlBuilder(link)\"\n    (click)=\"linkClicked.emit(link)\">\n    <span>{{link.text}}</span>\n  </a>\n</ng-template>\n\n<ng-template #sideNavEventLinkTemplate let-link>\n  <a [attr.class]=\"link.selected ? class + ' ' + currentClass : class\" (click)=\"linkClicked.emit(link)\" \n    href=\"javascript:void(0)\">\n    <span>{{link.text}}</span>\n  </a>\n</ng-template>\n\n<ng-template #sideNavEventLabelTemplate let-link>\n  <span>{{link.text}}</span>\n</ng-template>\n", dependencies: [{ kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: i1.NgSwitchDefault, selector: "[ngSwitchDefault]" }, { kind: "directive", type: i2.RouterLink, selector: "[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "info", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaLinkTemplateComponent, decorators: [{
            type: Component,
            args: [{ selector: `usa-link-template`, template: "<ng-container [ngSwitch]=\"link.mode\">\n  <ng-container *ngSwitchCase=\"NavigationMode.EXTERNAL\">\n    <ng-container [ngTemplateOutlet]=\"sideNavExternalLinkTemplate\" [ngTemplateOutletContext]=\"{$implicit:link}\">\n    </ng-container>\n  </ng-container>\n  <ng-container *ngSwitchCase=\"NavigationMode.INTERNAL\">\n    <ng-container [ngTemplateOutlet]=\"sideNavInternalLinkTemplate\" [ngTemplateOutletContext]=\"{$implicit:link}\">\n    </ng-container>\n  </ng-container>\n  <ng-container *ngSwitchCase=\"NavigationMode.EVENT\">\n    <ng-container [ngTemplateOutlet]=\"sideNavEventLinkTemplate\" [ngTemplateOutletContext]=\"{$implicit:link}\">\n    </ng-container>\n  </ng-container>\n  <ng-container *ngSwitchCase=\"NavigationMode.LABEL\">\n    <ng-container [ngTemplateOutlet]=\"sideNavEventLabelTemplate\" [ngTemplateOutletContext]=\"{$implicit:link}\">\n    </ng-container>\n  </ng-container>\n  <ng-container *ngSwitchDefault>\n    <ng-container [ngTemplateOutlet]=\"sideNavEventLinkTemplate\" [ngTemplateOutletContext]=\"{$implicit:link}\">\n    </ng-container>\n  </ng-container>\n</ng-container>\n\n<ng-template #sideNavInternalLinkTemplate let-link>\n  <a [attr.class]=\"link.selected ? class + ' ' + currentClass : class\" [routerLink]=\"[link.path]\" \n    (click)=\"linkClicked.emit(link)\" [queryParams]=\"link.queryParams\" \n    [queryParamsHandling]=\"link.queryParamsHandling\" href=\"javascript:void(0)\">\n    <span>{{link.text}}</span>\n  </a>\n</ng-template>\n\n<ng-template #sideNavExternalLinkTemplate let-link>\n  <a [attr.class]=\"link.selected ? class + ' ' + currentClass : class\"[attr.href]=\"urlBuilder(link)\"\n    (click)=\"linkClicked.emit(link)\">\n    <span>{{link.text}}</span>\n  </a>\n</ng-template>\n\n<ng-template #sideNavEventLinkTemplate let-link>\n  <a [attr.class]=\"link.selected ? class + ' ' + currentClass : class\" (click)=\"linkClicked.emit(link)\" \n    href=\"javascript:void(0)\">\n    <span>{{link.text}}</span>\n  </a>\n</ng-template>\n\n<ng-template #sideNavEventLabelTemplate let-link>\n  <span>{{link.text}}</span>\n</ng-template>\n" }]
        }], propDecorators: { link: [{
                type: Input
            }], class: [{
                type: Input
            }], currentClass: [{
                type: Input
            }], linkClicked: [{
                type: Output
            }] } });

/**
 * Selector for custom link template for displaying breadcrumbs.
 * Usage:
 * <usa-breadcrumb [items]="items">
 *  <a *usaBreadcrumbLinkTemplate="let breadcrumb" href="myHref">{{breadcrumb.text}}</a>
 * </usa-breadcrumbs>
 */
class UsaBreadcrumbLinkTemplate {
    templateRef;
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaBreadcrumbLinkTemplate, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.2", type: UsaBreadcrumbLinkTemplate, selector: "[usaBreadcrumbLinkTemplate]", ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaBreadcrumbLinkTemplate, decorators: [{
            type: Directive,
            args: [{
                    selector: `[usaBreadcrumbLinkTemplate]`,
                }]
        }], ctorParameters: () => [{ type: i0.TemplateRef }] });
class UsaBreadcrumbComponent {
    cdr;
    breadcrumbLinkTemplate;
    /**
     * Toggles whether to wrap breadcrumb trail into new line on responsive
     * view or to truncate breadcrumb text. Value of true indicates breadcrumb
     * will wrap to new line, false will allow text to truncate
     * @default false
     */
    wrap = false;
    /**
     * Hides breadcrumbs when there is only one item to show for
     * breadcrumb trail. This occurs whenever the user is on the root
     * level page of the breadcrumb trail
     */
    hideSingleCrumb = false;
    /** List of breadcrumb items */
    items;
    selected = new EventEmitter();
    _displayedCrumbs;
    _showBreadcrumbs = true;
    _selectedBreadcrumb;
    constructor(
    /**
     * For public component usage if parents ever want to programatically
     * invoke change detection on component
     */
    cdr) {
        this.cdr = cdr;
    }
    /**
     * Initialize internal data within the component
     */
    ngOnInit() {
        this.updateShownCrumbs();
    }
    /**
     * Update data when relevant input reference changes
     */
    ngOnChanges(changes) {
        if (!changes.items && !changes.hideSingleCrumb)
            return;
        if (this._selectedBreadcrumb) {
            this._selectedBreadcrumb.selected = false;
        }
        this.updateShownCrumbs();
    }
    /**
     * Called whenever we need to update selected breadcrum to
     * another item. Normally occurs if user clicks on the breadcrum
     * @param breadcrumb
     */
    updateSelectedBreadcrumb(breadcrumb) {
        this._selectedBreadcrumb.selected = false;
        breadcrumb.selected = true;
        this.updateShownCrumbs();
        this.selected.emit(breadcrumb);
    }
    /**
     * Internal function to update the list of breadcrumbs currently shown as well
     * as other component fields
     */
    updateShownCrumbs() {
        if (!this.items || !this.items.length) {
            this._showBreadcrumbs = false;
            return;
        }
        let truncateIndex = this.items.findIndex((breadcrumb) => breadcrumb.selected);
        if (truncateIndex < 0) {
            truncateIndex = this.items.length - 1;
            this.items[truncateIndex].selected = true;
        }
        this._selectedBreadcrumb = this.items[truncateIndex];
        if (truncateIndex === 0 && this.hideSingleCrumb) {
            this._showBreadcrumbs = false;
        }
        else {
            this._showBreadcrumbs = true;
        }
        this._displayedCrumbs = this.items.slice(0, truncateIndex);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaBreadcrumbComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.2", type: UsaBreadcrumbComponent, selector: "usa-breadcrumb", inputs: { wrap: "wrap", hideSingleCrumb: "hideSingleCrumb", items: "items" }, outputs: { selected: "selected" }, queries: [{ propertyName: "breadcrumbLinkTemplate", first: true, predicate: UsaBreadcrumbLinkTemplate, descendants: true }], usesOnChanges: true, ngImport: i0, template: "<nav *ngIf=\"_showBreadcrumbs\" class=\"usa-breadcrumb\" aria-label=\"Breadcrumbs\" [ngClass]=\"{'usa-breadcrumb--wrap': wrap}\">\n  <ol class=\"usa-breadcrumb__list\">\n    <li *ngFor=\"let breadcrumb of _displayedCrumbs\" class=\"usa-breadcrumb__list-item\">\n        <ng-container *ngIf=\"breadcrumbLinkTemplate; else defaultLinkTemplate\" [ngTemplateOutlet]=\"breadcrumbLinkTemplate.templateRef\"\n          [ngTemplateOutletContext]=\"{$implicit: breadcrumb}\"\n        ></ng-container>\n        \n        <ng-template #defaultLinkTemplate>\n          <usa-link-template \n            [link]=\"breadcrumb\" \n            [currentClass]=\"''\" \n            [class]=\"'usa-breadcrumb__link'\"\n            (linkClicked)=\"updateSelectedBreadcrumb($event)\">\n          </usa-link-template>\n        </ng-template>\n    </li>\n    <li class=\"usa-breadcrumb__list-item usa-current\" aria-current=\"page\">\n      <span>{{_selectedBreadcrumb.text}}</span>\n    </li>\n  </ol>\n</nav>\n", styles: ["li.usa-breadcrumb__list-item:not(:last-child):after{background:url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\"><path d=\"M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z\"/></svg>') no-repeat center/contain}.usa-breadcrumb__list-item:nth-last-child(2) .usa-breadcrumb__link:before{background:url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\"><path d=\"M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z\"/></svg>') no-repeat center/contain}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: UsaLinkTemplateComponent, selector: "usa-link-template", inputs: ["link", "class", "currentClass"], outputs: ["linkClicked"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaBreadcrumbComponent, decorators: [{
            type: Component,
            args: [{ selector: 'usa-breadcrumb', changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, template: "<nav *ngIf=\"_showBreadcrumbs\" class=\"usa-breadcrumb\" aria-label=\"Breadcrumbs\" [ngClass]=\"{'usa-breadcrumb--wrap': wrap}\">\n  <ol class=\"usa-breadcrumb__list\">\n    <li *ngFor=\"let breadcrumb of _displayedCrumbs\" class=\"usa-breadcrumb__list-item\">\n        <ng-container *ngIf=\"breadcrumbLinkTemplate; else defaultLinkTemplate\" [ngTemplateOutlet]=\"breadcrumbLinkTemplate.templateRef\"\n          [ngTemplateOutletContext]=\"{$implicit: breadcrumb}\"\n        ></ng-container>\n        \n        <ng-template #defaultLinkTemplate>\n          <usa-link-template \n            [link]=\"breadcrumb\" \n            [currentClass]=\"''\" \n            [class]=\"'usa-breadcrumb__link'\"\n            (linkClicked)=\"updateSelectedBreadcrumb($event)\">\n          </usa-link-template>\n        </ng-template>\n    </li>\n    <li class=\"usa-breadcrumb__list-item usa-current\" aria-current=\"page\">\n      <span>{{_selectedBreadcrumb.text}}</span>\n    </li>\n  </ol>\n</nav>\n", styles: ["li.usa-breadcrumb__list-item:not(:last-child):after{background:url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\"><path d=\"M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z\"/></svg>') no-repeat center/contain}.usa-breadcrumb__list-item:nth-last-child(2) .usa-breadcrumb__link:before{background:url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\"><path d=\"M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z\"/></svg>') no-repeat center/contain}\n"] }]
        }], ctorParameters: () => [{ type: i0.ChangeDetectorRef }], propDecorators: { breadcrumbLinkTemplate: [{
                type: ContentChild,
                args: [UsaBreadcrumbLinkTemplate]
            }], wrap: [{
                type: Input
            }], hideSingleCrumb: [{
                type: Input
            }], items: [{
                type: Input
            }], selected: [{
                type: Output
            }] } });

class UsaLinkTemplateModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaLinkTemplateModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.2", ngImport: i0, type: UsaLinkTemplateModule, declarations: [UsaLinkTemplateComponent], imports: [CommonModule,
            RouterModule], exports: [UsaLinkTemplateComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaLinkTemplateModule, imports: [CommonModule,
            RouterModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaLinkTemplateModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        UsaLinkTemplateComponent
                    ],
                    imports: [
                        CommonModule,
                        RouterModule,
                    ],
                    exports: [
                        UsaLinkTemplateComponent
                    ]
                }]
        }] });

// import { UsaBreadcrumbLinkTemplate } from './breadcrumb.component';
class UsaBreadcrumbModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaBreadcrumbModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.2", ngImport: i0, type: UsaBreadcrumbModule, declarations: [UsaBreadcrumbComponent, UsaBreadcrumbLinkTemplate], imports: [CommonModule, UsaLinkTemplateModule], exports: [UsaBreadcrumbComponent, UsaBreadcrumbLinkTemplate] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaBreadcrumbModule, imports: [CommonModule, UsaLinkTemplateModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaBreadcrumbModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [UsaBreadcrumbComponent, UsaBreadcrumbLinkTemplate],
                    imports: [CommonModule, UsaLinkTemplateModule],
                    exports: [UsaBreadcrumbComponent, UsaBreadcrumbLinkTemplate],
                }]
        }] });

class USWDSCardBodyComponent {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: USWDSCardBodyComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.2", type: USWDSCardBodyComponent, selector: "uswds-card-body", host: { classAttribute: "usa-card__body" }, ngImport: i0, template: `
    <ng-content></ng-content>
  `, isInline: true });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: USWDSCardBodyComponent, decorators: [{
            type: Component,
            args: [{
                    selector: `uswds-card-body`,
                    template: `
    <ng-content></ng-content>
  `,
                    host: {
                        'class': 'usa-card__body'
                    },
                }]
        }] });

class USWDSCardFooterComponent {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: USWDSCardFooterComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.2", type: USWDSCardFooterComponent, selector: "uswds-card-footer", host: { classAttribute: "usa-card__footer" }, ngImport: i0, template: `
    <ng-content></ng-content>
  `, isInline: true });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: USWDSCardFooterComponent, decorators: [{
            type: Component,
            args: [{
                    selector: `uswds-card-footer`,
                    template: `
    <ng-content></ng-content>
  `,
                    host: {
                        'class': 'usa-card__footer'
                    }
                }]
        }] });

class USWDSCardGroupComponent {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: USWDSCardGroupComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.2", type: USWDSCardGroupComponent, selector: "uswds-card-group", ngImport: i0, template: `
  <ul class="usa-card-group">
    <ng-content></ng-content>
  </ul>`, isInline: true });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: USWDSCardGroupComponent, decorators: [{
            type: Component,
            args: [{
                    selector: `uswds-card-group`,
                    template: `
  <ul class="usa-card-group">
    <ng-content></ng-content>
  </ul>`
                }]
        }] });

class USWDSCardHeaderComponent {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: USWDSCardHeaderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.2", type: USWDSCardHeaderComponent, selector: "uswds-card-header", host: { classAttribute: "usa-card__header" }, ngImport: i0, template: `
    <ng-content></ng-content>
  `, isInline: true });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: USWDSCardHeaderComponent, decorators: [{
            type: Component,
            args: [{
                    selector: `uswds-card-header`,
                    template: `
    <ng-content></ng-content>
  `,
                    host: {
                        'class': 'usa-card__header'
                    }
                }]
        }] });

class USWDSCardMediaComponent {
    // Inset media content - aligns media within the card's padding
    inset = false;
    // Stretch media content to card border
    exdent = false;
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: USWDSCardMediaComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.2", type: USWDSCardMediaComponent, selector: "uswds-card-media", inputs: { inset: "inset", exdent: "exdent" }, host: { properties: { "class.usa-card__inset": "inset", "class.usa-card__exdent": "exdent" }, classAttribute: "usa-card__media" }, ngImport: i0, template: `
  <header>
    <div class="usa-card__img">
      <ng-content></ng-content>
    </div>
  </header>`, isInline: true });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: USWDSCardMediaComponent, decorators: [{
            type: Component,
            args: [{
                    selector: `uswds-card-media`,
                    template: `
  <header>
    <div class="usa-card__img">
      <ng-content></ng-content>
    </div>
  </header>`,
                    host: {
                        'class': 'usa-card__media',
                        '[class.usa-card__inset]': 'inset',
                        '[class.usa-card__exdent]': 'exdent',
                    }
                }]
        }], propDecorators: { inset: [{
                type: Input
            }], exdent: [{
                type: Input
            }] } });

class USWDSCardComponent {
    flagView = false;
    headerFirst = false;
    flagMediaRight = false;
    // Additional classes to add to card item eg: 'tablet:grid-col-6 desktop:grid-col-9'
    additionalStyles;
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: USWDSCardComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.2", type: USWDSCardComponent, selector: "[uswds-card]", inputs: { flagView: "flagView", headerFirst: "headerFirst", flagMediaRight: "flagMediaRight", additionalStyles: "additionalStyles" }, host: { properties: { "class.usa-card--header-first": "headerFirst", "class.usa-card--flag": "flagView", "class.usa-card--media-right": "flagMediaRight" }, classAttribute: "usa-card" }, ngImport: i0, template: `
    <div class="usa-card__container">
      <ng-content></ng-content>
    </div>
  `, isInline: true });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: USWDSCardComponent, decorators: [{
            type: Component,
            args: [{
                    selector: '[uswds-card]',
                    template: `
    <div class="usa-card__container">
      <ng-content></ng-content>
    </div>
  `,
                    host: {
                        'class': 'usa-card',
                        '[class.usa-card--header-first]': 'headerFirst',
                        '[class.usa-card--flag]': 'flagView',
                        '[class.usa-card--media-right]': 'flagMediaRight',
                    }
                }]
        }], propDecorators: { flagView: [{
                type: Input
            }], headerFirst: [{
                type: Input
            }], flagMediaRight: [{
                type: Input
            }], additionalStyles: [{
                type: Input
            }] } });

class USWDSCardModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: USWDSCardModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.2", ngImport: i0, type: USWDSCardModule, declarations: [USWDSCardComponent,
            USWDSCardBodyComponent,
            USWDSCardFooterComponent,
            USWDSCardGroupComponent,
            USWDSCardHeaderComponent,
            USWDSCardMediaComponent], imports: [CommonModule], exports: [USWDSCardComponent,
            USWDSCardBodyComponent,
            USWDSCardFooterComponent,
            USWDSCardGroupComponent,
            USWDSCardHeaderComponent,
            USWDSCardMediaComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: USWDSCardModule, imports: [CommonModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: USWDSCardModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        USWDSCardComponent,
                        USWDSCardBodyComponent,
                        USWDSCardFooterComponent,
                        USWDSCardGroupComponent,
                        USWDSCardHeaderComponent,
                        USWDSCardMediaComponent
                    ],
                    imports: [
                        CommonModule
                    ],
                    exports: [
                        USWDSCardComponent,
                        USWDSCardBodyComponent,
                        USWDSCardFooterComponent,
                        USWDSCardGroupComponent,
                        USWDSCardHeaderComponent,
                        USWDSCardMediaComponent
                    ]
                }]
        }] });

let nextId$5 = 0;
class UsaCheckboxLabelDescription {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaCheckboxLabelDescription, deps: [], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.2", type: UsaCheckboxLabelDescription, selector: "[usaCheckboxDescription]", host: { classAttribute: "usa-checkbox__label-description" }, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaCheckboxLabelDescription, decorators: [{
            type: Directive,
            args: [{
                    selector: '[usaCheckboxDescription]',
                    host: {
                        class: 'usa-checkbox__label-description'
                    }
                }]
        }] });
class UsaCheckboxComponent {
    cdr;
    nativeInput;
    tile;
    checked;
    disabled;
    ariaLabel = '';
    ariaLabelledby;
    ariaDescribedby;
    id = `usa-checkbox-${nextId$5++}`;
    required = false;
    /** Name value will be applied to the input element if present */
    name;
    get indeterminate() { return this._indeterminate; }
    ;
    set indeterminate(value) {
        if (!this.nativeInput) {
            return;
        }
        this._indeterminate = value;
        this.nativeInput.nativeElement.indeterminate = value;
    }
    _indeterminate;
    change = new EventEmitter();
    /**
    * Invoked when the model has been changed
    */
    onChange = (_) => { };
    /**
     * Invoked when the model has been touched
     */
    onTouched = () => { };
    constructor(cdr) {
        this.cdr = cdr;
    }
    writeValue(value) {
        this.checked = !!value;
        this.cdr.markForCheck();
    }
    /**
     * Registers a callback function that should be called when the control's value changes in the UI.
     * @param fn
     */
    registerOnChange(fn) {
        this.onChange = fn;
    }
    /**
      * Registers a callback function that should be called when the control receives a blur event.
      * @param fn
      */
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    _getAriaChecked() {
        if (this.checked) {
            return 'true';
        }
        return this.indeterminate ? 'mixed' : 'false';
    }
    onCheckboxClick($event) {
        $event.stopPropagation();
        this.checked = !this.checked;
        this.onChange(this.checked);
        this.change.emit(this.checked);
    }
    preventChangePropogation($event) {
        $event.stopPropagation();
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaCheckboxComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.2", type: UsaCheckboxComponent, selector: "usa-checkbox", inputs: { tile: "tile", checked: "checked", disabled: "disabled", ariaLabel: ["aria-label", "ariaLabel"], ariaLabelledby: ["aria-labelledby", "ariaLabelledby"], ariaDescribedby: ["aria-describedby", "ariaDescribedby"], id: "id", required: "required", name: "name", indeterminate: "indeterminate" }, outputs: { change: "change" }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => UsaCheckboxComponent),
                multi: true,
            },
        ], viewQueries: [{ propertyName: "nativeInput", first: true, predicate: ["input"], descendants: true }], ngImport: i0, template: "<div class=\"usa-checkbox\">\n  <input #input\n  class=\"usa-checkbox__input\" type=\"checkbox\"\n  [ngClass]=\"{'usa-checkbox__input--tile': tile}\"\n  [id]=\"id\"\n  [required]=\"required\"\n  [checked]=\"checked\"\n  [indeterminate]=\"indeterminate\"\n  [disabled]=\"disabled\"\n  [attr.name]=\"name\"\n  [attr.aria-label]=\"ariaLabel || null\"\n  [attr.aria-labelledby]=\"ariaLabelledby\"\n  [attr.aria-checked]=\"_getAriaChecked()\"\n  [attr.aria-describedby]=\"ariaDescribedby\"\n  (change)=\"preventChangePropogation($event)\"\n  (click)=\"onCheckboxClick($event)\">\n  <label class=\"usa-checkbox__label\" [for]=\"id\">\n    <ng-content></ng-content>\n    <ng-content select=\"usaCheckboxDescription\"></ng-content>\n  </label>\n</div>\n", dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaCheckboxComponent, decorators: [{
            type: Component,
            args: [{ selector: 'usa-checkbox', providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => UsaCheckboxComponent),
                            multi: true,
                        },
                    ], changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"usa-checkbox\">\n  <input #input\n  class=\"usa-checkbox__input\" type=\"checkbox\"\n  [ngClass]=\"{'usa-checkbox__input--tile': tile}\"\n  [id]=\"id\"\n  [required]=\"required\"\n  [checked]=\"checked\"\n  [indeterminate]=\"indeterminate\"\n  [disabled]=\"disabled\"\n  [attr.name]=\"name\"\n  [attr.aria-label]=\"ariaLabel || null\"\n  [attr.aria-labelledby]=\"ariaLabelledby\"\n  [attr.aria-checked]=\"_getAriaChecked()\"\n  [attr.aria-describedby]=\"ariaDescribedby\"\n  (change)=\"preventChangePropogation($event)\"\n  (click)=\"onCheckboxClick($event)\">\n  <label class=\"usa-checkbox__label\" [for]=\"id\">\n    <ng-content></ng-content>\n    <ng-content select=\"usaCheckboxDescription\"></ng-content>\n  </label>\n</div>\n" }]
        }], ctorParameters: () => [{ type: i0.ChangeDetectorRef }], propDecorators: { nativeInput: [{
                type: ViewChild,
                args: ['input']
            }], tile: [{
                type: Input
            }], checked: [{
                type: Input
            }], disabled: [{
                type: Input
            }], ariaLabel: [{
                type: Input,
                args: ['aria-label']
            }], ariaLabelledby: [{
                type: Input,
                args: ['aria-labelledby']
            }], ariaDescribedby: [{
                type: Input,
                args: ['aria-describedby']
            }], id: [{
                type: Input
            }], required: [{
                type: Input
            }], name: [{
                type: Input
            }], indeterminate: [{
                type: Input
            }], change: [{
                type: Output
            }] } });

class UsaCheckboxModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaCheckboxModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.2", ngImport: i0, type: UsaCheckboxModule, declarations: [UsaCheckboxComponent,
            UsaCheckboxLabelDescription], imports: [CommonModule], exports: [UsaCheckboxComponent,
            UsaCheckboxLabelDescription] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaCheckboxModule, imports: [CommonModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaCheckboxModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        UsaCheckboxComponent,
                        UsaCheckboxLabelDescription
                    ],
                    imports: [
                        CommonModule,
                    ],
                    exports: [
                        UsaCheckboxComponent,
                        UsaCheckboxLabelDescription
                    ]
                }]
        }] });

class UsaComboBoxItemTemplate {
    templateRef;
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaComboBoxItemTemplate, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.2", type: UsaComboBoxItemTemplate, selector: "[usa-combo-box-item-template]", ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaComboBoxItemTemplate, decorators: [{
            type: Directive,
            args: [{
                    selector: `[usa-combo-box-item-template]`,
                }]
        }], ctorParameters: () => [{ type: i0.TemplateRef }] });
class UsaComboboxList {
    el;
    cdr;
    renderer;
    document;
    dropdownListBox;
    /** List of items to display in dropdown */
    items;
    labelField;
    valueField;
    /** Provided custom template for displaying each item.
     * If none provided, then the label property of each item will be shown */
    customItemTemplate;
    /**
     * HTML id value to attach to container element
     */
    listId;
    /**
     * If virtualScroll is enabled, a scrollEnd event
     * will be fired when user scrolls to last item in the list,
     * allowing clients to load in more data
     */
    virtualScroll = true;
    /**
     * Direction to display the dropdown box
     */
    direction;
    /** Id of label for listbox */
    ariaLabelledBy;
    selectedItem;
    /**
     * Emitted when a value is selected from the dropdown list
     */
    selected = new EventEmitter();
    /**
     * Emitted when the user presses the up arrow key and focus
     * is on first item in dropdown list. This indicates to the client
     * that the dropdown list should close and focus should move
     * back to the combo box input field
     */
    focusInput = new EventEmitter();
    /**
     * Emitted when user has scrolled to the end of the dropdown list.
     * This event only fires if virtual scroll is enabled
     */
    scrollEnd = new EventEmitter();
    // Reference to currently focused item
    _focusedItem;
    /**
     * Referenced to currently highlighted item. Highlighted items have a dark
     * border around to draw attention to it, but do not necessarily have focus.
     * This can occur if focus is on input and the highlighted item is the item
     * that best matches input query.
     */
    _highlightedItem;
    /** List of functions to call to un-bind events registered through renderer.listen call */
    _eventListeners = [];
    constructor(el, cdr, renderer, document) {
        this.el = el;
        this.cdr = cdr;
        this.renderer = renderer;
        this.document = document;
    }
    trackByFn(index) {
        return index;
    }
    ngAfterViewInit() {
        this.setDropdownDirection();
        this.registerEventHandlers();
        if (this.selectedItem) {
            const index = this.items.findIndex((item) => item === this.selectedItem);
            this.highlightItem(index);
        }
    }
    ngOnDestroy() {
        this._eventListeners.forEach((listener) => listener());
    }
    ngOnChanges(changes) {
        if (!changes.items) {
            return;
        }
        /**
         * New list of items is provided. Remove listeners to old item list, and attach listeners
         * to the new items
         */
        this._eventListeners.forEach((unlistener) => unlistener());
        this._eventListeners = [];
        this.cdr.detectChanges();
        this.registerEventHandlers();
    }
    selectItem(item) {
        if (item.disabled)
            return;
        this.selected.emit(item);
    }
    onFocus(item, index, itemHtml) {
        this._focusedItem = { item, index, itemHtml };
    }
    /**
     * Handles keypress on combobox dropdown items
     * @param $event
     * @returns
     */
    onKeyDown($event) {
        switch (true) {
            case isArrowDown($event):
                if (this._focusedItem?.index === this.items.length - 1)
                    return;
                const nextSibling = this._focusedItem.itemHtml
                    .nextElementSibling;
                this.updateFocusedItem(this._focusedItem.index + 1, nextSibling);
                $event.preventDefault();
                break;
            case isArrowUp($event):
                if (this._focusedItem?.index === 0) {
                    this.focusInput.emit();
                    return;
                }
                const previousSibling = this._focusedItem.itemHtml
                    .previousElementSibling;
                this.updateFocusedItem(this._focusedItem.index - 1, previousSibling);
                $event.preventDefault();
                break;
            case isPageUp($event):
            case isPageDown($event):
                const dropdownNativeElement = this.dropdownListBox.nativeElement;
                if (!dropdownNativeElement.firstElementChild ||
                    !dropdownNativeElement.firstElementChild.clientHeight) {
                    return;
                }
                const numItemsToScrollPast = Math.ceil(dropdownNativeElement.clientHeight /
                    dropdownNativeElement.firstElementChild.clientHeight);
                let newIndex = Math.min(this._focusedItem.index + numItemsToScrollPast, this.items.length - 1);
                if (isPageUp($event)) {
                    newIndex = Math.max(this._focusedItem.index - numItemsToScrollPast, 0);
                }
                const newFocusedElement = this.el.nativeElement.querySelector(`#${this.listId}-${newIndex}`);
                this.updateFocusedItem(newIndex, newFocusedElement);
                $event.preventDefault();
                break;
            case isHome($event):
                this.focusFirstElement();
                $event.preventDefault();
                break;
            case isEnd$1($event):
                this.focusLastElement();
                $event.preventDefault();
                break;
            case isEnter($event):
            case isTab($event):
                this.selectItem(this._focusedItem.item);
                $event.preventDefault();
                break;
        }
    }
    /**
     * Focus on first element of combo-box dropdown
     */
    focusFirstElement() {
        const firstElement = this.dropdownListBox.nativeElement
            .firstElementChild;
        this.updateFocusedItem(0, firstElement);
        this.cdr.detectChanges();
    }
    focusLastElement() {
        const lastIndex = this.items.length - 1;
        const lastElement = this.dropdownListBox.nativeElement
            .lastElementChild;
        this.updateFocusedItem(lastIndex, lastElement);
        this.cdr.detectChanges();
    }
    focusHighlightedElement() {
        if (!this._highlightedItem) {
            this.focusFirstElement();
        }
        else {
            this.updateFocusedItem(this._highlightedItem.index, this._highlightedItem.itemHtml);
        }
    }
    /**
     * Used by default template for rendering display value. If each item is
     * an object, get its given value property, otherwise, simply display the item
     */
    getRenderValue(item) {
        if (typeof item === 'object') {
            return item[this.labelField];
        }
        return item;
    }
    /**
     * Public interface that allows components to highlight an item in dropdown
     * without moving focus to it. This simply adds a visible border to the item
     * and moves it to visible area of the dropdown
     */
    highlightItem(index) {
        if (index < 0 || index >= this.items.length)
            return;
        const itemId = `${this.listId}-${index}`;
        const itemHtml = this.el.nativeElement.querySelector(`#${itemId}`);
        this._highlightedItem = { item: this.items[index], index, itemHtml };
        itemHtml.scrollIntoView({ block: 'end' });
        this.cdr.detectChanges();
    }
    registerEventHandlers() {
        this.bindMouseOverListeners();
        this.bindScrollListener();
    }
    /**
     * Attaches mouseover event to each list element in the dropdown. Since the mouseover
     * event fires quite often, we attach it this way in the ts rather than through HTML
     * This coupled with changeDetectionStrategy of OnPush minimizes the amount
     * of necessary change detection triggers
     */
    bindMouseOverListeners() {
        const children = Array.from(this.dropdownListBox.nativeElement.children);
        children.forEach((child, index) => {
            const listener = this.renderer.listen(child, 'mouseover', () => {
                if (this.document.activeElement === child) {
                    return;
                }
                this.updateFocusedItem(index, child);
                this.cdr.detectChanges();
            });
            this._eventListeners.push(listener);
        });
    }
    /**
     * Adds scroll event binding if virtual scrolling is enabled.
     * This event listens for whether the user has scrolled to the last
     * item in the list or not. If so, it will fire an event
     * indicating that the user has scrolled to the end and more data
     * should be fetched
     * @returns
     */
    bindScrollListener() {
        if (!this.virtualScroll)
            return;
        const dropdownElement = this.dropdownListBox.nativeElement;
        const scrollListener = this.renderer.listen(dropdownElement, 'scroll', () => {
            const currentScrolledAmount = dropdownElement.offsetHeight + dropdownElement.scrollTop;
            const totalScrollAmount = dropdownElement.scrollHeight;
            if (currentScrolledAmount >= totalScrollAmount) {
                this.scrollEnd.emit();
            }
        });
        this._eventListeners.push(scrollListener);
    }
    setDropdownDirection() {
        const dropdownRect = this.dropdownListBox.nativeElement
            .getClientRects()
            .item(0);
        /**
         * If there isn't enough room to display dropdown above the input, then simply display dropdown
         * below regardless of space
         */
        if (this.direction === 'bottom' || dropdownRect.height > dropdownRect.top)
            return;
        const dropdownY = dropdownRect.height + dropdownRect.top;
        /**
         * If there is no space to display dropdown below the input, then display dropdown above the input
         */
        if (this.direction === 'top' || dropdownY >= window.innerHeight) {
            this.dropdownListBox.nativeElement.style.bottom = '100%';
            this.dropdownListBox.nativeElement.style.borderBottomWidth = '0';
            this.dropdownListBox.nativeElement.style.borderTop = '1px solid';
        }
    }
    updateFocusedItem(index, itemHtml) {
        const item = this.items[index];
        this._focusedItem = { item, index, itemHtml };
        this._highlightedItem = { item, index, itemHtml };
        itemHtml.focus();
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaComboboxList, deps: [{ token: i0.ElementRef }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.2", type: UsaComboboxList, selector: "usa-combo-box-list", inputs: { items: "items", labelField: "labelField", valueField: "valueField", customItemTemplate: "customItemTemplate", listId: "listId", virtualScroll: "virtualScroll", direction: "direction", ariaLabelledBy: "ariaLabelledBy", selectedItem: "selectedItem" }, outputs: { selected: "selected", focusInput: "focusInput", scrollEnd: "scrollEnd" }, viewQueries: [{ propertyName: "dropdownListBox", first: true, predicate: ["dropdownListbox"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<ul #dropdownListbox [attr.id]=\"listId\" class=\"usa-combo-box__list\" role=\"listbox\"\n  [attr.aria-labelledby]=\"ariaLabelledBy\">\n\n  <li *ngFor=\"let item of items; index as i; trackBy: trackByFn\" #itemHtml class=\"usa-combo-box__list-option\"\n    [attr.tabindex]=\"_highlightedItem?.item === item ? 0 : -1\" [attr.aria-setsize]=\"items.length\" [attr.aria-posinset]=\"i\"\n    [attr.aria-selected]=\"selectedItem === item\" role=\"option\" value=\"{{item[valueField]}}\" [attr.id]=\"listId + '-' + i\"\n    [ngClass]=\"{\n      'usa-combo-box__list-option--focused': _highlightedItem?.item === item,\n      'usa-combo-box__list-option--selected': selectedItem === item,\n      'text-base cursor-default': item.disabled\n    }\" \n    (click)=\"selectItem(item)\"\n    (focus)=\"onFocus(item, i, itemHtml)\"\n    (keydown)=\"onKeyDown($event)\">\n    <ng-container [ngTemplateOutlet]=\"customItemTemplate?.templateRef || defaultOptionTemplate\"\n      [ngTemplateOutletContext]=\"{$implicit: item}\"></ng-container>\n\n  </li>\n</ul>\n\n<ng-template #defaultOptionTemplate let-item>\n  {{getRenderValue(item)}}\n</ng-template>\n", dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaComboboxList, decorators: [{
            type: Component,
            args: [{ selector: `usa-combo-box-list`, changeDetection: ChangeDetectionStrategy.OnPush, template: "<ul #dropdownListbox [attr.id]=\"listId\" class=\"usa-combo-box__list\" role=\"listbox\"\n  [attr.aria-labelledby]=\"ariaLabelledBy\">\n\n  <li *ngFor=\"let item of items; index as i; trackBy: trackByFn\" #itemHtml class=\"usa-combo-box__list-option\"\n    [attr.tabindex]=\"_highlightedItem?.item === item ? 0 : -1\" [attr.aria-setsize]=\"items.length\" [attr.aria-posinset]=\"i\"\n    [attr.aria-selected]=\"selectedItem === item\" role=\"option\" value=\"{{item[valueField]}}\" [attr.id]=\"listId + '-' + i\"\n    [ngClass]=\"{\n      'usa-combo-box__list-option--focused': _highlightedItem?.item === item,\n      'usa-combo-box__list-option--selected': selectedItem === item,\n      'text-base cursor-default': item.disabled\n    }\" \n    (click)=\"selectItem(item)\"\n    (focus)=\"onFocus(item, i, itemHtml)\"\n    (keydown)=\"onKeyDown($event)\">\n    <ng-container [ngTemplateOutlet]=\"customItemTemplate?.templateRef || defaultOptionTemplate\"\n      [ngTemplateOutletContext]=\"{$implicit: item}\"></ng-container>\n\n  </li>\n</ul>\n\n<ng-template #defaultOptionTemplate let-item>\n  {{getRenderValue(item)}}\n</ng-template>\n" }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }], propDecorators: { dropdownListBox: [{
                type: ViewChild,
                args: ['dropdownListbox']
            }], items: [{
                type: Input
            }], labelField: [{
                type: Input
            }], valueField: [{
                type: Input
            }], customItemTemplate: [{
                type: Input
            }], listId: [{
                type: Input
            }], virtualScroll: [{
                type: Input
            }], direction: [{
                type: Input
            }], ariaLabelledBy: [{
                type: Input
            }], selectedItem: [{
                type: Input
            }], selected: [{
                type: Output
            }], focusInput: [{
                type: Output
            }], scrollEnd: [{
                type: Output
            }] } });

let comboBoxId = 0;
let listBoxId = 0;
class UsaComboBoxComponent {
    el;
    cdr;
    comboBoxInput;
    comboBoxDropdown;
    /** List of items to display in dropdown */
    items;
    /** ID to use for html input. One will be auto generated if not provided */
    id = `usa-combo-box-${comboBoxId++}`;
    /** Id to use for html list box. One will be auto generated if not provided */
    listId = `usa-combo-box__list-${listBoxId++}`;
    /** Defines which property of each item to display to the user */
    labelField;
    /** Defines which property to consider as internal value for each item */
    valueField;
    /** Currently present value in the combo box's input field */
    value = '';
    /** Whether the input field can be written to or not */
    readonly = undefined;
    /**
     * Toggles whether or not to emit scrollEnd event when a user scrolls to the
     * bottom of the current item list
     */
    virtualScroll = true;
    disabled = false;
    /** Emitted with a value change occurs in user input */
    changeEvent = new EventEmitter();
    /** Emitted when an item is selected */
    selected = new EventEmitter();
    /**
     * Emitted when a user scrolls to the bottom of the current item list.
     * This event signals clients to fetch additional data to append to current items
     * list if additional data exists.
     */
    scrollEnd = new EventEmitter();
    /** Custom template to use for rendering each item in items list */
    itemTemplate;
    _onChange = (_) => { };
    _onTouched = () => { };
    _displayDropdown = false;
    _selectedItem;
    onDocumentClick($event) {
        if (this.el.nativeElement.contains($event.target)) {
            return;
        }
        this._displayDropdown = false;
        if (this._selectedItem) {
            this.updateValue(this._selectedItem);
        }
        else {
            this.updateValue('');
        }
    }
    constructor(el, cdr) {
        this.el = el;
        this.cdr = cdr;
    }
    writeValue(obj) {
        this.value = obj;
    }
    registerOnChange(fn) {
        this._onChange = fn;
    }
    registerOnTouched(fn) {
        this._onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    onValueChange($event) {
        this.updateValue($event);
        this._displayDropdown = true;
    }
    selectItem(item) {
        this.comboBoxInput.nativeElement.focus();
        this._displayDropdown = false;
        if (this._selectedItem === item)
            return;
        this._selectedItem = item;
        this.updateValue(item);
        this.selected.emit();
    }
    clearInput() {
        this.updateValue('');
        this._selectedItem = undefined;
        this.comboBoxInput?.nativeElement.focus();
    }
    onFocus() {
        this._onTouched();
    }
    onScrollEnd() {
        this.scrollEnd.emit();
    }
    /**
     * Move focus to combo box input and close dropdown
     */
    focusInput() {
        this.comboBoxInput.nativeElement.focus();
        this._displayDropdown = false;
    }
    /**
     * Handles keypress on combobox input field
     * @param $event
     * @returns
     */
    onInputKeyDown($event) {
        const keyPressed = $event.key || $event.keyCode;
        switch (keyPressed) {
            case Key.ArrowDown:
            case MicrosfotKeys.ArrowDown:
            case KeyCode.ArrowDown:
                if (!this._displayDropdown) {
                    this._displayDropdown = true;
                    this.cdr.detectChanges();
                }
                if (this.comboBoxDropdown) {
                    this.comboBoxDropdown.focusHighlightedElement();
                }
                $event.preventDefault();
                break;
            case Key.ArrowUp:
            case MicrosfotKeys.ArrowUp:
            case KeyCode.ArrowUp:
                this._displayDropdown = false;
                $event.preventDefault();
                break;
        }
    }
    updateValue(value) {
        if (this.value === value || this.value === value[this.labelField])
            return;
        if (typeof value === 'object') {
            this.value = value[this.labelField];
        }
        else {
            this.value = value;
        }
        this._onChange(this.value);
        this.changeEvent.emit(this.value);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaComboBoxComponent, deps: [{ token: i0.ElementRef }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.2", type: UsaComboBoxComponent, selector: "usa-combobox", inputs: { items: "items", id: "id", listId: "listId", labelField: "labelField", valueField: "valueField", value: "value", readonly: "readonly", virtualScroll: "virtualScroll", disabled: "disabled" }, outputs: { changeEvent: "change", selected: "selected", scrollEnd: "scrollEnd" }, host: { listeners: { "document:click": "onDocumentClick($event)" } }, providers: [{
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => UsaComboBoxComponent),
                multi: true
            }], queries: [{ propertyName: "itemTemplate", first: true, predicate: UsaComboBoxItemTemplate, descendants: true }], viewQueries: [{ propertyName: "comboBoxInput", first: true, predicate: ["comboBoxInput"], descendants: true }, { propertyName: "comboBoxDropdown", first: true, predicate: UsaComboboxList, descendants: true }], ngImport: i0, template: "<div class=\"usa-combo-box\" [ngClass]=\"{'usa-combo-box--pristine': value?.length}\">\n  <input #comboBoxInput \n    [attr.id]=\"id\" [attr.aria-owns]=\"listId\" aria-autocomplete=\"list\" [attr.aria-describedby]=\"id + '--assistiveHint'\"\n    [attr.aria-expanded]=\"_displayDropdown\" autocapitalize=\"off\" autocomplete=\"off\" class=\"usa-combo-box__input\" type=\"text\"\n    role=\"combobox\" [attr.aria-activedescendant]=\"comboBoxDropdown?._focusedItem?.id\" \n    (focus)=\"onFocus()\" (input)=\"onValueChange($event.target.value)\" (keydown)=\"onInputKeyDown($event)\" \n    (click)=\"disabled ? '' : _displayDropdown = true\"\n    [value]=\"value\" [disabled]=\"disabled\" [attr.readonly]=\"readonly === true ? true : undefined\">\n\n  <span class=\"usa-combo-box__clear-input__wrapper\" tabindex=\"-1\">\n    <button type=\"button\" class=\"usa-combo-box__clear-input\" aria-label=\"Clear the select contents\" (click)=\"clearInput()\">&nbsp;</button>\n  </span>\n  <span class=\"usa-combo-box__input-button-separator\">&nbsp;</span>\n  <span class=\"usa-combo-box__toggle-list__wrapper\" tabindex=\"-1\">\n    <button type=\"button\" (click)=\"disabled ? '' : _displayDropdown = !_displayDropdown\" tabindex=\"-1\" class=\"usa-combo-box__toggle-list\"\n      aria-label=\"Toggle the dropdown list\">&nbsp;</button>\n  </span>\n\n  <usa-combo-box-list *ngIf=\"_displayDropdown\"\n    #comboBoxList\n    [items]=\"items\"\n    [labelField]=\"labelField\"\n    [valueField]=\"valueField\"\n    [customItemTemplate]=\"itemTemplate\"\n    [listId]=\"listId\"\n    [virtualScroll]=\"virtualScroll\"\n    [selectedItem]=\"_selectedItem\"\n    (selected)=\"selectItem($event)\"\n    (focusInput)=\"focusInput()\"\n    (scrollEnd)=\"onScrollEnd()\"\n  >\n  </usa-combo-box-list>\n\n  <div class=\"usa-combo-box__status usa-sr-only\" role=\"status\"></div>\n  <span [attr.id]=\"id + '--assistiveHint'\" class=\"usa-sr-only\">\n    When autocomplete results are available use up and down arrows to review and enter to select.\n    Touch device users, explore by touch or with swipe gestures.\n  </span>\n</div>\n", dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: UsaComboboxList, selector: "usa-combo-box-list", inputs: ["items", "labelField", "valueField", "customItemTemplate", "listId", "virtualScroll", "direction", "ariaLabelledBy", "selectedItem"], outputs: ["selected", "focusInput", "scrollEnd"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaComboBoxComponent, decorators: [{
            type: Component,
            args: [{ selector: 'usa-combobox', providers: [{
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => UsaComboBoxComponent),
                            multi: true
                        }], changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"usa-combo-box\" [ngClass]=\"{'usa-combo-box--pristine': value?.length}\">\n  <input #comboBoxInput \n    [attr.id]=\"id\" [attr.aria-owns]=\"listId\" aria-autocomplete=\"list\" [attr.aria-describedby]=\"id + '--assistiveHint'\"\n    [attr.aria-expanded]=\"_displayDropdown\" autocapitalize=\"off\" autocomplete=\"off\" class=\"usa-combo-box__input\" type=\"text\"\n    role=\"combobox\" [attr.aria-activedescendant]=\"comboBoxDropdown?._focusedItem?.id\" \n    (focus)=\"onFocus()\" (input)=\"onValueChange($event.target.value)\" (keydown)=\"onInputKeyDown($event)\" \n    (click)=\"disabled ? '' : _displayDropdown = true\"\n    [value]=\"value\" [disabled]=\"disabled\" [attr.readonly]=\"readonly === true ? true : undefined\">\n\n  <span class=\"usa-combo-box__clear-input__wrapper\" tabindex=\"-1\">\n    <button type=\"button\" class=\"usa-combo-box__clear-input\" aria-label=\"Clear the select contents\" (click)=\"clearInput()\">&nbsp;</button>\n  </span>\n  <span class=\"usa-combo-box__input-button-separator\">&nbsp;</span>\n  <span class=\"usa-combo-box__toggle-list__wrapper\" tabindex=\"-1\">\n    <button type=\"button\" (click)=\"disabled ? '' : _displayDropdown = !_displayDropdown\" tabindex=\"-1\" class=\"usa-combo-box__toggle-list\"\n      aria-label=\"Toggle the dropdown list\">&nbsp;</button>\n  </span>\n\n  <usa-combo-box-list *ngIf=\"_displayDropdown\"\n    #comboBoxList\n    [items]=\"items\"\n    [labelField]=\"labelField\"\n    [valueField]=\"valueField\"\n    [customItemTemplate]=\"itemTemplate\"\n    [listId]=\"listId\"\n    [virtualScroll]=\"virtualScroll\"\n    [selectedItem]=\"_selectedItem\"\n    (selected)=\"selectItem($event)\"\n    (focusInput)=\"focusInput()\"\n    (scrollEnd)=\"onScrollEnd()\"\n  >\n  </usa-combo-box-list>\n\n  <div class=\"usa-combo-box__status usa-sr-only\" role=\"status\"></div>\n  <span [attr.id]=\"id + '--assistiveHint'\" class=\"usa-sr-only\">\n    When autocomplete results are available use up and down arrows to review and enter to select.\n    Touch device users, explore by touch or with swipe gestures.\n  </span>\n</div>\n" }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i0.ChangeDetectorRef }], propDecorators: { comboBoxInput: [{
                type: ViewChild,
                args: ['comboBoxInput']
            }], comboBoxDropdown: [{
                type: ViewChild,
                args: [UsaComboboxList]
            }], items: [{
                type: Input
            }], id: [{
                type: Input
            }], listId: [{
                type: Input
            }], labelField: [{
                type: Input
            }], valueField: [{
                type: Input
            }], value: [{
                type: Input
            }], readonly: [{
                type: Input
            }], virtualScroll: [{
                type: Input
            }], disabled: [{
                type: Input
            }], changeEvent: [{
                type: Output,
                args: ['change']
            }], selected: [{
                type: Output
            }], scrollEnd: [{
                type: Output
            }], itemTemplate: [{
                type: ContentChild,
                args: [UsaComboBoxItemTemplate]
            }], onDocumentClick: [{
                type: HostListener,
                args: ['document:click', ['$event']]
            }] } });

class UsaComboBoxListModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaComboBoxListModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.2", ngImport: i0, type: UsaComboBoxListModule, declarations: [UsaComboboxList,
            UsaComboBoxItemTemplate], imports: [CommonModule], exports: [UsaComboboxList,
            UsaComboBoxItemTemplate] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaComboBoxListModule, imports: [CommonModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaComboBoxListModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [
                        UsaComboboxList,
                        UsaComboBoxItemTemplate
                    ],
                    exports: [
                        UsaComboboxList,
                        UsaComboBoxItemTemplate
                    ]
                }]
        }] });

class UsaComboboxModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaComboboxModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.2", ngImport: i0, type: UsaComboboxModule, declarations: [UsaComboBoxComponent], imports: [CommonModule, UsaComboBoxListModule], exports: [UsaComboBoxComponent, UsaComboBoxListModule] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaComboboxModule, imports: [CommonModule, UsaComboBoxListModule, UsaComboBoxListModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaComboboxModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [UsaComboBoxComponent],
                    imports: [CommonModule, UsaComboBoxListModule],
                    exports: [UsaComboBoxComponent, UsaComboBoxListModule],
                }]
        }] });

let dropdownId = 0;
class UsaDropdownComponent {
    cdr;
    model;
    /** Id of dropdown field */
    id = `usa-dropdown-${dropdownId++}`;
    /** HTML name attribute for dropdown */
    name;
    /** List of selectable options */
    options;
    disabled = false;
    optionChange = new EventEmitter();
    onChange = (v) => { };
    onTouched = () => { };
    constructor(cdr) {
        this.cdr = cdr;
    }
    onOptionSelected($event) {
        const options = $event.target.options;
        const selectedOption = options.item(options.selectedIndex);
        this.model = { label: selectedOption.label, value: selectedOption.value };
        this.onChange(this.model);
        this.optionChange.emit(this.model);
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    writeValue(value) {
        this.model = value;
        this.cdr.markForCheck();
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaDropdownComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.2", type: UsaDropdownComponent, selector: "usa-dropdown", inputs: { id: "id", name: "name", options: "options", disabled: "disabled" }, outputs: { optionChange: "optionChange" }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => UsaDropdownComponent),
                multi: true,
            },
        ], ngImport: i0, template: "<select class=\"usa-select\" [attr.name]=\"name\" [attr.id]=\"id\" (change)=\"onOptionSelected($event)\" [disabled]=\"disabled\">\n  <option *ngFor=\"let option of options\" [value]=\"option.value\" [disabled]=\"option.disabled\">{{option.label}}</option>\n</select>\n", dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaDropdownComponent, decorators: [{
            type: Component,
            args: [{ selector: 'usa-dropdown', providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => UsaDropdownComponent),
                            multi: true,
                        },
                    ], changeDetection: ChangeDetectionStrategy.OnPush, template: "<select class=\"usa-select\" [attr.name]=\"name\" [attr.id]=\"id\" (change)=\"onOptionSelected($event)\" [disabled]=\"disabled\">\n  <option *ngFor=\"let option of options\" [value]=\"option.value\" [disabled]=\"option.disabled\">{{option.label}}</option>\n</select>\n" }]
        }], ctorParameters: () => [{ type: i0.ChangeDetectorRef }], propDecorators: { id: [{
                type: Input
            }], name: [{
                type: Input
            }], options: [{
                type: Input
            }], disabled: [{
                type: Input
            }], optionChange: [{
                type: Output
            }] } });

class UsaDropdownModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaDropdownModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.2", ngImport: i0, type: UsaDropdownModule, declarations: [UsaDropdownComponent], imports: [CommonModule], exports: [UsaDropdownComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaDropdownModule, imports: [CommonModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaDropdownModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [
                        UsaDropdownComponent
                    ],
                    exports: [
                        UsaDropdownComponent
                    ]
                }]
        }] });

class FileInputConfig {
    multiple = false;
    acceptFileType = undefined;
    clearFilesOnAdd = true;
    displayFileInfo = true;
    uploadRequest = undefined;
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: FileInputConfig, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: FileInputConfig, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: FileInputConfig, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

class UsaFilePreviewDirective {
    el;
    file;
    uploadRequest;
    uploadError = new EventEmitter();
    imageElement;
    constructor(el) {
        this.el = el;
    }
    ngOnInit() {
        this.imageElement = this.el.nativeElement;
        this.imageElement.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
        this.imageElement.classList.add('is-loading');
        if (!this.uploadRequest) {
            this.removeLoading(this.file, this.imageElement);
            return;
        }
        this.uploadRequest(this.file).toPromise()
            .then(() => {
            this.removeLoading(this.file, this.imageElement);
        })
            .catch(() => {
            this.uploadError.emit(this.file);
            this.imageElement.classList.remove('is-loading');
            this.imageElement.src = '';
        });
    }
    removeLoading(file, imageElement) {
        const filePreviewClass = this._getFilePreviewClass(this.file.name);
        imageElement.classList.remove('is-loading');
        if (file.type.indexOf('image') > -1) {
            imageElement.src = URL.createObjectURL(file);
        }
        else {
            imageElement.classList.add(filePreviewClass);
        }
    }
    _getFilePreviewClass(fileName) {
        if (fileName.indexOf(".pdf") > 0) {
            return 'usa-file-input__preview-image--pdf';
        }
        else if (fileName.indexOf(".doc") > 0 ||
            fileName.indexOf(".pages") > 0) {
            return 'usa-file-input__preview-image--word';
        }
        else if (fileName.indexOf(".xls") > 0 ||
            fileName.indexOf(".numbers") > 0) {
            return 'usa-file-input__preview-image--excel';
        }
        else if (fileName.indexOf(".mov") > 0 || fileName.indexOf(".mp4") > 0) {
            return 'usa-file-input__preview-image--video';
        }
        else {
            return 'usa-file-input__preview-image--generic';
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaFilePreviewDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.2", type: UsaFilePreviewDirective, selector: "[usaFilePreview]", inputs: { file: "file", uploadRequest: "uploadRequest" }, outputs: { uploadError: "uploadError" }, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaFilePreviewDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: `[usaFilePreview]`
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { file: [{
                type: Input
            }], uploadRequest: [{
                type: Input
            }], uploadError: [{
                type: Output
            }] } });

class UsaFileInputComponent {
    fileInputConfig;
    fileInputElement;
    multiple = false;
    acceptFileType = '';
    id;
    hint;
    disabled;
    selectedFiles = [];
    clearFilesOnAdd;
    displayFileInfo;
    uploadRequest;
    selectedFilesChange = new EventEmitter();
    uploadError = new EventEmitter();
    DRAG_OVER_STATE = false;
    ERROR_STATE = false;
    inputFiles = [];
    // Save the callbacks, make sure to have a default so your app
    // doesn't crash when one isn't (yet) registered
    onChange = (v) => { };
    onTouched = () => { };
    constructor(fileInputConfig) {
        this.fileInputConfig = fileInputConfig;
        this.multiple = this.fileInputConfig.multiple;
        this.acceptFileType = this.fileInputConfig.acceptFileType;
        this.clearFilesOnAdd = this.fileInputConfig.clearFilesOnAdd;
        this.displayFileInfo = this.fileInputConfig.displayFileInfo;
        this.uploadRequest = this.fileInputConfig.uploadRequest;
    }
    onDragLeave() {
        this.DRAG_OVER_STATE = false;
    }
    onDragOver() {
        this.DRAG_OVER_STATE = true;
    }
    onFileDrop() {
        this.DRAG_OVER_STATE = false;
    }
    onNewFilesUpload($event) {
        const newFiles = Array.from($event.target.files);
        this.fileInputElement.nativeElement.value = null;
        if (newFiles.length === 0) {
            return;
        }
        // Validate new files match expected types
        let areValidFiles = this.validateFileType(newFiles);
        if (areValidFiles) {
            this.ERROR_STATE = false;
        }
        else {
            this.ERROR_STATE = true;
            this.selectedFiles = [];
            this.inputFiles = [];
            return;
        }
        // Clear current files OR append to existing based on user config
        if (!this.multiple || this.clearFilesOnAdd) {
            this.inputFiles = [];
            this.selectedFiles = newFiles;
        }
        else {
            this.selectedFiles = this.selectedFiles.concat(newFiles);
        }
        // Read file data and add laoding / preview states
        newFiles.forEach(file => {
            const imageId = this.getImageId(file, this.inputFiles);
            const inputFile = {
                isLoading: true, imageId, file
            };
            this.inputFiles.push(inputFile);
        });
        this.selectedFilesChange.emit(this.selectedFiles);
        // Notify Angular to update its model
        this.onChange(this.selectedFiles);
        this.onTouched();
    }
    removeFile(file) {
        const index = this.selectedFiles.indexOf(file);
        let inputFileIndex = -1;
        this.inputFiles.forEach((inputFile, index) => {
            if (inputFile.file === file) {
                inputFileIndex = index;
            }
        });
        if (index === -1 || inputFileIndex === -1) {
            return;
        }
        this.selectedFiles.splice(index, 1);
        this.selectedFilesChange.emit(this.selectedFiles);
        this.writeValue(this.selectedFiles);
        this.onChange(this.selectedFiles);
        this.onTouched();
    }
    clearFiles() {
        this.selectedFiles = [];
        this.selectedFilesChange.emit(this.selectedFiles);
        this.writeValue(this.selectedFiles);
        this.onChange(this.selectedFiles);
        this.onTouched();
    }
    onUploadError(file) {
        this.uploadError.emit(file);
    }
    trackLoadedFilesBy(index, item) {
        return item.imageId;
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    writeValue(files) {
        if (this.disabled || !files) {
            return;
        }
        let areValidFiles = this.validateFileType(files);
        if (areValidFiles) {
            this.ERROR_STATE = false;
        }
        else {
            this.ERROR_STATE = true;
            return;
        }
        this.inputFiles = [];
        this.selectedFiles = files;
        // Read file data and add laoding / preview states
        files.forEach(file => {
            const imageId = this.getImageId(file, this.inputFiles);
            const inputFile = {
                isLoading: true, imageId, file
            };
            this.inputFiles.push(inputFile);
        });
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    validateFileType(files) {
        if (!this.acceptFileType) {
            return true;
        }
        const acceptedFiles = this.acceptFileType.split(',');
        for (let i = 0; i < files.length; i++) {
            const isValidFileType = acceptedFiles.some(acceptedFileType => {
                const endsWithFileType = new RegExp(acceptedFileType + '$', 'i').test(files[i].name);
                return endsWithFileType || files[i].type.includes(acceptedFileType.replace(/\*/g, ""));
            });
            if (!isValidFileType) {
                return false;
            }
        }
        return true;
    }
    /**
     * Given a file and list of pre-uploaded files, generates and returns an id for the file.
     * If file already exists in pre-uploaded files list, then the id will simply be appended with
     * a counter to ensure uniqueness
     * @param file - File to generate id for
     * @param preExistingFiles - List of files that are uploaded and already have an id
     * @returns An id for the image
     */
    getImageId(file, preUploadedFiles) {
        let imageId = this._makeSafeForID(file.name);
        imageId = `a${imageId}`;
        let numExisting = 0;
        preUploadedFiles.forEach(file => {
            if (file.imageId === imageId) {
                numExisting++;
            }
        });
        if (numExisting > 0) {
            imageId = `${imageId}${numExisting}`;
        }
        return imageId;
    }
    /**
     * Creates an ID name for each file that strips all invalid characters.
     * @param {string} name - name of the file added to file input
     * @returns {string} same characters as the name with invalid chars removed
     */
    _makeSafeForID(name) {
        return name.replace(/[^a-z0-9]/g, function replaceName(s) {
            const c = s.charCodeAt(0);
            if (c === 32)
                return "-";
            if (c >= 65 && c <= 90)
                return `img_${s.toLowerCase()}`;
            return `__000${(c.toString(16)).slice(-4)}`;
        });
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaFileInputComponent, deps: [{ token: FileInputConfig }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.2", type: UsaFileInputComponent, selector: "usa-file-input", inputs: { multiple: "multiple", acceptFileType: "acceptFileType", id: "id", hint: "hint", disabled: "disabled", selectedFiles: "selectedFiles", clearFilesOnAdd: "clearFilesOnAdd", displayFileInfo: "displayFileInfo", uploadRequest: "uploadRequest" }, outputs: { selectedFilesChange: "selectedFilesChange", uploadError: "uploadError" }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => UsaFileInputComponent),
                multi: true,
            },
        ], viewQueries: [{ propertyName: "fileInputElement", first: true, predicate: ["fileInputEl"], descendants: true }], ngImport: i0, template: "<span class=\"usa-hint\" [attr.id]=\"id + '-hint'\">{{hint}}</span>\n<div class=\"usa-file-input grid-row\">\n  <div class=\"usa-file-input__target\" [ngClass]=\"{\n      'usa-file-input--drag': DRAG_OVER_STATE,\n      'has-invalid-file': ERROR_STATE\n    }\">\n    <ng-container *ngIf=\"displayFileInfo && (inputFiles && inputFiles.length); else selectFiles\">\n      <div class=\"usa-file-input__preview-heading\">\n        <ng-container *ngIf=\"inputFiles.length > 1; else singleFileSelected\">\n          {{inputFiles.length}} files selected\n          <span class=\"usa-file-input__choose\">Change files</span>\n        </ng-container>\n        <ng-template #singleFileSelected>\n          Selected file\n          <span class=\"usa-file-input__choose\">Change file</span>\n        </ng-template>\n      </div>\n      <div class=\"usa-file-input__preview\"\n        *ngFor=\"let inputFile of inputFiles; trackBy:trackLoadedFilesBy\">\n        <img usaFilePreview [attr.id]=\"inputFile.imageId\" [file]=\"inputFile.file\" [uploadRequest]=\"uploadRequest\" (uploadError)=\"onUploadError($event)\"\n          class=\"usa-file-input__preview-image \" />\n        {{inputFile.file.name}}\n      </div>\n    </ng-container>\n\n    <div class=\"usa-file-input__box\"></div>\n    <div *ngIf=\"ERROR_STATE === true\" class=\"usa-file-input__accepted-files-message\">This is not a valid file type.\n    </div>\n    <input #fileInputEl [attr.id]=\"id\" class=\"usa-file-input__input\" type=\"file\" [attr.name]=\"id\" [attr.files]=\"selectedFiles\"\n      [attr.aria-describedby]=\"id + '-hint'\" [attr.accept]=\"acceptFileType\"\n      [attr.multiple]=\"multiple ? multiple : undefined\" [disabled]=\"disabled\" (dragover)=\"onDragOver()\"\n      (dragleave)=\"onDragLeave()\" (drop)=\"onFileDrop()\" (change)=\"onNewFilesUpload($event)\">\n  </div>\n</div>\n\n<ng-template #selectFiles>\n  <div class=\"usa-file-input__instructions\">\n    <span class=\"usa-file-input__drag-text\">Drag file here or </span>\n    <span class=\"usa-file-input__choose\">choose from folder</span>\n  </div>\n</ng-template>\n", dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: UsaFilePreviewDirective, selector: "[usaFilePreview]", inputs: ["file", "uploadRequest"], outputs: ["uploadError"] }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaFileInputComponent, decorators: [{
            type: Component,
            args: [{ selector: 'usa-file-input', providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => UsaFileInputComponent),
                            multi: true,
                        },
                    ], template: "<span class=\"usa-hint\" [attr.id]=\"id + '-hint'\">{{hint}}</span>\n<div class=\"usa-file-input grid-row\">\n  <div class=\"usa-file-input__target\" [ngClass]=\"{\n      'usa-file-input--drag': DRAG_OVER_STATE,\n      'has-invalid-file': ERROR_STATE\n    }\">\n    <ng-container *ngIf=\"displayFileInfo && (inputFiles && inputFiles.length); else selectFiles\">\n      <div class=\"usa-file-input__preview-heading\">\n        <ng-container *ngIf=\"inputFiles.length > 1; else singleFileSelected\">\n          {{inputFiles.length}} files selected\n          <span class=\"usa-file-input__choose\">Change files</span>\n        </ng-container>\n        <ng-template #singleFileSelected>\n          Selected file\n          <span class=\"usa-file-input__choose\">Change file</span>\n        </ng-template>\n      </div>\n      <div class=\"usa-file-input__preview\"\n        *ngFor=\"let inputFile of inputFiles; trackBy:trackLoadedFilesBy\">\n        <img usaFilePreview [attr.id]=\"inputFile.imageId\" [file]=\"inputFile.file\" [uploadRequest]=\"uploadRequest\" (uploadError)=\"onUploadError($event)\"\n          class=\"usa-file-input__preview-image \" />\n        {{inputFile.file.name}}\n      </div>\n    </ng-container>\n\n    <div class=\"usa-file-input__box\"></div>\n    <div *ngIf=\"ERROR_STATE === true\" class=\"usa-file-input__accepted-files-message\">This is not a valid file type.\n    </div>\n    <input #fileInputEl [attr.id]=\"id\" class=\"usa-file-input__input\" type=\"file\" [attr.name]=\"id\" [attr.files]=\"selectedFiles\"\n      [attr.aria-describedby]=\"id + '-hint'\" [attr.accept]=\"acceptFileType\"\n      [attr.multiple]=\"multiple ? multiple : undefined\" [disabled]=\"disabled\" (dragover)=\"onDragOver()\"\n      (dragleave)=\"onDragLeave()\" (drop)=\"onFileDrop()\" (change)=\"onNewFilesUpload($event)\">\n  </div>\n</div>\n\n<ng-template #selectFiles>\n  <div class=\"usa-file-input__instructions\">\n    <span class=\"usa-file-input__drag-text\">Drag file here or </span>\n    <span class=\"usa-file-input__choose\">choose from folder</span>\n  </div>\n</ng-template>\n" }]
        }], ctorParameters: () => [{ type: FileInputConfig }], propDecorators: { fileInputElement: [{
                type: ViewChild,
                args: ['fileInputEl']
            }], multiple: [{
                type: Input
            }], acceptFileType: [{
                type: Input
            }], id: [{
                type: Input
            }], hint: [{
                type: Input
            }], disabled: [{
                type: Input
            }], selectedFiles: [{
                type: Input
            }], clearFilesOnAdd: [{
                type: Input
            }], displayFileInfo: [{
                type: Input
            }], uploadRequest: [{
                type: Input
            }], selectedFilesChange: [{
                type: Output
            }], uploadError: [{
                type: Output
            }] } });

class UsaFileInputModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaFileInputModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.2", ngImport: i0, type: UsaFileInputModule, declarations: [UsaFileInputComponent,
            UsaFilePreviewDirective], imports: [CommonModule,
            ReactiveFormsModule], exports: [UsaFileInputComponent,
            UsaFilePreviewDirective] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaFileInputModule, providers: [
            FileInputConfig
        ], imports: [CommonModule,
            ReactiveFormsModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaFileInputModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                    ],
                    declarations: [
                        UsaFileInputComponent,
                        UsaFilePreviewDirective,
                    ],
                    exports: [
                        UsaFileInputComponent,
                        UsaFilePreviewDirective
                    ],
                    providers: [
                        FileInputConfig
                    ]
                }]
        }] });

var ModalDismissReasons;
(function (ModalDismissReasons) {
    ModalDismissReasons[ModalDismissReasons["BACKDROP_CLICK"] = 0] = "BACKDROP_CLICK";
    ModalDismissReasons[ModalDismissReasons["CLOSE_CLICKED"] = 1] = "CLOSE_CLICKED";
    ModalDismissReasons[ModalDismissReasons["ESC"] = 2] = "ESC";
})(ModalDismissReasons || (ModalDismissReasons = {}));

/**
 * A reference to the currently opened (active) modal.
 *
 * Instances of this class can be injected into your component passed as modal content.
 * So you can `.close()` or `.dismiss()` the modal window from your component.
 */
class UsaActiveModal {
    /**
     * Closes the modal with an optional `result` value.
     *
     * The `UsaModalRef.result` promise will be resolved with the provided value.
     */
    close(result) { }
    /**
     * Dismisses the modal with an optional `reason` value.
     *
     * The `UsaModalRef.result` promise will be rejected with the provided value.
     */
    dismiss(reason) { }
}
/**
 * A reference to the newly opened modal returned by the `UsaModal.open()` method.
 */
class UsaModalRef {
    _windowCmptRef;
    _contentRef;
    _backdropCmptRef;
    _beforeDismiss;
    _closed = new Subject();
    _dismissed = new Subject();
    _hidden = new Subject();
    _resolve;
    _reject;
    /**
     * The instance of a component used for the modal content.
     *
     * When a `TemplateRef` is used as the content or when the modal is closed, will return `undefined`.
     */
    get componentInstance() {
        if (this._contentRef && this._contentRef.componentRef) {
            return this._contentRef.componentRef.instance;
        }
    }
    /**
     * The promise that is resolved when the modal is closed and rejected when the modal is dismissed.
     */
    result;
    /**
     * The observable that emits when the modal is closed via the `.close()` method.
     *
     * It will emit the result passed to the `.close()` method.
     *
     * @since 8.0.0
     */
    get closed() { return this._closed.asObservable().pipe(takeUntil(this._hidden)); }
    /**
     * The observable that emits when the modal is dismissed via the `.dismiss()` method.
     *
     * It will emit the reason passed to the `.dismissed()` method by the user, or one of the internal
     * reasons like backdrop click or ESC key press.
     *
     * @since 8.0.0
     */
    get dismissed() { return this._dismissed.asObservable().pipe(takeUntil(this._hidden)); }
    /**
     * The observable that emits when both modal window and backdrop are closed and animations were finished.
     * At this point modal and backdrop elements will be removed from the DOM tree.
     *
     * This observable will be completed after emitting.
     *
     * @since 8.0.0
     */
    get hidden() { return this._hidden.asObservable(); }
    /**
     * The observable that emits when modal is fully visible and animation was finished.
     * Modal DOM element is always available synchronously after calling 'modal.open()' service.
     *
     * This observable will be completed after emitting.
     * It will not emit, if modal is closed before open animation is finished.
     *
     * @since 8.0.0
     */
    get shown() { return this._windowCmptRef.instance.shown.asObservable(); }
    constructor(_windowCmptRef, _contentRef, _backdropCmptRef, _beforeDismiss) {
        this._windowCmptRef = _windowCmptRef;
        this._contentRef = _contentRef;
        this._backdropCmptRef = _backdropCmptRef;
        this._beforeDismiss = _beforeDismiss;
        _windowCmptRef.instance.dismissEvent.subscribe((reason) => { this.dismiss(reason); });
        this.result = new Promise((resolve, reject) => {
            this._resolve = resolve;
            this._reject = reject;
        });
        this.result.then(null, () => { });
    }
    /**
     * Closes the modal with an optional `result` value.
     *
     * The `UsaMobalRef.result` promise will be resolved with the provided value.
     */
    close(result) {
        if (this._windowCmptRef) {
            this._closed.next(result);
            this._resolve(result);
            this._removeModalElements();
        }
    }
    _dismiss(reason) {
        this._dismissed.next(reason);
        this._reject(reason);
        this._removeModalElements();
    }
    /**
     * Dismisses the modal with an optional `reason` value.
     *
     * The `UsaModalRef.result` promise will be rejected with the provided value.
     */
    dismiss(reason) {
        if (this._windowCmptRef) {
            if (!this._beforeDismiss) {
                this._dismiss(reason);
            }
            else {
                const dismiss = this._beforeDismiss();
                if (dismiss && dismiss.then) {
                    dismiss.then(result => {
                        if (result !== false) {
                            this._dismiss(reason);
                        }
                    }, () => { });
                }
                else if (dismiss !== false) {
                    this._dismiss(reason);
                }
            }
        }
    }
    _removeModalElements() {
        this._windowCmptRef.instance.hide().subscribe(() => {
            if (this._backdropCmptRef) {
                const { nativeElement } = this._backdropCmptRef.location;
                nativeElement.parentNode.removeChild(nativeElement);
                this._backdropCmptRef.destroy();
                this._backdropCmptRef = null;
            }
            const nativeElement = this._windowCmptRef.location.nativeElement;
            nativeElement.parentNode.removeChild(nativeElement);
            this._windowCmptRef.destroy();
            if (this._contentRef && this._contentRef.viewRef) {
                this._contentRef.viewRef.destroy();
            }
            this._windowCmptRef = null;
            this._contentRef = null;
            this._hidden.next();
            this._hidden.complete();
        });
    }
}

const FOCUSABLE_ELEMENTS_SELECTOR = [
    'a[href]', 'button:not([disabled])', 'input:not([disabled]):not([type="hidden"])', 'select:not([disabled])',
    'textarea:not([disabled])', '[contenteditable]', '[tabindex]:not([tabindex="-1"])'
].join(', ');
/**
 * Returns first and last focusable elements inside of a given element based on specific CSS selector
 */
function getFocusableBoundaryElements(element) {
    const list = Array.from(element.querySelectorAll(FOCUSABLE_ELEMENTS_SELECTOR))
        .filter(el => el.tabIndex !== -1);
    return [list[0], list[list.length - 1]];
}
/**
 * Function that enforces browser focus to be trapped inside a DOM element.
 *
 * Works only for clicks inside the element and navigation with 'Tab', ignoring clicks outside of the element
 *
 * @param zone Angular zone
 * @param element The element around which focus will be trapped inside
 * @param stopFocusTrap$ The observable stream. When completed the focus trap will clean up listeners
 * and free internal resources
 * @param refocusOnClick Put the focus back to the last focused element whenever a click occurs on element (default to
 * false)
 */
const usaFocusTrap = (zone, element, stopFocusTrap$, refocusOnClick = false) => {
    zone.runOutsideAngular(() => {
        // last focused element
        const lastFocusedElement$ = fromEvent(element, 'focusin').pipe(takeUntil(stopFocusTrap$), map(e => e.target));
        // 'tab' / 'shift+tab' stream
        fromEvent(element, 'keydown')
            .pipe(takeUntil(stopFocusTrap$), 
        // tslint:disable:deprecation
        filter(e => e.key === Key.Tab || e.key === MicrosfotKeys.Tab || e.which === KeyCode.Tab), 
        // tslint:enable:deprecation
        withLatestFrom(lastFocusedElement$))
            .subscribe(([tabEvent, focusedElement]) => {
            const [first, last] = getFocusableBoundaryElements(element);
            if ((focusedElement === first || focusedElement === element) && tabEvent.shiftKey) {
                last.focus();
                tabEvent.preventDefault();
            }
            if (focusedElement === last && !tabEvent.shiftKey) {
                first.focus();
                tabEvent.preventDefault();
            }
        });
        // inside click
        if (refocusOnClick) {
            fromEvent(element, 'click')
                .pipe(takeUntil(stopFocusTrap$), withLatestFrom(lastFocusedElement$), map(arr => arr[1]))
                .subscribe(lastFocusedElement => lastFocusedElement.focus());
        }
    });
};

function getTransitionDurationMs(element) {
    const { transitionDelay, transitionDuration } = window.getComputedStyle(element);
    const transitionDelaySec = parseFloat(transitionDelay);
    const transitionDurationSec = parseFloat(transitionDuration);
    return (transitionDelaySec + transitionDurationSec) * 1000;
}

const environment = {
    transitionTimerDelayMs: 5,
};

const noopFn = () => { };
const { transitionTimerDelayMs } = environment;
const runningTransitions = new Map();
const usaRunTransition = (zone, element, startFn, options) => {
    // Getting initial context from options
    let context = options.context || {};
    // Checking if there are already running transitions on the given element.
    const running = runningTransitions.get(element);
    if (running) {
        switch (options.runningTransition) {
            // If there is one running and we want for it to 'continue' to run, we have to cancel the new one.
            // We're not emitting any values, but simply completing the observable (EMPTY).
            case 'continue':
                return EMPTY;
            // If there is one running and we want for it to 'stop', we have to complete the running one.
            // We're simply completing the running one and not emitting any values and merging newly provided context
            // with the one coming from currently running transition.
            case 'stop':
                zone.run(() => running.transition$.complete());
                context = Object.assign(running.context, context);
                runningTransitions.delete(element);
        }
    }
    // Running the start function
    const endFn = startFn(element, options.animation, context) || noopFn;
    // If 'prefer-reduced-motion' is enabled, the 'transition' will be set to 'none'.
    // If animations are disabled, we have to emit a value and complete the observable
    // In this case we have to call the end function, but can finish immediately by emitting a value,
    // completing the observable and executing end functions synchronously.
    if (!options.animation || window.getComputedStyle(element).transitionProperty === 'none') {
        zone.run(() => endFn());
        return of(undefined).pipe(runInZone(zone));
    }
    // Starting a new transition
    const transition$ = new Subject();
    const finishTransition$ = new Subject();
    const stop$ = transition$.pipe(endWith(true));
    runningTransitions.set(element, {
        transition$,
        complete: () => {
            finishTransition$.next();
            finishTransition$.complete();
        },
        context
    });
    const transitionDurationMs = getTransitionDurationMs(element);
    // 1. We have to both listen for the 'transitionend' event and have a 'just-in-case' timer,
    // because 'transitionend' event might not be fired in some browsers, if the transitioning
    // element becomes invisible (ex. when scrolling, making browser tab inactive, etc.). The timer
    // guarantees, that we'll release the DOM element and complete 'usaRunTransition'.
    // 2. We need to filter transition end events, because they might bubble from shorter transitions
    // on inner DOM elements. We're only interested in the transition on the 'element' itself.
    zone.runOutsideAngular(() => {
        const transitionEnd$ = fromEvent(element, 'transitionend').pipe(takeUntil(stop$), filter(({ target }) => target === element));
        const timer$ = timer(transitionDurationMs + transitionTimerDelayMs).pipe(takeUntil(stop$));
        race(timer$, transitionEnd$, finishTransition$).pipe(takeUntil(stop$)).subscribe(() => {
            runningTransitions.delete(element);
            zone.run(() => {
                endFn();
                transition$.next();
                transition$.complete();
            });
        });
    });
    return transition$.asObservable();
};
const usaCompleteTransition = (element) => {
    runningTransitions.get(element)?.complete();
};

class ContentRef {
    nodes;
    viewRef;
    componentRef;
    constructor(nodes, viewRef, componentRef) {
        this.nodes = nodes;
        this.viewRef = viewRef;
        this.componentRef = componentRef;
    }
}
class PopupService {
    _type;
    _injector;
    _viewContainerRef;
    _renderer;
    _ngZone;
    _componentFactoryResolver;
    _applicationRef;
    _windowRef = null;
    _contentRef = null;
    constructor(_type, _injector, _viewContainerRef, _renderer, _ngZone, _componentFactoryResolver, _applicationRef) {
        this._type = _type;
        this._injector = _injector;
        this._viewContainerRef = _viewContainerRef;
        this._renderer = _renderer;
        this._ngZone = _ngZone;
        this._componentFactoryResolver = _componentFactoryResolver;
        this._applicationRef = _applicationRef;
    }
    open(content, context, animation = false) {
        if (!this._windowRef) {
            this._contentRef = this._getContentRef(content, context);
            this._windowRef = this._viewContainerRef.createComponent(this._componentFactoryResolver.resolveComponentFactory(this._type), this._viewContainerRef.length, this._injector, this._contentRef.nodes);
        }
        const { nativeElement } = this._windowRef.location;
        const transition$ = this._ngZone.onStable.pipe(take(1), mergeMap(() => usaRunTransition(this._ngZone, nativeElement, ({ classList }) => classList.add('show'), { animation, runningTransition: 'continue' })));
        return { windowRef: this._windowRef, transition$ };
    }
    close(animation = false) {
        if (!this._windowRef) {
            return of(undefined);
        }
        return usaRunTransition(this._ngZone, this._windowRef.location.nativeElement, ({ classList }) => classList.remove('show'), { animation, runningTransition: 'stop' })
            .pipe(tap(() => {
            if (this._windowRef) {
                // this is required because of the container='body' option
                this._viewContainerRef.remove(this._viewContainerRef.indexOf(this._windowRef.hostView));
                this._windowRef = null;
            }
            if (this._contentRef?.viewRef) {
                this._applicationRef.detachView(this._contentRef.viewRef);
                this._contentRef.viewRef.destroy();
                this._contentRef = null;
            }
        }));
    }
    _getContentRef(content, context) {
        if (!content) {
            return new ContentRef([]);
        }
        else if (content instanceof TemplateRef) {
            const viewRef = content.createEmbeddedView(context);
            this._applicationRef.attachView(viewRef);
            return new ContentRef([viewRef.rootNodes], viewRef);
        }
        else {
            return new ContentRef([[this._renderer.createText(`${content}`)]]);
        }
    }
}

class UsaModalWrapper {
    _el;
    constructor(_el) {
        this._el = _el;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaModalWrapper, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.2", type: UsaModalWrapper, selector: "usa-modal-wrapper", host: { styleAttribute: "z-index: 1050", classAttribute: "usa-modal-wrapper" }, ngImport: i0, template: `
    <div class="usa-modal-overlay"></div>
  `, isInline: true, encapsulation: i0.ViewEncapsulation.None });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaModalWrapper, decorators: [{
            type: Component,
            args: [{
                    selector: 'usa-modal-wrapper',
                    encapsulation: ViewEncapsulation.None,
                    template: `
    <div class="usa-modal-overlay"></div>
  `,
                    host: {
                        'class': 'usa-modal-wrapper',
                        'style': 'z-index: 1050'
                    }
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }] });

const animationBody = [
    transition('* => enter', [
        style({ opacity: 0, transform: 'scale(0.7)' }),
        animate('150ms cubic-bezier(0, 0, 0.2, 1)', style({ transform: 'none', opacity: 1 }))
    ]),
    transition('* => slideEnter', [
        style({ right: '-15rem' }),
        animate('150ms', style({ right: '0rem' }))
    ]),
    transition('* => void, * => exit', [
        style({ transform: 'none' }),
        animate('75ms cubic-bezier(0.4, 0.0, 0.2, 1)', style({ opacity: 0 }))
    ]),
    transition('* => slideExit', [
        style({ right: '0rem' }),
        animate('150ms', style({ right: '-15rem' }))
    ]),
];
/**
 * Animations used by SdsDialog.
 * @docs-private
 */
const usaDialogAnimations = {
    /** Animation that is applied on the dialog container by defalt. */
    dialogContainer: trigger('dialogContainer', animationBody)
};

let nextId$4 = 0;
class UsaModalWindow {
    _document;
    _elRef;
    _zone;
    _closed$ = new Subject();
    _elWithFocus = null; // element that is focused prior to modal opening
    /** State of the dialog animation. */
    _state;
    _dialogEl;
    animation;
    ariaLabelledBy;
    ariaDescribedBy;
    backdrop = true;
    keyboard = true;
    size;
    modalDialogClass;
    overlayElement;
    showClose = true;
    id = `usa-modal-${nextId$4++}`;
    dismissEvent = new EventEmitter();
    shown = new Subject();
    hidden = new Subject();
    _animationStateChanged = new Subject();
    constructor(_document, _elRef, _zone) {
        this._document = _document;
        this._elRef = _elRef;
        this._zone = _zone;
    }
    dismiss(reason) { this.dismissEvent.emit(reason); }
    ngOnInit() {
        this._elWithFocus = this._document.activeElement;
        this._state = this.animation ? 'slideEnter' : 'enter';
    }
    ngAfterViewInit() { this._show(); }
    ngOnDestroy() { this._disableEventHandling(); }
    hide() {
        const exitAnimation$ = this._startExitAnimation();
        exitAnimation$.subscribe(() => {
            this.hidden.next();
            this.hidden.complete();
        });
        this._disableEventHandling();
        this._restoreFocus();
        return exitAnimation$;
    }
    onCloseClicked() {
        this.dismiss(ModalDismissReasons.CLOSE_CLICKED);
    }
    _show() {
        this._enableEventHandling();
        this._setFocus();
    }
    _enableEventHandling() {
        const { nativeElement } = this._elRef;
        this._zone.runOutsideAngular(() => {
            fromEvent(nativeElement, 'keydown')
                .pipe(takeUntil(this._closed$), filter(e => e.key === Key.Escape || e.key === MicrosfotKeys.Escape || e.which === KeyCode.Escape))
                .subscribe(event => {
                if (this.keyboard) {
                    requestAnimationFrame(() => {
                        if (!event.defaultPrevented) {
                            this._zone.run(() => this.dismiss(ModalDismissReasons.ESC));
                        }
                    });
                }
            });
            let preventClose = false;
            fromEvent(this._dialogEl.nativeElement, 'mousedown')
                .pipe(takeUntil(this._closed$), tap(() => preventClose = false), switchMap(() => fromEvent(nativeElement, 'mouseup').pipe(takeUntil(this._closed$), take(1))), filter(({ target }) => nativeElement === target))
                .subscribe(() => { preventClose = true; });
            fromEvent(this.overlayElement, 'click').pipe(takeUntil(this._closed$)).subscribe(({ target }) => {
                if (this.overlayElement === target) {
                    if (this.backdrop === true && !preventClose) {
                        this._zone.run(() => this.dismiss(ModalDismissReasons.BACKDROP_CLICK));
                    }
                }
                preventClose = false;
            });
        });
    }
    _disableEventHandling() { this._closed$.next(); }
    _setFocus() {
        const { nativeElement } = this._elRef;
        if (!nativeElement.contains(document.activeElement)) {
            const autoFocusable = nativeElement.querySelector(`[usaAutofocus]`);
            const firstFocusable = getFocusableBoundaryElements(nativeElement)[0];
            const elementToFocus = autoFocusable || firstFocusable || nativeElement;
            elementToFocus.focus();
        }
    }
    _restoreFocus() {
        const body = this._document.body;
        const elWithFocus = this._elWithFocus;
        let elementToFocus;
        if (elWithFocus && elWithFocus['focus'] && body.contains(elWithFocus)) {
            elementToFocus = elWithFocus;
        }
        else {
            elementToFocus = body;
        }
        this._zone.runOutsideAngular(() => {
            setTimeout(() => elementToFocus.focus());
            this._elWithFocus = null;
        });
    }
    _startExitAnimation() {
        this._state = this.animation ? 'slideExit' : 'exit';
        return this._animationStateChanged.asObservable();
    }
    /** Callback, invoked whenever an animation on the host completes. */
    _onAnimationDone(event) {
        if (event.toState === 'exit' || event.toState === 'slideExit') {
            this._animationStateChanged.next();
            this._animationStateChanged.complete();
        }
        if (event.toState === 'enter' || event.toState === 'slideEnter') {
            this.shown.next();
            this.shown.complete();
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaModalWindow, deps: [{ token: DOCUMENT }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.2", type: UsaModalWindow, selector: "usa-modal-window", inputs: { animation: "animation", ariaLabelledBy: "ariaLabelledBy", ariaDescribedBy: "ariaDescribedBy", backdrop: "backdrop", keyboard: "keyboard", size: "size", modalDialogClass: "modalDialogClass", overlayElement: "overlayElement", showClose: "showClose", id: "id" }, outputs: { dismissEvent: "dismiss" }, host: { attributes: { "role": "dialog", "tabindex": "-1" }, listeners: { "@dialogContainer.done": "_onAnimationDone($event)" }, properties: { "class": "\"usa-modal\" + (modalDialogClass ? \" \" + modalDialogClass : \"\")", "class.usa-modal--lg": "size === 'lg'", "attr.id": "id", "attr.aria-modal": "true", "attr.aria-labelledby": "ariaLabelledBy", "attr.aria-describedby": "ariaDescribedBy", "@.disabled": "!animation", "@dialogContainer": "_state" } }, viewQueries: [{ propertyName: "_dialogEl", first: true, predicate: ["dialog"], descendants: true, static: true }], ngImport: i0, template: `
    <div #dialog class="usa-modal__content">
      <div class="usa-modal__main">
        <ng-content></ng-content>
      </div>

      <button *ngIf="showClose" class="usa-button usa-modal__close" aria-label="Close this window" (click)="onCloseClicked()">
        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24" class="usa-icon">
          <path d="M0 0h24v24H0z" fill="none"/>
          <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
        </svg>
      </button>
    </div>
    `, isInline: true, dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], animations: [usaDialogAnimations.dialogContainer], encapsulation: i0.ViewEncapsulation.None });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaModalWindow, decorators: [{
            type: Component,
            args: [{
                    selector: 'usa-modal-window',
                    animations: [usaDialogAnimations.dialogContainer],
                    host: {
                        '[class]': '"usa-modal" + (modalDialogClass ? " " + modalDialogClass : "")',
                        '[class.usa-modal--lg]': 'size === \'lg\'',
                        'role': 'dialog',
                        'tabindex': '-1',
                        '[attr.id]': 'id',
                        '[attr.aria-modal]': 'true',
                        '[attr.aria-labelledby]': 'ariaLabelledBy',
                        '[attr.aria-describedby]': 'ariaDescribedBy',
                        '[@.disabled]': '!animation',
                        '[@dialogContainer]': '_state',
                        '(@dialogContainer.done)': '_onAnimationDone($event)',
                    },
                    template: `
    <div #dialog class="usa-modal__content">
      <div class="usa-modal__main">
        <ng-content></ng-content>
      </div>

      <button *ngIf="showClose" class="usa-button usa-modal__close" aria-label="Close this window" (click)="onCloseClicked()">
        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24" class="usa-icon">
          <path d="M0 0h24v24H0z" fill="none"/>
          <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
        </svg>
      </button>
    </div>
    `,
                    encapsulation: ViewEncapsulation.None,
                }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: i0.ElementRef }, { type: i0.NgZone }], propDecorators: { _dialogEl: [{
                type: ViewChild,
                args: ['dialog', { static: true }]
            }], animation: [{
                type: Input
            }], ariaLabelledBy: [{
                type: Input
            }], ariaDescribedBy: [{
                type: Input
            }], backdrop: [{
                type: Input
            }], keyboard: [{
                type: Input
            }], size: [{
                type: Input
            }], modalDialogClass: [{
                type: Input
            }], overlayElement: [{
                type: Input
            }], showClose: [{
                type: Input
            }], id: [{
                type: Input
            }], dismissEvent: [{
                type: Output,
                args: ['dismiss']
            }] } });

const noop = () => { };
/**
 * Utility to handle the scrollbar.
 *
 * It allows to compensate the lack of a vertical scrollbar by adding an
 * equivalent padding on the right of the body, and to remove this compensation.
 */
class ScrollBar {
    _document;
    constructor(_document) {
        this._document = _document;
    }
    /**
     * To be called right before a potential vertical scrollbar would be removed:
     *
     * - if there was a scrollbar, adds some compensation padding to the body
     * to keep the same layout as when the scrollbar is there
     * - if there was none, there is nothing to do
     *
     * @return a callback used to revert the compensation (noop if there was none,
     * otherwise a function removing the padding)
     */
    compensate() {
        const width = this._getWidth();
        return !this._isPresent(width) ? noop : this._adjustBody(width);
    }
    /**
     * Adds a padding of the given width on the right of the body.
     *
     * @return a callback used to revert the padding to its previous value
     */
    _adjustBody(scrollbarWidth) {
        const body = this._document.body;
        const userSetPaddingStyle = body.style.paddingRight;
        const actualPadding = parseFloat(window.getComputedStyle(body)['padding-right']);
        body.style['padding-right'] = `${actualPadding + scrollbarWidth}px`;
        return () => body.style['padding-right'] = userSetPaddingStyle;
    }
    /**
     * Tells whether a scrollbar is currently present on the body.
     *
     * @return true if scrollbar is present, false otherwise
     */
    _isPresent(scrollbarWidth) {
        const rect = this._document.body.getBoundingClientRect();
        const bodyToViewportGap = window.innerWidth - (rect.left + rect.right);
        const uncertainty = 0.1 * scrollbarWidth;
        return bodyToViewportGap >= scrollbarWidth - uncertainty;
    }
    /**
     * Calculates and returns the width of a scrollbar.
     *
     * @return the width of a scrollbar on this page
     */
    _getWidth() {
        const measurer = this._document.createElement('div');
        measurer.className = 'modal-scrollbar-measure';
        const body = this._document.body;
        body.appendChild(measurer);
        const width = measurer.getBoundingClientRect().width - measurer.clientWidth;
        body.removeChild(measurer);
        return width;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: ScrollBar, deps: [{ token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: ScrollBar, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: ScrollBar, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }] });

class UsaModalStack {
    _applicationRef;
    _injector;
    _document;
    _scrollBar;
    _rendererFactory;
    _ngZone;
    _activeWindowCmptHasChanged = new Subject();
    _ariaHiddenValues = new Map();
    _modalRefs = [];
    _windowAttributes = [
        'animation', 'ariaLabelledBy', 'ariaDescribedBy', 'backdrop', 'keyboard', 'size',
        'modalDialogClass', 'overlayElement', 'showClose', 'id'
    ];
    _windowCmpts = [];
    _activeInstances = new EventEmitter();
    constructor(_applicationRef, _injector, _document, _scrollBar, _rendererFactory, _ngZone) {
        this._applicationRef = _applicationRef;
        this._injector = _injector;
        this._document = _document;
        this._scrollBar = _scrollBar;
        this._rendererFactory = _rendererFactory;
        this._ngZone = _ngZone;
        // Trap focus on active WindowCmpt
        this._activeWindowCmptHasChanged.subscribe(() => {
            if (this._windowCmpts.length) {
                const activeWindowCmpt = this._windowCmpts[this._windowCmpts.length - 1];
                usaFocusTrap(this._ngZone, activeWindowCmpt.location.nativeElement, this._activeWindowCmptHasChanged);
                this._revertAriaHidden();
                this._setAriaHidden(activeWindowCmpt.location.nativeElement);
            }
        });
    }
    open(moduleCFR, contentInjector, content, options) {
        const renderer = this._rendererFactory.createRenderer(null, null);
        let containerEl = this._document.body;
        const revertPaddingForScrollBar = this._scrollBar.compensate();
        const removeBodyClass = () => {
            if (!this._modalRefs.length) {
                renderer.removeClass(this._document.body, 'usa-js-modal--active');
                this._revertAriaHidden();
            }
        };
        const activeModal = new UsaActiveModal();
        const contentRef = this._getContentRef(moduleCFR, options.injector || contentInjector, content, activeModal);
        let backdropCmptRef = this._attachBackdrop(moduleCFR, containerEl);
        const overlayRef = backdropCmptRef.instance._el.nativeElement.querySelector('.usa-modal-overlay');
        let windowCmptRef = this._attachWindowComponent(moduleCFR, overlayRef, contentRef);
        let usaModalRef = new UsaModalRef(windowCmptRef, contentRef, backdropCmptRef, options.beforeDismiss);
        this._registerModalRef(usaModalRef);
        this._registerWindowCmpt(windowCmptRef);
        usaModalRef.result.then(revertPaddingForScrollBar, revertPaddingForScrollBar);
        usaModalRef.result.then(removeBodyClass, removeBodyClass);
        activeModal.close = (result) => { usaModalRef.close(result); };
        activeModal.dismiss = (reason) => { usaModalRef.dismiss(reason); };
        this._applyWindowOptions(windowCmptRef.instance, options);
        if (this._modalRefs.length === 1) {
            renderer.addClass(this._document.body, 'usa-js-modal--active');
        }
        return usaModalRef;
    }
    get activeInstances() { return this._activeInstances; }
    dismissAll(reason) { this._modalRefs.forEach(usaModalRef => usaModalRef.dismiss(reason)); }
    hasOpenModals() { return this._modalRefs.length > 0; }
    _attachBackdrop(moduleCFR, containerEl) {
        let backdropFactory = moduleCFR.resolveComponentFactory(UsaModalWrapper);
        let backdropCmptRef = backdropFactory.create(this._injector);
        this._applicationRef.attachView(backdropCmptRef.hostView);
        containerEl.appendChild(backdropCmptRef.location.nativeElement);
        return backdropCmptRef;
    }
    _attachWindowComponent(moduleCFR, containerEl, contentRef) {
        let windowFactory = moduleCFR.resolveComponentFactory(UsaModalWindow);
        let windowCmptRef = windowFactory.create(this._injector, contentRef.nodes);
        windowCmptRef.instance.overlayElement = containerEl;
        this._applicationRef.attachView(windowCmptRef.hostView);
        containerEl.appendChild(windowCmptRef.location.nativeElement);
        return windowCmptRef;
    }
    _applyWindowOptions(windowInstance, options) {
        this._windowAttributes.forEach((optionName) => {
            if (isDefined(options[optionName])) {
                windowInstance[optionName] = options[optionName];
            }
        });
    }
    _getContentRef(moduleCFR, contentInjector, content, activeModal) {
        if (!content) {
            return new ContentRef([]);
        }
        else if (content instanceof TemplateRef) {
            return this._createFromTemplateRef(content, activeModal);
        }
        else if (isString(content)) {
            return this._createFromString(content);
        }
        else {
            return this._createFromComponent(moduleCFR, contentInjector, content, activeModal);
        }
    }
    _createFromTemplateRef(content, activeModal) {
        const context = {
            $implicit: activeModal,
            close(result) { activeModal.close(result); },
            dismiss(reason) { activeModal.dismiss(reason); }
        };
        const viewRef = content.createEmbeddedView(context);
        this._applicationRef.attachView(viewRef);
        return new ContentRef([viewRef.rootNodes], viewRef);
    }
    _createFromString(content) {
        const component = this._document.createTextNode(`${content}`);
        return new ContentRef([[component]]);
    }
    _createFromComponent(moduleCFR, contentInjector, content, context) {
        const contentCmptFactory = moduleCFR.resolveComponentFactory(content);
        const modalContentInjector = Injector.create({ providers: [{ provide: UsaActiveModal, useValue: context }], parent: contentInjector });
        const componentRef = contentCmptFactory.create(modalContentInjector);
        const componentNativeEl = componentRef.location.nativeElement;
        this._applicationRef.attachView(componentRef.hostView);
        // FIXME: we should here get rid of the component nativeElement
        // and use `[Array.from(componentNativeEl.childNodes)]` instead and remove the above CSS class.
        return new ContentRef([[componentNativeEl]], componentRef.hostView, componentRef);
    }
    _setAriaHidden(element) {
        const parent = element.parentElement;
        if (parent && element !== this._document.body) {
            Array.from(parent.children).forEach(sibling => {
                if (sibling !== element && sibling.nodeName !== 'SCRIPT') {
                    this._ariaHiddenValues.set(sibling, sibling.getAttribute('aria-hidden'));
                    sibling.setAttribute('aria-hidden', 'true');
                }
            });
            this._setAriaHidden(parent);
        }
    }
    _revertAriaHidden() {
        this._ariaHiddenValues.forEach((value, element) => {
            if (value) {
                element.setAttribute('aria-hidden', value);
            }
            else {
                element.removeAttribute('aria-hidden');
            }
        });
        this._ariaHiddenValues.clear();
    }
    _registerModalRef(usaModalRef) {
        const unregisterModalRef = () => {
            const index = this._modalRefs.indexOf(usaModalRef);
            if (index > -1) {
                this._modalRefs.splice(index, 1);
                this._activeInstances.emit(this._modalRefs);
            }
        };
        this._modalRefs.push(usaModalRef);
        this._activeInstances.emit(this._modalRefs);
        usaModalRef.result.then(unregisterModalRef, unregisterModalRef);
    }
    _registerWindowCmpt(usaWindowCmpt) {
        this._windowCmpts.push(usaWindowCmpt);
        this._activeWindowCmptHasChanged.next();
        usaWindowCmpt.onDestroy(() => {
            const index = this._windowCmpts.indexOf(usaWindowCmpt);
            if (index > -1) {
                this._windowCmpts.splice(index, 1);
                this._activeWindowCmptHasChanged.next();
            }
        });
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaModalStack, deps: [{ token: i0.ApplicationRef }, { token: i0.Injector }, { token: DOCUMENT }, { token: ScrollBar }, { token: i0.RendererFactory2 }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaModalStack, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaModalStack, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: i0.ApplicationRef }, { type: i0.Injector }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: ScrollBar }, { type: i0.RendererFactory2 }, { type: i0.NgZone }] });

/**
 *
 * You can inject this service, typically in your root component, and customize the values of its properties in
 * order to provide default values for all modals used in the application.
*
* @since 3.1.0
*/
class UsaModalConfig {
    ariaLabelledBy;
    ariaDescribedBy;
    backdrop = true;
    beforeDismiss;
    injector;
    keyboard = true;
    size;
    modalDialogClass;
    showClose = true;
    animation = true;
    id;
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaModalConfig, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaModalConfig, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaModalConfig, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

/**
 * A service for opening modal windows.
 *
 * Creating a modal is straightforward: create a component or a template and pass it as an argument to
 * the `.open()` method.
 */
class UsaModalService {
    _moduleCFR;
    _injector;
    _modalStack;
    _config;
    constructor(_moduleCFR, _injector, _modalStack, _config) {
        this._moduleCFR = _moduleCFR;
        this._injector = _injector;
        this._modalStack = _modalStack;
        this._config = _config;
    }
    /**
     * Opens a new modal window with the specified content and supplied options.
     *
     * Content can be provided as a `TemplateRef` or a component type. If you pass a component type as content,
     * then instances of those components can be injected with an instance of the `UsaActiveModal` class. You can then
     * use `UsaActiveModal` methods to close / dismiss modals from "inside" of your component.
     */
    open(content, options = {}) {
        const combinedOptions = { ...this._config, animation: this._config.animation, ...options };
        return this._modalStack.open(this._moduleCFR, this._injector, content, combinedOptions);
    }
    /**
     * Returns an observable that holds the active modal instances.
     */
    get activeInstances() { return this._modalStack.activeInstances; }
    /**
     * Dismisses all currently displayed modal windows with the supplied reason.
     *
     * @since 3.1.0
     */
    dismissAll(reason) { this._modalStack.dismissAll(reason); }
    /**
     * Indicates if there are currently any open modal windows in the application.
     *
     * @since 3.3.0
     */
    hasOpenModals() { return this._modalStack.hasOpenModals(); }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaModalService, deps: [{ token: i0.ComponentFactoryResolver }, { token: i0.Injector }, { token: UsaModalStack }, { token: UsaModalConfig }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaModalService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaModalService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: i0.ComponentFactoryResolver }, { type: i0.Injector }, { type: UsaModalStack }, { type: UsaModalConfig }] });

class UsaModalModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaModalModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.2", ngImport: i0, type: UsaModalModule, declarations: [UsaModalWrapper, UsaModalWindow], imports: [CommonModule], exports: [UsaModalWrapper,
            UsaModalWindow] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaModalModule, imports: [CommonModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaModalModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                    ],
                    declarations: [UsaModalWrapper, UsaModalWindow],
                    exports: [
                        UsaModalWrapper,
                        UsaModalWindow,
                    ]
                }]
        }] });

class UsaSidenavComponent {
    NavigationMode = UsaNavigationMode;
    sidenavContent;
    /**
     * Enables navigation items to be toggled. By default all EXTERNAL and INTERNAL links are fully collapsed unless specified in sidenavContent.
     *
     * 'single' will allow only one branch to be expanded at a time. If a new branch is expanded, all open branches will collapse
     *
     * 'multiple' will allow all branches to be expanded independently of each other.
     */
    expandType;
    /**
     * Collapse the children of LABEL by default. Setting to false has no effect on behavior of single-select. This behavior can be overriden on a link by link basis via configuation
     */
    autoCollapseLabels = true;
    /**
     * Enables links with a mode of NavigationMode.LABEL to be collapsed, by default they are expanded and locked.
     */
    enableLabelCollapse = false;
    /**
     * If true, the first child of the first label in the side nav will be selected by default
     */
    selectFirstLabelChild = false;
    sidenavClicked = new EventEmitter();
    ngOnInit() {
        // If collapse is enabled, collapse all children by default. If label, expand to show children and select the first child of the first label
        if (this.expandType) {
            this.sidenavContent.map((link) => {
                if (link.mode !== UsaNavigationMode.LABEL) {
                    // By default, link will not be expanded to show children. But this can be overridden for a given link based on configuration
                    link.collapsed = link.collapsed === undefined ? true : link.collapsed;
                }
                else {
                    link.collapsed =
                        link.collapsed === undefined
                            ? !this.autoCollapseLabels && this.expandType !== 'multiple'
                            : link.collapsed;
                }
                if (link.children) {
                    this.collapseChildren(link);
                }
            });
        }
    }
    collapseChildren(link) {
        link.children = link.children.map((childLink) => {
            childLink.collapsed = true;
            return childLink;
        });
    }
    onSidenavItemClicked(item) {
        this.deselectSideNav(this.sidenavContent);
        this.selectSideNav(item, this.sidenavContent);
        if (item.children && this.canCollapseLabel(item)) {
            item.collapsed = !item.collapsed;
            this.toggleBasedOnSelected(item.children);
        }
        if (this.expandType === 'single') {
            this.toggleBasedOnSelected(this.sidenavContent);
        }
        this.sidenavClicked.emit(item);
    }
    /**
     *
     * @param link - Link which has been clicked on
     * @returns true if either link is not a label, or it is a label and label collapse is enabled
     */
    canCollapseLabel(link) {
        return link.mode === UsaNavigationMode.LABEL
            ? this.enableLabelCollapse
            : true;
    }
    toggleBasedOnSelected(links) {
        links.forEach((link) => {
            link.collapsed = link.selected ? false : true;
            if (link.children) {
                this.toggleBasedOnSelected(link.children);
            }
            return;
        });
    }
    /**
     * Deselects any previously selected sidenav item
     * @param sidenavItems
     */
    deselectSideNav(sidenavItems) {
        sidenavItems.forEach((sideNavItem) => {
            if (sideNavItem.children) {
                this.deselectSideNav(sideNavItem.children);
            }
            sideNavItem.selected = false;
        });
    }
    /**
     * Selects the clicked sidenav item as we as any parent
     * @param selectedItem
     * @param allNavItems
     */
    selectSideNav(selectedItem, allNavItems) {
        for (const item of allNavItems) {
            if (item === selectedItem) {
                item.selected = true;
                return true;
            }
            else if (item.children) {
                const isChildSelected = this.selectSideNav(selectedItem, item.children);
                if (isChildSelected) {
                    item.selected = true;
                    return true;
                }
            }
        }
        return false;
    }
    /**
     * When expandType is multiple, expands all collapseable links in sidenav
     */
    expandAll() {
        if (this.expandType === 'multiple') {
            this.sidenavContent.forEach((link) => this.expandChildren(link, false));
        }
    }
    /**
     * Collapses all links
     */
    collapseAll() {
        this.sidenavContent.forEach((link) => this.expandChildren(link, true));
    }
    expandChildren(link, collapsedValue) {
        if (link.children) {
            link.collapsed = collapsedValue;
            link.children.forEach((childLink) => childLink.children
                ? this.expandChildren(childLink, collapsedValue)
                : null);
        }
    }
    queryStringBuilder(item) {
        const ret = [];
        let keys = [];
        if (item.queryParams) {
            keys = Object.keys(item.queryParams);
        }
        for (const d of keys) {
            ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(item.queryParams[d]));
        }
        return ret.join('&');
    }
    /**
     * creates url from provided route and query params
     * @param item - Link to use when building url
     */
    urlBuilder(item) {
        let url = item.path;
        const queryParams = this.queryStringBuilder(item);
        if (queryParams) {
            if (url.indexOf('?') === -1) {
                url += '?' + queryParams;
            }
            else if (url.indexOf('?') === url.length - 1) {
                url += queryParams;
            }
            else {
                url += '&' + queryParams;
            }
        }
        return url;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaSidenavComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.2", type: UsaSidenavComponent, selector: "usa-sidenav", inputs: { sidenavContent: "sidenavContent", expandType: "expandType", autoCollapseLabels: "autoCollapseLabels", enableLabelCollapse: "enableLabelCollapse", selectFirstLabelChild: "selectFirstLabelChild" }, outputs: { sidenavClicked: "sidenavClicked" }, ngImport: i0, template: "<ul class=\"usa-sidenav\">\n  <li *ngFor=\"let link of sidenavContent\" class=\"usa-sidenav__item\">\n    <ng-container [ngTemplateOutlet]=\"sideNavLinkTemplate\" [ngTemplateOutletContext]=\"{$implicit:link}\">\n    </ng-container>\n  </li>\n</ul>\n\n<ng-template #sideNavLinkTemplate let-link>\n  <usa-link-template [link]=\"link\" (linkClicked)=\"onSidenavItemClicked($event)\"></usa-link-template>\n  <div *ngIf=\"!expandType || (expandType && !link.collapsed)\">\n    <ul class=\"usa-sidenav__sublist\">\n      <li *ngFor=\"let link of link.children\" class=\"sidenav__item\">\n        <ng-container [ngTemplateOutlet]=\"sideNavLinkTemplate\" [ngTemplateOutletContext]=\"{$implicit:link}\">\n        </ng-container>\n      </li>\n    </ul>\n  </div>\n</ng-template>\n", dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: UsaLinkTemplateComponent, selector: "usa-link-template", inputs: ["link", "class", "currentClass"], outputs: ["linkClicked"] }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaSidenavComponent, decorators: [{
            type: Component,
            args: [{ selector: `usa-sidenav`, template: "<ul class=\"usa-sidenav\">\n  <li *ngFor=\"let link of sidenavContent\" class=\"usa-sidenav__item\">\n    <ng-container [ngTemplateOutlet]=\"sideNavLinkTemplate\" [ngTemplateOutletContext]=\"{$implicit:link}\">\n    </ng-container>\n  </li>\n</ul>\n\n<ng-template #sideNavLinkTemplate let-link>\n  <usa-link-template [link]=\"link\" (linkClicked)=\"onSidenavItemClicked($event)\"></usa-link-template>\n  <div *ngIf=\"!expandType || (expandType && !link.collapsed)\">\n    <ul class=\"usa-sidenav__sublist\">\n      <li *ngFor=\"let link of link.children\" class=\"sidenav__item\">\n        <ng-container [ngTemplateOutlet]=\"sideNavLinkTemplate\" [ngTemplateOutletContext]=\"{$implicit:link}\">\n        </ng-container>\n      </li>\n    </ul>\n  </div>\n</ng-template>\n" }]
        }], propDecorators: { sidenavContent: [{
                type: Input
            }], expandType: [{
                type: Input
            }], autoCollapseLabels: [{
                type: Input
            }], enableLabelCollapse: [{
                type: Input
            }], selectFirstLabelChild: [{
                type: Input
            }], sidenavClicked: [{
                type: Output
            }] } });

class UsaSidenavModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaSidenavModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.2", ngImport: i0, type: UsaSidenavModule, declarations: [UsaSidenavComponent], imports: [CommonModule,
            UsaLinkTemplateModule], exports: [UsaSidenavComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaSidenavModule, imports: [CommonModule,
            UsaLinkTemplateModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaSidenavModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        UsaLinkTemplateModule
                    ],
                    declarations: [
                        UsaSidenavComponent
                    ],
                    exports: [
                        UsaSidenavComponent
                    ]
                }]
        }] });

let nextId$3 = 0;
class UsaSearchComponent {
    cdr;
    model = '';
    _onChange = (_) => { };
    _onTouched = () => { };
    ariaLabel = 'search component';
    id = `usa-search-${nextId$3++}`;
    size;
    buttonText = 'Search';
    placeholder = '';
    name = "search";
    onBlur = new EventEmitter(null);
    searchTextChange = new EventEmitter(null);
    onTextSubmit = new EventEmitter(null);
    constructor(cdr) {
        this.cdr = cdr;
    }
    focusChange(event) {
        this.onBlur.emit(event.target.value);
    }
    onKeydown(event) {
        if (event.code == Key.Enter) {
            this.model = event.target.value;
            this.updateModel();
            event.preventDefault();
        }
    }
    onValueChange(event) {
        this.searchTextChange.emit(event);
    }
    // Helper method to programatically update the search value to the model
    onSubmit(val, ev) {
        this.model = val;
        this.updateModel();
        ev.preventDefault();
        this.onTextSubmit.emit(val);
    }
    // Helper method that gets a new instance of the model and notifies ControlValueAccessor that we have a new model for this FormControl (our custom component)
    updateModel() {
        this._onChange(this.model);
    }
    // ControlValueAccessor (and Formly) is trying to update the value of the FormControl (our custom component) programatically
    // If there is a value we will just overwrite items
    // If there is no value we reset the items array to be empty
    writeValue(value) {
        if (value) {
            this.model = value;
            this.cdr.markForCheck();
        }
        else {
            this.model = '';
            this.cdr.markForCheck();
        }
    }
    // ControlValueAccessor hook that lets us call this._onChange(var) to let the form know our variable has changed (in this case model)
    registerOnChange(fn) {
        this._onChange = fn;
    }
    // ControlValueAccessor hook (not used)
    registerOnTouched(fn) {
        this._onTouched = fn;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaSearchComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.2", type: UsaSearchComponent, selector: "usa-search", inputs: { ariaLabel: "ariaLabel", id: "id", size: "size", buttonText: "buttonText", placeholder: "placeholder", name: "name" }, outputs: { onBlur: "onBlur", searchTextChange: "searchTextChange", onTextSubmit: "onTextSubmit" }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => UsaSearchComponent),
                multi: true,
            },
        ], ngImport: i0, template: " <section [attr.aria-label]=\"ariaLabel\">\n   <form class=\"usa-search\" role=\"search\" [ngClass]=\"{\n    'usa-search--big': size === 'big',\n    'usa-search--small':size == 'small'\n   }\">\n     <label class=\"usa-sr-only\" [attr.for]=\"id\">Search</label>\n     <input class=\"usa-input\" [attr.id]=\"id\" type=\"search\" [attr.name]=\"name\" [placeholder]=\"placeholder\" #searchInput\n       [value]=\"model\" (blur)=\"focusChange($event)\" (input)=\"onValueChange($event.target.value)\"\n       (keydown)=\"onKeydown($event)\" />\n     <button class=\"usa-button\" type=\"submit\" (click)=\"onSubmit(searchInput.value, $event);\">\n       <span [ngClass]=\"[size === 'small' ? 'usa-sr-only' : 'usa-search__submit-text']\">\n         {{ buttonText }}\n       </span>\n     </button>\n   </form>\n </section>\n", dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaSearchComponent, decorators: [{
            type: Component,
            args: [{ selector: 'usa-search', providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => UsaSearchComponent),
                            multi: true,
                        },
                    ], changeDetection: ChangeDetectionStrategy.OnPush, template: " <section [attr.aria-label]=\"ariaLabel\">\n   <form class=\"usa-search\" role=\"search\" [ngClass]=\"{\n    'usa-search--big': size === 'big',\n    'usa-search--small':size == 'small'\n   }\">\n     <label class=\"usa-sr-only\" [attr.for]=\"id\">Search</label>\n     <input class=\"usa-input\" [attr.id]=\"id\" type=\"search\" [attr.name]=\"name\" [placeholder]=\"placeholder\" #searchInput\n       [value]=\"model\" (blur)=\"focusChange($event)\" (input)=\"onValueChange($event.target.value)\"\n       (keydown)=\"onKeydown($event)\" />\n     <button class=\"usa-button\" type=\"submit\" (click)=\"onSubmit(searchInput.value, $event);\">\n       <span [ngClass]=\"[size === 'small' ? 'usa-sr-only' : 'usa-search__submit-text']\">\n         {{ buttonText }}\n       </span>\n     </button>\n   </form>\n </section>\n" }]
        }], ctorParameters: () => [{ type: i0.ChangeDetectorRef }], propDecorators: { ariaLabel: [{
                type: Input
            }], id: [{
                type: Input
            }], size: [{
                type: Input
            }], buttonText: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], name: [{
                type: Input
            }], onBlur: [{
                type: Output
            }], searchTextChange: [{
                type: Output
            }], onTextSubmit: [{
                type: Output
            }] } });

class UsaSearchModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaSearchModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.2", ngImport: i0, type: UsaSearchModule, declarations: [UsaSearchComponent], imports: [CommonModule], exports: [UsaSearchComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaSearchModule, imports: [CommonModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaSearchModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [UsaSearchComponent],
                    imports: [
                        CommonModule
                    ],
                    exports: [UsaSearchComponent]
                }]
        }] });

/**
 * A configuration service for the Step Indeicator component.
 *
 * You can inject this service, typically in your root component, and customize its properties
 * to provide default values for all accordions used in the application.
 */
class UsaStepIndicatorConfig {
    /**
     * Hides labels on each step when set to true
     * @default false
     */
    hideLabels = false;
    /**
     * Centers labels on each step when set to true -
     * if hideLabels is also true, then labels will be hidden
     * @default false
     */
    centerLabels = false;
    /**
     * Displays step counters in between each step
     * @default true
     */
    displayCounters = false;
    /**
     * Shrinks the size of counters if they are displayed
     * @default false
     */
    smallCounters = false;
    /**
     * Defines whether to place the header above or below the steps.
     * String value of 'top' represents above while 'bottom' represents below
     * @default bottom
     */
    headerPosition = 'bottom';
    /**
     * Disable the ability to click on specific step segments in step indicator
     */
    disableStepSelection = false;
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaStepIndicatorConfig, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaStepIndicatorConfig, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaStepIndicatorConfig, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

let stepIndicatorId = 0;
class UsaStepIndicatorComponent {
    elementRef;
    /**
     * Hides labels on each step when set to true
     */
    hideLabels = false;
    /**
     * Centers label with the step bar when set to true
     */
    centerLabels = false;
    /**
     * Displays step counter
     */
    displayCounters = false;
    /**
     * Shrinks size of displayed step counter
     */
    smallCounters = false;
    /**
     * Whether to place the header above or below the step indicator
     */
    headerPosition = 'bottom';
    /**
     * Disables the ability to navigate to steps by clicking on the step bar
     */
    disableStepSelection = false;
    id = `usa-step-indicator-${stepIndicatorId++}`;
    /**
     * Currently selected step
     */
    currentStep = 0;
    /**
     * All possible steps
     */
    steps = [];
    currentStepChange = new EventEmitter();
    constructor(config, elementRef) {
        this.elementRef = elementRef;
        this.hideLabels = config.hideLabels;
        this.centerLabels = config.centerLabels;
        this.displayCounters = config.displayCounters;
        this.smallCounters = config.smallCounters;
        this.headerPosition = config.headerPosition;
        this.disableStepSelection = config.disableStepSelection;
    }
    ngOnChanges(changes) {
        if (changes.currentStep) {
            if (this.currentStep > this.steps.length - 1 || this.currentStep < 0) {
                throw new Error(`Steps in step indicator is out of bounds.
          Current Step: ${this.currentStep}, Step Range: 0 - ${this.steps.length - 1}`);
            }
        }
    }
    onStepClicked(stepIndex, step) {
        if (step.disabled || this.disableStepSelection) {
            return;
        }
        this.currentStepChange.emit(stepIndex);
    }
    onKeyDown(event, index) {
        const keyPressed = event.key || event.keyCode;
        let nextStepIndex;
        switch (keyPressed) {
            case Key.ArrowRight:
            case MicrosfotKeys.ArrowRight:
            case KeyCode.ArrowRight:
                nextStepIndex = getNextItemIndexInList(index, this.steps, 1);
                this._getAllStepListElements()[nextStepIndex].focus();
                event.preventDefault();
                break;
            case Key.ArrowLeft:
            case MicrosfotKeys.ArrowLeft:
            case KeyCode.ArrowLeft:
                nextStepIndex = getNextItemIndexInList(index, this.steps, -1);
                this._getAllStepListElements()[nextStepIndex].focus();
                event.preventDefault();
                break;
            case Key.Home:
            case MicrosfotKeys.Home:
            case KeyCode.Home:
                nextStepIndex = this.steps.findIndex(step => !step.disabled);
                this._getAllStepListElements()[nextStepIndex].focus();
                event.preventDefault();
                break;
            case Key.End:
            case MicrosfotKeys.End:
            case KeyCode.End:
                nextStepIndex = findLastIndex(this.steps, (step => !step.disabled));
                this._getAllStepListElements()[nextStepIndex].focus();
                event.preventDefault();
                break;
        }
    }
    getFillPercentage(step) {
        if (step.completionPercent === undefined || step != this.steps[this.currentStep]) {
            return undefined;
        }
        if (step.completionPercent % 25 === 0 || step.completionPercent % 33 === 0) {
            return `fill-${step.completionPercent}`;
        }
        const roundedStep = Math.round(step.completionPercent / 10) * 10;
        return `fill-${roundedStep}`;
    }
    getSegmentScale(step) {
        if (step.segmentScale === undefined)
            return undefined;
        const segmentPercentage = Math.max(0.5, Math.min(4, step.segmentScale)) * 100;
        return `scale-percent-${segmentPercentage}`;
    }
    _getAllStepListElements() {
        const listElements = this.elementRef.nativeElement.querySelectorAll(`#${this.id} .usa-step-indicator__segment`);
        return Array.prototype.slice.call(listElements);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaStepIndicatorComponent, deps: [{ token: UsaStepIndicatorConfig }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.2", type: UsaStepIndicatorComponent, selector: "usa-step-indicator", inputs: { hideLabels: "hideLabels", centerLabels: "centerLabels", displayCounters: "displayCounters", smallCounters: "smallCounters", headerPosition: "headerPosition", disableStepSelection: "disableStepSelection", id: "id", currentStep: "currentStep", steps: "steps" }, outputs: { currentStepChange: "currentStepChange" }, host: { properties: { "class.usa-step-indicator--no-labels": "hideLabels", "class.usa-step-indicator--center": "centerLabels && !hideLabels", "class.usa-step-indicator--counters": "displayCounters && !smallCounters", "class.usa-step-indicator--counters-sm": "smallCounters" }, classAttribute: "usa-step-indicator" }, usesOnChanges: true, ngImport: i0, template: "<div class=\"usa-step-indicator\" aria-label=\"progress\">\n\n  <div class=\"usa-sr-only\">Step {{ currentStep + 1 }} out of\n    {{ steps.length }} ,\n    {{ steps[currentStep].label }}</div>\n  <div *ngIf=\"headerPosition === 'top'\" class=\"usa-step-indicator__header\">\n    <ng-container *ngTemplateOutlet=\"headerTemplate\"></ng-container>\n  </div>\n\n  <ol class=\"usa-step-indicator__segments\" role=\"tablist\" [attr.id]=\"id\">\n    <li *ngFor=\"let step of steps; index as i\" role=\"tab\" [attr.tabindex]=\"0\"\n      [attr.aria-disabled]=\"step.disabled || disableStepSelection ? true : undefined\"\n      class=\"usa-step-indicator__segment {{getFillPercentage(step)}} {{getSegmentScale(step)}}\" [attr.id]=\"id + '-' + i\"\n      (click)=\"onStepClicked(i, step)\" (keyup.enter)=\"onStepClicked(i, step)\" (keydown)=\"onKeyDown($event, i)\"\n      [ngClass]=\"{\n        'usa-step-indicator__segment--complete': i < currentStep,\n        'usa-step-indicator__segment--current': i === currentStep,\n        'usa-step-indicator__segment--no-counter': displayCounters && !step.label,\n        'cursor-pointer': !step.disabled && !disableStepSelection\n      }\" [attr.aria-current]=\"i == currentStep ? true : undefined\"\n      [attr.aria-selected]=\"i == currentStep ? true : undefined\">\n      <span class=\"usa-step-indicator__segment-label\">{{step.label}}\n        <span class=\"usa-sr-only\">{{i < currentStep ? 'completed' : i > currentStep ? 'not completed' : ''}}</span>\n      </span>\n    </li>\n  </ol>\n\n  <div *ngIf=\"headerPosition === 'bottom'\" class=\"usa-step-indicator__header\">\n    <ng-container *ngTemplateOutlet=\"headerTemplate\"></ng-container>\n  </div>\n</div>\n\n<ng-template #headerTemplate>\n  <ng-content select=\"[UsaStepHeader]\"></ng-content>\n</ng-template>\n", styles: [".usa-step-indicator__segment.scale-percent-50{max-width:7.5rem;flex-grow:.5}.usa-step-indicator__segment.scale-percent-100{max-width:15rem;flex-grow:1}.usa-step-indicator__segment.scale-percent-150{max-width:22.5rem;flex-grow:1.5}.usa-step-indicator__segment.scale-percent-200{max-width:30rem;flex-grow:2}.usa-step-indicator__segment.scale-percent-250{max-width:37.5rem;flex-grow:2.5}.usa-step-indicator__segment.scale-percent-300{max-width:45rem;flex-grow:3}.usa-step-indicator__segment.scale-percent-350{max-width:52.5rem;flex-grow:3.5}.usa-step-indicator__segment.scale-percent-400{max-width:60rem;flex-grow:4}.fill-0.usa-step-indicator__segment--current:after{background:linear-gradient(to right,#005ea2,#dfe1e2 0%)}.fill-10.usa-step-indicator__segment--current:after{background:linear-gradient(to right,#005ea2 10%,#dfe1e2 10%)}.fill-20.usa-step-indicator__segment--current:after{background:linear-gradient(to right,#005ea2 20%,#dfe1e2 20%)}.fill-30.usa-step-indicator__segment--current:after{background:linear-gradient(to right,#005ea2 30%,#dfe1e2 30%)}.fill-40.usa-step-indicator__segment--current:after{background:linear-gradient(to right,#005ea2 40%,#dfe1e2 40%)}.fill-50.usa-step-indicator__segment--current:after{background:linear-gradient(to right,#005ea2 50%,#dfe1e2 50%)}.fill-60.usa-step-indicator__segment--current:after{background:linear-gradient(to right,#005ea2 60%,#dfe1e2 60%)}.fill-70.usa-step-indicator__segment--current:after{background:linear-gradient(to right,#005ea2 70%,#dfe1e2 70%)}.fill-80.usa-step-indicator__segment--current:after{background:linear-gradient(to right,#005ea2 80%,#dfe1e2 80%)}.fill-90.usa-step-indicator__segment--current:after{background:linear-gradient(to right,#005ea2 90%,#dfe1e2 90%)}.fill-100.usa-step-indicator__segment--current:after{background:linear-gradient(to right,#005ea2 100%,#dfe1e2)}.fill-33.usa-step-indicator__segment--current:after{background:linear-gradient(to right,#005ea2 33%,#dfe1e2 33%)}.fill-66.usa-step-indicator__segment--current:after{background:linear-gradient(to right,#005ea2 66%,#dfe1e2 66%)}.fill-99.usa-step-indicator__segment--current:after{background:linear-gradient(to right,#005ea2 99%,#dfe1e2 99%)}.fill-25.usa-step-indicator__segment--current:after{background:linear-gradient(to right,#005ea2 25%,#dfe1e2 25%)}.fill-75.usa-step-indicator__segment--current:after{background:linear-gradient(to right,#005ea2 75%,#dfe1e2 75%)}.usa-step-indicator__segment--no-counter:before{content:\"\";box-shadow:inset 0 0 0 .25rem #f5f5f0,0 0 0 .25rem #fff!important}.usa-step-indicator__segment:before{box-shadow:inset 0 0 0 .25rem #f5f5f0,0 0 0 .25rem #fff!important}.usa-step-indicator__segment--current:before{box-shadow:inset 0 0 0 .25rem #2672de,0 0 0 .25rem #fff!important}.usa-step-indicator__segment--complete:before{box-shadow:inset 0 0 0 .25rem #1a4480,0 0 0 .25rem #fff!important}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaStepIndicatorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'usa-step-indicator', host: {
                        'class': 'usa-step-indicator',
                        '[class.usa-step-indicator--no-labels]': 'hideLabels',
                        '[class.usa-step-indicator--center]': 'centerLabels && !hideLabels',
                        '[class.usa-step-indicator--counters]': 'displayCounters && !smallCounters',
                        '[class.usa-step-indicator--counters-sm]': 'smallCounters',
                    }, template: "<div class=\"usa-step-indicator\" aria-label=\"progress\">\n\n  <div class=\"usa-sr-only\">Step {{ currentStep + 1 }} out of\n    {{ steps.length }} ,\n    {{ steps[currentStep].label }}</div>\n  <div *ngIf=\"headerPosition === 'top'\" class=\"usa-step-indicator__header\">\n    <ng-container *ngTemplateOutlet=\"headerTemplate\"></ng-container>\n  </div>\n\n  <ol class=\"usa-step-indicator__segments\" role=\"tablist\" [attr.id]=\"id\">\n    <li *ngFor=\"let step of steps; index as i\" role=\"tab\" [attr.tabindex]=\"0\"\n      [attr.aria-disabled]=\"step.disabled || disableStepSelection ? true : undefined\"\n      class=\"usa-step-indicator__segment {{getFillPercentage(step)}} {{getSegmentScale(step)}}\" [attr.id]=\"id + '-' + i\"\n      (click)=\"onStepClicked(i, step)\" (keyup.enter)=\"onStepClicked(i, step)\" (keydown)=\"onKeyDown($event, i)\"\n      [ngClass]=\"{\n        'usa-step-indicator__segment--complete': i < currentStep,\n        'usa-step-indicator__segment--current': i === currentStep,\n        'usa-step-indicator__segment--no-counter': displayCounters && !step.label,\n        'cursor-pointer': !step.disabled && !disableStepSelection\n      }\" [attr.aria-current]=\"i == currentStep ? true : undefined\"\n      [attr.aria-selected]=\"i == currentStep ? true : undefined\">\n      <span class=\"usa-step-indicator__segment-label\">{{step.label}}\n        <span class=\"usa-sr-only\">{{i < currentStep ? 'completed' : i > currentStep ? 'not completed' : ''}}</span>\n      </span>\n    </li>\n  </ol>\n\n  <div *ngIf=\"headerPosition === 'bottom'\" class=\"usa-step-indicator__header\">\n    <ng-container *ngTemplateOutlet=\"headerTemplate\"></ng-container>\n  </div>\n</div>\n\n<ng-template #headerTemplate>\n  <ng-content select=\"[UsaStepHeader]\"></ng-content>\n</ng-template>\n", styles: [".usa-step-indicator__segment.scale-percent-50{max-width:7.5rem;flex-grow:.5}.usa-step-indicator__segment.scale-percent-100{max-width:15rem;flex-grow:1}.usa-step-indicator__segment.scale-percent-150{max-width:22.5rem;flex-grow:1.5}.usa-step-indicator__segment.scale-percent-200{max-width:30rem;flex-grow:2}.usa-step-indicator__segment.scale-percent-250{max-width:37.5rem;flex-grow:2.5}.usa-step-indicator__segment.scale-percent-300{max-width:45rem;flex-grow:3}.usa-step-indicator__segment.scale-percent-350{max-width:52.5rem;flex-grow:3.5}.usa-step-indicator__segment.scale-percent-400{max-width:60rem;flex-grow:4}.fill-0.usa-step-indicator__segment--current:after{background:linear-gradient(to right,#005ea2,#dfe1e2 0%)}.fill-10.usa-step-indicator__segment--current:after{background:linear-gradient(to right,#005ea2 10%,#dfe1e2 10%)}.fill-20.usa-step-indicator__segment--current:after{background:linear-gradient(to right,#005ea2 20%,#dfe1e2 20%)}.fill-30.usa-step-indicator__segment--current:after{background:linear-gradient(to right,#005ea2 30%,#dfe1e2 30%)}.fill-40.usa-step-indicator__segment--current:after{background:linear-gradient(to right,#005ea2 40%,#dfe1e2 40%)}.fill-50.usa-step-indicator__segment--current:after{background:linear-gradient(to right,#005ea2 50%,#dfe1e2 50%)}.fill-60.usa-step-indicator__segment--current:after{background:linear-gradient(to right,#005ea2 60%,#dfe1e2 60%)}.fill-70.usa-step-indicator__segment--current:after{background:linear-gradient(to right,#005ea2 70%,#dfe1e2 70%)}.fill-80.usa-step-indicator__segment--current:after{background:linear-gradient(to right,#005ea2 80%,#dfe1e2 80%)}.fill-90.usa-step-indicator__segment--current:after{background:linear-gradient(to right,#005ea2 90%,#dfe1e2 90%)}.fill-100.usa-step-indicator__segment--current:after{background:linear-gradient(to right,#005ea2 100%,#dfe1e2)}.fill-33.usa-step-indicator__segment--current:after{background:linear-gradient(to right,#005ea2 33%,#dfe1e2 33%)}.fill-66.usa-step-indicator__segment--current:after{background:linear-gradient(to right,#005ea2 66%,#dfe1e2 66%)}.fill-99.usa-step-indicator__segment--current:after{background:linear-gradient(to right,#005ea2 99%,#dfe1e2 99%)}.fill-25.usa-step-indicator__segment--current:after{background:linear-gradient(to right,#005ea2 25%,#dfe1e2 25%)}.fill-75.usa-step-indicator__segment--current:after{background:linear-gradient(to right,#005ea2 75%,#dfe1e2 75%)}.usa-step-indicator__segment--no-counter:before{content:\"\";box-shadow:inset 0 0 0 .25rem #f5f5f0,0 0 0 .25rem #fff!important}.usa-step-indicator__segment:before{box-shadow:inset 0 0 0 .25rem #f5f5f0,0 0 0 .25rem #fff!important}.usa-step-indicator__segment--current:before{box-shadow:inset 0 0 0 .25rem #2672de,0 0 0 .25rem #fff!important}.usa-step-indicator__segment--complete:before{box-shadow:inset 0 0 0 .25rem #1a4480,0 0 0 .25rem #fff!important}\n"] }]
        }], ctorParameters: () => [{ type: UsaStepIndicatorConfig }, { type: i0.ElementRef }], propDecorators: { hideLabels: [{
                type: Input
            }], centerLabels: [{
                type: Input
            }], displayCounters: [{
                type: Input
            }], smallCounters: [{
                type: Input
            }], headerPosition: [{
                type: Input
            }], disableStepSelection: [{
                type: Input
            }], id: [{
                type: Input
            }], currentStep: [{
                type: Input
            }], steps: [{
                type: Input
            }], currentStepChange: [{
                type: Output
            }] } });

class UsaStepIndicatorHeaderComponent {
    stepIndicator;
    template;
    constructor(stepIndicator) {
        this.stepIndicator = stepIndicator;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaStepIndicatorHeaderComponent, deps: [{ token: UsaStepIndicatorComponent, host: true }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.2", type: UsaStepIndicatorHeaderComponent, selector: "[UsaStepHeader]", inputs: { template: "template" }, host: { properties: { "class.margin-top-0": "stepIndicator.headerPosition === 'top'", "class.margin-bottom-4": "stepIndicator.headerPosition === 'top'" }, classAttribute: "usa-step-indicator__heading" }, ngImport: i0, template: `
    <ng-container *ngIf="template; else default">
      <ng-template [ngTemplateOutlet]="template"></ng-template>
    </ng-container>

    <ng-template #default>
      <span class="usa-step-indicator__heading-counter">
        <span class="usa-step-indicator__current-step">{{
          stepIndicator?.currentStep + 1
        }}</span>
        <span class="usa-step-indicator__total-steps">
          of {{ stepIndicator?.steps.length }}</span
        >
      </span>
      <span class="usa-step-indicator__heading-text">{{
        stepIndicator?.steps[stepIndicator?.currentStep].label
      }}</span>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaStepIndicatorHeaderComponent, decorators: [{
            type: Component,
            args: [{
                    selector: `[UsaStepHeader]`,
                    template: `
    <ng-container *ngIf="template; else default">
      <ng-template [ngTemplateOutlet]="template"></ng-template>
    </ng-container>

    <ng-template #default>
      <span class="usa-step-indicator__heading-counter">
        <span class="usa-step-indicator__current-step">{{
          stepIndicator?.currentStep + 1
        }}</span>
        <span class="usa-step-indicator__total-steps">
          of {{ stepIndicator?.steps.length }}</span
        >
      </span>
      <span class="usa-step-indicator__heading-text">{{
        stepIndicator?.steps[stepIndicator?.currentStep].label
      }}</span>
    </ng-template>
  `,
                    host: {
                        class: 'usa-step-indicator__heading',
                        '[class.margin-top-0]': "stepIndicator.headerPosition === 'top'",
                        '[class.margin-bottom-4]': "stepIndicator.headerPosition === 'top'",
                    },
                }]
        }], ctorParameters: () => [{ type: UsaStepIndicatorComponent, decorators: [{
                    type: Host
                }] }], propDecorators: { template: [{
                type: Input
            }] } });

class UsaStepIndicatorModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaStepIndicatorModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.2", ngImport: i0, type: UsaStepIndicatorModule, declarations: [UsaStepIndicatorComponent,
            UsaStepIndicatorHeaderComponent], imports: [CommonModule], exports: [UsaStepIndicatorComponent,
            UsaStepIndicatorHeaderComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaStepIndicatorModule, imports: [CommonModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaStepIndicatorModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        UsaStepIndicatorComponent,
                        UsaStepIndicatorHeaderComponent
                    ],
                    imports: [
                        CommonModule
                    ],
                    exports: [
                        UsaStepIndicatorComponent,
                        UsaStepIndicatorHeaderComponent
                    ]
                }]
        }] });

class UsaTableDataDef {
    templateRef;
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaTableDataDef, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.2", type: UsaTableDataDef, selector: "[usaTableDataDef]", ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaTableDataDef, decorators: [{
            type: Directive,
            args: [{
                    selector: `[usaTableDataDef]`,
                }]
        }], ctorParameters: () => [{ type: i0.TemplateRef }] });
class UsaTableData {
    el;
    _isSortActive = false;
    constructor(el) {
        this.el = el;
    }
    setSortActive() {
        this._isSortActive = true;
    }
    setSortInactive() {
        this._isSortActive = false;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaTableData, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.2", type: UsaTableData, selector: "[usa-table-data]", host: { properties: { "attr.data-sort-active": "_isSortActive ? _isSortActive : undefined" } }, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaTableData, decorators: [{
            type: Directive,
            args: [{
                    selector: `[usa-table-data]`,
                    host: {
                        '[attr.data-sort-active]': '_isSortActive ? _isSortActive : undefined',
                    }
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }] });
/**
 * Represents one row of table data
 */
class UsaDataRowDef {
    templateRef;
    cdr;
    usaDataRowDefColumns;
    ngOnChanges() {
        this.cdr.detectChanges();
    }
    constructor(templateRef, cdr) {
        this.templateRef = templateRef;
        this.cdr = cdr;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaDataRowDef, deps: [{ token: i0.TemplateRef }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.2", type: UsaDataRowDef, selector: "[usaDataRowDef]", inputs: { usaDataRowDefColumns: "usaDataRowDefColumns" }, usesOnChanges: true, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaDataRowDef, decorators: [{
            type: Directive,
            args: [{
                    selector: `[usaDataRowDef]`,
                }]
        }], ctorParameters: () => [{ type: i0.TemplateRef }, { type: i0.ChangeDetectorRef }], propDecorators: { usaDataRowDefColumns: [{
                type: Input
            }] } });

class UsaSort {
    _el;
    _document;
    sortFn;
    sortClicked = new EventEmitter();
    ariaSort = 'none';
    ariaLabel;
    _columnHeaderText;
    constructor(_el, _document) {
        this._el = _el;
        this._document = _document;
    }
    onClick() {
        this.toggleAriaSort();
        const sortFn = this.sortFn ? this.sortFn : this.defaultSortFunction;
        const eventDetails = {
            sortFn,
            sortState: this.ariaSort,
            columnHeaderText: this._columnHeaderText
        };
        let event;
        if (typeof (Event) === 'function') {
            event = new CustomEvent('sort', { bubbles: true, detail: eventDetails });
        }
        else {
            // IE11 support
            event = this._document.createEvent('CustomEvent');
            event.initCustomEvent('sort', true, true, eventDetails);
        }
        this._el.nativeElement.dispatchEvent(event);
        this.sortClicked.emit(this.ariaSort);
    }
    setColumnHeader(columnHeaderText) {
        this._columnHeaderText = columnHeaderText;
        this.ariaLabel = `Click to sort ${this._columnHeaderText}`;
    }
    toggleAriaSort() {
        this.ariaSort = this.ariaSort === 'none' || this.ariaSort === 'descending' ? 'ascending' : 'descending';
        const sortOrder = this.ariaSort === 'ascending' ? 'in descending order' : 'in ascending order';
        this.ariaLabel = `Click to sort ${this._columnHeaderText} ${this.ariaSort ? sortOrder : ''}`;
    }
    disableSort() {
        this.ariaSort = 'none';
        this.ariaLabel = `Click to sort ${this._columnHeaderText}`;
    }
    defaultSortFunction(value1, value2) {
        // if neither value is empty, and if both values are already numbers, compare numerically
        if (value1 &&
            value2 &&
            !Number.isNaN(Number(value1)) &&
            !Number.isNaN(Number(value2))) {
            return value1 - value2;
        }
        if (!value1 || !value2) {
            return value1 ? 1 : value2 ? -1 : 0;
        }
        // Otherwise, compare alphabetically based on current user locale
        return value1
            .toString()
            .localeCompare(value2, navigator.language, {
            numeric: true,
            ignorePunctuation: true,
        });
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaSort, deps: [{ token: i0.ElementRef }, { token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.2", type: UsaSort, selector: "button[usa-sort]", inputs: { sortFn: "sortFn" }, outputs: { sortClicked: "sortClicked" }, host: { listeners: { "click": "onClick($event)" }, properties: { "attr.aria-label": "ariaLabel" }, classAttribute: "usa-table__header__button" }, ngImport: i0, template: `
        <svg
          [ngSwitch]="ariaSort"
          class="usa-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <g *ngSwitchCase="'descending'" class="descending">
            <path d="M17 17L15.59 15.59L12.9999 18.17V2H10.9999V18.17L8.41 15.58L7 17L11.9999 22L17 17Z"></path>
          </g>
          <g *ngSwitchCase="'ascending'" class="ascending">
            <path transform="rotate(180, 12, 12)" d="M17 17L15.59 15.59L12.9999 18.17V2H10.9999V18.17L8.41 15.58L7 17L11.9999 22L17 17Z"></path>
          </g>
          <g *ngSwitchCase="'none'" class="unsorted">
            <polygon points="15.17 15 13 17.17 13 6.83 15.17 9 16.58 7.59 12 3 7.41 7.59 8.83 9 11 6.83 11 17.17 8.83 15 7.42 16.41 12 21 16.59 16.41 15.17 15"></polygon>
          </g>
        </svg>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaSort, decorators: [{
            type: Component,
            args: [{
                    selector: `button[usa-sort]`,
                    host: {
                        class: 'usa-table__header__button',
                        '[attr.aria-label]': 'ariaLabel',
                        '(click)': 'onClick($event)',
                    },
                    template: `
        <svg
          [ngSwitch]="ariaSort"
          class="usa-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <g *ngSwitchCase="'descending'" class="descending">
            <path d="M17 17L15.59 15.59L12.9999 18.17V2H10.9999V18.17L8.41 15.58L7 17L11.9999 22L17 17Z"></path>
          </g>
          <g *ngSwitchCase="'ascending'" class="ascending">
            <path transform="rotate(180, 12, 12)" d="M17 17L15.59 15.59L12.9999 18.17V2H10.9999V18.17L8.41 15.58L7 17L11.9999 22L17 17Z"></path>
          </g>
          <g *ngSwitchCase="'none'" class="unsorted">
            <polygon points="15.17 15 13 17.17 13 6.83 15.17 9 16.58 7.59 12 3 7.41 7.59 8.83 9 11 6.83 11 17.17 8.83 15 7.42 16.41 12 21 16.59 16.41 15.17 15"></polygon>
          </g>
        </svg>
  `
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }], propDecorators: { sortFn: [{
                type: Input
            }], sortClicked: [{
                type: Output
            }] } });

/**
 * Structural Directive to extract table header template
 * from user
 */
class UsaTableHeaderDef {
    templateRef;
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaTableHeaderDef, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.2", type: UsaTableHeaderDef, selector: "[usaTableHeaderDef]", ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaTableHeaderDef, decorators: [{
            type: Directive,
            args: [{
                    selector: `[usaTableHeaderDef]`,
                }]
        }], ctorParameters: () => [{ type: i0.TemplateRef }] });
/**
 * Directive to apply certain styles and/or attribute to table header
 */
class UsaTableHeader {
    elementRef;
    usaSort;
    ariaLabel;
    ariaSort;
    _defaultAriaLabel;
    constructor(elementRef) {
        this.elementRef = elementRef;
    }
    ngAfterViewInit() {
        if (this.ariaLabel) {
            this.usaSort.setColumnHeader(this.ariaLabel);
            return;
        }
        let ariaLabel = this.elementRef.nativeElement.innerText;
        this._defaultAriaLabel = ariaLabel;
        if (this.usaSort) {
            this.usaSort.setColumnHeader(this._defaultAriaLabel);
            ariaLabel = this._defaultAriaLabel + ', sortable column, currently unsorted';
        }
        this.ariaLabel = ariaLabel;
    }
    setSortState(sortState) {
        if (sortState === 'none') {
            this.setSortInactive();
            return;
        }
        this.ariaSort = sortState;
        if (this._defaultAriaLabel) {
            this.ariaLabel = this._defaultAriaLabel + ', sortable column, currently sorted ' + this.ariaSort;
        }
    }
    setSortInactive() {
        this.ariaSort = undefined;
        this.usaSort.disableSort();
        if (this._defaultAriaLabel) {
            this.ariaLabel = this._defaultAriaLabel + ', sortable column, currently unsorted';
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaTableHeader, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.2", type: UsaTableHeader, selector: "[usa-table-header]", inputs: { ariaLabel: "ariaLabel" }, host: { properties: { "attr.role": "'columnheader'", "attr.scope": "'col'", "attr.data-sortable": "usaSort ? true : undefined", "attr.aria-sort": "ariaSort ? ariaSort : undefined", "attr.aria-label": "ariaLabel" } }, queries: [{ propertyName: "usaSort", first: true, predicate: UsaSort, descendants: true }], ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaTableHeader, decorators: [{
            type: Directive,
            args: [{
                    selector: `[usa-table-header]`,
                    host: {
                        '[attr.role]': '\'columnheader\'',
                        '[attr.scope]': '\'col\'',
                        '[attr.data-sortable]': 'usaSort ? true : undefined',
                        '[attr.aria-sort]': 'ariaSort ? ariaSort : undefined',
                        '[attr.aria-label]': 'ariaLabel'
                    }
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { usaSort: [{
                type: ContentChild,
                args: [UsaSort]
            }], ariaLabel: [{
                type: Input
            }] } });
/**
 * Represents one row of table headers. Multiple rows of
 * table headers can exist in one table
 */
class UsaHeaderRowDef {
    templateRef;
    usaHeaderRowDef;
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaHeaderRowDef, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.2", type: UsaHeaderRowDef, selector: "[usaHeaderRowDef]", inputs: { usaHeaderRowDef: "usaHeaderRowDef" }, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaHeaderRowDef, decorators: [{
            type: Directive,
            args: [{
                    selector: `[usaHeaderRowDef]`,
                }]
        }], ctorParameters: () => [{ type: i0.TemplateRef }], propDecorators: { usaHeaderRowDef: [{
                type: Input
            }] } });

class UsaTableConfig {
    /**
     * Display table without column borders
     * @default false
     */
    borderless = false;
    /**
     * Allow table to scroll horizontally when content expand view width
     * @default false
     */
    scrollable = false;
    /**
     * Add alternating light/grey background color when displaying table rows
     * @default false
     */
    striped = false;
    /**
     * Minimize table cell padding
     * @default false
     */
    compact = false;
    /**
     * Stack table when in mobile sized view
     * @default true
     */
    stacked = true;
    /**
     * Displays first column as header when in stacked mode
     * @default false
     */
    stackedHeader = false;
    /**
     * Whether or not the data is sorted server side. If set to true, then
     * the table will not perform sort operations on given data, but simply
     * handle bookkeeping of sort state and event emission
     * @default false
     */
    serverSideSort = false;
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaTableConfig, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaTableConfig, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaTableConfig, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

class HighlightOnHoverDirective {
    el;
    renderer;
    hoverClass = 'usa-table__row--hovered';
    usaHighlightOnHover = false;
    constructor(el, renderer) {
        this.el = el;
        this.renderer = renderer;
    }
    onMouseEnter() {
        if (this.usaHighlightOnHover) {
            this.addHoverClass();
        }
    }
    onMouseLeave() {
        if (this.usaHighlightOnHover) {
            this.removeHoverClass();
        }
    }
    addHoverClass() {
        this.renderer.addClass(this.el.nativeElement, this.hoverClass);
    }
    removeHoverClass() {
        this.renderer.removeClass(this.el.nativeElement, this.hoverClass);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: HighlightOnHoverDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.2", type: HighlightOnHoverDirective, selector: "tr[usaHighlightOnHover]", inputs: { usaHighlightOnHover: "usaHighlightOnHover" }, host: { listeners: { "mouseenter": "onMouseEnter()", "mouseleave": "onMouseLeave()" } }, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: HighlightOnHoverDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'tr[usaHighlightOnHover]',
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i0.Renderer2 }], propDecorators: { usaHighlightOnHover: [{
                type: Input
            }], onMouseEnter: [{
                type: HostListener,
                args: ['mouseenter']
            }], onMouseLeave: [{
                type: HostListener,
                args: ['mouseleave']
            }] } });

class UsaColumnDef {
    tableHeaderTemplate;
    tableHeader;
    tableDataTemplate;
    tableData;
    tableSort;
    usaColumnDef;
    isSortActive = false;
    setSortActive(sortState) {
        this.tableHeader.setSortState(sortState);
        this.tableData.forEach((data) => data.setSortActive());
        this.isSortActive = true;
    }
    setSortInactive() {
        this.tableHeader.setSortState('none');
        this.tableData.forEach((data) => data.setSortInactive());
        this.isSortActive = false;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaColumnDef, deps: [], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.2", type: UsaColumnDef, selector: "[usaColumnDef]", inputs: { usaColumnDef: "usaColumnDef" }, queries: [{ propertyName: "tableHeaderTemplate", first: true, predicate: UsaTableHeaderDef, descendants: true }, { propertyName: "tableHeader", first: true, predicate: UsaTableHeader, descendants: true }, { propertyName: "tableDataTemplate", first: true, predicate: UsaTableDataDef, descendants: true }, { propertyName: "tableSort", first: true, predicate: UsaSort, descendants: true }, { propertyName: "tableData", predicate: UsaTableData }], ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaColumnDef, decorators: [{
            type: Directive,
            args: [{
                    selector: `[usaColumnDef]`,
                }]
        }], propDecorators: { tableHeaderTemplate: [{
                type: ContentChild,
                args: [UsaTableHeaderDef]
            }], tableHeader: [{
                type: ContentChild,
                args: [UsaTableHeader]
            }], tableDataTemplate: [{
                type: ContentChild,
                args: [UsaTableDataDef]
            }], tableData: [{
                type: ContentChildren,
                args: [UsaTableData]
            }], tableSort: [{
                type: ContentChild,
                args: [UsaSort]
            }], usaColumnDef: [{
                type: Input
            }] } });
class UsaTableComponent {
    config;
    cdr;
    /**
     * Display table without column borders
     * @default false
     */
    borderless;
    /**
     * Allow table to scroll horizontally when content expand view width
     * @default true
     */
    scrollable;
    /**
     * Add alternating light/grey background color when displaying table rows
     * @default false
     */
    striped;
    /**
     * Minimize table cell padding
     * @default false
     */
    compact;
    /**
     * Stack table when in mobile sized view
     */
    stacked;
    /**
     * Displays first column as header when in stacked mode
     */
    stackedHeader;
    /**
     * Tracking function that will be used to check the differences in data changes.
     * Used similarly to ngFor trackBy function Optimize row operations by identifying
     * a row based on its data relative to the function to know if a row should be
     * added/removed/moved. Accepts a function that takes two parameters, index and item.
     */
    trackBy;
    /**
     * Whether or not the data is sorted server side. If set to true, then
     * the table will not perform sort operations on given data, but simply
     * handle bookkeeping of sort state and event emission
     */
    serverSideSort;
    /**
     * Highlight row which is currently being hovered by cursor
     */
    highlightRowOnHover;
    /**
     * Emitted whenever a column's sort button is clicked. Emits columns name and
     * sort state (ascending/descending) value
     */
    sortClicked = new EventEmitter();
    rowClicked = new EventEmitter();
    /**
     * The column definitions provided by the user that contain what the header, data, and footer
     * cells should render for each column.
     */
    _contentColumnDefs;
    /** Set of data row definitions that were provided to the table as content children. */
    _tableDataDefs;
    /** Set of header row definitions that were provided to the table as content children. */
    _contentHeaderRowDefs;
    /** Array Populated by Content Childern of UsaHeaderRowDef */
    _headerRowDefs;
    displayedData;
    _columnHeaderMap = new Map();
    _columnDataMap = new Map();
    /**
     * Reference of table sort info if new data is dynamically added / removed
     */
    _sortedColumnInfo = {
        sortState: undefined,
        sortFn: undefined,
        sortColumn: undefined,
    };
    _ariaLiveSortMessage;
    /**
     * Internal flag that gets raised anytime input data reference changes to indicate
     * next content check cycle, we need to re-evaluate the column with data sort active
     */
    _resortAfterContentCheck = false;
    /**
     * Event bubbled up from sort button on click. Sorts the table based on
     * sort function for the given column
     * @param $event
     */
    onSortClicked($event) {
        let isColumnFound = false;
        this._contentColumnDefs.forEach((column) => {
            if (!column.tableSort) {
                return;
            }
            const tableSortEl = column.tableSort._el.nativeElement;
            if (column.isSortActive && $event.target != tableSortEl) {
                column.setSortInactive();
            }
            else if (tableSortEl === $event.target) {
                this._sortColumnData(column, $event.detail.sortFn, $event.detail.sortState);
                isColumnFound = true;
            }
        });
        this.setAriaLiveOnSort();
        $event?.stopImmediatePropagation();
        if (!isColumnFound) {
            return;
        }
        const sortEvent = {
            column: this._sortedColumnInfo.sortColumn.usaColumnDef,
            sortState: this._sortedColumnInfo.sortState,
        };
        this.sortClicked.emit(sortEvent);
    }
    constructor(config, cdr) {
        this.config = config;
        this.cdr = cdr;
        this.borderless = this.config.borderless;
        this.compact = this.config.compact;
        this.scrollable = this.config.scrollable;
        this.striped = this.config.striped;
        this.stacked = this.config.stacked;
        this.stackedHeader = this.config.stackedHeader;
        this.serverSideSort = this.config.serverSideSort;
    }
    ngAfterContentInit() {
        this._contentColumnDefs.forEach((column) => {
            this._columnHeaderMap.set(column.usaColumnDef, column);
            this._columnDataMap.set(column.usaColumnDef, column.tableDataTemplate?.templateRef);
        });
        this._headerRowDefs = this._contentHeaderRowDefs.toArray();
    }
    ngOnChanges(changes) {
        if (!changes.displayedData || !this._sortedColumnInfo.sortColumn) {
            return;
        }
        this._resortAfterContentCheck = true;
        this.cdr.detectChanges();
    }
    ngAfterContentChecked() {
        if (!this._resortAfterContentCheck) {
            return;
        }
        this._sortColumnData(this._sortedColumnInfo.sortColumn, this._sortedColumnInfo.sortFn, this._sortedColumnInfo.sortState);
        this.cdr.detectChanges();
        this._resortAfterContentCheck = false;
    }
    _sortColumnData(sortColumn, sortFn, sortState) {
        sortColumn.setSortActive(sortState);
        this._sortedColumnInfo = {
            sortFn,
            sortState,
            sortColumn,
        };
        /**
         * Sorting done from server side - omit front end side sorting
         */
        if (this.serverSideSort) {
            return;
        }
        this.displayedData.sort((a, b) => {
            const valueA = a[sortColumn.usaColumnDef];
            const valueB = b[sortColumn.usaColumnDef];
            // Invert sorting if state is descending
            return sortState === 'ascending'
                ? sortFn(valueA, valueB)
                : -1 * sortFn(valueA, valueB);
        });
    }
    setAriaLiveOnSort() {
        if (!this._sortedColumnInfo.sortColumn ||
            !this._sortedColumnInfo.sortState) {
            return;
        }
        const sortedColumn = this._sortedColumnInfo.sortColumn.tableHeader._defaultAriaLabel;
        this._ariaLiveSortMessage = `The column ${sortedColumn} is now sorted in ${this._sortedColumnInfo.sortState} order`;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaTableComponent, deps: [{ token: UsaTableConfig }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.2", type: UsaTableComponent, selector: "usa-table", inputs: { borderless: "borderless", scrollable: "scrollable", striped: "striped", compact: "compact", stacked: "stacked", stackedHeader: "stackedHeader", trackBy: "trackBy", serverSideSort: "serverSideSort", highlightRowOnHover: "highlightRowOnHover", displayedData: "displayedData" }, outputs: { sortClicked: "sortClicked", rowClicked: "rowClicked" }, host: { listeners: { "sort": "onSortClicked($event)" } }, queries: [{ propertyName: "_tableDataDefs", first: true, predicate: UsaDataRowDef, descendants: true }, { propertyName: "_contentColumnDefs", predicate: UsaColumnDef, descendants: true }, { propertyName: "_contentHeaderRowDefs", predicate: UsaHeaderRowDef, descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div [ngClass]=\"{'usa-table-container--scrollable': scrollable}\">\n  <table role=\"table\" class=\"usa-table\" \n    [ngClass]=\"{\n      'usa-table--borderless': borderless, \n      'usa-table--striped': striped, \n      'usa-table--compact': compact,\n      'usa-table--stacked': stacked,\n      'usa-table--stacked-header': stackedHeader\n    }\">\n    <ng-content select=\"caption\"></ng-content>\n    <thead>\n      <ng-container *ngFor=\"let headerRowDef of _headerRowDefs\"\n        [ngTemplateOutlet]=\"headerTmpl\" [ngTemplateOutletContext]=\"{tableHeaders: headerRowDef.usaHeaderRowDef}\"></ng-container>\n    </thead>\n    <tbody>\n      <ng-container *ngFor=\"let data of displayedData; index as i; trackBy: trackBy ? trackBy : undefined\" \n        [ngTemplateOutlet]=\"dataTmpl\" [ngTemplateOutletContext]=\"{data: data, index: i}\"> </ng-container>\n    </tbody>\n  </table>\n</div>\n\n<div class=\"usa-sr-only usa-table__announcement-region\" aria-live=\"polite\">\n  {{_ariaLiveSortMessage}}\n</div>\n\n\n<!-- Table Header Template-->\n<ng-template #headerTmpl let-tableHeaders=\"tableHeaders\">\n  <tr>\n    <ng-container *ngFor=\"let header of tableHeaders\">\n      <ng-container [ngTemplateOutlet]=\"_columnHeaderMap?.get(header)?.tableHeaderTemplate?.templateRef\"></ng-container>\n    </ng-container>\n  </tr>\n</ng-template>\n\n\n<!-- Table Data Template -->\n<ng-template #dataTmpl let-data=\"data\" let-index=\"index\" >\n  <tr [usaHighlightOnHover]=\"highlightRowOnHover\" (click)=\"rowClicked.emit(data)\">\n    <th *ngIf=\"data.rowHeader\" scope=\"row\">{{data.rowHeader}}</th>\n    <ng-container \n      *ngFor=\"let header of _tableDataDefs.usaDataRowDefColumns\"\n      [ngTemplateOutlet]=\"_columnDataMap.get(header)\"\n      [ngTemplateOutletContext]=\"{\n        $implicit: data, \n        index: index\n      }\">\n    </ng-container>\n  </tr>\n</ng-template>\n\n\n", styles: ["::ng-deep tr.usa-table__row--hovered td{background-color:#e1f3f8!important;cursor:pointer}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: HighlightOnHoverDirective, selector: "tr[usaHighlightOnHover]", inputs: ["usaHighlightOnHover"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaTableComponent, decorators: [{
            type: Component,
            args: [{ selector: 'usa-table', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div [ngClass]=\"{'usa-table-container--scrollable': scrollable}\">\n  <table role=\"table\" class=\"usa-table\" \n    [ngClass]=\"{\n      'usa-table--borderless': borderless, \n      'usa-table--striped': striped, \n      'usa-table--compact': compact,\n      'usa-table--stacked': stacked,\n      'usa-table--stacked-header': stackedHeader\n    }\">\n    <ng-content select=\"caption\"></ng-content>\n    <thead>\n      <ng-container *ngFor=\"let headerRowDef of _headerRowDefs\"\n        [ngTemplateOutlet]=\"headerTmpl\" [ngTemplateOutletContext]=\"{tableHeaders: headerRowDef.usaHeaderRowDef}\"></ng-container>\n    </thead>\n    <tbody>\n      <ng-container *ngFor=\"let data of displayedData; index as i; trackBy: trackBy ? trackBy : undefined\" \n        [ngTemplateOutlet]=\"dataTmpl\" [ngTemplateOutletContext]=\"{data: data, index: i}\"> </ng-container>\n    </tbody>\n  </table>\n</div>\n\n<div class=\"usa-sr-only usa-table__announcement-region\" aria-live=\"polite\">\n  {{_ariaLiveSortMessage}}\n</div>\n\n\n<!-- Table Header Template-->\n<ng-template #headerTmpl let-tableHeaders=\"tableHeaders\">\n  <tr>\n    <ng-container *ngFor=\"let header of tableHeaders\">\n      <ng-container [ngTemplateOutlet]=\"_columnHeaderMap?.get(header)?.tableHeaderTemplate?.templateRef\"></ng-container>\n    </ng-container>\n  </tr>\n</ng-template>\n\n\n<!-- Table Data Template -->\n<ng-template #dataTmpl let-data=\"data\" let-index=\"index\" >\n  <tr [usaHighlightOnHover]=\"highlightRowOnHover\" (click)=\"rowClicked.emit(data)\">\n    <th *ngIf=\"data.rowHeader\" scope=\"row\">{{data.rowHeader}}</th>\n    <ng-container \n      *ngFor=\"let header of _tableDataDefs.usaDataRowDefColumns\"\n      [ngTemplateOutlet]=\"_columnDataMap.get(header)\"\n      [ngTemplateOutletContext]=\"{\n        $implicit: data, \n        index: index\n      }\">\n    </ng-container>\n  </tr>\n</ng-template>\n\n\n", styles: ["::ng-deep tr.usa-table__row--hovered td{background-color:#e1f3f8!important;cursor:pointer}\n"] }]
        }], ctorParameters: () => [{ type: UsaTableConfig }, { type: i0.ChangeDetectorRef }], propDecorators: { borderless: [{
                type: Input
            }], scrollable: [{
                type: Input
            }], striped: [{
                type: Input
            }], compact: [{
                type: Input
            }], stacked: [{
                type: Input
            }], stackedHeader: [{
                type: Input
            }], trackBy: [{
                type: Input
            }], serverSideSort: [{
                type: Input
            }], highlightRowOnHover: [{
                type: Input
            }], sortClicked: [{
                type: Output
            }], rowClicked: [{
                type: Output
            }], _contentColumnDefs: [{
                type: ContentChildren,
                args: [UsaColumnDef, { descendants: true }]
            }], _tableDataDefs: [{
                type: ContentChild,
                args: [UsaDataRowDef]
            }], _contentHeaderRowDefs: [{
                type: ContentChildren,
                args: [UsaHeaderRowDef, {
                        descendants: true,
                    }]
            }], displayedData: [{
                type: Input
            }], onSortClicked: [{
                type: HostListener,
                args: ['sort', ['$event']]
            }] } });

class UsaTableModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaTableModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.2", ngImport: i0, type: UsaTableModule, declarations: [UsaTableComponent,
            UsaColumnDef,
            UsaTableHeader,
            UsaTableHeaderDef,
            UsaHeaderRowDef,
            UsaTableDataDef,
            UsaDataRowDef,
            UsaSort,
            UsaTableData,
            HighlightOnHoverDirective], imports: [CommonModule], exports: [UsaTableComponent,
            UsaColumnDef,
            UsaTableHeader,
            UsaHeaderRowDef,
            UsaTableHeaderDef,
            UsaTableDataDef,
            UsaDataRowDef,
            UsaSort,
            UsaTableData,
            HighlightOnHoverDirective] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaTableModule, imports: [CommonModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaTableModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        UsaTableComponent,
                        UsaColumnDef,
                        UsaTableHeader,
                        UsaTableHeaderDef,
                        UsaHeaderRowDef,
                        UsaTableDataDef,
                        UsaDataRowDef,
                        UsaSort,
                        UsaTableData,
                        HighlightOnHoverDirective,
                    ],
                    imports: [
                        CommonModule
                    ],
                    exports: [
                        UsaTableComponent,
                        UsaColumnDef,
                        UsaTableHeader,
                        UsaHeaderRowDef,
                        UsaTableHeaderDef,
                        UsaTableDataDef,
                        UsaDataRowDef,
                        UsaSort,
                        UsaTableData,
                        HighlightOnHoverDirective,
                    ],
                }]
        }] });

let nextId$2 = 0;
class UsaTextareaComponent {
    control;
    model = '';
    _onChange = (_) => { };
    _onTouched = () => { };
    /**
     * Sets the ariaLabel attribute
     */
    ariaLabel = 'Textarea component';
    /**
     * Sets the rowHeight
     */
    rowHeight;
    /**
     * Sets the maxLength attribute
     */
    maxlength;
    /**
     * Sets the maxLength attribute
     */
    minlength;
    /**
     * Sets the id attribute
     */
    id = `usa-textarea-${nextId$2++}`;
    /**
     * Sets the placeholder attribute
     */
    placeholder = '';
    /**
     * Sets the name attribute
     */
    name = 'textarea';
    /**
     * Optional assistance text to be set when placeholder attribute is used
     */
    title;
    /**
     * Sets the disabled attribute
     */
    disabled;
    /**
     * Emits focus/blur  event
     */
    onBlur = new EventEmitter(null);
    /**
     *  emits the new value when the model value changes.
     */
    valueChange = new EventEmitter();
    /**
     * Sets the required attribute
     */
    required; // deprecated
    /**
     * Sets the required attribute
     */
    requiredFlag;
    /**
     * Sets the label text
     */
    label;
    /**
     * Sets the helpful description text
     */
    description;
    /**
     * Sets the general error message
     */
    errorMessage;
    wrapperRef;
    constructor(control) {
        this.control = control;
        this.control && (this.control.valueAccessor = this);
    }
    onInputChange(value) {
        this._onTouched();
        this.model = value;
        this._onChange(value);
        this.valueChange.emit(value);
    }
    focusChange(event) {
        this.model = event.target.value;
        this.updateModel();
        this.onBlur.emit(this.model);
        this._onTouched();
    }
    onValueChange(event) {
        this.model = event.target.value;
        this.updateModel();
    }
    onKeydown(event) {
        if (event.code == Key.Enter) {
            this.model = event.target.value;
            this.updateModel();
            event.preventDefault();
        }
    }
    // Helper method that gets a new instance of the model and notifies ControlValueAccessor that we have a new model for this FormControl (our custom component)
    updateModel() {
        this._onChange(this.model);
        if (this.wrapperRef)
            this.wrapperRef.formatErrors(this.control);
    }
    // ControlValueAccessor (and Formly) is trying to update the value of the FormControl (our custom component) programatically
    // If there is a value we will just overwrite items
    // If there is no value we reset the items array to be empty
    writeValue(value) {
        this.model = value;
    }
    // ControlValueAccessor hook that lets us call this._onChange(var) to let the form know our variable has changed (in this case model)
    registerOnChange(fn) {
        this._onChange = fn;
    }
    // ControlValueAccessor hook (not used)
    registerOnTouched(fn) {
        this._onTouched = fn;
    }
    // Set disable state
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    // Check for invalid
    get invalid() {
        return this.control ? this.control.invalid : false;
    }
    // To apply the error/success class for the textarea
    get showError() {
        if (!this.control) {
            return false;
        }
        const { dirty, touched } = this.control;
        return this.invalid ? dirty || touched : false;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaTextareaComponent, deps: [{ token: i1$1.NgControl, optional: true, self: true }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.2", type: UsaTextareaComponent, selector: "usa-textarea", inputs: { ariaLabel: "ariaLabel", rowHeight: "rowHeight", maxlength: "maxlength", minlength: "minlength", id: "id", placeholder: "placeholder", name: "name", title: "title", disabled: "disabled", required: "required", requiredFlag: "requiredFlag", label: "label", description: "description", errorMessage: "errorMessage", wrapperRef: "wrapperRef" }, outputs: { onBlur: "onBlur", valueChange: "valueChange" }, ngImport: i0, template: "<textarea [ngClass]=\"{'usa-input--error': showError, 'usa-input--success': !showError && control && control.valid}\"\n  [ngModel]=\"model\" type=\"textarea\" class=\"usa-textarea\" [attr.id]=\"id\" [attr.name]=\"name\"\n  [attr.placeholder]=\"placeholder\" #textarea [attr.title]=\"title\" [rows]=\"rowHeight\" [minlength]=\"minlength\"\n  [attr.maxlength]=\"maxlength ? maxlength : 524288\" [disabled]=\"disabled\" (ngModelChange)=\"onInputChange($event)\"\n  (focus)=\"focusChange($event)\" (blur)=\"focusChange($event)\" (input)=\"onValueChange($event)\"\n  (keydown)=\"onKeydown($event)\" [ngModelOptions]=\"{standalone: true}\">\n  </textarea>\n", dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$1.MinLengthValidator, selector: "[minlength][formControlName],[minlength][formControl],[minlength][ngModel]", inputs: ["minlength"] }, { kind: "directive", type: i1$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaTextareaComponent, decorators: [{
            type: Component,
            args: [{ selector: 'usa-textarea', template: "<textarea [ngClass]=\"{'usa-input--error': showError, 'usa-input--success': !showError && control && control.valid}\"\n  [ngModel]=\"model\" type=\"textarea\" class=\"usa-textarea\" [attr.id]=\"id\" [attr.name]=\"name\"\n  [attr.placeholder]=\"placeholder\" #textarea [attr.title]=\"title\" [rows]=\"rowHeight\" [minlength]=\"minlength\"\n  [attr.maxlength]=\"maxlength ? maxlength : 524288\" [disabled]=\"disabled\" (ngModelChange)=\"onInputChange($event)\"\n  (focus)=\"focusChange($event)\" (blur)=\"focusChange($event)\" (input)=\"onValueChange($event)\"\n  (keydown)=\"onKeydown($event)\" [ngModelOptions]=\"{standalone: true}\">\n  </textarea>\n" }]
        }], ctorParameters: () => [{ type: i1$1.NgControl, decorators: [{
                    type: Self
                }, {
                    type: Optional
                }] }], propDecorators: { ariaLabel: [{
                type: Input
            }], rowHeight: [{
                type: Input
            }], maxlength: [{
                type: Input
            }], minlength: [{
                type: Input
            }], id: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], name: [{
                type: Input
            }], title: [{
                type: Input
            }], disabled: [{
                type: Input
            }], onBlur: [{
                type: Output
            }], valueChange: [{
                type: Output
            }], required: [{
                type: Input
            }], requiredFlag: [{
                type: Input
            }], label: [{
                type: Input
            }], description: [{
                type: Input
            }], errorMessage: [{
                type: Input
            }], wrapperRef: [{
                type: Input
            }] } });

class FormFieldComponent {
    cdr;
    /**
     * sets the label text
     */
    label;
    /**
     * sets the id attribute value
     */
    id;
    /**
     * sets the description text
     */
    description;
    /**
     * deprecated, toggles the required text
     */
    required = false;
    /**
     * toggles the required text
     */
    requiredFlag = false;
    /**
     * set the error message
     */
    set errorMessage(message) {
        this._errorMessage = message;
    }
    get errorMessage() {
        return this._errorMessage;
    }
    input;
    errorElId;
    descriptionElId;
    _errorMessage = '';
    constructor(cdr) {
        this.cdr = cdr;
    }
    formatErrors(control) {
        if (!control) {
            return;
        }
        if (control.pristine || !control.errors) {
            this.errorMessage = '';
            return;
        }
        if (control.invalid && control.errors) {
            for (const k in control.errors) {
                const errorObject = control.errors[k];
                // to check if it's not null & is object
                if (errorObject.message !== null &&
                    typeof errorObject.message === 'object') {
                    this.errorMessage = errorObject.message;
                    return;
                }
                this.setInvalidErrors(k, errorObject);
            }
        }
    }
    clearError() {
        this.errorMessage = '';
    }
    setInvalidErrors(error, errorObject) {
        const actualLength = errorObject.actualLength;
        const requiredLength = errorObject.requiredLength;
        switch (error) {
            case 'minlength':
                this.errorMessage = `The number of characters should not be less than ${requiredLength}`;
                return;
            case 'maxlength':
                this.errorMessage =
                    actualLength +
                        ' characters input but max length is ' +
                        requiredLength;
                return;
            case 'required':
                this.errorMessage = 'This field is required';
                return;
            case 'isNotBeforeToday':
                this.errorMessage = 'Date must not be before today';
                return;
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: FormFieldComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.2", type: FormFieldComponent, selector: "usa-form-field", inputs: { label: "label", id: "id", description: "description", required: "required", requiredFlag: "requiredFlag", errorMessage: "errorMessage" }, ngImport: i0, template: "<div #labelDiv [class.usa-form-group--error]=\"!!errorMessage\" class=\"usa-form-group \">\n  <label *ngIf=\"!!label\" [attr.for]=\"id\" class=\"usa-label\" [class.usa-input-error-label]=\"errorMessage\">\n    {{ label || '' }}\n    <span *ngIf=\"required || requiredFlag\">\n      (Required)\n    </span>\n  </label>\n  <div *ngIf=\"description\" [attr.id]=\"id\" class=\"usa-label--description form-text text-muted\" [innerHTML]=\"description\">\n  </div>\n  <div *ngIf=\"!!errorMessage\" class=\"usa-error-message\" [style.display]=\"'block'\" [attr.id]=\"errorElId\">\n    {{errorMessage}}\n  </div>\n  <ng-content></ng-content>\n</div>\n", dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: FormFieldComponent, decorators: [{
            type: Component,
            args: [{ selector: 'usa-form-field', template: "<div #labelDiv [class.usa-form-group--error]=\"!!errorMessage\" class=\"usa-form-group \">\n  <label *ngIf=\"!!label\" [attr.for]=\"id\" class=\"usa-label\" [class.usa-input-error-label]=\"errorMessage\">\n    {{ label || '' }}\n    <span *ngIf=\"required || requiredFlag\">\n      (Required)\n    </span>\n  </label>\n  <div *ngIf=\"description\" [attr.id]=\"id\" class=\"usa-label--description form-text text-muted\" [innerHTML]=\"description\">\n  </div>\n  <div *ngIf=\"!!errorMessage\" class=\"usa-error-message\" [style.display]=\"'block'\" [attr.id]=\"errorElId\">\n    {{errorMessage}}\n  </div>\n  <ng-content></ng-content>\n</div>\n" }]
        }], ctorParameters: () => [{ type: i0.ChangeDetectorRef }], propDecorators: { label: [{
                type: Input
            }], id: [{
                type: Input
            }], description: [{
                type: Input
            }], required: [{
                type: Input
            }], requiredFlag: [{
                type: Input
            }], errorMessage: [{
                type: Input
            }] } });

class USWDSFormFieldModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: USWDSFormFieldModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.2", ngImport: i0, type: USWDSFormFieldModule, declarations: [FormFieldComponent], imports: [CommonModule], exports: [FormFieldComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: USWDSFormFieldModule, imports: [CommonModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: USWDSFormFieldModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FormFieldComponent],
                    exports: [FormFieldComponent],
                    imports: [CommonModule],
                }]
        }] });

class UsaTextareaModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaTextareaModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.2", ngImport: i0, type: UsaTextareaModule, declarations: [UsaTextareaComponent], imports: [CommonModule,
            ReactiveFormsModule,
            USWDSFormFieldModule,
            FormsModule], exports: [UsaTextareaComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaTextareaModule, imports: [CommonModule,
            ReactiveFormsModule,
            USWDSFormFieldModule,
            FormsModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaTextareaModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [UsaTextareaComponent],
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        USWDSFormFieldModule,
                        FormsModule,
                    ],
                    exports: [UsaTextareaComponent],
                }]
        }] });

class UsaTooltipDirective {
    el;
    renderer;
    // Span which contains the tooltip text
    tooltipBody;
    // Element which causes tooltip to be shown, tooltip apppears relative to this
    tooltipTrigger;
    // Element which wraps tooltip and trigger
    tooltipWrapper;
    TRIANGLE_SIZE = 5;
    position = 'top';
    /**
     * Value to be displayed in tooltip
     */
    title;
    /**
     * Additional classes to be applied to wrapper
     */
    classes;
    constructor(el, renderer) {
        this.el = el;
        this.renderer = renderer;
    }
    ngAfterViewInit() {
        const tooltipID = `tooltip-${Math.floor(Math.random() * 900000) + 100000}`;
        this.tooltipTrigger = this.el.nativeElement;
        this.tooltipWrapper = document.createElement('span');
        this.tooltipBody = document.createElement('span');
        this.tooltipTrigger.setAttribute('aria-describedby', tooltipID);
        this.tooltipTrigger.setAttribute('tabindex', '0');
        this.tooltipTrigger.classList.remove('usa-tooltip');
        const parent = this.renderer.parentNode(this.el.nativeElement);
        parent.replaceChild(this.tooltipWrapper, this.el.nativeElement);
        this.renderer.appendChild(this.tooltipWrapper, this.tooltipTrigger);
        this.renderer.appendChild(this.tooltipWrapper, this.tooltipBody);
        this.renderer.addClass(this.tooltipWrapper, 'usa-tooltip');
        if (this.classes) {
            this.classes
                .split(' ')
                .forEach((className) => this.tooltipWrapper.classList.add(className));
        }
        this.renderer.addClass(this.tooltipBody, 'usa-tooltip__body');
        this.renderer.setAttribute(this.tooltipBody, 'id', tooltipID);
        this.renderer.setAttribute(this.tooltipBody, 'role', 'tooltip');
        this.renderer.setAttribute(this.tooltipBody, 'aria-hidden', 'true');
        const text = this.renderer.createText(this.title);
        this.renderer.appendChild(this.tooltipBody, text);
    }
    positionTop() {
        this.resetPositionStyles(this.tooltipBody);
        const top = this.calculateMarginOffset('top', this.tooltipBody.offsetHeight, this.tooltipTrigger);
        const left = this.calculateMarginOffset('left', this.tooltipBody.offsetWidth, this.tooltipTrigger);
        this.setPositionClass('top');
        this.tooltipBody.style.left = '50%';
        this.tooltipBody.style.top = `-${this.TRIANGLE_SIZE}px`;
        this.tooltipBody.style.margin = `-${top}px 0 0 -${left / 2}px`;
    }
    positionBottom() {
        this.resetPositionStyles(this.tooltipBody);
        const left = this.calculateMarginOffset('left', this.tooltipBody.offsetWidth, this.tooltipTrigger);
        this.setPositionClass('bottom');
        this.tooltipBody.style.left = '50%';
        this.tooltipBody.style.margin = `${this.TRIANGLE_SIZE}px 0 0 -${left / 2}px`;
    }
    positionLeft() {
        this.resetPositionStyles(this.tooltipBody);
        const top = this.calculateMarginOffset('top', this.tooltipBody.offsetHeight, this.tooltipTrigger);
        const left = this.calculateMarginOffset('left', this.tooltipTrigger.offsetLeft > this.tooltipBody.offsetWidth
            ? this.tooltipTrigger.offsetLeft - this.tooltipBody.offsetWidth
            : this.tooltipBody.offsetWidth, this.tooltipTrigger);
        this.setPositionClass('left');
        this.tooltipBody.style.top = `50%`;
        this.tooltipBody.style.left = `-${this.TRIANGLE_SIZE}px`;
        this.tooltipBody.style.margin = `-${top / 2}px 0 0 ${this.tooltipTrigger.offsetLeft > this.tooltipBody.offsetWidth
            ? left
            : -left}px`;
    }
    positionRight() {
        this.resetPositionStyles(this.tooltipBody);
        const top = this.calculateMarginOffset('top', this.tooltipBody.offsetHeight, this.tooltipTrigger);
        this.setPositionClass('right');
        this.tooltipBody.style.top = '50%';
        this.tooltipBody.style.left = `${this.tooltipTrigger.offsetLeft +
            this.tooltipTrigger.offsetWidth +
            this.TRIANGLE_SIZE}px`;
        this.tooltipBody.style.margin = `-${top / 2}px 0 0 0`;
    }
    setPositionClass(position) {
        this.renderer.removeClass(this.tooltipBody, 'usa-tooltip__body--top');
        this.renderer.removeClass(this.tooltipBody, 'usa-tooltip__body--bottom');
        this.renderer.removeClass(this.tooltipBody, 'usa-tooltip__body--left');
        this.renderer.removeClass(this.tooltipBody, 'usa-tooltip__body--right');
        this.renderer.addClass(this.tooltipBody, `usa-tooltip__body--${position}`);
    }
    show() {
        this.tooltipBody.setAttribute('aria-hidden', 'false');
        this.renderer.addClass(this.tooltipBody, 'is-set');
        this.renderer.addClass(this.tooltipBody, 'is-visible');
        switch (this.position) {
            case 'top': {
                this.positionTop();
                if (!this.isInViewport(this.tooltipBody)) {
                    this.positionBottom();
                }
                break;
            }
            case 'bottom': {
                this.positionBottom();
                if (!this.isInViewport(this.tooltipBody)) {
                    this.positionTop();
                }
                break;
            }
            case 'left':
                this.positionLeft();
                if (!this.isInViewport(this.tooltipBody)) {
                    this.positionRight();
                    if (!this.isInViewport(this.tooltipBody)) {
                        this.positionTop();
                    }
                }
                break;
            case 'right':
                this.positionRight();
                if (!this.isInViewport(this.tooltipBody)) {
                    this.positionLeft();
                    if (!this.isInViewport(this.tooltipBody)) {
                        this.positionTop();
                    }
                }
                break;
        }
    }
    hide() {
        this.renderer.removeClass(this.tooltipBody, 'is-set');
        this.renderer.removeClass(this.tooltipBody, 'is-visible');
        this.tooltipBody.setAttribute('aria-hidden', 'true');
    }
    isInViewport(elementToCheck) {
        const rect = elementToCheck.getBoundingClientRect();
        return (rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <=
                (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth));
    }
    offsetMargin(target, propertyToCheck) {
        return parseInt(window.getComputedStyle(target).getPropertyValue(propertyToCheck), 10);
    }
    calculateMarginOffset(positionToCheck, bodyOffset, trigger) {
        return this.offsetMargin(trigger, `margin-${positionToCheck}`) > 0
            ? bodyOffset - this.offsetMargin(trigger, `margin-${positionToCheck}`)
            : bodyOffset;
    }
    resetPositionStyles(target) {
        target.style.top = null;
        target.style.bottom = null;
        target.style.right = null;
        target.style.left = null;
        target.style.margin = null;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaTooltipDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.2", type: UsaTooltipDirective, selector: "[usaTooltip]", inputs: { position: "position", title: "title", classes: "classes" }, host: { listeners: { "mouseenter": "show()", "focus": "show()", "mouseleave": "hide()", "blur": "hide()" }, classAttribute: "usa-tooltip__trigger" }, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaTooltipDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[usaTooltip]',
                    host: {
                        class: 'usa-tooltip__trigger',
                        '(mouseenter)': 'show()',
                        '(focus)': 'show()',
                        '(mouseleave)': 'hide()',
                        '(blur)': 'hide()',
                    },
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i0.Renderer2 }], propDecorators: { position: [{
                type: Input
            }], title: [{
                type: Input
            }], classes: [{
                type: Input
            }] } });

class UsaTooltipModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaTooltipModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.2", ngImport: i0, type: UsaTooltipModule, declarations: [UsaTooltipDirective], imports: [CommonModule], exports: [UsaTooltipDirective] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaTooltipModule, imports: [CommonModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaTooltipModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                    ],
                    declarations: [
                        UsaTooltipDirective
                    ],
                    exports: [
                        UsaTooltipDirective
                    ]
                }]
        }] });

/** @docs-private */
function createMissingDateImplError(provider) {
    return Error(`UsaDatePicker: No provider found for ${provider}. You must import one of the following ` +
        `modules at your application root: UsaNativeDateModule, UsaMomentDateModule, or provide a ` +
        `custom implementation.`);
}

/** For internal use - directive that adds or removes class based on hover */
class HoverClassDirective {
    elementRef;
    constructor(elementRef) {
        this.elementRef = elementRef;
    }
    hoverClass;
    onMouseEnter() {
        this.elementRef.nativeElement.classList.add(this.hoverClass);
    }
    onMouseLeave() {
        this.elementRef.nativeElement.classList.remove(this.hoverClass);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: HoverClassDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.2", type: HoverClassDirective, selector: "[hover-class]", inputs: { hoverClass: ["hover-class", "hoverClass"] }, host: { listeners: { "mouseenter": "onMouseEnter()", "mouseleave": "onMouseLeave()" } }, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: HoverClassDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[hover-class]'
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { hoverClass: [{
                type: Input,
                args: ['hover-class']
            }], onMouseEnter: [{
                type: HostListener,
                args: ['mouseenter']
            }], onMouseLeave: [{
                type: HostListener,
                args: ['mouseleave']
            }] } });
class HoverClassModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: HoverClassModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.2", ngImport: i0, type: HoverClassModule, declarations: [HoverClassDirective], imports: [CommonModule], exports: [HoverClassDirective] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: HoverClassModule, imports: [CommonModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: HoverClassModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [HoverClassDirective],
                    imports: [CommonModule],
                    exports: [HoverClassDirective]
                }]
        }] });

/**
 * An internal class that represents the data corresponding to a single calendar cell.
 * @docs-private
 */
class UsaCalendarCell {
    value;
    displayValue;
    ariaLabel;
    enabled;
    cssClasses;
    compareValue;
    rawValue;
    constructor(value, displayValue, ariaLabel, enabled, cssClasses = {}, compareValue = value, rawValue) {
        this.value = value;
        this.displayValue = displayValue;
        this.ariaLabel = ariaLabel;
        this.enabled = enabled;
        this.cssClasses = cssClasses;
        this.compareValue = compareValue;
        this.rawValue = rawValue;
    }
}
/**
 * An internal component used to display calendar data in a table.
 * @docs-private
 */
class UsaCalendarBody {
    _elementRef;
    _ngZone;
    /**
     * Used to skip the next focus event when rendering the preview range.
     * We need a flag like this, because some browsers fire focus events asynchronously.
     */
    _skipNextFocus;
    view;
    /** The label for the table. (e.g. "Jan 2017"). */
    label;
    /** The cells to display in the table. */
    rows;
    prevMonthRow;
    nextMonthRow;
    /** The value in the table that corresponds to today. */
    todayValue;
    /** Start value of the selected date range. */
    startValue;
    /** End value of the selected date range. */
    endValue;
    /** The minimum number of free cells needed to fit the label in the first row. */
    labelMinRequiredCells;
    /** The number of columns in the table. */
    numCols = 7;
    /** The cell number of the active cell in the table. */
    activeCell = 0;
    /** Whether a range is being selected. */
    isRange = false;
    /**
     * The aspect ratio (width / height) to use for the cells in the table. This aspect ratio will be
     * maintained even as the table resizes.
     */
    cellAspectRatio = 1;
    /** Start of the comparison range. */
    comparisonStart;
    /** End of the comparison range. */
    comparisonEnd;
    /** Start of the preview range. */
    previewStart = null;
    /** End of the preview range. */
    previewEnd = null;
    /** Emits when a new value is selected. */
    selectedValueChange = new EventEmitter();
    /** Emits when the preview has changed as a result of a user action. */
    previewChange = new EventEmitter();
    /** The number of blank cells to put at the beginning for the first row. */
    _firstRowOffset;
    /** Padding for the individual date cells. */
    _cellPadding;
    /** Width of an individual cell. */
    _cellWidth;
    constructor(_elementRef, _ngZone) {
        this._elementRef = _elementRef;
        this._ngZone = _ngZone;
        _ngZone.runOutsideAngular(() => {
            const element = _elementRef.nativeElement;
            element.addEventListener('mouseenter', this._enterHandler, true);
            element.addEventListener('focus', this._enterHandler, true);
            element.addEventListener('mouseleave', this._leaveHandler, true);
            element.addEventListener('blur', this._leaveHandler, true);
        });
    }
    /** Called when a cell is clicked. */
    _cellClicked(cell, event) {
        if (cell.enabled) {
            this.selectedValueChange.emit({ value: cell.compareValue, event });
        }
    }
    /** Returns whether a cell should be marked as selected. */
    _isSelected(value) {
        return this.startValue === value || this.endValue === value;
    }
    ngOnChanges(changes) {
        const columnChanges = changes['numCols'];
        const { rows, numCols } = this;
        if (changes['rows'] || columnChanges) {
            this._firstRowOffset = rows && rows.length && rows[0].length ? numCols - rows[0].length : 0;
        }
        if (changes['cellAspectRatio'] || columnChanges || !this._cellPadding) {
            this._cellPadding = `${50 * this.cellAspectRatio / numCols}%`;
        }
        if (columnChanges || !this._cellWidth) {
            this._cellWidth = `${100 / numCols}%`;
        }
    }
    ngOnDestroy() {
        const element = this._elementRef.nativeElement;
        element.removeEventListener('mouseenter', this._enterHandler, true);
        element.removeEventListener('focus', this._enterHandler, true);
        element.removeEventListener('mouseleave', this._leaveHandler, true);
        element.removeEventListener('blur', this._leaveHandler, true);
    }
    /** Returns whether a cell is active. */
    _isActiveCell(rowIndex, colIndex) {
        let cellNumber = rowIndex * this.numCols + colIndex;
        // Account for the fact that the first row may not have as many cells.
        if (rowIndex) {
            cellNumber -= this._firstRowOffset;
        }
        return cellNumber == this.activeCell;
    }
    /** Focuses the active cell after the microtask queue is empty. */
    _focusActiveCell(movePreview = true) {
        this._ngZone.runOutsideAngular(() => {
            this._ngZone.onStable.pipe(take(1)).subscribe(() => {
                const activeCell = this._elementRef.nativeElement.querySelector('.usa-date-picker__calendar__date--focused');
                if (activeCell) {
                    if (!movePreview) {
                        this._skipNextFocus = true;
                    }
                    activeCell.focus();
                }
            });
        });
    }
    /** Gets whether a value is the start of the main range. */
    _isRangeStart(value) {
        return isStart(value, this.startValue, this.endValue);
    }
    /** Gets whether a value is the end of the main range. */
    _isRangeEnd(value) {
        return isEnd(value, this.startValue, this.endValue);
    }
    /** Gets whether a value is within the currently-selected range. */
    _isInRange(value) {
        return isInRange(value, this.startValue, this.endValue, this.isRange);
    }
    /** Gets whether a value is the start of the comparison range. */
    _isComparisonStart(value) {
        return isStart(value, this.comparisonStart, this.comparisonEnd);
    }
    /** Whether the cell is a start bridge cell between the main and comparison ranges. */
    _isComparisonBridgeStart(value, rowIndex, colIndex) {
        if (!this._isComparisonStart(value) || this._isRangeStart(value) || !this._isInRange(value)) {
            return false;
        }
        let previousCell = this.rows[rowIndex][colIndex - 1];
        if (!previousCell) {
            const previousRow = this.rows[rowIndex - 1];
            previousCell = previousRow && previousRow[previousRow.length - 1];
        }
        return previousCell && !this._isRangeEnd(previousCell.compareValue);
    }
    /** Whether the cell is an end bridge cell between the main and comparison ranges. */
    _isComparisonBridgeEnd(value, rowIndex, colIndex) {
        if (!this._isComparisonEnd(value) || this._isRangeEnd(value) || !this._isInRange(value)) {
            return false;
        }
        let nextCell = this.rows[rowIndex][colIndex + 1];
        if (!nextCell) {
            const nextRow = this.rows[rowIndex + 1];
            nextCell = nextRow && nextRow[0];
        }
        return nextCell && !this._isRangeStart(nextCell.compareValue);
    }
    /** Gets whether a value is the end of the comparison range. */
    _isComparisonEnd(value) {
        return isEnd(value, this.comparisonStart, this.comparisonEnd);
    }
    /** Gets whether a value is within the current comparison range. */
    _isInComparisonRange(value) {
        return isInRange(value, this.comparisonStart, this.comparisonEnd, this.isRange);
    }
    /**
     * Gets whether a value is the same as the start and end of the comparison range.
     * For context, the functions that we use to determine whether something is the start/end of
     * a range don't allow for the start and end to be on the same day, because we'd have to use
     * much more specific CSS selectors to style them correctly in all scenarios. This is fine for
     * the regular range, because when it happens, the selected styles take over and still show where
     * the range would've been, however we don't have these selected styles for a comparison range.
     * This function is used to apply a class that serves the same purpose as the one for selected
     * dates, but it only applies in the context of a comparison range.
     */
    _isComparisonIdentical(value) {
        // Note that we don't need to null check the start/end
        // here, because the `value` will always be defined.
        return this.comparisonStart === this.comparisonEnd && value === this.comparisonStart;
    }
    /** Gets whether a value is the start of the preview range. */
    _isPreviewStart(value) {
        return isStart(value, this.previewStart, this.previewEnd);
    }
    /** Gets whether a value is the end of the preview range. */
    _isPreviewEnd(value) {
        return isEnd(value, this.previewStart, this.previewEnd);
    }
    /** Gets whether a value is inside the preview range. */
    _isInPreview(value) {
        return isInRange(value, this.previewStart, this.previewEnd, this.isRange);
    }
    /**
     * Event handler for when the user enters an element
     * inside the calendar body (e.g. by hovering in or focus).
     */
    _enterHandler = (event) => {
        if (this._skipNextFocus && event.type === 'focus') {
            this._skipNextFocus = false;
            return;
        }
        // We only need to hit the zone when we're selecting a range.
        if (event.target && this.isRange) {
            const cell = this._getCellFromElement(event.target);
            if (cell) {
                this._ngZone.run(() => this.previewChange.emit({ value: cell.enabled ? cell : null, event }));
            }
        }
    };
    /**
     * Event handler for when the user's pointer leaves an element
     * inside the calendar body (e.g. by hovering out or blurring).
     */
    _leaveHandler = (event) => {
        // We only need to hit the zone when we're selecting a range.
        if (this.previewEnd !== null && this.isRange) {
            // Only reset the preview end value when leaving cells. This looks better, because
            // we have a gap between the cells and the rows and we don't want to remove the
            // range just for it to show up again when the user moves a few pixels to the side.
            if (event.target && isTableCell(event.target)) {
                this._ngZone.run(() => this.previewChange.emit({ value: null, event }));
            }
        }
    };
    /** Finds the UsaCalendarCell that corresponds to a DOM node. */
    _getCellFromElement(element) {
        let cell;
        if (isTableCell(element)) {
            cell = element;
        }
        else if (isTableCell(element.parentNode)) {
            cell = element.parentNode;
        }
        if (cell) {
            const row = cell.getAttribute('data-mat-row');
            const col = cell.getAttribute('data-mat-col');
            if (row && col) {
                return this.rows[parseInt(row)][parseInt(col)];
            }
        }
        return null;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaCalendarBody, deps: [{ token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.2", type: UsaCalendarBody, selector: "[usa-calendar-body]", inputs: { view: "view", label: "label", rows: "rows", prevMonthRow: "prevMonthRow", nextMonthRow: "nextMonthRow", todayValue: "todayValue", startValue: "startValue", endValue: "endValue", labelMinRequiredCells: "labelMinRequiredCells", numCols: "numCols", activeCell: "activeCell", isRange: "isRange", cellAspectRatio: "cellAspectRatio", comparisonStart: "comparisonStart", comparisonEnd: "comparisonEnd", previewStart: "previewStart", previewEnd: "previewEnd" }, outputs: { selectedValueChange: "selectedValueChange", previewChange: "previewChange" }, exportAs: ["usaCalendarBody"], usesOnChanges: true, ngImport: i0, template: "\n<!-- Create the first row separately so we can include a special spacer cell. -->\n<tr *ngFor=\"let row of rows; let rowIndex = index\" role=\"row\">\n  <!-- First Row -->\n  <ng-container *ngIf=\"rowIndex === 0\">\n    <td *ngFor=\"let item of prevMonthRow; let colIndex = index\">\n      <ng-container [ngTemplateOutlet]=\"cellButton\" \n        [ngTemplateOutletContext]=\"{$implicit: {item: item, prevMonth: true}}\"></ng-container>\n    </td>\n    <td *ngFor=\"let item of rows[0]; let colIndex = index\">\n      <ng-container [ngTemplateOutlet]=\"cellButton\" \n        [ngTemplateOutletContext]=\"{$implicit: {item: item, rowIndex: rowIndex, colIndex: colIndex}}\">\n      </ng-container>\n    </td>\n  </ng-container>\n\n  <!-- Middle rows -->\n  <ng-container *ngIf=\"rowIndex > 0 && rowIndex < rows.length - 1\">\n    <td *ngFor=\"let item of row; let colIndex = index\">\n      <ng-container [ngTemplateOutlet]=\"cellButton\" [ngTemplateOutletContext]=\"{$implicit: {item: item, rowIndex: rowIndex, colIndex: colIndex}}\"></ng-container>\n    </td>\n  </ng-container>\n\n  <ng-container *ngIf=\"rowIndex === rows.length - 1\">\n    <td *ngFor=\"let item of rows[rows.length - 1]; let colIndex = index\">\n      <ng-container [ngTemplateOutlet]=\"cellButton\" [ngTemplateOutletContext]=\"{$implicit: {item: item, rowIndex: rowIndex, colIndex: colIndex}}\"></ng-container>\n    </td>\n    <td *ngFor=\"let item of nextMonthRow; let colIndex = index\">\n      <ng-container [ngTemplateOutlet]=\"cellButton\" \n        [ngTemplateOutletContext]=\"{$implicit: {item: item, nextMonth: true}}\">\n      </ng-container>\n    </td>\n  </ng-container>\n</tr>\n\n<ng-template #cellButton let-data>\n  <button\n  role=\"gridcell\"\n  class=\"usa-date-picker__calendar__date\"\n  [hover-class]=\"'usa-date-picker__calendar__date--focused'\"\n  [ngClass]=\"data.item.cssClasses\"\n  [tabindex]=\"_isActiveCell(data.rowIndex, data.colIndex) ? 0 : -1\"\n  [attr.aria-disabled]=\"!data.item.enabled\"\n  [class.text-base-light]=\"data.item.enabled ? undefined : true\"\n  [class.usa-date-picker__calendar__date--selected]=\"_isSelected(data.item.compareValue)\"\n  [class.usa-date-picker__calendar__date--current-month]=\"view === 'month' && !data.prevMonth && !data.nextMonth && data.item.enabled\"\n  [class.usa-date-picker__calendar__date--previous-month]=\"view === 'month' &&  data.prevMonth && data.item.enabled\"\n  [class.usa-date-picker__calendar__date--next-month]=\"view === 'month' && data.nextMonth && data.item.enabled\"\n  [class.usa-date-picker__calendar__date--today]=\"!data.prevMonth && !data.nextMonth && todayValue === data.item.compareValue\"\n  [class.usa-date-picker__calendar__date--focused]=\"_isActiveCell(data.rowIndex, data.colIndex)\"\n  [class.usa-date-picker__calendar__year]=\"view === 'multi-year'\"\n  [attr.aria-label]=\"data.item.ariaLabel\"\n  [attr.aria-disabled]=\"!data.item.enabled || null\"\n  [attr.aria-selected]=\"_isSelected(data.item.compareValue)\"\n  (click)=\"_cellClicked(data.item, $event)\">\n    {{data.item.displayValue}}\n</button>\n</ng-template>", dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: HoverClassDirective, selector: "[hover-class]", inputs: ["hover-class"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaCalendarBody, decorators: [{
            type: Component,
            args: [{ selector: '[usa-calendar-body]', exportAs: 'usaCalendarBody', changeDetection: ChangeDetectionStrategy.OnPush, template: "\n<!-- Create the first row separately so we can include a special spacer cell. -->\n<tr *ngFor=\"let row of rows; let rowIndex = index\" role=\"row\">\n  <!-- First Row -->\n  <ng-container *ngIf=\"rowIndex === 0\">\n    <td *ngFor=\"let item of prevMonthRow; let colIndex = index\">\n      <ng-container [ngTemplateOutlet]=\"cellButton\" \n        [ngTemplateOutletContext]=\"{$implicit: {item: item, prevMonth: true}}\"></ng-container>\n    </td>\n    <td *ngFor=\"let item of rows[0]; let colIndex = index\">\n      <ng-container [ngTemplateOutlet]=\"cellButton\" \n        [ngTemplateOutletContext]=\"{$implicit: {item: item, rowIndex: rowIndex, colIndex: colIndex}}\">\n      </ng-container>\n    </td>\n  </ng-container>\n\n  <!-- Middle rows -->\n  <ng-container *ngIf=\"rowIndex > 0 && rowIndex < rows.length - 1\">\n    <td *ngFor=\"let item of row; let colIndex = index\">\n      <ng-container [ngTemplateOutlet]=\"cellButton\" [ngTemplateOutletContext]=\"{$implicit: {item: item, rowIndex: rowIndex, colIndex: colIndex}}\"></ng-container>\n    </td>\n  </ng-container>\n\n  <ng-container *ngIf=\"rowIndex === rows.length - 1\">\n    <td *ngFor=\"let item of rows[rows.length - 1]; let colIndex = index\">\n      <ng-container [ngTemplateOutlet]=\"cellButton\" [ngTemplateOutletContext]=\"{$implicit: {item: item, rowIndex: rowIndex, colIndex: colIndex}}\"></ng-container>\n    </td>\n    <td *ngFor=\"let item of nextMonthRow; let colIndex = index\">\n      <ng-container [ngTemplateOutlet]=\"cellButton\" \n        [ngTemplateOutletContext]=\"{$implicit: {item: item, nextMonth: true}}\">\n      </ng-container>\n    </td>\n  </ng-container>\n</tr>\n\n<ng-template #cellButton let-data>\n  <button\n  role=\"gridcell\"\n  class=\"usa-date-picker__calendar__date\"\n  [hover-class]=\"'usa-date-picker__calendar__date--focused'\"\n  [ngClass]=\"data.item.cssClasses\"\n  [tabindex]=\"_isActiveCell(data.rowIndex, data.colIndex) ? 0 : -1\"\n  [attr.aria-disabled]=\"!data.item.enabled\"\n  [class.text-base-light]=\"data.item.enabled ? undefined : true\"\n  [class.usa-date-picker__calendar__date--selected]=\"_isSelected(data.item.compareValue)\"\n  [class.usa-date-picker__calendar__date--current-month]=\"view === 'month' && !data.prevMonth && !data.nextMonth && data.item.enabled\"\n  [class.usa-date-picker__calendar__date--previous-month]=\"view === 'month' &&  data.prevMonth && data.item.enabled\"\n  [class.usa-date-picker__calendar__date--next-month]=\"view === 'month' && data.nextMonth && data.item.enabled\"\n  [class.usa-date-picker__calendar__date--today]=\"!data.prevMonth && !data.nextMonth && todayValue === data.item.compareValue\"\n  [class.usa-date-picker__calendar__date--focused]=\"_isActiveCell(data.rowIndex, data.colIndex)\"\n  [class.usa-date-picker__calendar__year]=\"view === 'multi-year'\"\n  [attr.aria-label]=\"data.item.ariaLabel\"\n  [attr.aria-disabled]=\"!data.item.enabled || null\"\n  [attr.aria-selected]=\"_isSelected(data.item.compareValue)\"\n  (click)=\"_cellClicked(data.item, $event)\">\n    {{data.item.displayValue}}\n</button>\n</ng-template>" }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i0.NgZone }], propDecorators: { view: [{
                type: Input
            }], label: [{
                type: Input
            }], rows: [{
                type: Input
            }], prevMonthRow: [{
                type: Input
            }], nextMonthRow: [{
                type: Input
            }], todayValue: [{
                type: Input
            }], startValue: [{
                type: Input
            }], endValue: [{
                type: Input
            }], labelMinRequiredCells: [{
                type: Input
            }], numCols: [{
                type: Input
            }], activeCell: [{
                type: Input
            }], isRange: [{
                type: Input
            }], cellAspectRatio: [{
                type: Input
            }], comparisonStart: [{
                type: Input
            }], comparisonEnd: [{
                type: Input
            }], previewStart: [{
                type: Input
            }], previewEnd: [{
                type: Input
            }], selectedValueChange: [{
                type: Output
            }], previewChange: [{
                type: Output
            }] } });
/** Checks whether a node is a table cell element. */
function isTableCell(node) {
    return node.nodeName === 'TD';
}
/** Checks whether a value is the start of a range. */
function isStart(value, start, end) {
    return end !== null && start !== end && value < end && value === start;
}
/** Checks whether a value is the end of a range. */
function isEnd(value, start, end) {
    return start !== null && start !== end && value >= start && value === end;
}
/** Checks whether a value is inside of a range. */
function isInRange(value, start, end, rangeEnabled) {
    return rangeEnabled && start !== null && end !== null && start !== end &&
        value >= start && value <= end;
}

/** InjectionToken for datePicker that can be used to override default locale code. */
const USA_DATE_LOCALE = new InjectionToken('USA_DATE_LOCALE', {
    providedIn: 'root',
    factory: USA_DATE_LOCALE_FACTORY,
});
/** @docs-private */
function USA_DATE_LOCALE_FACTORY() {
    return inject(LOCALE_ID);
}
/** Adapts type `D` to be usable as a date by components that work with dates. */
class DateAdapter {
    /** The locale to use for all dates. */
    locale;
    _localeChanges = new Subject();
    /** A stream that emits when the locale changes. */
    localeChanges = this._localeChanges;
    /**
     * Given a potential date object, returns that same date object if it is
     * a valid date, or `null` if it's not a valid date.
     * @param obj The object to check.
     * @returns A date or `null`.
     */
    getValidDateOrNull(obj) {
        return this.isDateInstance(obj) && this.isValid(obj) ? obj : null;
    }
    /**
     * Attempts to deserialize a value to a valid date object. This is different from parsing in that
     * deserialize should only accept non-ambiguous, locale-independent formats (e.g. a ISO 8601
     * string). The default implementation does not allow any deserialization, it simply checks that
     * the given value is already a valid date object or null. The `<usa-datePicker>` will call this
     * method on all of its `@Input()` properties that accept dates. It is therefore possible to
     * support passing values from your backend directly to these properties by overriding this method
     * to also deserialize the format used by your backend.
     * @param value The value to be deserialized into a date object.
     * @returns The deserialized date object, either a valid date, null if the value can be
     *     deserialized into a null date (e.g. the empty string), or an invalid date.
     */
    deserialize(value) {
        if (value == null || this.isDateInstance(value) && this.isValid(value)) {
            return value;
        }
        return this.invalid();
    }
    /**
     * Sets the locale used for all dates.
     * @param locale The new locale.
     */
    setLocale(locale) {
        this.locale = locale;
        this._localeChanges.next();
    }
    /**
     * Compares two dates.
     * @param first The first date to compare.
     * @param second The second date to compare.
     * @returns 0 if the dates are equal, a number less than 0 if the first date is earlier,
     *     a number greater than 0 if the first date is later.
     */
    compareDate(first, second) {
        return this.getYear(first) - this.getYear(second) ||
            this.getMonth(first) - this.getMonth(second) ||
            this.getDate(first) - this.getDate(second);
    }
    /**
     * Checks if two dates are equal.
     * @param first The first date to check.
     * @param second The second date to check.
     * @returns Whether the two dates are equal.
     *     Null dates are considered equal to other null dates.
     */
    sameDate(first, second) {
        if (first && second) {
            let firstValid = this.isValid(first);
            let secondValid = this.isValid(second);
            if (firstValid && secondValid) {
                return !this.compareDate(first, second);
            }
            return firstValid == secondValid;
        }
        return first == second;
    }
    /**
     * Clamp the given date between min and max dates.
     * @param date The date to clamp.
     * @param min The minimum value to allow. If null or omitted no min is enforced.
     * @param max The maximum value to allow. If null or omitted no max is enforced.
     * @returns `min` if `date` is less than `min`, `max` if date is greater than `max`,
     *     otherwise `date`.
     */
    clampDate(date, min, max) {
        if (min && this.compareDate(date, min) < 0) {
            return min;
        }
        if (max && this.compareDate(date, max) > 0) {
            return max;
        }
        return date;
    }
}

/** A class representing a range of dates. */
class DateRange {
    start;
    end;
    /**
     * Ensures that objects with a `start` and `end` property can't be assigned to a variable that
     * expects a `DateRange`
     */
    // tslint:disable-next-line:no-unused-variable
    _disableStructuralEquivalency;
    constructor(
    /** The start date of the range. */
    start, 
    /** The end date of the range. */
    end) {
        this.start = start;
        this.end = end;
    }
}
/**
 * A selection model containing a date selection.
 * @docs-private
 * @dynamic
 */
class UsaDateSelectionModel {
    selection;
    _adapter;
    _selectionChanged = new Subject();
    /** Emits when the selection has changed. */
    selectionChanged = this._selectionChanged;
    constructor(
    /** The current selection. */
    selection, _adapter) {
        this.selection = selection;
        this._adapter = _adapter;
        this.selection = selection;
    }
    /**
     * Updates the current selection in the model.
     * @param value New selection that should be assigned.
     * @param source Object that triggered the selection change.
     */
    updateSelection(value, source) {
        const oldValue = this.selection;
        this.selection = value;
        this._selectionChanged.next({ selection: value, source, oldValue });
    }
    ngOnDestroy() {
        this._selectionChanged.complete();
    }
    _isValidDateInstance(date) {
        return this._adapter.isDateInstance(date) && this._adapter.isValid(date);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaDateSelectionModel, deps: "invalid", target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaDateSelectionModel });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaDateSelectionModel, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: undefined }, { type: DateAdapter }] });
/**
 * A selection model that contains a single date.
 * @docs-private
 */
class UsaSingleDateSelectionModel extends UsaDateSelectionModel {
    constructor(adapter) {
        super(null, adapter);
    }
    /**
     * Adds a date to the current selection. In the case of a single date selection, the added date
     * simply overwrites the previous selection
     */
    add(date) {
        super.updateSelection(date, this);
    }
    /** Checks whether the current selection is valid. */
    isValid() {
        return this.selection != null && this._isValidDateInstance(this.selection);
    }
    /**
     * Checks whether the current selection is complete. In the case of a single date selection, this
     * is true if the current selection is not null.
     */
    isComplete() {
        return this.selection != null;
    }
    /** Clones the selection model. */
    clone() {
        const clone = new UsaSingleDateSelectionModel(this._adapter);
        clone.updateSelection(this.selection, this);
        return clone;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaSingleDateSelectionModel, deps: [{ token: DateAdapter }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaSingleDateSelectionModel });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaSingleDateSelectionModel, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: DateAdapter }] });
/**
 * A selection model that contains a date range.
 * @docs-private
 */
class UsaRangeDateSelectionModel extends UsaDateSelectionModel {
    constructor(adapter) {
        super(new DateRange(null, null), adapter);
    }
    /**
     * Adds a date to the current selection. In the case of a date range selection, the added date
     * fills in the next `null` value in the range. If both the start and the end already have a date,
     * the selection is reset so that the given date is the new `start` and the `end` is null.
     */
    add(date) {
        let { start, end } = this.selection;
        if (start == null) {
            start = date;
        }
        else if (end == null) {
            end = date;
        }
        else {
            start = date;
            end = null;
        }
        super.updateSelection(new DateRange(start, end), this);
    }
    /** Checks whether the current selection is valid. */
    isValid() {
        const { start, end } = this.selection;
        // Empty ranges are valid.
        if (start == null && end == null) {
            return true;
        }
        // Complete ranges are only valid if both dates are valid and the start is before the end.
        if (start != null && end != null) {
            return this._isValidDateInstance(start) && this._isValidDateInstance(end) &&
                this._adapter.compareDate(start, end) <= 0;
        }
        // Partial ranges are valid if the start/end is valid.
        return (start == null || this._isValidDateInstance(start)) &&
            (end == null || this._isValidDateInstance(end));
    }
    /**
     * Checks whether the current selection is complete. In the case of a date range selection, this
     * is true if the current selection has a non-null `start` and `end`.
     */
    isComplete() {
        return this.selection.start != null && this.selection.end != null;
    }
    /** Clones the selection model. */
    clone() {
        const clone = new UsaRangeDateSelectionModel(this._adapter);
        clone.updateSelection(this.selection, this);
        return clone;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaRangeDateSelectionModel, deps: [{ token: DateAdapter }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaRangeDateSelectionModel });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaRangeDateSelectionModel, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: DateAdapter }] });
/** @docs-private */
function USA_SINGLE_DATE_SELECTION_MODEL_FACTORY(parent, adapter) {
    return parent || new UsaSingleDateSelectionModel(adapter);
}
/**
 * Used to provide a single selection model to a component.
 * @docs-private
 */
const USA_SINGLE_DATE_SELECTION_MODEL_PROVIDER = {
    provide: UsaDateSelectionModel,
    deps: [[new Optional(), new SkipSelf(), UsaDateSelectionModel], DateAdapter],
    useFactory: USA_SINGLE_DATE_SELECTION_MODEL_FACTORY,
};
/** @docs-private */
function USA_RANGE_DATE_SELECTION_MODEL_FACTORY(parent, adapter) {
    return parent || new UsaRangeDateSelectionModel(adapter);
}
/**
 * Used to provide a range selection model to a component.
 * @docs-private
 */
const USA_RANGE_DATE_SELECTION_MODEL_PROVIDER = {
    provide: UsaDateSelectionModel,
    deps: [[new Optional(), new SkipSelf(), UsaDateSelectionModel], DateAdapter],
    useFactory: USA_RANGE_DATE_SELECTION_MODEL_FACTORY,
};

/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/** Injection token used to customize the date range selection behavior. */
const USA_DATE_RANGE_SELECTION_STRATEGY = new InjectionToken('USA_DATE_RANGE_SELECTION_STRATEGY');
/** Provides the default date range selection behavior. */
class DefaultUsaCalendarRangeStrategy {
    _dateAdapter;
    constructor(_dateAdapter) {
        this._dateAdapter = _dateAdapter;
    }
    selectionFinished(date, currentRange) {
        let { start, end } = currentRange;
        if (start == null) {
            start = date;
        }
        else if (end == null && date && this._dateAdapter.compareDate(date, start) >= 0) {
            end = date;
        }
        else {
            start = date;
            end = null;
        }
        return new DateRange(start, end);
    }
    createPreview(activeDate, currentRange) {
        let start = null;
        let end = null;
        if (currentRange.start && !currentRange.end && activeDate) {
            start = currentRange.start;
            end = activeDate;
        }
        return new DateRange(start, end);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: DefaultUsaCalendarRangeStrategy, deps: [{ token: DateAdapter }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: DefaultUsaCalendarRangeStrategy });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: DefaultUsaCalendarRangeStrategy, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: DateAdapter }] });
/** @docs-private */
function USA_CALENDAR_RANGE_STRATEGY_PROVIDER_FACTORY(parent, adapter) {
    return parent || new DefaultUsaCalendarRangeStrategy(adapter);
}
/** @docs-private */
const USA_CALENDAR_RANGE_STRATEGY_PROVIDER = {
    provide: USA_DATE_RANGE_SELECTION_STRATEGY,
    deps: [[new Optional(), new SkipSelf(), USA_DATE_RANGE_SELECTION_STRATEGY], DateAdapter],
    useFactory: USA_CALENDAR_RANGE_STRATEGY_PROVIDER_FACTORY,
};

const USA_DATE_FORMATS = new InjectionToken('usa-date-formats');

const DAYS_PER_WEEK = 7;
/**
 * An internal component used to display a single month in the datePicker.
 * @docs-private
 */
class UsaMonthView {
    _changeDetectorRef;
    _dateFormats;
    _dateAdapter;
    _rangeStrategy;
    _rerenderSubscription = Subscription.EMPTY;
    /** Flag used to filter out space/enter keyup events that originated outside of the view. */
    _selectionKeyPressed;
    /**
     * The date to display in this month view (everything other than the month and year is ignored).
     */
    get activeDate() { return this._activeDate; }
    set activeDate(value) {
        const oldActiveDate = this._activeDate;
        const validDate = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(value)) || this._dateAdapter.today();
        this._activeDate = this._dateAdapter.clampDate(validDate, this.minDate, this.maxDate);
        if (!this._hasSameMonthAndYear(oldActiveDate, this._activeDate)) {
            this._init();
        }
    }
    _activeDate;
    /** The currently selected date. */
    get selected() { return this._selected; }
    set selected(value) {
        if (value instanceof DateRange) {
            this._selected = value;
        }
        else {
            this._selected = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(value));
        }
        this._setRanges(this._selected);
    }
    _selected;
    /** The minimum selectable date. */
    get minDate() { return this._minDate; }
    set minDate(value) {
        this._minDate = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(value));
    }
    _minDate;
    /** The maximum selectable date. */
    get maxDate() { return this._maxDate; }
    set maxDate(value) {
        this._maxDate = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(value));
    }
    _maxDate;
    /** Function used to filter which dates are selectable. */
    dateFilter;
    /** Function that can be used to add custom CSS classes to dates. */
    dateClass;
    /** Start of the comparison range. */
    comparisonStart;
    /** End of the comparison range. */
    comparisonEnd;
    /** Emits when a new date is selected. */
    selectedChange = new EventEmitter();
    /** Emits when any date is selected. */
    _userSelection = new EventEmitter();
    /** Emits when any date is activated. */
    activeDateChange = new EventEmitter();
    /** The body of calendar table */
    _usaCalendarBody;
    /** The label for this month (e.g. "January 2017"). */
    _monthLabel;
    /** Grid of calendar cells representing the dates of the month. */
    _weeks;
    /** Last few dates for previous month to place in first row  if there is offset space */
    _prevMonthDays;
    /** First few dates for next month to place in last row if there is offset space */
    _nextMonthDays;
    /** The number of blank cells in the first row before the 1st of the month. */
    _firstWeekOffset;
    /** Start value of the currently-shown date range. */
    _rangeStart;
    /** End value of the currently-shown date range. */
    _rangeEnd;
    /** Start value of the currently-shown comparison date range. */
    _comparisonRangeStart;
    /** End value of the currently-shown comparison date range. */
    _comparisonRangeEnd;
    /** Start of the preview range. */
    _previewStart;
    /** End of the preview range. */
    _previewEnd;
    /** Whether the user is currently selecting a range of dates. */
    _isRange;
    /** The date of the month that today falls on. Null if today is in another month. */
    _todayDate;
    /** The names of the weekdays. */
    _weekdays;
    constructor(_changeDetectorRef, _dateFormats, _dateAdapter, _rangeStrategy) {
        this._changeDetectorRef = _changeDetectorRef;
        this._dateFormats = _dateFormats;
        this._dateAdapter = _dateAdapter;
        this._rangeStrategy = _rangeStrategy;
        if (isDevMode()) {
            if (!this._dateAdapter) {
                throw createMissingDateImplError('DateAdapter');
            }
            if (!this._dateFormats) {
                throw createMissingDateImplError('USA_DATE_FORMATS');
            }
        }
        this._activeDate = this._dateAdapter.today();
    }
    ngAfterContentInit() {
        this._rerenderSubscription = this._dateAdapter.localeChanges
            .pipe(startWith(null))
            .subscribe(() => this._init());
    }
    ngOnChanges(changes) {
        const comparisonChange = changes['comparisonStart'] || changes['comparisonEnd'];
        if (comparisonChange && !comparisonChange.firstChange) {
            this._setRanges(this.selected);
        }
    }
    ngOnDestroy() {
        this._rerenderSubscription.unsubscribe();
    }
    /** Handles when a new date is selected. */
    _dateSelected(event) {
        const date = new Date(event.value).getDate();
        const selectedYear = this._dateAdapter.getYear(this.activeDate);
        const selectedMonth = new Date(event.value).getMonth();
        const selectedDate = this._dateAdapter.createDate(selectedYear, selectedMonth, date);
        let rangeStartDate;
        let rangeEndDate;
        if (this._selected instanceof DateRange) {
            rangeStartDate = this._getDateInCurrentMonth(this._selected.start);
            rangeEndDate = this._getDateInCurrentMonth(this._selected.end);
        }
        else {
            rangeStartDate = rangeEndDate = this._getDateInCurrentMonth(this._selected);
        }
        if (rangeStartDate !== date || rangeEndDate !== date) {
            this.selectedChange.emit(selectedDate);
        }
        this._userSelection.emit({ value: selectedDate, event: event.event });
        this._previewStart = this._previewEnd = null;
        this._changeDetectorRef.markForCheck();
    }
    /** Handles keydown events on the calendar body when calendar is in month view. */
    _handleCalendarBodyKeydown(event) {
        // TODO(mmalerba): We currently allow keyboard navigation to disabled dates, but just prevent
        // disabled ones from being selected. This may not be ideal, we should look into whether
        // navigation should skip over disabled dates, and if so, how to implement that efficiently.
        const oldActiveDate = this._activeDate;
        switch (event.keyCode) {
            case KeyCode.ArrowLeft:
                this.activeDate = this._dateAdapter.addCalendarDays(this._activeDate, -1);
                break;
            case KeyCode.ArrowRight:
                this.activeDate = this._dateAdapter.addCalendarDays(this._activeDate, 1);
                break;
            case KeyCode.ArrowUp:
                this.activeDate = this._dateAdapter.addCalendarDays(this._activeDate, -7);
                break;
            case KeyCode.ArrowDown:
                this.activeDate = this._dateAdapter.addCalendarDays(this._activeDate, 7);
                break;
            case KeyCode.Home:
                this.activeDate = this._dateAdapter.addCalendarDays(this._activeDate, 1 - this._dateAdapter.getDate(this._activeDate));
                break;
            case KeyCode.End:
                this.activeDate = this._dateAdapter.addCalendarDays(this._activeDate, (this._dateAdapter.getNumDaysInMonth(this._activeDate) -
                    this._dateAdapter.getDate(this._activeDate)));
                break;
            case KeyCode.PageUp:
                this.activeDate = event.altKey ?
                    this._dateAdapter.addCalendarYears(this._activeDate, -1) :
                    this._dateAdapter.addCalendarMonths(this._activeDate, -1);
                break;
            case KeyCode.PageDown:
                this.activeDate = event.altKey ?
                    this._dateAdapter.addCalendarYears(this._activeDate, 1) :
                    this._dateAdapter.addCalendarMonths(this._activeDate, 1);
                break;
            case KeyCode.Enter:
            case KeyCode.Space:
                this._selectionKeyPressed = true;
                if (this._canSelect(this._activeDate)) {
                    // Prevent unexpected default actions such as form submission.
                    // Note that we only prevent the default action here while the selection happens in
                    // `keyup` below. We can't do the selection here, because it can cause the calendar to
                    // reopen if focus is restored immediately. We also can't call `preventDefault` on `keyup`
                    // because it's too late (see #23305).
                    event.preventDefault();
                }
                return;
            case KeyCode.Escape:
                // Abort the current range selection if the user presses escape mid-selection.
                if (this._previewEnd != null && !hasModifierKey(event)) {
                    this._previewStart = this._previewEnd = null;
                    this.selectedChange.emit(null);
                    this._userSelection.emit({ value: null, event });
                    event.preventDefault();
                    event.stopPropagation(); // Prevents the overlay from closing.
                }
                return;
            default:
                // Don't prevent default or focus active cell on keys that we don't explicitly handle.
                return;
        }
        if (this._dateAdapter.compareDate(oldActiveDate, this.activeDate)) {
            this.activeDateChange.emit(this.activeDate);
        }
        this._focusActiveCell();
        // Prevent unexpected default actions such as form submission.
        event.preventDefault();
    }
    /** Handles keyup events on the calendar body when calendar is in month view. */
    _handleCalendarBodyKeyup(event) {
        if (event.keyCode === KeyCode.Space || event.keyCode === KeyCode.Enter) {
            if (this._selectionKeyPressed && this._canSelect(this._activeDate)) {
                this._dateSelected({ value: this._getCellCompareValue(this._activeDate), event });
            }
            this._selectionKeyPressed = false;
        }
    }
    /** Initializes this month view. */
    _init() {
        this._setRanges(this.selected);
        this._todayDate = this._getCellCompareValue(this._dateAdapter.today());
        this._monthLabel = this._dateFormats.display.monthLabel
            ? this._dateAdapter.format(this.activeDate, this._dateFormats.display.monthLabel)
            : this._dateAdapter.getMonthNames('short')[this._dateAdapter.getMonth(this.activeDate)]
                .toLocaleUpperCase();
        let firstOfMonth = this._dateAdapter.createDate(this._dateAdapter.getYear(this.activeDate), this._dateAdapter.getMonth(this.activeDate), 1);
        this._firstWeekOffset =
            (DAYS_PER_WEEK + this._dateAdapter.getDayOfWeek(firstOfMonth) -
                this._dateAdapter.getFirstDayOfWeek()) % DAYS_PER_WEEK;
        this._initWeekdays();
        this._createWeekCells();
        this._changeDetectorRef.markForCheck();
    }
    /** Focuses the active cell after the microtask queue is empty. */
    _focusActiveCell(movePreview) {
        this._usaCalendarBody._focusActiveCell(movePreview);
    }
    /** Called when the user has activated a new cell and the preview needs to be updated. */
    _previewChanged({ event, value: cell }) {
        if (this._rangeStrategy) {
            // We can assume that this will be a range, because preview
            // events aren't fired for single date selections.
            const value = cell ? cell.rawValue : null;
            const previewRange = this._rangeStrategy.createPreview(value, this.selected, event);
            this._previewStart = this._getCellCompareValue(previewRange.start);
            this._previewEnd = this._getCellCompareValue(previewRange.end);
            // Note that here we need to use `detectChanges`, rather than `markForCheck`, because
            // the way `_focusActiveCell` is set up at the moment makes it fire at the wrong time
            // when navigating one month back using the keyboard which will cause this handler
            // to throw a "changed after checked" error when updating the preview state.
            this._changeDetectorRef.detectChanges();
        }
    }
    /** Initializes the weekdays. */
    _initWeekdays() {
        const firstDayOfWeek = this._dateAdapter.getFirstDayOfWeek();
        const narrowWeekdays = this._dateAdapter.getDayOfWeekNames('narrow');
        const longWeekdays = this._dateAdapter.getDayOfWeekNames('long');
        // Rotate the labels for days of the week based on the configured first day of the week.
        let weekdays = longWeekdays.map((long, i) => {
            return { long, narrow: narrowWeekdays[i] };
        });
        this._weekdays = weekdays.slice(firstDayOfWeek).concat(weekdays.slice(0, firstDayOfWeek));
    }
    /** Creates UsaCalendarCells for the dates in this month. */
    _createWeekCells() {
        this._createCellForPrevMonth();
        const daysInMonth = this._dateAdapter.getNumDaysInMonth(this.activeDate);
        const prevMonth = this._dateAdapter.addCalendarMonths(this.activeDate, -1);
        const daysInPrevMonth = this._dateAdapter.getNumDaysInMonth(prevMonth);
        this._prevMonthDays = [];
        for (let i = daysInPrevMonth - this._firstWeekOffset; i < daysInPrevMonth; i++) {
            this._prevMonthDays.push(this.getCalendarCell(prevMonth, i));
        }
        this._weeks = [[]];
        for (let i = 0, cell = this._firstWeekOffset; i < daysInMonth; i++, cell++) {
            if (cell == DAYS_PER_WEEK) {
                this._weeks.push([]);
                cell = 0;
            }
            this._weeks[this._weeks.length - 1].push(this.getCalendarCell(this.activeDate, i));
        }
        this._createCellForNextMonth();
    }
    /**
     * Creates filler cells of previous month date to display in first row of current month view
     */
    _createCellForPrevMonth() {
        const prevMonth = this._dateAdapter.addCalendarMonths(this.activeDate, -1);
        const daysInPrevMonth = this._dateAdapter.getNumDaysInMonth(prevMonth);
        this._prevMonthDays = [];
        for (let i = daysInPrevMonth - this._firstWeekOffset; i < daysInPrevMonth; i++) {
            this._prevMonthDays.push(this.getCalendarCell(prevMonth, i));
        }
    }
    /**
     * Creates filler cells of next month date to display in last row of current month view
     */
    _createCellForNextMonth() {
        const remainingDaysInLastRow = this._dateAdapter.getDayOfWeekNames('long').length - this._weeks[this._weeks.length - 1].length;
        const nextMonth = this._dateAdapter.addCalendarMonths(this.activeDate, 1);
        this._nextMonthDays = [];
        for (let i = 0; i < remainingDaysInLastRow; i++) {
            this._nextMonthDays.push(this.getCalendarCell(nextMonth, i));
        }
    }
    /** Creates a calender cell object for each cell of the calender */
    getCalendarCell(date, dateNum) {
        const dateNames = this._dateAdapter.getDateNames();
        const cellDate = this._dateAdapter.createDate(this._dateAdapter.getYear(date), this._dateAdapter.getMonth(date), dateNum + 1);
        const enabled = this._shouldEnableDate(cellDate);
        const ariaLabel = this._dateAdapter.format(cellDate, this._dateFormats.display.dateA11yLabel);
        const cellClasses = this.dateClass ? this.dateClass(cellDate, 'month') : undefined;
        return new UsaCalendarCell(dateNum + 1, dateNames[dateNum], ariaLabel, enabled, cellClasses, this._getCellCompareValue(cellDate), cellDate);
    }
    /** Date filter for the month */
    _shouldEnableDate(date) {
        return !!date &&
            (!this.minDate || this._dateAdapter.compareDate(date, this.minDate) >= 0) &&
            (!this.maxDate || this._dateAdapter.compareDate(date, this.maxDate) <= 0) &&
            (!this.dateFilter || this.dateFilter(date));
    }
    /**
     * Gets the date in this month that the given Date falls on.
     * Returns null if the given Date is in another month.
     */
    _getDateInCurrentMonth(date) {
        return date && this._hasSameMonthAndYear(date, this.activeDate) ?
            this._dateAdapter.getDate(date) : null;
    }
    /** Checks whether the 2 dates are non-null and fall within the same month of the same year. */
    _hasSameMonthAndYear(d1, d2) {
        return !!(d1 && d2 && this._dateAdapter.getMonth(d1) == this._dateAdapter.getMonth(d2) &&
            this._dateAdapter.getYear(d1) == this._dateAdapter.getYear(d2));
    }
    /** Gets the value that will be used to one cell to another. */
    _getCellCompareValue(date) {
        if (date) {
            // We use the time since the Unix epoch to compare dates in this view, rather than the
            // cell values, because we need to support ranges that span across multiple months/years.
            const year = this._dateAdapter.getYear(date);
            const month = this._dateAdapter.getMonth(date);
            const day = this._dateAdapter.getDate(date);
            return new Date(year, month, day).getTime();
        }
        return null;
    }
    /** Sets the current range based on a model value. */
    _setRanges(selectedValue) {
        if (selectedValue instanceof DateRange) {
            this._rangeStart = this._getCellCompareValue(selectedValue.start);
            this._rangeEnd = this._getCellCompareValue(selectedValue.end);
            this._isRange = true;
        }
        else {
            this._rangeStart = this._rangeEnd = this._getCellCompareValue(selectedValue);
            this._isRange = false;
        }
        this._comparisonRangeStart = this._getCellCompareValue(this.comparisonStart);
        this._comparisonRangeEnd = this._getCellCompareValue(this.comparisonEnd);
    }
    /** Gets whether a date can be selected in the month view. */
    _canSelect(date) {
        return !this.dateFilter || this.dateFilter(date);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaMonthView, deps: [{ token: i0.ChangeDetectorRef }, { token: USA_DATE_FORMATS, optional: true }, { token: DateAdapter, optional: true }, { token: USA_DATE_RANGE_SELECTION_STRATEGY, optional: true }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.2", type: UsaMonthView, selector: "usa-month-view", inputs: { activeDate: "activeDate", selected: "selected", minDate: "minDate", maxDate: "maxDate", dateFilter: "dateFilter", dateClass: "dateClass", comparisonStart: "comparisonStart", comparisonEnd: "comparisonEnd" }, outputs: { selectedChange: "selectedChange", _userSelection: "_userSelection", activeDateChange: "activeDateChange" }, viewQueries: [{ propertyName: "_usaCalendarBody", first: true, predicate: UsaCalendarBody, descendants: true }], exportAs: ["usaMonthView"], usesOnChanges: true, ngImport: i0, template: "<table class=\"usa-date-picker__calendar__table\">\n  <thead>\n    <tr>\n      <!-- For the day-of-the-week column header, we use an `<abbr>` element because VoiceOver\n           ignores the `aria-label`. ChromeVox, however, does not read the full name\n           for the `<abbr>`, so we still set `aria-label` on the header element. -->\n      <th scope=\"col\" *ngFor=\"let day of _weekdays\" [attr.aria-label]=\"day.long\" class=\"usa-date-picker__calendar__day-of-week\">\n        <span [attr.title]=\"day.long\">{{day.narrow}}</span>\n      </th>\n    </tr>\n  </thead>\n  <tbody usa-calendar-body\n         [label]=\"_monthLabel\"\n         [rows]=\"_weeks\"\n         [view]=\"'month'\"\n         [prevMonthRow]=\"_prevMonthDays\"\n         [nextMonthRow]=\"_nextMonthDays\"\n         [todayValue]=\"_todayDate!\"\n         [startValue]=\"_rangeStart!\"\n         [endValue]=\"_rangeEnd!\"\n         [comparisonStart]=\"_comparisonRangeStart\"\n         [comparisonEnd]=\"_comparisonRangeEnd\"\n         [previewStart]=\"_previewStart\"\n         [previewEnd]=\"_previewEnd\"\n         [isRange]=\"_isRange\"\n         [labelMinRequiredCells]=\"3\"\n         [activeCell]=\"_dateAdapter.getDate(activeDate) - 1\"\n         (selectedValueChange)=\"_dateSelected($event)\"\n         (previewChange)=\"_previewChanged($event)\"\n         (keyup)=\"_handleCalendarBodyKeyup($event)\"\n         (keydown)=\"_handleCalendarBodyKeydown($event)\">\n  </tbody>\n</table>\n", dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "component", type: UsaCalendarBody, selector: "[usa-calendar-body]", inputs: ["view", "label", "rows", "prevMonthRow", "nextMonthRow", "todayValue", "startValue", "endValue", "labelMinRequiredCells", "numCols", "activeCell", "isRange", "cellAspectRatio", "comparisonStart", "comparisonEnd", "previewStart", "previewEnd"], outputs: ["selectedValueChange", "previewChange"], exportAs: ["usaCalendarBody"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaMonthView, decorators: [{
            type: Component,
            args: [{ selector: 'usa-month-view', exportAs: 'usaMonthView', changeDetection: ChangeDetectionStrategy.OnPush, template: "<table class=\"usa-date-picker__calendar__table\">\n  <thead>\n    <tr>\n      <!-- For the day-of-the-week column header, we use an `<abbr>` element because VoiceOver\n           ignores the `aria-label`. ChromeVox, however, does not read the full name\n           for the `<abbr>`, so we still set `aria-label` on the header element. -->\n      <th scope=\"col\" *ngFor=\"let day of _weekdays\" [attr.aria-label]=\"day.long\" class=\"usa-date-picker__calendar__day-of-week\">\n        <span [attr.title]=\"day.long\">{{day.narrow}}</span>\n      </th>\n    </tr>\n  </thead>\n  <tbody usa-calendar-body\n         [label]=\"_monthLabel\"\n         [rows]=\"_weeks\"\n         [view]=\"'month'\"\n         [prevMonthRow]=\"_prevMonthDays\"\n         [nextMonthRow]=\"_nextMonthDays\"\n         [todayValue]=\"_todayDate!\"\n         [startValue]=\"_rangeStart!\"\n         [endValue]=\"_rangeEnd!\"\n         [comparisonStart]=\"_comparisonRangeStart\"\n         [comparisonEnd]=\"_comparisonRangeEnd\"\n         [previewStart]=\"_previewStart\"\n         [previewEnd]=\"_previewEnd\"\n         [isRange]=\"_isRange\"\n         [labelMinRequiredCells]=\"3\"\n         [activeCell]=\"_dateAdapter.getDate(activeDate) - 1\"\n         (selectedValueChange)=\"_dateSelected($event)\"\n         (previewChange)=\"_previewChanged($event)\"\n         (keyup)=\"_handleCalendarBodyKeyup($event)\"\n         (keydown)=\"_handleCalendarBodyKeydown($event)\">\n  </tbody>\n</table>\n" }]
        }], ctorParameters: () => [{ type: i0.ChangeDetectorRef }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [USA_DATE_FORMATS]
                }] }, { type: DateAdapter, decorators: [{
                    type: Optional
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [USA_DATE_RANGE_SELECTION_STRATEGY]
                }, {
                    type: Optional
                }] }], propDecorators: { activeDate: [{
                type: Input
            }], selected: [{
                type: Input
            }], minDate: [{
                type: Input
            }], maxDate: [{
                type: Input
            }], dateFilter: [{
                type: Input
            }], dateClass: [{
                type: Input
            }], comparisonStart: [{
                type: Input
            }], comparisonEnd: [{
                type: Input
            }], selectedChange: [{
                type: Output
            }], _userSelection: [{
                type: Output
            }], activeDateChange: [{
                type: Output
            }], _usaCalendarBody: [{
                type: ViewChild,
                args: [UsaCalendarBody]
            }] } });

const yearsPerPage = 12;
const yearsPerRow = 4;
/**
 * An internal component used to display a year selector in the datePicker.
 * @docs-private
 */
class UsaMultiYearView {
    _changeDetectorRef;
    _dateAdapter;
    _rerenderSubscription = Subscription.EMPTY;
    /** Flag used to filter out space/enter keyup events that originated outside of the view. */
    _selectionKeyPressed;
    /** The date to display in this multi-year view (everything other than the year is ignored). */
    get activeDate() { return this._activeDate; }
    set activeDate(value) {
        let oldActiveDate = this._activeDate;
        const validDate = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(value)) || this._dateAdapter.today();
        this._activeDate = this._dateAdapter.clampDate(validDate, this.minDate, this.maxDate);
        if (!isSameMultiYearView(this._dateAdapter, oldActiveDate, this._activeDate, this.minDate, this.maxDate)) {
            this._init();
        }
    }
    _activeDate;
    /** The currently selected date. */
    get selected() { return this._selected; }
    set selected(value) {
        if (value instanceof DateRange) {
            this._selected = value;
        }
        else {
            this._selected = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(value));
        }
        this._setSelectedYear(value);
    }
    _selected;
    /** The minimum selectable date. */
    get minDate() { return this._minDate; }
    set minDate(value) {
        this._minDate = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(value));
    }
    _minDate;
    /** The maximum selectable date. */
    get maxDate() { return this._maxDate; }
    set maxDate(value) {
        this._maxDate = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(value));
    }
    _maxDate;
    /** A function used to filter which dates are selectable. */
    dateFilter;
    /** Function that can be used to add custom CSS classes to date cells. */
    dateClass;
    /** Emits when a new year is selected. */
    selectedChange = new EventEmitter();
    /** Emits the selected year. This doesn't imply a change on the selected date */
    yearSelected = new EventEmitter();
    /** Emits when any date is activated. */
    activeDateChange = new EventEmitter();
    /** The body of calendar table */
    _usaCalendarBody;
    /** Grid of calendar cells representing the currently displayed years. */
    _years;
    /** The year that today falls on. */
    _todayYear;
    /** The year of the selected date. Null if the selected date is null. */
    _selectedYear;
    constructor(_changeDetectorRef, _dateAdapter) {
        this._changeDetectorRef = _changeDetectorRef;
        this._dateAdapter = _dateAdapter;
        if (!this._dateAdapter && isDevMode()) {
            throw createMissingDateImplError('DateAdapter');
        }
        this._activeDate = this._dateAdapter.today();
    }
    ngAfterContentInit() {
        this._rerenderSubscription = this._dateAdapter.localeChanges
            .pipe(startWith(null))
            .subscribe(() => this._init());
    }
    ngOnDestroy() {
        this._rerenderSubscription.unsubscribe();
    }
    /** Initializes this multi-year view. */
    _init() {
        this._todayYear = this._dateAdapter.getYear(this._dateAdapter.today());
        // We want a range years such that we maximize the number of
        // enabled dates visible at once. This prevents issues where the minimum year
        // is the last item of a page OR the maximum year is the first item of a page.
        // The offset from the active year to the "slot" for the starting year is the
        // *actual* first rendered year in the multi-year view.
        const activeYear = this._dateAdapter.getYear(this._activeDate);
        const minYearOfPage = activeYear - getActiveOffset(this._dateAdapter, this.activeDate, this.minDate, this.maxDate);
        this._years = [];
        for (let i = 0, row = []; i < yearsPerPage; i++) {
            row.push(minYearOfPage + i);
            if (row.length == yearsPerRow) {
                this._years.push(row.map(year => this._createCellForYear(year)));
                row = [];
            }
        }
        this._changeDetectorRef.markForCheck();
    }
    // TODO
    getNextYears() {
        this.activeDate = this._dateAdapter.addCalendarYears(this.activeDate, yearsPerPage);
    }
    getPreviousYears() {
        this.activeDate = this._dateAdapter.addCalendarYears(this.activeDate, -yearsPerPage);
    }
    /** Handles when a new year is selected. */
    _yearSelected(event) {
        const year = event.value;
        this.yearSelected.emit(this._dateAdapter.createDate(year, 0, 1));
        let month = this._dateAdapter.getMonth(this.activeDate);
        let daysInMonth = this._dateAdapter.getNumDaysInMonth(this._dateAdapter.createDate(year, month, 1));
        this.selectedChange.emit(this._dateAdapter.createDate(year, month, Math.min(this._dateAdapter.getDate(this.activeDate), daysInMonth)));
    }
    /** Handles keydown events on the calendar body when calendar is in multi-year view. */
    _handleCalendarBodyKeydown(event) {
        const oldActiveDate = this._activeDate;
        switch (event.keyCode) {
            case KeyCode.ArrowLeft:
                this.activeDate = this._dateAdapter.addCalendarYears(this._activeDate, -1);
                break;
            case KeyCode.ArrowRight:
                this.activeDate = this._dateAdapter.addCalendarYears(this._activeDate, 1);
                break;
            case KeyCode.ArrowUp:
                this.activeDate = this._dateAdapter.addCalendarYears(this._activeDate, -yearsPerRow);
                break;
            case KeyCode.ArrowDown:
                this.activeDate = this._dateAdapter.addCalendarYears(this._activeDate, yearsPerRow);
                break;
            case KeyCode.Home:
                this.activeDate = this._dateAdapter.addCalendarYears(this._activeDate, -getActiveOffset(this._dateAdapter, this.activeDate, this.minDate, this.maxDate));
                break;
            case KeyCode.End:
                this.activeDate = this._dateAdapter.addCalendarYears(this._activeDate, yearsPerPage - getActiveOffset(this._dateAdapter, this.activeDate, this.minDate, this.maxDate) - 1);
                break;
            case KeyCode.PageUp:
                this.activeDate =
                    this._dateAdapter.addCalendarYears(this._activeDate, event.altKey ? -yearsPerPage * 10 : -yearsPerPage);
                break;
            case KeyCode.PageDown:
                this.activeDate =
                    this._dateAdapter.addCalendarYears(this._activeDate, event.altKey ? yearsPerPage * 10 : yearsPerPage);
                break;
            case KeyCode.Enter:
            case KeyCode.Space:
                // Note that we only prevent the default action here while the selection happens in
                // `keyup` below. We can't do the selection here, because it can cause the calendar to
                // reopen if focus is restored immediately. We also can't call `preventDefault` on `keyup`
                // because it's too late (see #23305).
                this._selectionKeyPressed = true;
                break;
            default:
                // Don't prevent default or focus active cell on keys that we don't explicitly handle.
                return;
        }
        if (this._dateAdapter.compareDate(oldActiveDate, this.activeDate)) {
            this.activeDateChange.emit(this.activeDate);
        }
        this._focusActiveCell();
        // Prevent unexpected default actions such as form submission.
        event.preventDefault();
    }
    /** Handles keyup events on the calendar body when calendar is in multi-year view. */
    _handleCalendarBodyKeyup(event) {
        if (event.keyCode === KeyCode.Space || event.keyCode === KeyCode.Enter) {
            if (this._selectionKeyPressed) {
                this._yearSelected({ value: this._dateAdapter.getYear(this._activeDate), event });
            }
            this._selectionKeyPressed = false;
        }
    }
    _getActiveCell() {
        return getActiveOffset(this._dateAdapter, this.activeDate, this.minDate, this.maxDate);
    }
    /** Focuses the active cell after the microtask queue is empty. */
    _focusActiveCell() {
        this._usaCalendarBody._focusActiveCell();
    }
    /** Creates an UsaCalendarCell for the given year. */
    _createCellForYear(year) {
        const date = this._dateAdapter.createDate(year, 0, 1);
        const yearName = this._dateAdapter.getYearName(date);
        const cellClasses = this.dateClass ? this.dateClass(date, 'multi-year') : undefined;
        return new UsaCalendarCell(year, yearName, yearName, this._shouldEnableYear(year), cellClasses);
    }
    /** Whether the given year is enabled. */
    _shouldEnableYear(year) {
        // disable if the year is greater than maxDate lower than minDate
        if (year === undefined || year === null ||
            (this.maxDate && year > this._dateAdapter.getYear(this.maxDate)) ||
            (this.minDate && year < this._dateAdapter.getYear(this.minDate))) {
            return false;
        }
        // enable if it reaches here and there's no filter defined
        if (!this.dateFilter) {
            return true;
        }
        const firstOfYear = this._dateAdapter.createDate(year, 0, 1);
        // If any date in the year is enabled count the year as enabled.
        for (let date = firstOfYear; this._dateAdapter.getYear(date) == year; date = this._dateAdapter.addCalendarDays(date, 1)) {
            if (this.dateFilter(date)) {
                return true;
            }
        }
        return false;
    }
    /** Sets the currently-highlighted year based on a model value. */
    _setSelectedYear(value) {
        this._selectedYear = null;
        if (value instanceof DateRange) {
            const displayValue = value.start || value.end;
            if (displayValue) {
                this._selectedYear = this._dateAdapter.getYear(displayValue);
            }
        }
        else if (value) {
            this._selectedYear = this._dateAdapter.getYear(value);
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaMultiYearView, deps: [{ token: i0.ChangeDetectorRef }, { token: DateAdapter, optional: true }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.2", type: UsaMultiYearView, selector: "usa-multi-year-view", inputs: { activeDate: "activeDate", selected: "selected", minDate: "minDate", maxDate: "maxDate", dateFilter: "dateFilter", dateClass: "dateClass" }, outputs: { selectedChange: "selectedChange", yearSelected: "yearSelected", activeDateChange: "activeDateChange" }, viewQueries: [{ propertyName: "_usaCalendarBody", first: true, predicate: UsaCalendarBody, descendants: true }], exportAs: ["usaMultiYearView"], ngImport: i0, template: "<div class=\"usa-date-picker__calendar__year-picker\">\n  <table class=\"usa-date-picker__calendar__table\">\n    <tbody>\n      <tr>\n        <td>\n          <button type=\"button\" (click)=\"getPreviousYears()\"\n            class=\"usa-date-picker__calendar__previous-year-chunk\" aria-label=\"Navigate back 12 years\">&nbsp;</button>\n        </td>\n        <td colspan=\"3\">\n          <table class=\"usa-date-picker__calendar__table\" role=\"grid\">\n            <tbody usa-calendar-body\n                   [view]=\"'multi-year'\"\n                   [rows]=\"_years\"\n                   [todayValue]=\"_todayYear\"\n                   [startValue]=\"_selectedYear!\"\n                   [endValue]=\"_selectedYear!\"\n                   [numCols]=\"4\"\n                   [cellAspectRatio]=\"4 / 7\"\n                   [activeCell]=\"_getActiveCell()\"\n                   (selectedValueChange)=\"_yearSelected($event)\"\n                   (keyup)=\"_handleCalendarBodyKeyup($event)\"\n                   (keydown)=\"_handleCalendarBodyKeydown($event)\">\n            </tbody>\n          </table>\n        </td>\n        <td>\n          <button type=\"button\" (click)=\"getNextYears()\"\n            class=\"usa-date-picker__calendar__next-year-chunk\" aria-label=\"Navigate forward 12 years\">&nbsp;</button>\n        </td>\n      </tr>\n    </tbody>\n  </table>\n</div>\n\n\n", dependencies: [{ kind: "component", type: UsaCalendarBody, selector: "[usa-calendar-body]", inputs: ["view", "label", "rows", "prevMonthRow", "nextMonthRow", "todayValue", "startValue", "endValue", "labelMinRequiredCells", "numCols", "activeCell", "isRange", "cellAspectRatio", "comparisonStart", "comparisonEnd", "previewStart", "previewEnd"], outputs: ["selectedValueChange", "previewChange"], exportAs: ["usaCalendarBody"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaMultiYearView, decorators: [{
            type: Component,
            args: [{ selector: 'usa-multi-year-view', exportAs: 'usaMultiYearView', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"usa-date-picker__calendar__year-picker\">\n  <table class=\"usa-date-picker__calendar__table\">\n    <tbody>\n      <tr>\n        <td>\n          <button type=\"button\" (click)=\"getPreviousYears()\"\n            class=\"usa-date-picker__calendar__previous-year-chunk\" aria-label=\"Navigate back 12 years\">&nbsp;</button>\n        </td>\n        <td colspan=\"3\">\n          <table class=\"usa-date-picker__calendar__table\" role=\"grid\">\n            <tbody usa-calendar-body\n                   [view]=\"'multi-year'\"\n                   [rows]=\"_years\"\n                   [todayValue]=\"_todayYear\"\n                   [startValue]=\"_selectedYear!\"\n                   [endValue]=\"_selectedYear!\"\n                   [numCols]=\"4\"\n                   [cellAspectRatio]=\"4 / 7\"\n                   [activeCell]=\"_getActiveCell()\"\n                   (selectedValueChange)=\"_yearSelected($event)\"\n                   (keyup)=\"_handleCalendarBodyKeyup($event)\"\n                   (keydown)=\"_handleCalendarBodyKeydown($event)\">\n            </tbody>\n          </table>\n        </td>\n        <td>\n          <button type=\"button\" (click)=\"getNextYears()\"\n            class=\"usa-date-picker__calendar__next-year-chunk\" aria-label=\"Navigate forward 12 years\">&nbsp;</button>\n        </td>\n      </tr>\n    </tbody>\n  </table>\n</div>\n\n\n" }]
        }], ctorParameters: () => [{ type: i0.ChangeDetectorRef }, { type: DateAdapter, decorators: [{
                    type: Optional
                }] }], propDecorators: { activeDate: [{
                type: Input
            }], selected: [{
                type: Input
            }], minDate: [{
                type: Input
            }], maxDate: [{
                type: Input
            }], dateFilter: [{
                type: Input
            }], dateClass: [{
                type: Input
            }], selectedChange: [{
                type: Output
            }], yearSelected: [{
                type: Output
            }], activeDateChange: [{
                type: Output
            }], _usaCalendarBody: [{
                type: ViewChild,
                args: [UsaCalendarBody]
            }] } });
function isSameMultiYearView(dateAdapter, date1, date2, minDate, maxDate) {
    const year1 = dateAdapter.getYear(date1);
    const year2 = dateAdapter.getYear(date2);
    const startingYear = getStartingYear(dateAdapter, minDate, maxDate);
    return Math.floor((year1 - startingYear) / yearsPerPage) ===
        Math.floor((year2 - startingYear) / yearsPerPage);
}
/**
 * When the multi-year view is first opened, the active year will be in view.
 * So we compute how many years are between the active year and the *slot* where our
 * "startingYear" will render when paged into view.
 */
function getActiveOffset(dateAdapter, activeDate, minDate, maxDate) {
    const activeYear = dateAdapter.getYear(activeDate);
    return euclideanModulo((activeYear - getStartingYear(dateAdapter, minDate, maxDate)), yearsPerPage);
}
/**
 * We pick a "starting" year such that either the maximum year would be at the end
 * or the minimum year would be at the beginning of a page.
 */
function getStartingYear(dateAdapter, minDate, maxDate) {
    let startingYear = 0;
    if (maxDate) {
        const maxYear = dateAdapter.getYear(maxDate);
        startingYear = maxYear - yearsPerPage + 1;
    }
    else if (minDate) {
        startingYear = dateAdapter.getYear(minDate);
    }
    return startingYear;
}
/** Gets remainder that is non-negative, even if first number is negative */
function euclideanModulo(a, b) {
    return (a % b + b) % b;
}

/**
 * An internal component used to display a single year in the datePicker.
 * @docs-private
 */
class UsaYearView {
    _changeDetectorRef;
    _dateFormats;
    _dateAdapter;
    _rerenderSubscription = Subscription.EMPTY;
    /** Flag used to filter out space/enter keyup events that originated outside of the view. */
    _selectionKeyPressed;
    /** The date to display in this year view (everything other than the year is ignored). */
    get activeDate() { return this._activeDate; }
    set activeDate(value) {
        let oldActiveDate = this._activeDate;
        const validDate = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(value)) || this._dateAdapter.today();
        this._activeDate = this._dateAdapter.clampDate(validDate, this.minDate, this.maxDate);
        if (this._dateAdapter.getYear(oldActiveDate) !== this._dateAdapter.getYear(this._activeDate)) {
            this._init();
        }
    }
    _activeDate;
    /** The currently selected date. */
    get selected() { return this._selected; }
    set selected(value) {
        if (value instanceof DateRange) {
            this._selected = value;
        }
        else {
            this._selected = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(value));
        }
        this._setSelectedMonth(value);
    }
    _selected;
    /** The minimum selectable date. */
    get minDate() { return this._minDate; }
    set minDate(value) {
        this._minDate = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(value));
    }
    _minDate;
    /** The maximum selectable date. */
    get maxDate() { return this._maxDate; }
    set maxDate(value) {
        this._maxDate = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(value));
    }
    _maxDate;
    /** A function used to filter which dates are selectable. */
    dateFilter;
    /** Function that can be used to add custom CSS classes to date cells. */
    dateClass;
    /** Emits when a new month is selected. */
    selectedChange = new EventEmitter();
    /** Emits the selected month. This doesn't imply a change on the selected date */
    monthSelected = new EventEmitter();
    /** Emits when any date is activated. */
    activeDateChange = new EventEmitter();
    /** The body of calendar table */
    _usaCalendarBody;
    /** Grid of calendar cells representing the months of the year. */
    _months;
    /** The label for this year (e.g. "2017"). */
    _yearLabel;
    /** The month in this year that today falls on. Null if today is in a different year. */
    _todayMonth;
    /**
     * The month in this year that the selected Date falls on.
     * Null if the selected Date is in a different year.
     */
    _selectedMonth;
    constructor(_changeDetectorRef, _dateFormats, _dateAdapter) {
        this._changeDetectorRef = _changeDetectorRef;
        this._dateFormats = _dateFormats;
        this._dateAdapter = _dateAdapter;
        if (isDevMode()) {
            if (!this._dateAdapter) {
                throw createMissingDateImplError('DateAdapter');
            }
            if (!this._dateFormats) {
                throw createMissingDateImplError('USA_DATE_FORMATS');
            }
        }
        this._activeDate = this._dateAdapter.today();
    }
    ngAfterContentInit() {
        this._rerenderSubscription = this._dateAdapter.localeChanges
            .pipe(startWith(null))
            .subscribe(() => this._init());
    }
    ngOnDestroy() {
        this._rerenderSubscription.unsubscribe();
    }
    /** Handles when a new month is selected. */
    _monthSelected(event) {
        const month = event.value;
        const normalizedDate = this._dateAdapter.createDate(this._dateAdapter.getYear(this.activeDate), month, 1);
        this.monthSelected.emit(normalizedDate);
        const daysInMonth = this._dateAdapter.getNumDaysInMonth(normalizedDate);
        this.selectedChange.emit(this._dateAdapter.createDate(this._dateAdapter.getYear(this.activeDate), month, Math.min(this._dateAdapter.getDate(this.activeDate), daysInMonth)));
    }
    /** Handles keydown events on the calendar body when calendar is in year view. */
    _handleCalendarBodyKeydown(event) {
        // TODO(mmalerba): We currently allow keyboard navigation to disabled dates, but just prevent
        // disabled ones from being selected. This may not be ideal, we should look into whether
        // navigation should skip over disabled dates, and if so, how to implement that efficiently.
        const oldActiveDate = this._activeDate;
        switch (event.keyCode) {
            case KeyCode.ArrowLeft:
                this.activeDate = this._dateAdapter.addCalendarMonths(this._activeDate, -1);
                break;
            case KeyCode.ArrowRight:
                this.activeDate = this._dateAdapter.addCalendarMonths(this._activeDate, 1);
                break;
            case KeyCode.ArrowUp:
                this.activeDate = this._dateAdapter.addCalendarMonths(this._activeDate, -4);
                break;
            case KeyCode.ArrowDown:
                this.activeDate = this._dateAdapter.addCalendarMonths(this._activeDate, 4);
                break;
            case KeyCode.Home:
                this.activeDate = this._dateAdapter.addCalendarMonths(this._activeDate, -this._dateAdapter.getMonth(this._activeDate));
                break;
            case KeyCode.End:
                this.activeDate = this._dateAdapter.addCalendarMonths(this._activeDate, 11 - this._dateAdapter.getMonth(this._activeDate));
                break;
            case KeyCode.PageUp:
                this.activeDate =
                    this._dateAdapter.addCalendarYears(this._activeDate, event.altKey ? -10 : -1);
                break;
            case KeyCode.PageDown:
                this.activeDate =
                    this._dateAdapter.addCalendarYears(this._activeDate, event.altKey ? 10 : 1);
                break;
            case KeyCode.Enter:
            case KeyCode.Space:
                // Note that we only prevent the default action here while the selection happens in
                // `keyup` below. We can't do the selection here, because it can cause the calendar to
                // reopen if focus is restored immediately. We also can't call `preventDefault` on `keyup`
                // because it's too late (see #23305).
                this._selectionKeyPressed = true;
                break;
            default:
                // Don't prevent default or focus active cell on keys that we don't explicitly handle.
                return;
        }
        if (this._dateAdapter.compareDate(oldActiveDate, this.activeDate)) {
            this.activeDateChange.emit(this.activeDate);
        }
        this._focusActiveCell();
        // Prevent unexpected default actions such as form submission.
        event.preventDefault();
    }
    /** Handles keyup events on the calendar body when calendar is in year view. */
    _handleCalendarBodyKeyup(event) {
        if (event.keyCode === KeyCode.Space || event.keyCode === KeyCode.Enter) {
            if (this._selectionKeyPressed) {
                this._monthSelected({ value: this._dateAdapter.getMonth(this._activeDate), event });
            }
            this._selectionKeyPressed = false;
        }
    }
    /** Initializes this year view. */
    _init() {
        this._setSelectedMonth(this.selected);
        this._todayMonth = this._getMonthInCurrentYear(this._dateAdapter.today());
        this._yearLabel = this._dateAdapter.getYearName(this.activeDate);
        let monthNames = this._dateAdapter.getMonthNames('short');
        // First row of months only contains 5 elements so we can fit the year label on the same row.
        this._months = [[0, 1, 2, 3], [4, 5, 6, 7], [8, 9, 10, 11]].map(row => row.map(month => this._createCellForMonth(month, monthNames[month])));
        this._changeDetectorRef.markForCheck();
    }
    /** Focuses the active cell after the microtask queue is empty. */
    _focusActiveCell() {
        this._usaCalendarBody._focusActiveCell();
    }
    /**
     * Gets the month in this year that the given Date falls on.
     * Returns null if the given Date is in another year.
     */
    _getMonthInCurrentYear(date) {
        return date && this._dateAdapter.getYear(date) == this._dateAdapter.getYear(this.activeDate) ?
            this._dateAdapter.getMonth(date) : null;
    }
    /** Creates an UsaCalendarCell for the given month. */
    _createCellForMonth(month, monthName) {
        const date = this._dateAdapter.createDate(this._dateAdapter.getYear(this.activeDate), month, 1);
        const ariaLabel = this._dateAdapter.format(date, this._dateFormats.display.monthYearA11yLabel);
        const cellClasses = this.dateClass ? this.dateClass(date, 'year') : undefined;
        return new UsaCalendarCell(month, monthName.toLocaleUpperCase(), ariaLabel, this._shouldEnableMonth(month), cellClasses);
    }
    /** Whether the given month is enabled. */
    _shouldEnableMonth(month) {
        const activeYear = this._dateAdapter.getYear(this.activeDate);
        if (month === undefined || month === null ||
            this._isYearAndMonthAfterMaxDate(activeYear, month) ||
            this._isYearAndMonthBeforeMinDate(activeYear, month)) {
            return false;
        }
        if (!this.dateFilter) {
            return true;
        }
        const firstOfMonth = this._dateAdapter.createDate(activeYear, month, 1);
        // If any date in the month is enabled count the month as enabled.
        for (let date = firstOfMonth; this._dateAdapter.getMonth(date) == month; date = this._dateAdapter.addCalendarDays(date, 1)) {
            if (this.dateFilter(date)) {
                return true;
            }
        }
        return false;
    }
    /**
     * Tests whether the combination month/year is after this.maxDate, considering
     * just the month and year of this.maxDate
     */
    _isYearAndMonthAfterMaxDate(year, month) {
        if (this.maxDate) {
            const maxYear = this._dateAdapter.getYear(this.maxDate);
            const maxMonth = this._dateAdapter.getMonth(this.maxDate);
            return year > maxYear || (year === maxYear && month > maxMonth);
        }
        return false;
    }
    /**
     * Tests whether the combination month/year is before this.minDate, considering
     * just the month and year of this.minDate
     */
    _isYearAndMonthBeforeMinDate(year, month) {
        if (this.minDate) {
            const minYear = this._dateAdapter.getYear(this.minDate);
            const minMonth = this._dateAdapter.getMonth(this.minDate);
            return year < minYear || (year === minYear && month < minMonth);
        }
        return false;
    }
    /** Sets the currently-selected month based on a model value. */
    _setSelectedMonth(value) {
        if (value instanceof DateRange) {
            this._selectedMonth = this._getMonthInCurrentYear(value.start) ||
                this._getMonthInCurrentYear(value.end);
        }
        else {
            this._selectedMonth = this._getMonthInCurrentYear(value);
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaYearView, deps: [{ token: i0.ChangeDetectorRef }, { token: USA_DATE_FORMATS, optional: true }, { token: DateAdapter, optional: true }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.2", type: UsaYearView, selector: "usa-year-view", inputs: { activeDate: "activeDate", selected: "selected", minDate: "minDate", maxDate: "maxDate", dateFilter: "dateFilter", dateClass: "dateClass" }, outputs: { selectedChange: "selectedChange", monthSelected: "monthSelected", activeDateChange: "activeDateChange" }, viewQueries: [{ propertyName: "_usaCalendarBody", first: true, predicate: UsaCalendarBody, descendants: true }], exportAs: ["usaYearView"], ngImport: i0, template: "<table class=\"usa-date-picker__calendar__table\" role=\"grid\">\n  <tbody usa-calendar-body\n         [label]=\"_yearLabel\"\n         [rows]=\"_months\"\n         [todayValue]=\"_todayMonth!\"\n         [startValue]=\"_selectedMonth!\"\n         [endValue]=\"_selectedMonth!\"\n         [labelMinRequiredCells]=\"2\"\n         [numCols]=\"4\"\n         [cellAspectRatio]=\"4 / 7\"\n         [activeCell]=\"_dateAdapter.getMonth(activeDate)\"\n         (selectedValueChange)=\"_monthSelected($event)\"\n         (keyup)=\"_handleCalendarBodyKeyup($event)\"\n         (keydown)=\"_handleCalendarBodyKeydown($event)\">\n  </tbody>\n</table>\n", dependencies: [{ kind: "component", type: UsaCalendarBody, selector: "[usa-calendar-body]", inputs: ["view", "label", "rows", "prevMonthRow", "nextMonthRow", "todayValue", "startValue", "endValue", "labelMinRequiredCells", "numCols", "activeCell", "isRange", "cellAspectRatio", "comparisonStart", "comparisonEnd", "previewStart", "previewEnd"], outputs: ["selectedValueChange", "previewChange"], exportAs: ["usaCalendarBody"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaYearView, decorators: [{
            type: Component,
            args: [{ selector: 'usa-year-view', exportAs: 'usaYearView', encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, template: "<table class=\"usa-date-picker__calendar__table\" role=\"grid\">\n  <tbody usa-calendar-body\n         [label]=\"_yearLabel\"\n         [rows]=\"_months\"\n         [todayValue]=\"_todayMonth!\"\n         [startValue]=\"_selectedMonth!\"\n         [endValue]=\"_selectedMonth!\"\n         [labelMinRequiredCells]=\"2\"\n         [numCols]=\"4\"\n         [cellAspectRatio]=\"4 / 7\"\n         [activeCell]=\"_dateAdapter.getMonth(activeDate)\"\n         (selectedValueChange)=\"_monthSelected($event)\"\n         (keyup)=\"_handleCalendarBodyKeyup($event)\"\n         (keydown)=\"_handleCalendarBodyKeydown($event)\">\n  </tbody>\n</table>\n" }]
        }], ctorParameters: () => [{ type: i0.ChangeDetectorRef }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [USA_DATE_FORMATS]
                }] }, { type: DateAdapter, decorators: [{
                    type: Optional
                }] }], propDecorators: { activeDate: [{
                type: Input
            }], selected: [{
                type: Input
            }], minDate: [{
                type: Input
            }], maxDate: [{
                type: Input
            }], dateFilter: [{
                type: Input
            }], dateClass: [{
                type: Input
            }], selectedChange: [{
                type: Output
            }], monthSelected: [{
                type: Output
            }], activeDateChange: [{
                type: Output
            }], _usaCalendarBody: [{
                type: ViewChild,
                args: [UsaCalendarBody]
            }] } });

/** Counter used to generate unique IDs. */
let uniqueId = 0;
/** Default header for MatCalendar */
class UsaCalendarHeader {
    calendar;
    _dateAdapter;
    _dateFormats;
    _buttonDescriptionId = `mat-calendar-button-${uniqueId++}`;
    ariaLiveText = '';
    constructor(calendar, _dateAdapter, _dateFormats, changeDetectorRef) {
        this.calendar = calendar;
        this._dateAdapter = _dateAdapter;
        this._dateFormats = _dateFormats;
        this.calendar.stateChanges.subscribe(() => changeDetectorRef.markForCheck());
    }
    get monthLabel() {
        return this._dateAdapter
            .format(this.calendar.activeDate, this._dateFormats.display.monthLabel)
            .toLocaleUpperCase();
    }
    get yearLabel() {
        return this._dateAdapter.getYearName(this.calendar.activeDate);
    }
    /** Handles user clicks on month label */
    monthClicked() {
        this.calendar.currentView = 'year';
    }
    /**
     * Handles user clicks on year label
     */
    yearClicked() {
        this.calendar.currentView = 'multi-year';
    }
    /** Handles user clicks on the previous button. */
    previousClicked() {
        this.calendar.activeDate = this._dateAdapter.addCalendarMonths(this.calendar.activeDate, -1);
        this.ariaLiveText = this._dateAdapter.getMonthNames('long')[this._dateAdapter.getMonth(this.calendar.activeDate)];
    }
    /** Handles user clicks on the next button. */
    nextClicked() {
        this.calendar.activeDate = this._dateAdapter.addCalendarMonths(this.calendar.activeDate, 1);
    }
    /** Handles user click of next year */
    nextYearClicked() {
        this.calendar.activeDate = this._dateAdapter.addCalendarYears(this.calendar.activeDate, 1);
    }
    /** Handles user click of previous year */
    previousYearClicked() {
        this.calendar.activeDate = this._dateAdapter.addCalendarYears(this.calendar.activeDate, -1);
    }
    /** Whether the previous period button is enabled. */
    previousEnabled() {
        if (!this.calendar.minDate) {
            return true;
        }
        return !this.calendar.minDate ||
            !this._isSameView(this.calendar.activeDate, this.calendar.minDate);
    }
    /** Whether the next period button is enabled. */
    nextEnabled() {
        return !this.calendar.maxDate ||
            !this._isSameView(this.calendar.activeDate, this.calendar.maxDate);
    }
    previousYearEnabled() {
        return !this.calendar.minDate ||
            !(this._dateAdapter.getYear(this.calendar.activeDate) === this._dateAdapter.getYear(this.calendar.minDate));
    }
    nextYearEnabled() {
        return !this.calendar.maxDate ||
            !(this._dateAdapter.getYear(this.calendar.activeDate) === this._dateAdapter.getYear(this.calendar.maxDate));
    }
    /** Whether the two dates represent the same view in the current view mode (month or year). */
    _isSameView(date1, date2) {
        if (this.calendar.currentView == 'month') {
            return this._dateAdapter.getYear(date1) == this._dateAdapter.getYear(date2) &&
                this._dateAdapter.getMonth(date1) == this._dateAdapter.getMonth(date2);
        }
        if (this.calendar.currentView == 'year') {
            return this._dateAdapter.getYear(date1) == this._dateAdapter.getYear(date2);
        }
        // Otherwise we are in 'multi-year' view.
        return isSameMultiYearView(this._dateAdapter, date1, date2, this.calendar.minDate, this.calendar.maxDate);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaCalendarHeader, deps: [{ token: forwardRef(() => UsaCalendar) }, { token: DateAdapter, optional: true }, { token: USA_DATE_FORMATS, optional: true }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.2", type: UsaCalendarHeader, selector: "usa-calendar-header", exportAs: ["usaCalendarHeader"], ngImport: i0, template: "<div class=\"usa-date-picker__calendar__row\">\n  <div class=\"usa-date-picker__calendar__cell usa-date-picker__calendar__cell--center-items\">\n    <button type=\"button\" (click)=\"previousYearClicked()\" [disabled]=\"!previousYearEnabled()\"\n      class=\"usa-date-picker__calendar__previous-year\" aria-label=\"Navigate back one year\">&nbsp;</button>\n  </div>\n  <div class=\"usa-date-picker__calendar__cell usa-date-picker__calendar__cell--center-items\">\n    <button type=\"button\" (click)=\"previousClicked()\"\n      [disabled]=\"!previousEnabled()\"\n      class=\"usa-date-picker__calendar__previous-month\" \n      aria-label=\"Navigate back one month\">&nbsp;</button>\n  </div>\n  <div class=\"usa-date-picker__calendar__cell usa-date-picker__calendar__month-label\">\n    <button type=\"button\" (click)=\"monthClicked()\" class=\"usa-date-picker__calendar__month-selection\" [attr.aria-label]=\"monthLabel + '. Click to select month'\">{{monthLabel}}</button>\n    <button type=\"button\" (click)=\"yearClicked()\" class=\"usa-date-picker__calendar__year-selection\" [attr.aria-label]=\"yearLabel + '. Click to select year'\">{{yearLabel}}</button>\n  </div>\n  <div class=\"usa-date-picker__calendar__cell usa-date-picker__calendar__cell--center-items\">\n    <button type=\"button\" [disabled]=\"!nextEnabled()\" (click)=\"nextClicked()\" \n      class=\"usa-date-picker__calendar__next-month\" \n      aria-label=\"Navigate forward one month\">&nbsp;</button>\n  </div>\n  <div class=\"usa-date-picker__calendar__cell usa-date-picker__calendar__cell--center-items\">\n    <button type=\"button\" (click)=\"nextYearClicked()\" [disabled]=\"!nextYearEnabled()\" \n      class=\"usa-date-picker__calendar__next-year\" aria-label=\"Navigate forward one year\">&nbsp;</button>\n  </div>\n</div>\n\n<span class=\"usa-sr-only\" aria-live=\"polite\">\n  {{monthLabel + ' ' + yearLabel}}\n</span>", changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaCalendarHeader, decorators: [{
            type: Component,
            args: [{ selector: 'usa-calendar-header', exportAs: 'usaCalendarHeader', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"usa-date-picker__calendar__row\">\n  <div class=\"usa-date-picker__calendar__cell usa-date-picker__calendar__cell--center-items\">\n    <button type=\"button\" (click)=\"previousYearClicked()\" [disabled]=\"!previousYearEnabled()\"\n      class=\"usa-date-picker__calendar__previous-year\" aria-label=\"Navigate back one year\">&nbsp;</button>\n  </div>\n  <div class=\"usa-date-picker__calendar__cell usa-date-picker__calendar__cell--center-items\">\n    <button type=\"button\" (click)=\"previousClicked()\"\n      [disabled]=\"!previousEnabled()\"\n      class=\"usa-date-picker__calendar__previous-month\" \n      aria-label=\"Navigate back one month\">&nbsp;</button>\n  </div>\n  <div class=\"usa-date-picker__calendar__cell usa-date-picker__calendar__month-label\">\n    <button type=\"button\" (click)=\"monthClicked()\" class=\"usa-date-picker__calendar__month-selection\" [attr.aria-label]=\"monthLabel + '. Click to select month'\">{{monthLabel}}</button>\n    <button type=\"button\" (click)=\"yearClicked()\" class=\"usa-date-picker__calendar__year-selection\" [attr.aria-label]=\"yearLabel + '. Click to select year'\">{{yearLabel}}</button>\n  </div>\n  <div class=\"usa-date-picker__calendar__cell usa-date-picker__calendar__cell--center-items\">\n    <button type=\"button\" [disabled]=\"!nextEnabled()\" (click)=\"nextClicked()\" \n      class=\"usa-date-picker__calendar__next-month\" \n      aria-label=\"Navigate forward one month\">&nbsp;</button>\n  </div>\n  <div class=\"usa-date-picker__calendar__cell usa-date-picker__calendar__cell--center-items\">\n    <button type=\"button\" (click)=\"nextYearClicked()\" [disabled]=\"!nextYearEnabled()\" \n      class=\"usa-date-picker__calendar__next-year\" aria-label=\"Navigate forward one year\">&nbsp;</button>\n  </div>\n</div>\n\n<span class=\"usa-sr-only\" aria-live=\"polite\">\n  {{monthLabel + ' ' + yearLabel}}\n</span>" }]
        }], ctorParameters: () => [{ type: UsaCalendar, decorators: [{
                    type: Inject,
                    args: [forwardRef(() => UsaCalendar)]
                }] }, { type: DateAdapter, decorators: [{
                    type: Optional
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [USA_DATE_FORMATS]
                }] }, { type: i0.ChangeDetectorRef }] });
/** A calendar that is used as part of the datePicker. */
class UsaCalendar {
    _dateAdapter;
    _dateFormats;
    _changeDetectorRef;
    /** An input indicating the type of the header component, if set. */
    headerComponent;
    /**
     * Used for scheduling that focus should be moved to the active cell on the next tick.
     * We need to schedule it, rather than do it immediately, because we have to wait
     * for Angular to re-evaluate the view children.
     */
    _moveFocusOnNextTick = false;
    /** A date representing the period (month or year) to start the calendar in. */
    get startAt() { return this._startAt; }
    set startAt(value) {
        this._startAt = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(value));
    }
    _startAt;
    /** Whether the calendar should be started in month or year view. */
    startView = 'month';
    /** The currently selected date. */
    get selected() { return this._selected; }
    set selected(value) {
        if (value instanceof DateRange) {
            this._selected = value;
        }
        else {
            this._selected = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(value));
        }
    }
    _selected;
    /** The minimum selectable date. */
    get minDate() { return this._minDate; }
    set minDate(value) {
        this._minDate = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(value));
    }
    _minDate;
    /** The maximum selectable date. */
    get maxDate() { return this._maxDate; }
    set maxDate(value) {
        this._maxDate = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(value));
    }
    _maxDate;
    /** Function used to filter which dates are selectable. */
    dateFilter;
    /** Function that can be used to add custom CSS classes to dates. */
    dateClass;
    /** Start of the comparison range. */
    comparisonStart;
    /** End of the comparison range. */
    comparisonEnd;
    /** Emits when the currently selected date changes. */
    selectedChange = new EventEmitter();
    /**
     * Emits the year chosen in multiyear view.
     * This doesn't imply a change on the selected date.
     */
    yearSelected = new EventEmitter();
    /**
     * Emits the month chosen in year view.
     * This doesn't imply a change on the selected date.
     */
    monthSelected = new EventEmitter();
    /**
     * Emits when the current view changes.
     */
    viewChanged = new EventEmitter(true);
    /** Emits when any date is selected. */
    _userSelection = new EventEmitter();
    /** Reference to the current month view component. */
    monthView;
    /** Reference to the current year view component. */
    yearView;
    /** Reference to the current multi-year view component. */
    multiYearView;
    /**
     * The current active date. This determines which time period is shown and which date is
     * highlighted when using keyboard navigation.
     */
    get activeDate() { return this._clampedActiveDate; }
    set activeDate(value) {
        this._clampedActiveDate = this._dateAdapter.clampDate(value, this.minDate, this.maxDate);
        this.stateChanges.next();
        this._changeDetectorRef.markForCheck();
    }
    _clampedActiveDate;
    /** Whether the calendar is in month view. */
    get currentView() { return this._currentView; }
    set currentView(value) {
        const viewChangedResult = this._currentView !== value ? value : null;
        this._currentView = value;
        this._moveFocusOnNextTick = true;
        this._changeDetectorRef.markForCheck();
        if (viewChangedResult) {
            this.viewChanged.emit(viewChangedResult);
        }
    }
    _currentView;
    /**
     * Emits whenever there is a state change that the header may need to respond to.
     */
    stateChanges = new Subject();
    constructor(_dateAdapter, _dateFormats, _changeDetectorRef) {
        this._dateAdapter = _dateAdapter;
        this._dateFormats = _dateFormats;
        this._changeDetectorRef = _changeDetectorRef;
        if (isDevMode()) {
            if (!this._dateAdapter) {
                throw createMissingDateImplError('DateAdapter');
            }
            if (!this._dateFormats) {
                throw createMissingDateImplError('USA_DATE_FORMATS');
            }
        }
    }
    ngAfterContentInit() {
        this.activeDate = this.startAt || this._dateAdapter.today();
        // Assign to the private property since we don't want to move focus on init.
        this._currentView = this.startView;
    }
    ngAfterViewChecked() {
        if (this._moveFocusOnNextTick) {
            this._moveFocusOnNextTick = false;
            this.focusActiveCell();
        }
    }
    ngOnDestroy() {
        this.stateChanges.complete();
    }
    ngOnChanges(changes) {
        const change = changes['minDate'] || changes['maxDate'] || changes['dateFilter'];
        if (change && !change.firstChange) {
            const view = this._getCurrentViewComponent();
            if (view) {
                // We need to `detectChanges` manually here, because the `minDate`, `maxDate` etc. are
                // passed down to the view via data bindings which won't be up-to-date when we call `_init`.
                this._changeDetectorRef.detectChanges();
                view._init();
            }
        }
        this.stateChanges.next();
    }
    /** Focuses the active date. */
    focusActiveCell() {
        this._getCurrentViewComponent()._focusActiveCell(false);
    }
    /** Updates today's date after an update of the active date */
    updateTodaysDate() {
        this._getCurrentViewComponent()._init();
    }
    /** Handles date selection in the month view. */
    _dateSelected(event) {
        const date = event.value;
        if (this.selected instanceof DateRange ||
            (date && !this._dateAdapter.sameDate(date, this.selected))) {
            this.selectedChange.emit(date);
        }
        this._userSelection.emit(event);
    }
    /** Handles year selection in the multiyear view. */
    _yearSelectedInMultiYearView(normalizedYear) {
        this.yearSelected.emit(normalizedYear);
    }
    /** Handles month selection in the year view. */
    _monthSelectedInYearView(normalizedMonth) {
        this.monthSelected.emit(normalizedMonth);
    }
    /** Handles year/month selection in the multi-year/year views. */
    _goToDateInView(date, view) {
        this.activeDate = date;
        this.currentView = view;
    }
    /** Returns the component instance that corresponds to the current calendar view. */
    _getCurrentViewComponent() {
        // The return type is explicitly written as a union to ensure that the Closure compiler does
        // not optimize calls to _init(). Without the explict return type, TypeScript narrows it to
        // only the first component type. See https://github.com/angular/components/issues/22996.
        return this.monthView || this.yearView || this.multiYearView;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaCalendar, deps: [{ token: DateAdapter, optional: true }, { token: USA_DATE_FORMATS, optional: true }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.2", type: UsaCalendar, selector: "usa-calendar", inputs: { headerComponent: "headerComponent", startAt: "startAt", startView: "startView", selected: "selected", minDate: "minDate", maxDate: "maxDate", dateFilter: "dateFilter", dateClass: "dateClass", comparisonStart: "comparisonStart", comparisonEnd: "comparisonEnd" }, outputs: { selectedChange: "selectedChange", yearSelected: "yearSelected", monthSelected: "monthSelected", viewChanged: "viewChanged", _userSelection: "_userSelection" }, providers: [USA_SINGLE_DATE_SELECTION_MODEL_PROVIDER], viewQueries: [{ propertyName: "monthView", first: true, predicate: UsaMonthView, descendants: true }, { propertyName: "yearView", first: true, predicate: UsaYearView, descendants: true }, { propertyName: "multiYearView", first: true, predicate: UsaMultiYearView, descendants: true }], exportAs: ["usaCalendar"], usesOnChanges: true, ngImport: i0, template: "<div class=\"usa-date-picker__calendar__date-picker\">\n  <usa-calendar-header></usa-calendar-header>\n  <div [ngSwitch]=\"currentView\">\n    <usa-month-view #monthView *ngSwitchCase=\"'month'\" [(activeDate)]=\"activeDate\" [selected]=\"selected\"\n      [dateFilter]=\"dateFilter\" [maxDate]=\"maxDate\" [minDate]=\"minDate\" [dateClass]=\"dateClass\"\n      [comparisonStart]=\"comparisonStart\" [comparisonEnd]=\"comparisonEnd\" (_userSelection)=\"_dateSelected($event)\">\n    </usa-month-view>\n    <usa-year-view #yearView *ngSwitchCase=\"'year'\" [(activeDate)]=\"activeDate\" [selected]=\"selected\"\n      [dateFilter]=\"dateFilter\" [maxDate]=\"maxDate\" [minDate]=\"minDate\" [dateClass]=\"dateClass\"\n      (monthSelected)=\"_monthSelectedInYearView($event)\" (selectedChange)=\"_goToDateInView($event, 'month')\">\n    </usa-year-view>\n    <usa-multi-year-view #multiYearView *ngSwitchCase=\"'multi-year'\" [(activeDate)]=\"activeDate\" [selected]=\"selected\"\n      [dateFilter]=\"dateFilter\" [maxDate]=\"maxDate\" [minDate]=\"minDate\" [dateClass]=\"dateClass\"\n      (yearSelected)=\"_yearSelectedInMultiYearView($event)\" (selectedChange)=\"_goToDateInView($event, 'month')\">\n    </usa-multi-year-view>\n  </div>\n</div>\n", dependencies: [{ kind: "directive", type: i1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "component", type: UsaCalendarHeader, selector: "usa-calendar-header", exportAs: ["usaCalendarHeader"] }, { kind: "component", type: UsaMonthView, selector: "usa-month-view", inputs: ["activeDate", "selected", "minDate", "maxDate", "dateFilter", "dateClass", "comparisonStart", "comparisonEnd"], outputs: ["selectedChange", "_userSelection", "activeDateChange"], exportAs: ["usaMonthView"] }, { kind: "component", type: UsaYearView, selector: "usa-year-view", inputs: ["activeDate", "selected", "minDate", "maxDate", "dateFilter", "dateClass"], outputs: ["selectedChange", "monthSelected", "activeDateChange"], exportAs: ["usaYearView"] }, { kind: "component", type: UsaMultiYearView, selector: "usa-multi-year-view", inputs: ["activeDate", "selected", "minDate", "maxDate", "dateFilter", "dateClass"], outputs: ["selectedChange", "yearSelected", "activeDateChange"], exportAs: ["usaMultiYearView"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaCalendar, decorators: [{
            type: Component,
            args: [{ selector: 'usa-calendar', exportAs: 'usaCalendar', changeDetection: ChangeDetectionStrategy.OnPush, providers: [USA_SINGLE_DATE_SELECTION_MODEL_PROVIDER], template: "<div class=\"usa-date-picker__calendar__date-picker\">\n  <usa-calendar-header></usa-calendar-header>\n  <div [ngSwitch]=\"currentView\">\n    <usa-month-view #monthView *ngSwitchCase=\"'month'\" [(activeDate)]=\"activeDate\" [selected]=\"selected\"\n      [dateFilter]=\"dateFilter\" [maxDate]=\"maxDate\" [minDate]=\"minDate\" [dateClass]=\"dateClass\"\n      [comparisonStart]=\"comparisonStart\" [comparisonEnd]=\"comparisonEnd\" (_userSelection)=\"_dateSelected($event)\">\n    </usa-month-view>\n    <usa-year-view #yearView *ngSwitchCase=\"'year'\" [(activeDate)]=\"activeDate\" [selected]=\"selected\"\n      [dateFilter]=\"dateFilter\" [maxDate]=\"maxDate\" [minDate]=\"minDate\" [dateClass]=\"dateClass\"\n      (monthSelected)=\"_monthSelectedInYearView($event)\" (selectedChange)=\"_goToDateInView($event, 'month')\">\n    </usa-year-view>\n    <usa-multi-year-view #multiYearView *ngSwitchCase=\"'multi-year'\" [(activeDate)]=\"activeDate\" [selected]=\"selected\"\n      [dateFilter]=\"dateFilter\" [maxDate]=\"maxDate\" [minDate]=\"minDate\" [dateClass]=\"dateClass\"\n      (yearSelected)=\"_yearSelectedInMultiYearView($event)\" (selectedChange)=\"_goToDateInView($event, 'month')\">\n    </usa-multi-year-view>\n  </div>\n</div>\n" }]
        }], ctorParameters: () => [{ type: DateAdapter, decorators: [{
                    type: Optional
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [USA_DATE_FORMATS]
                }] }, { type: i0.ChangeDetectorRef }], propDecorators: { headerComponent: [{
                type: Input
            }], startAt: [{
                type: Input
            }], startView: [{
                type: Input
            }], selected: [{
                type: Input
            }], minDate: [{
                type: Input
            }], maxDate: [{
                type: Input
            }], dateFilter: [{
                type: Input
            }], dateClass: [{
                type: Input
            }], comparisonStart: [{
                type: Input
            }], comparisonEnd: [{
                type: Input
            }], selectedChange: [{
                type: Output
            }], yearSelected: [{
                type: Output
            }], monthSelected: [{
                type: Output
            }], viewChanged: [{
                type: Output
            }], _userSelection: [{
                type: Output
            }], monthView: [{
                type: ViewChild,
                args: [UsaMonthView]
            }], yearView: [{
                type: ViewChild,
                args: [UsaYearView]
            }], multiYearView: [{
                type: ViewChild,
                args: [UsaMultiYearView]
            }] } });

/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/** Coerces a data-bound value (typically a string) to a boolean. */
function coerceBooleanProperty(value) {
    return value != null && `${value}` !== 'false';
}

let datePickerUid = 0;
/**
 * Component used as the content for the datePicker display. We use this instead of using
 * UsaCalendar directly as the content so we can control the initial focus. This also gives us a
 * place to put additional features of the display that are not part of the calendar itself in the
 * future. (e.g. confirmation buttons).
 * @docs-private
 */
class UsaDatePickerContent {
    _changeDetectorRef;
    _globalModel;
    _dateAdapter;
    _zone;
    _el;
    _rangeSelectionStrategy;
    _subscriptions = new Subscription();
    _model;
    /** Reference to the internal calendar component. */
    _calendar;
    /** Reference to the datePicker that created the overlay. */
    datePicker;
    /** Start of the comparison range. */
    comparisonStart;
    /** End of the comparison range. */
    comparisonEnd;
    /** Whether the datePicker is above or below the input. */
    _isAbove;
    /** Text for the close button. */
    _closeButtonText;
    /** Whether the close button currently has focus. */
    _closeButtonFocused;
    /** Keeps track of last click and indicates whether it was inside the calender or outside */
    wasInside = false;
    clickInside() {
        this.wasInside = true;
    }
    clickout() {
        if (!this.wasInside) {
            this.datePicker.close();
        }
        this.wasInside = false;
    }
    onKeydownHandler(event) {
        this.datePicker.close();
        event?.stopImmediatePropagation();
    }
    constructor(_changeDetectorRef, _globalModel, _dateAdapter, _zone, _el, _rangeSelectionStrategy) {
        this._changeDetectorRef = _changeDetectorRef;
        this._globalModel = _globalModel;
        this._dateAdapter = _dateAdapter;
        this._zone = _zone;
        this._el = _el;
        this._rangeSelectionStrategy = _rangeSelectionStrategy;
        this._closeButtonText = 'Close';
    }
    ngOnInit() {
        this._model = this._globalModel;
        usaFocusTrap(this._zone, this._el.nativeElement, this.datePicker.closedStream);
    }
    ngAfterViewInit() {
        this._subscriptions.add(this.datePicker.stateChanges.subscribe(() => {
            this._changeDetectorRef.markForCheck();
        }));
        this._calendar.focusActiveCell();
    }
    ngOnDestroy() {
        this._subscriptions.unsubscribe();
    }
    _handleUserSelection(event) {
        const selection = this._model.selection;
        const value = event.value;
        const isRange = selection instanceof DateRange;
        // If we're selecting a range and we have a selection strategy, always pass the value through
        // there. Otherwise don't assign null values to the model, unless we're selecting a range.
        // A null value when picking a range means that the user cancelled the selection (e.g. by
        // pressing escape), whereas when selecting a single value it means that the value didn't
        // change. This isn't very intuitive, but it's here for backwards-compatibility.
        if (isRange && this._rangeSelectionStrategy) {
            const newSelection = this._rangeSelectionStrategy.selectionFinished(value, selection, event.event);
            this._model.updateSelection(newSelection, this);
        }
        else if (value &&
            (isRange || !this._dateAdapter.sameDate(value, selection))) {
            this._model.add(value);
        }
        // Delegate closing the overlay to the actions.
        if (!this._model || this._model.isComplete()) {
            this.datePicker.close();
        }
    }
    _getSelected() {
        return this._model.selection;
    }
    /** Applies the current pending selection to the global model. */
    _applyPendingSelection() {
        if (this._model !== this._globalModel) {
            this._globalModel.updateSelection(this._model.selection, this);
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaDatePickerContent, deps: [{ token: i0.ChangeDetectorRef }, { token: UsaDateSelectionModel }, { token: DateAdapter }, { token: i0.NgZone }, { token: i0.ElementRef }, { token: USA_DATE_RANGE_SELECTION_STRATEGY, optional: true }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.2", type: UsaDatePickerContent, selector: "usa-date-picker-content", host: { listeners: { "click": "clickInside()", "document:click": "clickout()", "document:keydown.escape": "onKeydownHandler($event)" }, properties: { "attr.role": "dialog", "attr.aria-modal": "true", "attr.tabindex": "-1" }, classAttribute: "usa-date-picker__calendar" }, viewQueries: [{ propertyName: "_calendar", first: true, predicate: UsaCalendar, descendants: true }], exportAs: ["usaDatePickerContent"], ngImport: i0, template: "\n<usa-calendar\n  [id]=\"datePicker.id\"\n  [ngClass]=\"datePicker.panelClass\"\n  [startAt]=\"datePicker.startAt\"\n  [minDate]=\"datePicker._getMinDate()\"\n  [maxDate]=\"datePicker._getMaxDate()\"\n  [dateFilter]=\"datePicker._getDateFilter()\"\n  [headerComponent]=\"datePicker.calendarHeaderComponent\"\n  [selected]=\"_getSelected()\"\n  [dateClass]=\"datePicker.dateClass\"\n  [comparisonStart]=\"comparisonStart\"\n  [comparisonEnd]=\"comparisonEnd\"\n  (_userSelection)=\"_handleUserSelection($event)\"></usa-calendar>\n\n<!-- Invisible close button for screen reader users. -->\n<button\n  type=\"button\"\n  class=\"usa-sr-only\"\n  [class.cdk-visually-hidden]=\"!_closeButtonFocused\"\n  (focus)=\"_closeButtonFocused = true\"\n  (blur)=\"_closeButtonFocused = false\"\n  (click)=\"datePicker.close()\">{{ _closeButtonText }}</button>\n", dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "component", type: UsaCalendar, selector: "usa-calendar", inputs: ["headerComponent", "startAt", "startView", "selected", "minDate", "maxDate", "dateFilter", "dateClass", "comparisonStart", "comparisonEnd"], outputs: ["selectedChange", "yearSelected", "monthSelected", "viewChanged", "_userSelection"], exportAs: ["usaCalendar"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaDatePickerContent, decorators: [{
            type: Component,
            args: [{ selector: 'usa-date-picker-content', host: {
                        class: 'usa-date-picker__calendar',
                        '[attr.role]': 'dialog',
                        '[attr.aria-modal]': 'true',
                        '[attr.tabindex]': '-1',
                    }, exportAs: 'usaDatePickerContent', changeDetection: ChangeDetectionStrategy.OnPush, template: "\n<usa-calendar\n  [id]=\"datePicker.id\"\n  [ngClass]=\"datePicker.panelClass\"\n  [startAt]=\"datePicker.startAt\"\n  [minDate]=\"datePicker._getMinDate()\"\n  [maxDate]=\"datePicker._getMaxDate()\"\n  [dateFilter]=\"datePicker._getDateFilter()\"\n  [headerComponent]=\"datePicker.calendarHeaderComponent\"\n  [selected]=\"_getSelected()\"\n  [dateClass]=\"datePicker.dateClass\"\n  [comparisonStart]=\"comparisonStart\"\n  [comparisonEnd]=\"comparisonEnd\"\n  (_userSelection)=\"_handleUserSelection($event)\"></usa-calendar>\n\n<!-- Invisible close button for screen reader users. -->\n<button\n  type=\"button\"\n  class=\"usa-sr-only\"\n  [class.cdk-visually-hidden]=\"!_closeButtonFocused\"\n  (focus)=\"_closeButtonFocused = true\"\n  (blur)=\"_closeButtonFocused = false\"\n  (click)=\"datePicker.close()\">{{ _closeButtonText }}</button>\n" }]
        }], ctorParameters: () => [{ type: i0.ChangeDetectorRef }, { type: UsaDateSelectionModel }, { type: DateAdapter }, { type: i0.NgZone }, { type: i0.ElementRef }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [USA_DATE_RANGE_SELECTION_STRATEGY]
                }] }], propDecorators: { _calendar: [{
                type: ViewChild,
                args: [UsaCalendar]
            }], clickInside: [{
                type: HostListener,
                args: ['click']
            }], clickout: [{
                type: HostListener,
                args: ['document:click']
            }], onKeydownHandler: [{
                type: HostListener,
                args: ['document:keydown.escape', ['$event']]
            }] } });
/** Base class for a datePicker. */
class UsaDatePickerBase {
    _injector;
    _vcr;
    _cfr;
    _el;
    _dateAdapter;
    _model;
    _inputStateChanges = Subscription.EMPTY;
    /** An input indicating the type of the custom header component for the calendar, if set. */
    calendarHeaderComponent;
    /** The date to open the calendar to initially. */
    get startAt() {
        // If an explicit startAt is set we start there, otherwise we start at whatever the currently
        // selected value is.
        return (this._startAt ||
            (this.datePickerInput ? this.datePickerInput.getStartValue() : null));
    }
    set startAt(value) {
        this._startAt = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(value));
    }
    _startAt;
    /** The view that the calendar should start in. */
    startView = 'month';
    /** Whether the datePicker pop-up should be disabled. */
    get disabled() {
        return this._disabled === undefined && this.datePickerInput
            ? this.datePickerInput.disabled
            : !!this._disabled;
    }
    set disabled(value) {
        const newValue = coerceBooleanProperty(value);
        if (newValue !== this._disabled) {
            this._disabled = newValue;
            this.stateChanges.next(undefined);
        }
    }
    _disabled;
    /**
     * Whether to restore focus to the datePicker input when the calendar is closed.
     * Note that automatic focus restoration is an accessibility feature and it is recommended that
     * you provide your own equivalent, if you decide to turn it off.
     */
    get restoreFocus() {
        return this._restoreFocus;
    }
    set restoreFocus(value) {
        this._restoreFocus = coerceBooleanProperty(value);
    }
    _restoreFocus = true;
    /**
     * Emits selected year in multiyear view.
     * This doesn't imply a change on the selected date.
     */
    yearSelected = new EventEmitter();
    /**
     * Emits selected month in year view.
     * This doesn't imply a change on the selected date.
     */
    monthSelected = new EventEmitter();
    /** Function that can be used to add custom CSS classes to dates. */
    dateClass;
    /** Emits when the datePicker has been opened. */
    openedStream = new EventEmitter();
    /** Emits when the datePicker has been closed. */
    closedStream = new EventEmitter();
    /**
     * Classes to be passed to the date picker panel.
     * Supports string and string array values, similar to `ngClass`.
     */
    get panelClass() {
        return this._panelClass;
    }
    set panelClass(value) {
        this._panelClass = coerceStringArray(value);
    }
    _panelClass;
    /** Whether the calendar is open. */
    get opened() {
        return this._opened;
    }
    set opened(value) {
        coerceBooleanProperty(value) ? this.open() : this.close();
    }
    _opened = false;
    /** The id for the datePicker calendar. */
    id = `usa-date-picker-${datePickerUid++}`;
    /** The minimum selectable date. */
    _getMinDate() {
        return this.datePickerInput && this.datePickerInput.min;
    }
    /** The maximum selectable date. */
    _getMaxDate() {
        return this.datePickerInput && this.datePickerInput.max;
    }
    _getDateFilter() {
        return this.datePickerInput && this.datePickerInput.dateFilter;
    }
    /** Reference to the component instance rendered in the overlay. */
    _componentRef;
    /** The element that was focused before the datepicker was opened. */
    _focusedElementBeforeOpen = null;
    /** The input element this datePicker is associated with. */
    datePickerInput;
    /** Emits when the datePicker's state changes. */
    stateChanges = new Subject();
    constructor(_dialog, _injector, _vcr, _cfr, _el, _dateAdapter, 
    /**
     * @deprecated No longer being used. To be removed.
     * @breaking-change 13.0.0
     */
    _document, _model) {
        this._injector = _injector;
        this._vcr = _vcr;
        this._cfr = _cfr;
        this._el = _el;
        this._dateAdapter = _dateAdapter;
        this._model = _model;
        if (!this._dateAdapter && isDevMode()) {
            throw createMissingDateImplError('DateAdapter');
        }
    }
    ngOnChanges() {
        this.stateChanges.next(undefined);
    }
    ngOnDestroy() {
        this._destroyOverlay();
        this.close();
        this._inputStateChanges.unsubscribe();
        this.stateChanges.complete();
    }
    /** Selects the given date */
    select(date) {
        this._model.add(date);
    }
    /** Emits the selected year in multiyear view */
    _selectYear(normalizedYear) {
        this.yearSelected.emit(normalizedYear);
    }
    /** Emits selected month in year view */
    _selectMonth(normalizedMonth) {
        this.monthSelected.emit(normalizedMonth);
    }
    /**
     * Register an input with this datePicker.
     * @param input The datePicker input to register with this datePicker.
     * @returns Selection model that the input should hook itself up to.
     */
    registerInput(input) {
        if (this.datePickerInput && isDevMode()) {
            throw Error('A UsaDatePicker can only be associated with a single input.');
        }
        this._inputStateChanges.unsubscribe();
        this.datePickerInput = input;
        this._inputStateChanges = input.stateChanges.subscribe(() => this.stateChanges.next(undefined));
        return this._model;
    }
    /** Open the calendar. */
    open() {
        if (this._opened || this.disabled) {
            return;
        }
        if (!this.datePickerInput && isDevMode()) {
            throw Error('Attempted to open an UsaDatePicker with no associated input.');
        }
        this._focusedElementBeforeOpen = document.activeElement;
        this._openOverlay();
        this._opened = true;
        this.openedStream.emit();
    }
    /** Close the calendar. */
    close() {
        if (!this._opened) {
            return;
        }
        if (this._componentRef) {
            this._destroyOverlay();
        }
        const completeClose = () => {
            // The `_opened` could've been reset already if
            // we got two events in quick succession.
            if (this._opened) {
                this._opened = false;
                this.closedStream.emit();
                this._focusedElementBeforeOpen = null;
            }
        };
        if (this._restoreFocus) {
            // Because IE moves focus asynchronously, we can't count on it being restored before we've
            // marked the datePicker as closed. If the event fires out of sequence and the element that
            // we're refocusing opens the datePicker on focus, the user could be stuck with not being
            // able to close the calendar at all. We work around it by making the logic, that marks
            // the datePicker as closed, async as well.
            if (!this.datePickerInput.getConnectedOverlayOrigin().nativeElement.disabled) {
                this.datePickerInput.getConnectedOverlayOrigin().nativeElement.focus();
            }
            else if (this._focusedElementBeforeOpen) {
                this._focusedElementBeforeOpen.focus();
            }
            setTimeout(completeClose);
        }
        else {
            completeClose();
        }
    }
    /** Applies the current pending selection on the overlay to the model. */
    _applyPendingSelection() {
        this._componentRef?.instance?._applyPendingSelection();
    }
    /** Forwards relevant values from the datePicker to the datePicker content inside the overlay. */
    _forwardContentValues(instance) {
        instance.datePicker = this;
    }
    /** Opens the overlay with the calendar. */
    _openOverlay() {
        this._destroyOverlay();
        const calendarComponent = this._cfr.resolveComponentFactory(UsaDatePickerContent);
        this._componentRef = this._vcr.createComponent(calendarComponent, undefined, this._injector);
        this._forwardContentValues(this._componentRef.instance);
        const wrapper = this.findAncestor(this._el.nativeElement, 'usa-date-picker__wrapper');
        if (wrapper) {
            this._componentRef.location.nativeElement.style.top = `${wrapper.offsetHeight}px`;
        }
        wrapper.appendChild(this._componentRef.location.nativeElement);
    }
    /** Destroys the current overlay. */
    _destroyOverlay() {
        if (!this._componentRef) {
            return;
        }
        this._vcr.remove(this._vcr.indexOf(this._componentRef.hostView));
        this._componentRef = null;
    }
    /**
     * Finds closest ancestor element with the given class
     * @param element - The element to start searching from - this element will be exempt from the search
     * @param cls - The class string to search for
     * @returns Either root element if not found or the queried element
     */
    findAncestor(element, cls) {
        while ((element = element.parentElement) &&
            !element.classList.contains(cls))
            ;
        return element;
    }
    static ngAcceptInputType_disabled;
    static ngAcceptInputType_opened;
    static ngAcceptInputType_restoreFocus;
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaDatePickerBase, deps: [{ token: ElementRef }, { token: i0.Injector }, { token: i0.ViewContainerRef }, { token: i0.ComponentFactoryResolver }, { token: i0.ElementRef }, { token: DateAdapter, optional: true }, { token: DOCUMENT, optional: true }, { token: UsaDateSelectionModel }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.2", type: UsaDatePickerBase, inputs: { calendarHeaderComponent: "calendarHeaderComponent", startAt: "startAt", startView: "startView", disabled: "disabled", restoreFocus: "restoreFocus", dateClass: "dateClass", panelClass: "panelClass", opened: "opened" }, outputs: { yearSelected: "yearSelected", monthSelected: "monthSelected", openedStream: "opened", closedStream: "closed" }, usesOnChanges: true, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaDatePickerBase, decorators: [{
            type: Directive
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [ElementRef]
                }] }, { type: i0.Injector }, { type: i0.ViewContainerRef }, { type: i0.ComponentFactoryResolver }, { type: i0.ElementRef }, { type: DateAdapter, decorators: [{
                    type: Optional
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: UsaDateSelectionModel }], propDecorators: { calendarHeaderComponent: [{
                type: Input
            }], startAt: [{
                type: Input
            }], startView: [{
                type: Input
            }], disabled: [{
                type: Input
            }], restoreFocus: [{
                type: Input
            }], yearSelected: [{
                type: Output
            }], monthSelected: [{
                type: Output
            }], dateClass: [{
                type: Input
            }], openedStream: [{
                type: Output,
                args: ['opened']
            }], closedStream: [{
                type: Output,
                args: ['closed']
            }], panelClass: [{
                type: Input
            }], opened: [{
                type: Input
            }] } });

class UsaDatePickerWrapper {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaDatePickerWrapper, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.2", type: UsaDatePickerWrapper, selector: "usa-date-picker-wrapper", ngImport: i0, template: `
    <div class="usa-date-picker usa-date-picker--initialized">
      <div class="usa-date-picker__wrapper">
        <ng-content></ng-content>
      </div>
    </div>
   `, isInline: true });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaDatePickerWrapper, decorators: [{
            type: Component,
            args: [{
                    selector: `usa-date-picker-wrapper`,
                    template: `
    <div class="usa-date-picker usa-date-picker--initialized">
      <div class="usa-date-picker__wrapper">
        <ng-content></ng-content>
      </div>
    </div>
   `,
                }]
        }] });
/** Component responsible for managing the datePicker popup/dialog. */
class UsaDatePicker extends UsaDatePickerBase {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaDatePicker, deps: null, target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.2", type: UsaDatePicker, selector: "usa-date-picker", providers: [
            USA_SINGLE_DATE_SELECTION_MODEL_PROVIDER,
            { provide: UsaDatePickerBase, useExisting: UsaDatePicker },
        ], exportAs: ["usaDatePicker"], usesInheritance: true, ngImport: i0, template: ``, isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaDatePicker, decorators: [{
            type: Component,
            args: [{
                    selector: 'usa-date-picker',
                    template: ``,
                    exportAs: 'usaDatePicker',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    providers: [
                        USA_SINGLE_DATE_SELECTION_MODEL_PROVIDER,
                        { provide: UsaDatePickerBase, useExisting: UsaDatePicker },
                    ]
                }]
        }] });

/**
 * An event used for datePicker input and change events. We don't always have access to a native
 * input or change event because the event may have been triggered by the user clicking on the
 * calendar popup. For consistency, we always use UsaDatePickerInputEvent instead.
 */
class UsaDatePickerInputEvent {
    target;
    targetElement;
    /** The new value for the target datePicker input. */
    value;
    constructor(
    /** Reference to the datePicker input component that emitted the event. */
    target, 
    /** Reference to the native input element associated with the datePicker input. */
    targetElement) {
        this.target = target;
        this.targetElement = targetElement;
        this.value = this.target.value;
    }
}
/** Base class for datePicker inputs. */
class UsaDatePickerInputBase {
    _elementRef;
    _dateAdapter;
    _dateFormats;
    /** Whether the component has been initialized. */
    _isInitialized;
    /** The value of the input. */
    get value() {
        return this._model ? this._getValueFromModel(this._model.selection) : this._pendingValue;
    }
    set value(value) {
        this._assignValueProgrammatically(value);
    }
    _model;
    /** Whether the datePicker-input is disabled. */
    get disabled() { return !!this._disabled || this._parentDisabled(); }
    set disabled(value) {
        const newValue = coerceBooleanProperty(value);
        const element = this._elementRef.nativeElement;
        if (this._disabled !== newValue) {
            this._disabled = newValue;
            this.stateChanges.next(undefined);
        }
        // We need to null check the `blur` method, because it's undefined during SSR.
        // In Ivy static bindings are invoked earlier, before the element is attached to the DOM.
        // This can cause an error to be thrown in some browsers (IE/Edge) which assert that the
        // element has been inserted.
        if (newValue && this._isInitialized && element.blur) {
            // Normally, native input elements automatically blur if they turn disabled. This behavior
            // is problematic, because it would mean that it triggers another change detection cycle,
            // which then causes a changed after checked error if the input element was focused before.
            element.blur();
        }
    }
    _disabled;
    /** Emits when a `change` event is fired on this `<input>`. */
    dateChange = new EventEmitter();
    /** Emits when an `input` event is fired on this `<input>`. */
    dateInput = new EventEmitter();
    /** Emits when the internal state has changed */
    stateChanges = new Subject();
    _onTouched = () => { };
    _validatorOnChange = () => { };
    _cvaOnChange = () => { };
    _valueChangesSubscription = Subscription.EMPTY;
    _localeSubscription = Subscription.EMPTY;
    /**
     * Since the value is kept on the model which is assigned in an Input,
     * we might get a value before we have a model. This property keeps track
     * of the value until we have somewhere to assign it.
     */
    _pendingValue;
    /** The form control validator for whether the input parses. */
    _parseValidator = () => {
        return this._lastValueValid ?
            null : { 'usaDatePickerParse': { 'text': this._elementRef.nativeElement.value } };
    };
    /** The form control validator for the date filter. */
    _filterValidator = (control) => {
        const controlValue = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(control.value));
        return !controlValue || this._matchesFilter(controlValue) ?
            null : { 'usaDatePickerFilter': true };
    };
    /** The form control validator for the min date. */
    _minValidator = (control) => {
        const controlValue = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(control.value));
        const min = this._getMinDate();
        return (!min || !controlValue ||
            this._dateAdapter.compareDate(min, controlValue) <= 0) ?
            null : { 'usaDatePickerMin': { 'min': min, 'actual': controlValue } };
    };
    /** The form control validator for the max date. */
    _maxValidator = (control) => {
        const controlValue = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(control.value));
        const max = this._getMaxDate();
        return (!max || !controlValue ||
            this._dateAdapter.compareDate(max, controlValue) >= 0) ?
            null : { 'usaDatePickerMax': { 'max': max, 'actual': controlValue } };
    };
    /** Gets the base validator functions. */
    _getValidators() {
        return [this._parseValidator, this._minValidator, this._maxValidator, this._filterValidator];
    }
    /** Registers a date selection model with the input. */
    _registerModel(model) {
        this._model = model;
        this._valueChangesSubscription.unsubscribe();
        if (this._pendingValue) {
            this._assignValue(this._pendingValue);
        }
        this._valueChangesSubscription = this._model.selectionChanged.subscribe(event => {
            if (this._shouldHandleChangeEvent(event)) {
                const value = this._getValueFromModel(event.selection);
                this._lastValueValid = this._isValidValue(value);
                this._cvaOnChange(value);
                this._onTouched();
                this._formatValue(value);
                this.dateInput.emit(new UsaDatePickerInputEvent(this, this._elementRef.nativeElement));
                this.dateChange.emit(new UsaDatePickerInputEvent(this, this._elementRef.nativeElement));
            }
        });
    }
    /** Whether the last value set on the input was valid. */
    _lastValueValid = false;
    constructor(_elementRef, _dateAdapter, _dateFormats) {
        this._elementRef = _elementRef;
        this._dateAdapter = _dateAdapter;
        this._dateFormats = _dateFormats;
        if (isDevMode()) {
            if (!this._dateAdapter) {
                throw createMissingDateImplError('DateAdapter');
            }
            if (!this._dateFormats) {
                throw createMissingDateImplError('USA_DATE_FORMATS');
            }
        }
        // Update the displayed date when the locale changes.
        this._localeSubscription = _dateAdapter.localeChanges.subscribe(() => {
            this._assignValueProgrammatically(this.value);
        });
    }
    ngAfterViewInit() {
        this._isInitialized = true;
    }
    ngOnChanges(changes) {
        if (dateInputsHaveChanged(changes, this._dateAdapter)) {
            this.stateChanges.next(undefined);
        }
    }
    ngOnDestroy() {
        this._valueChangesSubscription.unsubscribe();
        this._localeSubscription.unsubscribe();
        this.stateChanges.complete();
    }
    /** @docs-private */
    registerOnValidatorChange(fn) {
        this._validatorOnChange = fn;
    }
    /** @docs-private */
    validate(c) {
        return this._validator ? this._validator(c) : null;
    }
    // Implemented as part of ControlValueAccessor.
    writeValue(value) {
        this._assignValueProgrammatically(value);
    }
    // Implemented as part of ControlValueAccessor.
    registerOnChange(fn) {
        this._cvaOnChange = fn;
    }
    // Implemented as part of ControlValueAccessor.
    registerOnTouched(fn) {
        this._onTouched = fn;
    }
    // Implemented as part of ControlValueAccessor.
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    _onKeydown(event) {
        const isAltDownArrow = event.altKey && event.keyCode === KeyCode.ArrowDown;
        if (isAltDownArrow && !this._elementRef.nativeElement.readOnly) {
            this._openPopup();
            event.preventDefault();
        }
    }
    _onInput(value) {
        const lastValueWasValid = this._lastValueValid;
        let date = this._dateAdapter.parse(value, this._dateFormats.parse.dateInput);
        this._lastValueValid = this._isValidValue(date);
        date = this._dateAdapter.getValidDateOrNull(date);
        if (!this._dateAdapter.sameDate(date, this.value)) {
            this._assignValue(date);
            this._cvaOnChange(date);
            this.dateInput.emit(new UsaDatePickerInputEvent(this, this._elementRef.nativeElement));
        }
        else {
            // Call the CVA change handler for invalid values
            // since this is what marks the control as dirty.
            if (value && !this.value) {
                this._cvaOnChange(date);
            }
            if (lastValueWasValid !== this._lastValueValid) {
                this._validatorOnChange();
            }
        }
    }
    _onChange() {
        this.dateChange.emit(new UsaDatePickerInputEvent(this, this._elementRef.nativeElement));
    }
    /** Handles blur events on the input. */
    _onBlur() {
        // Reformat the input only if we have a valid value.
        if (this.value) {
            this._formatValue(this.value);
        }
        this._onTouched();
    }
    /** Formats a value and sets it on the input element. */
    _formatValue(value) {
        this._elementRef.nativeElement.value =
            value ? this._dateAdapter.format(value, this._dateFormats.display.dateInput) : '';
    }
    /** Assigns a value to the model. */
    _assignValue(value) {
        // We may get some incoming values before the model was
        // assigned. Save the value so that we can assign it later.
        if (this._model) {
            this._assignValueToModel(value);
            this._pendingValue = null;
        }
        else {
            this._pendingValue = value;
        }
    }
    /** Whether a value is considered valid. */
    _isValidValue(value) {
        return !value || this._dateAdapter.isValid(value);
    }
    /**
     * Checks whether a parent control is disabled. This is in place so that it can be overridden
     * by inputs extending this one which can be placed inside of a group that can be disabled.
     */
    _parentDisabled() {
        return false;
    }
    /** Programmatically assigns a value to the input. */
    _assignValueProgrammatically(value) {
        value = this._dateAdapter.deserialize(value);
        this._lastValueValid = this._isValidValue(value);
        value = this._dateAdapter.getValidDateOrNull(value);
        this._assignValue(value);
        this._formatValue(value);
    }
    /** Gets whether a value matches the current date filter. */
    _matchesFilter(value) {
        const filter = this._getDateFilter();
        return !filter || filter(value);
    }
    // Accept `any` to avoid conflicts with other directives on `<input>` that
    // may accept different types.
    static ngAcceptInputType_value;
    static ngAcceptInputType_disabled;
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaDatePickerInputBase, deps: [{ token: i0.ElementRef }, { token: DateAdapter, optional: true }, { token: USA_DATE_FORMATS, optional: true }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.2", type: UsaDatePickerInputBase, inputs: { value: "value", disabled: "disabled" }, outputs: { dateChange: "dateChange", dateInput: "dateInput" }, usesOnChanges: true, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaDatePickerInputBase, decorators: [{
            type: Directive
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: DateAdapter, decorators: [{
                    type: Optional
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [USA_DATE_FORMATS]
                }] }], propDecorators: { value: [{
                type: Input
            }], disabled: [{
                type: Input
            }], dateChange: [{
                type: Output
            }], dateInput: [{
                type: Output
            }] } });
/**
 * Checks whether the `SimpleChanges` object from an `ngOnChanges`
 * callback has any changes, accounting for date objects.
 */
function dateInputsHaveChanged(changes, adapter) {
    const keys = Object.keys(changes);
    for (let key of keys) {
        const { previousValue, currentValue } = changes[key];
        if (adapter.isDateInstance(previousValue) && adapter.isDateInstance(currentValue)) {
            if (!adapter.sameDate(previousValue, currentValue)) {
                return true;
            }
        }
        else {
            return true;
        }
    }
    return false;
}

/** @docs-private */
const USA_DATEPICKER_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => UsaDatePickerInput),
    multi: true
};
/** @docs-private */
const USA_DATEPICKER_VALIDATORS = {
    provide: NG_VALIDATORS,
    useExisting: forwardRef(() => UsaDatePickerInput),
    multi: true
};
class UsaDatePickerInput extends UsaDatePickerInputBase {
    _closedSubscription = Subscription.EMPTY;
    /** The datePicker that this input is associated with. */
    set usaDatePicker(datePicker) {
        if (datePicker) {
            this._datePicker = datePicker;
            this._closedSubscription = datePicker.closedStream.subscribe(() => this._onTouched());
            this._registerModel(datePicker.registerInput(this));
        }
    }
    _datePicker;
    /** The minimum valid date. */
    get min() { return this._min; }
    set min(value) {
        const validValue = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(value));
        if (!this._dateAdapter.sameDate(validValue, this._min)) {
            this._min = validValue;
            this._validatorOnChange();
        }
    }
    _min;
    /** The maximum valid date. */
    get max() { return this._max; }
    set max(value) {
        const validValue = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(value));
        if (!this._dateAdapter.sameDate(validValue, this._max)) {
            this._max = validValue;
            this._validatorOnChange();
        }
    }
    _max;
    /** Function that can be used to filter out dates within the datePicker. */
    get dateFilter() { return this._dateFilter; }
    set dateFilter(value) {
        const wasMatchingValue = this._matchesFilter(this.value);
        this._dateFilter = value;
        if (this._matchesFilter(this.value) !== wasMatchingValue) {
            this._validatorOnChange();
        }
    }
    _dateFilter;
    /** The combined form control validator for this input. */
    _validator;
    constructor(elementRef, dateAdapter, dateFormats) {
        super(elementRef, dateAdapter, dateFormats);
        this._validator = Validators.compose(super._getValidators());
    }
    /**
     * Gets the element that the datePicker popup should be connected to.
     * @return The element to connect the popup to.
     */
    getConnectedOverlayOrigin() {
        return this._elementRef;
    }
    /** Gets the ID of an element that should be used a description for the calendar overlay. */
    getOverlayLabelId() {
        return this._elementRef.nativeElement.getAttribute('aria-labelledby');
    }
    /** Gets the value at which the calendar should start. */
    getStartValue() {
        return this.value;
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this._closedSubscription.unsubscribe();
    }
    /** Opens the associated datePicker. */
    _openPopup() {
        if (this._datePicker) {
            this._datePicker.open();
        }
    }
    _getValueFromModel(modelValue) {
        return modelValue;
    }
    _assignValueToModel(value) {
        if (this._model) {
            this._model.updateSelection(value, this);
        }
    }
    /** Gets the input's minimum date. */
    _getMinDate() {
        return this._min;
    }
    /** Gets the input's maximum date. */
    _getMaxDate() {
        return this._max;
    }
    /** Gets the input's date filtering function. */
    _getDateFilter() {
        return this._dateFilter;
    }
    _shouldHandleChangeEvent(event) {
        return event.source !== this;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaDatePickerInput, deps: [{ token: i0.ElementRef }, { token: DateAdapter, optional: true }, { token: USA_DATE_FORMATS, optional: true }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.2", type: UsaDatePickerInput, selector: "input[usaDatePicker]", inputs: { usaDatePicker: "usaDatePicker", min: "min", max: "max", dateFilter: ["usaDatePickerFilter", "dateFilter"] }, host: { listeners: { "input": "_onInput($event.target.value)", "change": "_onChange()", "blur": "_onBlur()", "keydown": "_onKeydown($event)" }, properties: { "attr.aria-haspopup": "_datePicker ? \"dialog\" : null", "attr.aria-owns": "(_datePicker?.opened && _datePicker.id) || null", "attr.min": "min ? _dateAdapter.toIso8601(min) : null", "attr.max": "max ? _dateAdapter.toIso8601(max) : null", "disabled": "disabled" }, classAttribute: "usa-input" }, providers: [
            USA_DATEPICKER_VALUE_ACCESSOR,
            USA_DATEPICKER_VALIDATORS,
        ], exportAs: ["usaDatePickerInput"], usesInheritance: true, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaDatePickerInput, decorators: [{
            type: Directive,
            args: [{
                    selector: 'input[usaDatePicker]',
                    providers: [
                        USA_DATEPICKER_VALUE_ACCESSOR,
                        USA_DATEPICKER_VALIDATORS,
                    ],
                    host: {
                        'class': 'usa-input',
                        '[attr.aria-haspopup]': '_datePicker ? "dialog" : null',
                        '[attr.aria-owns]': '(_datePicker?.opened && _datePicker.id) || null',
                        '[attr.min]': 'min ? _dateAdapter.toIso8601(min) : null',
                        '[attr.max]': 'max ? _dateAdapter.toIso8601(max) : null',
                        '[disabled]': 'disabled',
                        '(input)': '_onInput($event.target.value)',
                        '(change)': '_onChange()',
                        '(blur)': '_onBlur()',
                        '(keydown)': '_onKeydown($event)',
                    },
                    exportAs: 'usaDatePickerInput',
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: DateAdapter, decorators: [{
                    type: Optional
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [USA_DATE_FORMATS]
                }] }], propDecorators: { usaDatePicker: [{
                type: Input
            }], min: [{
                type: Input
            }], max: [{
                type: Input
            }], dateFilter: [{
                type: Input,
                args: ['usaDatePickerFilter']
            }] } });

/** Can be used to override the icon of a `usaDatePickerButton`. */
class UsaDatePickerButtonIcon {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaDatePickerButtonIcon, deps: [], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.2", type: UsaDatePickerButtonIcon, selector: "[usaDatePickerButtonIcon]", ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaDatePickerButtonIcon, decorators: [{
            type: Directive,
            args: [{
                    selector: '[usaDatePickerButtonIcon]'
                }]
        }] });
class UsaDatePickerButton {
    _changeDetectorRef;
    _stateChanges = Subscription.EMPTY;
    /** DatePicker instance that the button will toggle. */
    datePicker;
    /** Tabindex for the toggle. */
    tabIndex;
    /** Screenreader label for the button. */
    ariaLabel = 'Open Date Picker';
    /** Whether the toggle button is disabled. */
    get disabled() {
        if (this._disabled === undefined && this.datePicker) {
            return this.datePicker.disabled;
        }
        return !!this._disabled;
    }
    set disabled(value) {
        this._disabled = coerceBooleanProperty(value);
    }
    _disabled;
    /** Custom icon set by the consumer. */
    _customIcon;
    /** Underlying button element. */
    _button;
    constructor(_changeDetectorRef, defaultTabIndex) {
        this._changeDetectorRef = _changeDetectorRef;
        const parsedTabIndex = Number(defaultTabIndex);
        this.tabIndex = (parsedTabIndex || parsedTabIndex === 0) ? parsedTabIndex : null;
    }
    ngOnChanges(changes) {
        if (changes['datePicker']) {
            this._watchStateChanges();
        }
    }
    ngOnDestroy() {
        this._stateChanges.unsubscribe();
    }
    ngAfterContentInit() {
        this._watchStateChanges();
    }
    _toggle(event) {
        if (!this.datePicker) {
            return;
        }
        if (this.datePicker && this.datePicker.opened) {
            this.datePicker.close();
        }
        else if (!this.disabled) {
            this.datePicker.open();
            event.stopPropagation();
        }
    }
    _watchStateChanges() {
        const datePickerStateChanged = this.datePicker ? this.datePicker.stateChanges : of();
        const inputStateChanged = this.datePicker && this.datePicker.datePickerInput ?
            this.datePicker.datePickerInput.stateChanges : of();
        const datePickerToggled = this.datePicker ?
            merge(this.datePicker.openedStream, this.datePicker.closedStream) :
            of();
        this._stateChanges.unsubscribe();
        this._stateChanges = merge(datePickerStateChanged, inputStateChanged, datePickerToggled).subscribe(() => this._changeDetectorRef.markForCheck());
    }
    static ngAcceptInputType_disabled;
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaDatePickerButton, deps: [{ token: i0.ChangeDetectorRef }, { token: 'tabindex', attribute: true }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.2", type: UsaDatePickerButton, selector: "usa-date-picker-button", inputs: { datePicker: ["for", "datePicker"], tabIndex: "tabIndex", ariaLabel: ["aria-label", "ariaLabel"], disabled: "disabled" }, host: { listeners: { "click": "_toggle($event)" }, properties: { "attr.tabindex": "null", "attr.data-usa-calendar": "datePicker ? datePicker.id : null" }, classAttribute: "usa-date-picker__button" }, queries: [{ propertyName: "_customIcon", first: true, predicate: UsaDatePickerButtonIcon, descendants: true }], viewQueries: [{ propertyName: "_button", first: true, predicate: ["button"], descendants: true }], exportAs: ["usaDatePickerButton"], usesOnChanges: true, ngImport: i0, template: "<button #button type=\"button\" class=\"usa-date-picker__button\"\n  [attr.aria-haspopup]=\"datePicker ? true : null\"\n  [attr.aria-label]=\"ariaLabel\"\n  [attr.tabindex]=\"disabled ? -1 : tabIndex\"\n  [disabled]=\"disabled\">\n  &nbsp;\n</button>", changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaDatePickerButton, decorators: [{
            type: Component,
            args: [{ selector: 'usa-date-picker-button', host: {
                        'class': 'usa-date-picker__button',
                        '[attr.tabindex]': 'null',
                        // Used by the test harness to tie this toggle to its datePicker.
                        '[attr.data-usa-calendar]': 'datePicker ? datePicker.id : null',
                        // Bind the `click` on the host, rather than the inner `button`, so that we can call
                        // `stopPropagation` on it without affecting the user's `click` handlers. We need to stop
                        // it so that the input doesn't get focused automatically by the form field (See #21836).
                        '(click)': '_toggle($event)',
                    }, exportAs: 'usaDatePickerButton', changeDetection: ChangeDetectionStrategy.OnPush, template: "<button #button type=\"button\" class=\"usa-date-picker__button\"\n  [attr.aria-haspopup]=\"datePicker ? true : null\"\n  [attr.aria-label]=\"ariaLabel\"\n  [attr.tabindex]=\"disabled ? -1 : tabIndex\"\n  [disabled]=\"disabled\">\n  &nbsp;\n</button>" }]
        }], ctorParameters: () => [{ type: i0.ChangeDetectorRef }, { type: undefined, decorators: [{
                    type: Attribute,
                    args: ['tabindex']
                }] }], propDecorators: { datePicker: [{
                type: Input,
                args: ['for']
            }], tabIndex: [{
                type: Input
            }], ariaLabel: [{
                type: Input,
                args: ['aria-label']
            }], disabled: [{
                type: Input
            }], _customIcon: [{
                type: ContentChild,
                args: [UsaDatePickerButtonIcon]
            }], _button: [{
                type: ViewChild,
                args: ['button']
            }] } });

/**
 * Matches strings that have the form of a valid RFC 3339 string
 * (https://tools.ietf.org/html/rfc3339). Note that the string may not actually be a valid date
 * because the regex will match strings an with out of bounds month, date, etc.
 */
const ISO_8601_REGEX = /^\d{4}-\d{2}-\d{2}(?:T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|(?:(?:\+|-)\d{2}:\d{2}))?)?$/;
/** Creates an array and fills it with values. */
function range(length, valueFunction) {
    const valuesArray = Array(length);
    for (let i = 0; i < length; i++) {
        valuesArray[i] = valueFunction(i);
    }
    return valuesArray;
}
/** Adapts the native JS Date for use with cdk-based components that work with dates. */
class NativeDateAdapter extends DateAdapter {
    /**
     * @deprecated No longer being used. To be removed.
     * @breaking-change 14.0.0
     */
    useUtcForDisplay = false;
    constructor(usaDateLocale) {
        super();
        super.setLocale(usaDateLocale);
    }
    getYear(date) {
        return date.getFullYear();
    }
    getMonth(date) {
        return date.getMonth();
    }
    getDate(date) {
        return date.getDate();
    }
    getDayOfWeek(date) {
        return date.getDay();
    }
    getMonthNames(style) {
        const dtf = new Intl.DateTimeFormat(this.locale, { month: style, timeZone: 'utc' });
        return range(12, i => this._format(dtf, new Date(2017, i, 1)));
    }
    getDateNames() {
        const dtf = new Intl.DateTimeFormat(this.locale, { day: 'numeric', timeZone: 'utc' });
        return range(31, i => this._format(dtf, new Date(2017, 0, i + 1)));
    }
    getDayOfWeekNames(style) {
        const dtf = new Intl.DateTimeFormat(this.locale, { weekday: style, timeZone: 'utc' });
        return range(7, i => this._format(dtf, new Date(2017, 0, i + 1)));
    }
    getYearName(date) {
        const dtf = new Intl.DateTimeFormat(this.locale, { year: 'numeric', timeZone: 'utc' });
        return this._format(dtf, date);
    }
    getFirstDayOfWeek() {
        // We can't tell using native JS Date what the first day of the week is, we default to Sunday.
        return 0;
    }
    getNumDaysInMonth(date) {
        return this.getDate(this._createDateWithOverflow(this.getYear(date), this.getMonth(date) + 1, 0));
    }
    clone(date) {
        return new Date(date.getTime());
    }
    createDate(year, month, date) {
        if (isDevMode()) {
            // Check for invalid month and date (except upper bound on date which we have to check after
            // creating the Date).
            if (month < 0 || month > 11) {
                throw Error(`Invalid month index "${month}". Month index has to be between 0 and 11.`);
            }
            if (date < 1) {
                throw Error(`Invalid date "${date}". Date has to be greater than 0.`);
            }
        }
        let result = this._createDateWithOverflow(year, month, date);
        // Check that the date wasn't above the upper bound for the month, causing the month to overflow
        if (result.getMonth() != month && isDevMode()) {
            throw Error(`Invalid date "${date}" for month with index "${month}".`);
        }
        return result;
    }
    today() {
        return new Date();
    }
    parse(value) {
        // We have no way using the native JS Date to set the parse format or locale, so we ignore these
        // parameters.
        if (typeof value == 'number') {
            return new Date(value);
        }
        return value ? new Date(Date.parse(value)) : null;
    }
    format(date, displayFormat) {
        if (!this.isValid(date)) {
            throw Error('NativeDateAdapter: Cannot format invalid date.');
        }
        const dtf = new Intl.DateTimeFormat(this.locale, { ...displayFormat, timeZone: 'utc' });
        return this._format(dtf, date);
    }
    addCalendarYears(date, years) {
        return this.addCalendarMonths(date, years * 12);
    }
    addCalendarMonths(date, months) {
        let newDate = this._createDateWithOverflow(this.getYear(date), this.getMonth(date) + months, this.getDate(date));
        // It's possible to wind up in the wrong month if the original month has more days than the new
        // month. In this case we want to go to the last day of the desired month.
        // Note: the additional + 12 % 12 ensures we end up with a positive number, since JS % doesn't
        // guarantee this.
        if (this.getMonth(newDate) != ((this.getMonth(date) + months) % 12 + 12) % 12) {
            newDate = this._createDateWithOverflow(this.getYear(newDate), this.getMonth(newDate), 0);
        }
        return newDate;
    }
    addCalendarDays(date, days) {
        return this._createDateWithOverflow(this.getYear(date), this.getMonth(date), this.getDate(date) + days);
    }
    toIso8601(date) {
        return [
            date.getUTCFullYear(),
            this._2digit(date.getUTCMonth() + 1),
            this._2digit(date.getUTCDate())
        ].join('-');
    }
    /**
     * Returns the given value if given a valid Date or null. Deserializes valid ISO 8601 strings
     * (https://www.ietf.org/rfc/rfc3339.txt) into valid Dates and empty string into null. Returns an
     * invalid date for all other values.
     */
    deserialize(value) {
        if (typeof value === 'string') {
            if (!value) {
                return null;
            }
            // The `Date` constructor accepts formats other than ISO 8601, so we need to make sure the
            // string is the right format first.
            if (ISO_8601_REGEX.test(value)) {
                let date = new Date(value);
                if (this.isValid(date)) {
                    return date;
                }
            }
        }
        return super.deserialize(value);
    }
    isDateInstance(obj) {
        return obj instanceof Date;
    }
    isValid(date) {
        return !isNaN(date.getTime());
    }
    invalid() {
        return new Date(NaN);
    }
    /** Creates a date but allows the month and date to overflow. */
    _createDateWithOverflow(year, month, date) {
        // Passing the year to the constructor causes year numbers <100 to be converted to 19xx.
        // To work around this we use `setFullYear` and `setHours` instead.
        const d = new Date();
        d.setFullYear(year, month, date);
        d.setHours(0, 0, 0, 0);
        return d;
    }
    /**
     * Pads a number to make it two digits.
     * @param n The number to pad.
     * @returns The padded number.
     */
    _2digit(n) {
        return ('00' + n).slice(-2);
    }
    /**
     * When converting Date object to string, javascript built-in functions may return wrong
     * results because it applies its internal DST rules. The DST rules around the world change
     * very frequently, and the current valid rule is not always valid in previous years though.
     * We work around this problem building a new Date object which has its internal UTC
     * representation with the local date and time.
     * @param dtf Intl.DateTimeFormat object, containg the desired string format. It must have
     *    timeZone set to 'utc' to work fine.
     * @param date Date from which we want to get the string representation according to dtf
     * @returns A Date object with its UTC representation based on the passed in date info
     */
    _format(dtf, date) {
        // Passing the year to the constructor causes year numbers <100 to be converted to 19xx.
        // To work around this we use `setUTCFullYear` and `setUTCHours` instead.
        const d = new Date();
        d.setUTCFullYear(date.getFullYear(), date.getMonth(), date.getDate());
        d.setUTCHours(date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
        return dtf.format(d);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: NativeDateAdapter, deps: [{ token: USA_DATE_LOCALE, optional: true }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: NativeDateAdapter });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: NativeDateAdapter, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [USA_DATE_LOCALE]
                }] }] });

const USA_NATIVE_DATE_FORMATS = {
    parse: {
        dateInput: null,
    },
    display: {
        dateInput: { year: 'numeric', month: '2-digit', day: '2-digit' },
        monthYearLabel: { year: 'numeric', month: 'short' },
        monthLabel: { month: 'long' },
        dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
        monthYearA11yLabel: { year: 'numeric', month: 'long' },
    }
};

class UsaDatePickerModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaDatePickerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.2", ngImport: i0, type: UsaDatePickerModule, declarations: [UsaDatePickerInput,
            UsaDatePickerButton,
            UsaCalendar,
            UsaCalendarHeader,
            UsaCalendarBody,
            UsaMonthView,
            UsaYearView,
            UsaMultiYearView,
            UsaCalendarBody,
            UsaDatePickerContent,
            UsaDatePicker,
            UsaDatePickerWrapper,
            UsaDatePickerButtonIcon], imports: [CommonModule,
            HoverClassModule], exports: [UsaDatePickerInput,
            UsaDatePickerButton,
            UsaCalendar,
            UsaCalendarHeader,
            UsaCalendarBody,
            UsaDatePickerContent,
            UsaDatePicker,
            UsaDatePickerWrapper] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaDatePickerModule, providers: [
            { provide: DateAdapter, useClass: NativeDateAdapter },
            { provide: USA_DATE_FORMATS, useValue: USA_NATIVE_DATE_FORMATS }
        ], imports: [CommonModule,
            HoverClassModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaDatePickerModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        UsaDatePickerInput,
                        UsaDatePickerButton,
                        UsaCalendar,
                        UsaCalendarHeader,
                        UsaCalendarBody,
                        UsaMonthView,
                        UsaYearView,
                        UsaMultiYearView,
                        UsaCalendarBody,
                        UsaDatePickerContent,
                        UsaDatePicker,
                        UsaDatePickerWrapper,
                        UsaDatePickerButtonIcon,
                    ],
                    imports: [
                        CommonModule,
                        HoverClassModule,
                    ],
                    providers: [
                        { provide: DateAdapter, useClass: NativeDateAdapter },
                        { provide: USA_DATE_FORMATS, useValue: USA_NATIVE_DATE_FORMATS }
                    ],
                    exports: [
                        UsaDatePickerInput,
                        UsaDatePickerButton,
                        UsaCalendar,
                        UsaCalendarHeader,
                        UsaCalendarBody,
                        UsaDatePickerContent,
                        UsaDatePicker,
                        UsaDatePickerWrapper,
                    ]
                }]
        }] });

let nextId$1 = 0;
class UsaCharacterCountDirective {
    element;
    renderer2;
    zone;
    control;
    /** Directive's main input - max length of characters allowed */
    usaCharacterCount;
    /**
     * Id to use for character count message text. Will be auto-generated if not passed in
     */
    messageId = `usa-character-count-${nextId$1++}`;
    MESSAGE_CLASS = `usa-character-count__message`;
    MESSAGE_INVALID_CLASS = `usa-character-count__message--invalid`;
    /**
     * Subscription to form control's value changes if one exists
     * Allows us to unsubscribe during cleanup
     */
    valueSubscription = new Subscription();
    /** Reference to character count text being displayed to users */
    characterCounterText = '';
    /**
     * Watch for resize event changes to the host element. We want to keep the character
     * counter's width attribute in line with host's width for resizable input
     */
    _inputResizeObserver;
    /**
     * Reference to character counter message element. This will be created during init if
     * one with provided messageId does not already exist as sibling.
     */
    _messageElement;
    constructor(element, renderer2, zone, control) {
        this.element = element;
        this.renderer2 = renderer2;
        this.zone = zone;
        this.control = control;
    }
    ngOnInit() {
        if (!this.usaCharacterCount) {
            return;
        }
        if (this.control) {
            this.valueSubscription = this.control.valueChanges.subscribe(($event) => this.inputEventHandler($event));
        }
        else {
            this.element.nativeElement.addEventListener('input', this.inputEventHandler.bind(this));
        }
        // Get reference to character counter's message element
        this._messageElement = this.getMessageElement();
        this.setCharacterCountText(0, this.usaCharacterCount);
        /** Watch for input field's resize event so we can keep character counter text aligned with input */
        this._inputResizeObserver = new ResizeObserver((change) => {
            // Run renderer inside angular's zone so that we can ensure change detection will pick it up
            this.zone.run(() => {
                this._messageElement.style.width = `${change[0].borderBoxSize[0].inlineSize}px`;
            });
        });
        this._inputResizeObserver.observe(this.element.nativeElement);
    }
    ngOnDestroy() {
        /** Clean Up */
        this.valueSubscription.unsubscribe();
        this.element.nativeElement.removeEventListener('input', this.inputEventHandler);
        if (this._inputResizeObserver) {
            this._inputResizeObserver.unobserve(this.element.nativeElement);
        }
    }
    /** Gets reference to span element that will be used to display character counter text. If one does not exists, it will be created
     * and attached as sibling to host form element
     */
    getMessageElement() {
        let messageElement = this.element.nativeElement.parentElement.querySelector(`.${this.MESSAGE_CLASS}#${this.messageId}`);
        if (messageElement) {
            return messageElement;
        }
        messageElement = this.renderer2.createElement('span');
        messageElement.classList.add('usa-hint', this.MESSAGE_CLASS);
        messageElement.setAttribute('aria-live', 'polite');
        messageElement.setAttribute('id', this.messageId);
        messageElement.style.width = `${this.element.nativeElement.offsetWidth}px`;
        this.element.nativeElement.parentElement.insertBefore(messageElement, this.element.nativeElement.nextSibling);
        this._messageElement = messageElement;
        return messageElement;
    }
    inputEventHandler($event) {
        let value;
        if ($event instanceof InputEvent) {
            value = $event.target.value;
        }
        else {
            value = $event;
        }
        if (value === undefined || value === null) {
            return;
        }
        this.setCharacterCountText(value.length, this.usaCharacterCount);
    }
    /**
     * Sets character counter message based on current number of characters.
     * The message is appended as sibling element to the element this character count directive
     * is attached through reference of shared parent element.
     * @param currentLength
     */
    setCharacterCountText(currentLength, maxLength) {
        // Get message to display for amount of characters left
        this.characterCounterText = this.generateCharacterCounterText(currentLength, maxLength);
        // Add error css if over limit
        const isOverLimit = currentLength && currentLength > maxLength;
        this._messageElement.classList.toggle(this.MESSAGE_INVALID_CLASS, isOverLimit);
        this._messageElement.innerHTML = this.characterCounterText;
    }
    /**
     * Follows logic from USWDS' character counter's JS file so that messaging is consistent
     * @param currentLength
     * @param maxLength
     * @returns - string message to display based on current characters and max characters allowed
     */
    generateCharacterCounterText(currentLength, maxLength) {
        const isOverLimit = currentLength && currentLength > maxLength;
        if (currentLength === 0) {
            return `${maxLength} characters allowed`;
        }
        else {
            const difference = Math.abs(maxLength - currentLength);
            const characters = `character${difference === 1 ? "" : "s"}`;
            const guidance = isOverLimit ? "over limit" : "left";
            return `${difference} ${characters} ${guidance}`;
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaCharacterCountDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: i0.NgZone }, { token: i1$1.NgControl, optional: true }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.2", type: UsaCharacterCountDirective, selector: "[usaCharacterCount]", inputs: { usaCharacterCount: "usaCharacterCount", messageId: "messageId" }, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaCharacterCountDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[usaCharacterCount]',
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: i0.NgZone }, { type: i1$1.NgControl, decorators: [{
                    type: Optional
                }] }], propDecorators: { usaCharacterCount: [{
                type: Input
            }], messageId: [{
                type: Input
            }] } });

class UsaCharacterCountModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaCharacterCountModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.2", ngImport: i0, type: UsaCharacterCountModule, declarations: [UsaCharacterCountDirective], imports: [CommonModule], exports: [UsaCharacterCountDirective] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaCharacterCountModule, imports: [CommonModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaCharacterCountModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [UsaCharacterCountDirective],
                    imports: [
                        CommonModule
                    ],
                    exports: [
                        UsaCharacterCountDirective,
                    ]
                }]
        }] });

class UsaRadioLabelDescription {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaRadioLabelDescription, deps: [], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.2", type: UsaRadioLabelDescription, selector: "[usaRadioDescription]", host: { classAttribute: "usa-checkbox__label-description" }, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaRadioLabelDescription, decorators: [{
            type: Directive,
            args: [{
                    selector: '[usaRadioDescription]',
                    host: {
                        class: 'usa-checkbox__label-description'
                    }
                }]
        }] });
let nextId = 0;
class UsaRadioComponent {
    cdr;
    tile;
    value;
    disabled;
    checked;
    ariaLabel = '';
    ariaLabelledby = null;
    ariaDescribedby;
    id = `usa-radio-${nextId++}`;
    required = false;
    /** Name value will be applied to the input element if present */
    name = null;
    change = new EventEmitter();
    /**
    * Invoked when the model has been changed
    */
    onChange = (_) => { };
    /**
     * Invoked when the model has been touched
     */
    onTouched = () => { };
    constructor(cdr) {
        this.cdr = cdr;
    }
    writeValue(value) {
        this.checked = !!value;
        this.cdr.markForCheck();
    }
    /**
     * Registers a callback function that should be called when the control's value changes in the UI.
     * @param fn
     */
    registerOnChange(fn) {
        this.onChange = fn;
    }
    /**
      * Registers a callback function that should be called when the control receives a blur event.
      * @param fn
      */
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    onRadioClicked($event, input) {
        $event.stopPropagation();
        if (this.disabled) {
            return;
        }
        const outputValue = { target: input, value: input.value };
        this.checked = true;
        this.onChange(outputValue);
        this.change.emit(outputValue);
    }
    preventChangePropogation($event) {
        $event.stopPropagation();
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaRadioComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.2", type: UsaRadioComponent, selector: "usa-radio", inputs: { tile: "tile", value: "value", disabled: "disabled", checked: "checked", ariaLabel: ["aria-label", "ariaLabel"], ariaLabelledby: ["aria-labelledby", "ariaLabelledby"], ariaDescribedby: ["aria-describedby", "ariaDescribedby"], id: "id", required: "required", name: "name" }, outputs: { change: "change" }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => UsaRadioComponent),
                multi: true,
            },
        ], ngImport: i0, template: "<div class=\"usa-radio\">\n  <input #input\n  class=\"usa-radio__input\" type=\"radio\"\n  [ngClass]=\"{'usa-radio__input--tile': tile}\"\n  [id]=\"id\"\n  [required]=\"required\"\n  [checked]=\"checked\"\n  [disabled]=\"disabled\"\n  [value]=\"value\"\n  [attr.name]=\"name\"\n  [attr.aria-label]=\"ariaLabel || null\"\n  [attr.aria-labelledby]=\"ariaLabelledby\"\n  [attr.aria-checked]=\"checked\"\n  [attr.aria-describedby]=\"ariaDescribedby\"\n  (click)=\"onRadioClicked($event, input)\"\n  (change)=\"preventChangePropogation($event)\"\n  >\n  <label class=\"usa-radio__label\" [for]=\"id\">\n    <ng-content></ng-content>\n    <ng-content select=\"usaRadioDescription\"></ng-content>\n  </label>\n</div>\n", dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaRadioComponent, decorators: [{
            type: Component,
            args: [{ selector: `usa-radio`, providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => UsaRadioComponent),
                            multi: true,
                        },
                    ], changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"usa-radio\">\n  <input #input\n  class=\"usa-radio__input\" type=\"radio\"\n  [ngClass]=\"{'usa-radio__input--tile': tile}\"\n  [id]=\"id\"\n  [required]=\"required\"\n  [checked]=\"checked\"\n  [disabled]=\"disabled\"\n  [value]=\"value\"\n  [attr.name]=\"name\"\n  [attr.aria-label]=\"ariaLabel || null\"\n  [attr.aria-labelledby]=\"ariaLabelledby\"\n  [attr.aria-checked]=\"checked\"\n  [attr.aria-describedby]=\"ariaDescribedby\"\n  (click)=\"onRadioClicked($event, input)\"\n  (change)=\"preventChangePropogation($event)\"\n  >\n  <label class=\"usa-radio__label\" [for]=\"id\">\n    <ng-content></ng-content>\n    <ng-content select=\"usaRadioDescription\"></ng-content>\n  </label>\n</div>\n" }]
        }], ctorParameters: () => [{ type: i0.ChangeDetectorRef }], propDecorators: { tile: [{
                type: Input
            }], value: [{
                type: Input
            }], disabled: [{
                type: Input
            }], checked: [{
                type: Input
            }], ariaLabel: [{
                type: Input,
                args: ['aria-label']
            }], ariaLabelledby: [{
                type: Input,
                args: ['aria-labelledby']
            }], ariaDescribedby: [{
                type: Input,
                args: ['aria-describedby']
            }], id: [{
                type: Input
            }], required: [{
                type: Input
            }], name: [{
                type: Input
            }], change: [{
                type: Output
            }] } });

/**
 * Directive to allow heading for group of radio options
 */
class UsaRadioGroupLabel {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaRadioGroupLabel, deps: [], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.2", type: UsaRadioGroupLabel, selector: "[usaRadioGroupLabel]", ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaRadioGroupLabel, decorators: [{
            type: Directive,
            args: [{
                    selector: '[usaRadioGroupLabel]',
                }]
        }] });
class UsaRadioGroupComponent {
    /**
     * Invoked when the model has been changed
     */
    onChange;
    /**
    * Invoked when the model has been touched
    */
    onTouched;
    radioComponents;
    /**
     * Name for radio groups. A group of radio options should contain the same name
     */
    name;
    /**
     * Whether or not to display radio options as tile. This input is purely for presentation
     */
    tile;
    /**
     * Value of currently selected radio option. Each radio option within the group
     * should have a unique value. This value will match the currently selected
     * radio option's value within the group
     */
    get value() {
        return this._value;
    }
    set value(val) {
        this._value = val;
        if (!this.radioComponents)
            return;
        this.radioComponents.forEach(radio => {
            radio.checked = radio.value === val;
        });
    }
    _value;
    /**
     * Defines whether all radio options within the group are disabled or not.
     * To dispable individual radio buttons, please pass the disabled property directly
     * to the radio button
     */
    get disabled() {
        return this._disabled;
    }
    set disabled(value) {
        this._disabled = value;
        if (this.radioComponents) {
            this.radioComponents.forEach(radio => {
                radio.disabled = value;
            });
        }
    }
    _disabled = false;
    ariaLabelledBy;
    /**
     * Outputs whenever radio option changes. The output data will
     * contain two properties, target and value. Target will refer to
     * the HTMLInputElement for the selected radio input while value will
     * contain the provided value of the input
     */
    change = new EventEmitter();
    _subscriptions;
    constructor() {
        this.onChange = (_) => { };
        this.onTouched = () => { };
        this._subscriptions = new Subscription();
    }
    ngAfterContentInit() {
        this.radioComponents.forEach(radio => {
            radio.name = radio.name ? radio.name : this.name;
            radio.tile = radio.tile ? radio.tile : this.tile;
            radio.disabled = radio.disabled != undefined ? radio.disabled : this.disabled;
            if (this.value && radio.value === this.value) {
                radio.checked = true;
            }
            this._subscribeToRadioChange(radio);
        });
    }
    ngOnDestroy() {
        if (this._subscriptions) {
            this._subscriptions.unsubscribe();
        }
    }
    writeValue(value) {
        this.value = value;
        if (this.radioComponents) {
            this.radioComponents.forEach(radio => {
                radio.checked = value === radio.value;
            });
        }
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    _subscribeToRadioChange(radio) {
        const changeSubscription = radio.change.subscribe(((change) => {
            this.radioComponents.forEach(component => {
                component.checked = component === radio;
                component.cdr.markForCheck();
            });
            if (this.onChange && typeof (this.onChange) === 'function') {
                this.onChange(change.value);
            }
            this.change.emit(change);
        }).bind(this));
        this._subscriptions.add(changeSubscription);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaRadioGroupComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.2", type: UsaRadioGroupComponent, selector: "usa-radio-group", inputs: { name: "name", tile: "tile", value: "value", disabled: "disabled", ariaLabelledBy: "ariaLabelledBy" }, outputs: { change: "change" }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => UsaRadioGroupComponent),
                multi: true,
            },
        ], queries: [{ propertyName: "radioComponents", predicate: UsaRadioComponent }], ngImport: i0, template: `
  <div role="radiogroup" [attr.aria-labelledby]="ariaLabelledBy">
    <ng-content select="usaRadioGroupLabel"></ng-content>
    <ng-content></ng-content>
  </div>`, isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaRadioGroupComponent, decorators: [{
            type: Component,
            args: [{
                    selector: `usa-radio-group`,
                    template: `
  <div role="radiogroup" [attr.aria-labelledby]="ariaLabelledBy">
    <ng-content select="usaRadioGroupLabel"></ng-content>
    <ng-content></ng-content>
  </div>`,
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => UsaRadioGroupComponent),
                            multi: true,
                        },
                    ],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: () => [], propDecorators: { radioComponents: [{
                type: ContentChildren,
                args: [UsaRadioComponent]
            }], name: [{
                type: Input
            }], tile: [{
                type: Input
            }], value: [{
                type: Input
            }], disabled: [{
                type: Input
            }], ariaLabelledBy: [{
                type: Input
            }], change: [{
                type: Output
            }] } });

class UsaRadioModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaRadioModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.2", ngImport: i0, type: UsaRadioModule, declarations: [UsaRadioComponent,
            UsaRadioLabelDescription,
            UsaRadioGroupComponent,
            UsaRadioGroupLabel], imports: [CommonModule], exports: [UsaRadioComponent,
            UsaRadioLabelDescription,
            UsaRadioGroupComponent,
            UsaRadioGroupLabel] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaRadioModule, imports: [CommonModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaRadioModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [
                        UsaRadioComponent,
                        UsaRadioLabelDescription,
                        UsaRadioGroupComponent,
                        UsaRadioGroupLabel,
                    ],
                    exports: [
                        UsaRadioComponent,
                        UsaRadioLabelDescription,
                        UsaRadioGroupComponent,
                        UsaRadioGroupLabel,
                    ]
                }]
        }] });

/**
 * Define primary navigation links for the header. Use this over passing in JSON model
 * through primaryNavItems input if you'd like more customization to the header's primary
 * link templates. Only usable with ul tags.
 * @example
 * <usa-header>
 *  <ul usaHeaderPrimaryLinks>
 *     <li class="usa-nav__primary-item">
 *       <a href="<yourHref>">Navigation Link</a>
 *     </li>
 *   </ul>
 * </usa-header>
 *
 */
class UsaHeaderPrimaryLinks {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaHeaderPrimaryLinks, deps: [], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.2", type: UsaHeaderPrimaryLinks, selector: "ul[usaHeaderPrimaryLinks]", host: { classAttribute: "usa-nav__primary usa-accordion" }, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaHeaderPrimaryLinks, decorators: [{
            type: Directive,
            args: [{
                    selector: `ul[usaHeaderPrimaryLinks]`,
                    host: {
                        class: 'usa-nav__primary usa-accordion',
                    }
                }]
        }] });
/**
 * Additional content to add to primary header that are not navigation links.
 * This content will be added after the primary header links
 * @example
 * <usa-header>
 *  <div usaHeaderPrimaryExtra>
 *    <usa-search></usa-search>
 *  </div>
 * </usa-header>
 */
class UsaHeaderPrimaryExtra {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaHeaderPrimaryExtra, deps: [], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.2", type: UsaHeaderPrimaryExtra, selector: "[usaHeaderPrimaryExtra]", ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaHeaderPrimaryExtra, decorators: [{
            type: Directive,
            args: [{
                    selector: `[usaHeaderPrimaryExtra]`,
                }]
        }] });
/**
 * Define template for displaying primary navigation link. This is useful if you'd
 * like to pass in json model for primary links, and want some customization on
 * how the link text are displayed. Any primary links in the input model that do
 * not have `navigationMode` defined will use this template to display the link
 * @example
 * <usa-header [primaryNavItems]="yourJsonModel">
 *  <ng-template usaHeaderPrimaryLinkTemplate let-link>
 *    <your-custom-template-here [link]="link"></your-custom-template-here>
 *  </ng-template>
 * </usa-header>
 */
class UsaHeaderPrimaryLinkTemplate {
    templateRef;
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaHeaderPrimaryLinkTemplate, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.2", type: UsaHeaderPrimaryLinkTemplate, selector: "[usaHeaderPrimaryLinkTemplate]", ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaHeaderPrimaryLinkTemplate, decorators: [{
            type: Directive,
            args: [{
                    selector: `[usaHeaderPrimaryLinkTemplate]`
                }]
        }], ctorParameters: () => [{ type: i0.TemplateRef }] });
/**
 * Define secondary navigation links for the header. Use this over passing in JSON model
 * through secondaryNavItems input if you'd like more customization to the header's secondary
 * link templates. Only usable with ul tags.
 * @example
 * <usa header [extended]="true">
 *  <ul usaHeaderSecondaryLinks>
 *    <li class="usa-nav__secondary-item">
        <a href="<yourHref>">Secondary Link</a>
      </li>
 *  </ul>
 * </usa-header>
 */
class UsaHeaderSecondaryLinks {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaHeaderSecondaryLinks, deps: [], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.2", type: UsaHeaderSecondaryLinks, selector: "ul[usaHeaderSecondaryLinks]", host: { classAttribute: "usa-nav__secondary-links" }, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaHeaderSecondaryLinks, decorators: [{
            type: Directive,
            args: [{
                    selector: `ul[usaHeaderSecondaryLinks]`,
                    host: {
                        class: 'usa-nav__secondary-links',
                    }
                }]
        }] });
/**
 * Additional content to add to extended header aside from links. Content will be
 * added to the end of secondary links if secondary links are provided
 * @example
 * <usa-header [extended]="true">
 *  <div usaHeaderSecondaryExtra>
 *    <usa-search></usa-search>
 *  </div>
 * </usa-header>
 */
class UsaHeaderSecondaryExtra {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaHeaderSecondaryExtra, deps: [], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.2", type: UsaHeaderSecondaryExtra, selector: "[usaHeaderSecondaryExtra]", ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaHeaderSecondaryExtra, decorators: [{
            type: Directive,
            args: [{
                    selector: `[usaHeaderSecondaryExtra]`
                }]
        }] });
/**
 * Define template for displaying secondary navigation link. This is useful if you'd
 * like to pass in json model for secondary links, and want some customization on
 * how the link text are displayed. Any secondary links in the input model that do
 * not have `navigationMode` defined will use this template to display the link
 * @example
 * <usa-header [secondaryNavItems]="yourJsonModel">
 *  <ng-template usaHeaderSecondaryLinkTemplate let-link>
 *    <your-custom-template-here [link]="link"></your-custom-template-here>
 *  </ng-template>
 * </usa-header>
 */
class UsaHeaderSecondaryLinkTemplate {
    templateRef;
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaHeaderSecondaryLinkTemplate, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.2", type: UsaHeaderSecondaryLinkTemplate, selector: "[usaHeaderSecondaryLinkTemplate]", ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaHeaderSecondaryLinkTemplate, decorators: [{
            type: Directive,
            args: [{
                    selector: `[usaHeaderSecondaryLinkTemplate]`
                }]
        }], ctorParameters: () => [{ type: i0.TemplateRef }] });

class UsaHeaderComponent {
    changeDetector;
    primaryLinkTemplate;
    secondaryLinkTemplate;
    openNavBtn;
    closeNavBtn;
    mobileNavActive = false;
    /**
     * Title to display in header. Can be a string or a template reference
     */
    title;
    /**
     * Template to use for displaying menu button on mobile mode. By default,
     * the text 'Menu' will be used
     */
    menuButtonTemplate;
    /**
     * Aria label to use for over all navigation content
     * @default 'Primary Navigation'
     */
    navAriaLabel = 'Primary Navigation';
    /**
     * Whether the header should have secondary links or not.
     * @default false
     */
    extended = false;
    /**
     * Primary navigation items to display for header
     */
    primaryNavItems;
    /**
     * Secondary navigation items to display for header. Please note
     * that `extended` input must also be passed in as `true` for the
     * secondary nav items to display
     */
    secondaryNavItems;
    /**
     * Defines whether or not to display dark overlay in background
     * whenever submenu or megamenu is active
     */
    displayOverlayOnMenuOpen = false;
    /**
     * event emitted whenever a navigation item is clicked.
     * This only fires if navigation mode for the link event is NONE or undefined
     */
    linkEvent = new EventEmitter();
    NavigationMode = UsaNavigationMode;
    /** Reference of link whose dropdown menu is currently open */
    selectedDropdownLink;
    /** Reference to currently selected navigation link */
    selectedNavItem;
    // When the mobile nav is active, and the close box isn't visible,
    // we know the user's viewport has been resized to be larger.
    // Let's make the page state consistent by deactivating the mobile nav.
    onBrowserResize(event) {
        if (this.mobileNavActive &&
            this.closeNavBtn.nativeElement.getBoundingClientRect().width === 0) {
            this.mobileNavActive = false;
        }
    }
    documentClick($event) {
        this.selectedDropdownLink = null;
    }
    constructor(changeDetector) {
        this.changeDetector = changeDetector;
    }
    ngOnInit() {
        /** Look through primary and secondary nav and select the first selected nav item.
         * Toggle the rest off if they are selected */
        this.selectInitialNavItem(this.primaryNavItems);
        this.selectInitialNavItem(this.secondaryNavItems);
    }
    getTypeOfTitle() {
        return typeof this.title === 'string' ? 'string' : 'object';
    }
    /**
     * Takes in a text string and removes all white space characters and returns the new string
     * @param text
     */
    removeWhiteSpace(text) {
        return text.replace(/ /g, '');
    }
    /**
     * Link clicked and emits the link data into an event
     * @param link
     */
    linkClickEvent(link, parentNav) {
        const itemToSelect = parentNav ? parentNav : link;
        this.selectNavItem(itemToSelect);
        this.linkEvent.emit(link);
    }
    /**
     * Public Interface - select a navigation item to mark as selected.
     * @param item - The item to select. This item will be marked as selected, and
     * any previously selected item will be un-selected. Note that only one nav item may
     * be selected at a time
     */
    selectNavItem(item) {
        if (this.selectedNavItem) {
            this.selectedNavItem.selected = false;
        }
        this.selectedNavItem = item;
        this.selectedNavItem.selected = true;
        this.changeDetector.detectChanges();
    }
    dropdownLinkClicked(link, $event) {
        // Opened dropdown link was clicked, close it
        if (link === this.selectedDropdownLink) {
            this.selectedDropdownLink = null;
            return;
        }
        // Otherwise, set the newly clicked link as the new open dropdown
        this.selectedDropdownLink = link;
        $event?.stopImmediatePropagation();
    }
    openMobileNav() {
        this.mobileNavActive = true;
    }
    closeMobileNav() {
        this.mobileNavActive = false;
        this.openNavBtn.nativeElement.focus();
    }
    navAnimationEnd() {
        this.closeNavBtn.nativeElement.focus();
    }
    /** Used during component init - selects the initial nav item by looking through input nav items */
    selectInitialNavItem(navItemsList) {
        if (!navItemsList)
            return;
        navItemsList.forEach((item) => {
            if (this.selectedNavItem) {
                item.selected = false;
            }
            else if (item.selected) {
                this.selectedNavItem = item;
            }
        });
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaHeaderComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.2", type: UsaHeaderComponent, selector: "usa-header", inputs: { title: "title", menuButtonTemplate: "menuButtonTemplate", navAriaLabel: "navAriaLabel", extended: "extended", primaryNavItems: "primaryNavItems", secondaryNavItems: "secondaryNavItems", displayOverlayOnMenuOpen: "displayOverlayOnMenuOpen" }, outputs: { linkEvent: "linkEvent" }, host: { listeners: { "window:resize": "onBrowserResize($event)", "document:click": "documentClick($event)" } }, queries: [{ propertyName: "primaryLinkTemplate", first: true, predicate: UsaHeaderPrimaryLinkTemplate, descendants: true }, { propertyName: "secondaryLinkTemplate", first: true, predicate: UsaHeaderSecondaryLinkTemplate, descendants: true }], viewQueries: [{ propertyName: "openNavBtn", first: true, predicate: ["usaNavOpen"], descendants: true }, { propertyName: "closeNavBtn", first: true, predicate: ["usaNavClose"], descendants: true }], ngImport: i0, template: "<div class=\"usa-overlay\" \n  [class.is-visible]=\"mobileNavActive || (displayOverlayOnMenuOpen && selectedDropdownLink != null)\" \n  (click)=\"mobileNavActive ? closeMobileNav() : ''\">\n</div>\n<header class=\"usa-header\" [ngClass]=\"{'usa-header--extended': extended, 'usa-header--basic': !extended}\">\n  <div class=\"usa-nav-container\">\n    <div class=\"usa-navbar\">\n      <div class=\"usa-logo\">\n        <ng-container *ngIf=\"getTypeOfTitle() === 'object'; else titleText\" [ngTemplateOutlet]=\"title\"></ng-container>\n        <ng-template #titleText><em class=\"usa-logo__text\">{{title}}</em></ng-template>\n      </div>\n      <button #usaNavOpen class=\"usa-menu-btn\" (click)=\"openMobileNav()\">\n        <ng-container *ngIf=\"menuButtonTemplate; else menu\" [ngTemplateOutlet]=\"menuButtonTemplate\"></ng-container>\n        <ng-template #menu>\n          Menu\n          <span class=\"usa-sr-only\">Menu</span>\n        </ng-template>\n      </button>\n    </div>\n    <nav [attr.aria-label]=\"navAriaLabel\" class=\"usa-nav\" (keydown.esc)=\"closeMobileNav()\"\n      (animationend)=\"navAnimationEnd()\" [class.is-visible]=\"mobileNavActive\">\n      <ng-container *ngIf=\"extended; else headerNavigationLinks\">\n        <div class=\"usa-nav__inner\">  \n          <ng-container [ngTemplateOutlet]=\"headerNavigationLinks\"></ng-container>\n        </div>\n      </ng-container>\n\n      <ng-template #headerNavigationLinks>\n        <button #usaNavClose class=\"usa-nav__close\" (click)=\"closeMobileNav()\">\n          <span>Close</span>\n          <span class=\"usa-sr-only\">Close</span>\n        </button>\n\n        <ul class=\"usa-nav__primary usa-accordion\" *ngIf=\"primaryNavItems\">\n          <li *ngFor=\"let link of primaryNavItems\" class=\"usa-nav__primary-item\">\n            <ng-container [ngTemplateOutlet]=\"link.children ? dropDownTemplate : linkTemplate\"\n              [ngTemplateOutletContext]=\"{ $implicit: link, isPrimary: true }\"></ng-container>\n          </li>\n        </ul>\n\n        <ng-content select=\"[usaHeaderPrimaryLinks]\"></ng-content>\n        <ng-content select=\"[usaHeaderPrimaryExtra]\"></ng-content>\n\n        <div *ngIf=\"extended\" class=\"usa-nav__secondary\">\n          <ul *ngIf=\"secondaryNavItems\" class=\"usa-nav__secondary-links\">\n            <li *ngFor=\"let link of secondaryNavItems\" class=\"usa-nav__secondary-item\">\n              <ng-container [ngTemplateOutlet]=\"linkTemplate\" [ngTemplateOutletContext]=\"{ $implicit: link, isPrimary: false }\"></ng-container>\n            </li>\n          </ul>\n          <ng-content select=\"[usaHeaderSecondaryLinks]\"></ng-content>\n          <ng-content select=\"[usaHeaderSecondaryExtra]\"></ng-content>\n        </div>\n      </ng-template>\n    </nav>\n  </div>\n</header>\n\n<ng-template #linkTemplate let-link let-isPrimary=\"isPrimary\" let-parentNav=\"parentNav\">\n  <ng-container [ngTemplateOutlet]=\"\n    link.path ? linkHREFTemplate :\n    primaryLinkTemplate && isPrimary === true ? primaryLinkTemplate.templateRef :\n    secondaryLinkTemplate && isPrimary === false ? secondaryLinkTemplate.templateRef :\n    linkEventTemplate\"\n    [ngTemplateOutletContext]=\"{ $implicit: link, isPrimary: isPrimary, parentNav: parentNav }\"></ng-container>\n</ng-template>\n\n<ng-template #dropDownTemplate let-link>\n  <button [attr.id]=\"link.id\" class=\"usa-accordion__button usa-nav__link\"\n    [ngClass]=\"{'usa-current': link.selected}\"\n    [attr.aria-expanded]=\"link === selectedDropdownLink\" \n    [attr.aria-controls]=\"removeWhiteSpace(link.text) + '-section'\" \n    (click)=\"dropdownLinkClicked(link, $event)\">\n    <span>{{ link.text }}</span>\n  </button>\n  <ul *ngIf=\"link === selectedDropdownLink\" [attr.id]=\"removeWhiteSpace(link.text) + '-section'\" class=\"usa-nav__submenu\" \n    [ngClass]=\"{'usa-megamenu': link.isMegamenu}\">\n    <li *ngFor=\"let childLink of link.children\" class=\"usa-nav__submenu-item\">\n      <ng-container [ngTemplateOutlet]=\"linkTemplate\"\n         [ngTemplateOutletContext]=\"{ $implicit: childLink, parentNav: link }\">\n      </ng-container>\n    </li>\n  </ul>\n</ng-template>\n\n<ng-template #linkHREFTemplate let-link let-isPrimary>\n  <a [attr.id]=\"link.id\"\n    [ngClass]=\"{'usa-nav__link': isPrimary, 'usa-current': link.selected}\" \n    [attr.href]=\"[link.path]\">{{ link.text }}</a>\n</ng-template>\n\n<ng-template #linkEventTemplate let-link let-isPrimary=\"isPrimary\" let-parentNav=\"parentNav\">\n  <a [attr.id]=\"link.id\"\n    [ngClass]=\"{'usa-nav__link': isPrimary, 'usa-current': link.selected}\"\n    href=\"javascript:void(0)\" (click)=\"linkClickEvent(link, parentNav)\">{{ link.text }}</a>\n</ng-template>\n", dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaHeaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'usa-header', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"usa-overlay\" \n  [class.is-visible]=\"mobileNavActive || (displayOverlayOnMenuOpen && selectedDropdownLink != null)\" \n  (click)=\"mobileNavActive ? closeMobileNav() : ''\">\n</div>\n<header class=\"usa-header\" [ngClass]=\"{'usa-header--extended': extended, 'usa-header--basic': !extended}\">\n  <div class=\"usa-nav-container\">\n    <div class=\"usa-navbar\">\n      <div class=\"usa-logo\">\n        <ng-container *ngIf=\"getTypeOfTitle() === 'object'; else titleText\" [ngTemplateOutlet]=\"title\"></ng-container>\n        <ng-template #titleText><em class=\"usa-logo__text\">{{title}}</em></ng-template>\n      </div>\n      <button #usaNavOpen class=\"usa-menu-btn\" (click)=\"openMobileNav()\">\n        <ng-container *ngIf=\"menuButtonTemplate; else menu\" [ngTemplateOutlet]=\"menuButtonTemplate\"></ng-container>\n        <ng-template #menu>\n          Menu\n          <span class=\"usa-sr-only\">Menu</span>\n        </ng-template>\n      </button>\n    </div>\n    <nav [attr.aria-label]=\"navAriaLabel\" class=\"usa-nav\" (keydown.esc)=\"closeMobileNav()\"\n      (animationend)=\"navAnimationEnd()\" [class.is-visible]=\"mobileNavActive\">\n      <ng-container *ngIf=\"extended; else headerNavigationLinks\">\n        <div class=\"usa-nav__inner\">  \n          <ng-container [ngTemplateOutlet]=\"headerNavigationLinks\"></ng-container>\n        </div>\n      </ng-container>\n\n      <ng-template #headerNavigationLinks>\n        <button #usaNavClose class=\"usa-nav__close\" (click)=\"closeMobileNav()\">\n          <span>Close</span>\n          <span class=\"usa-sr-only\">Close</span>\n        </button>\n\n        <ul class=\"usa-nav__primary usa-accordion\" *ngIf=\"primaryNavItems\">\n          <li *ngFor=\"let link of primaryNavItems\" class=\"usa-nav__primary-item\">\n            <ng-container [ngTemplateOutlet]=\"link.children ? dropDownTemplate : linkTemplate\"\n              [ngTemplateOutletContext]=\"{ $implicit: link, isPrimary: true }\"></ng-container>\n          </li>\n        </ul>\n\n        <ng-content select=\"[usaHeaderPrimaryLinks]\"></ng-content>\n        <ng-content select=\"[usaHeaderPrimaryExtra]\"></ng-content>\n\n        <div *ngIf=\"extended\" class=\"usa-nav__secondary\">\n          <ul *ngIf=\"secondaryNavItems\" class=\"usa-nav__secondary-links\">\n            <li *ngFor=\"let link of secondaryNavItems\" class=\"usa-nav__secondary-item\">\n              <ng-container [ngTemplateOutlet]=\"linkTemplate\" [ngTemplateOutletContext]=\"{ $implicit: link, isPrimary: false }\"></ng-container>\n            </li>\n          </ul>\n          <ng-content select=\"[usaHeaderSecondaryLinks]\"></ng-content>\n          <ng-content select=\"[usaHeaderSecondaryExtra]\"></ng-content>\n        </div>\n      </ng-template>\n    </nav>\n  </div>\n</header>\n\n<ng-template #linkTemplate let-link let-isPrimary=\"isPrimary\" let-parentNav=\"parentNav\">\n  <ng-container [ngTemplateOutlet]=\"\n    link.path ? linkHREFTemplate :\n    primaryLinkTemplate && isPrimary === true ? primaryLinkTemplate.templateRef :\n    secondaryLinkTemplate && isPrimary === false ? secondaryLinkTemplate.templateRef :\n    linkEventTemplate\"\n    [ngTemplateOutletContext]=\"{ $implicit: link, isPrimary: isPrimary, parentNav: parentNav }\"></ng-container>\n</ng-template>\n\n<ng-template #dropDownTemplate let-link>\n  <button [attr.id]=\"link.id\" class=\"usa-accordion__button usa-nav__link\"\n    [ngClass]=\"{'usa-current': link.selected}\"\n    [attr.aria-expanded]=\"link === selectedDropdownLink\" \n    [attr.aria-controls]=\"removeWhiteSpace(link.text) + '-section'\" \n    (click)=\"dropdownLinkClicked(link, $event)\">\n    <span>{{ link.text }}</span>\n  </button>\n  <ul *ngIf=\"link === selectedDropdownLink\" [attr.id]=\"removeWhiteSpace(link.text) + '-section'\" class=\"usa-nav__submenu\" \n    [ngClass]=\"{'usa-megamenu': link.isMegamenu}\">\n    <li *ngFor=\"let childLink of link.children\" class=\"usa-nav__submenu-item\">\n      <ng-container [ngTemplateOutlet]=\"linkTemplate\"\n         [ngTemplateOutletContext]=\"{ $implicit: childLink, parentNav: link }\">\n      </ng-container>\n    </li>\n  </ul>\n</ng-template>\n\n<ng-template #linkHREFTemplate let-link let-isPrimary>\n  <a [attr.id]=\"link.id\"\n    [ngClass]=\"{'usa-nav__link': isPrimary, 'usa-current': link.selected}\" \n    [attr.href]=\"[link.path]\">{{ link.text }}</a>\n</ng-template>\n\n<ng-template #linkEventTemplate let-link let-isPrimary=\"isPrimary\" let-parentNav=\"parentNav\">\n  <a [attr.id]=\"link.id\"\n    [ngClass]=\"{'usa-nav__link': isPrimary, 'usa-current': link.selected}\"\n    href=\"javascript:void(0)\" (click)=\"linkClickEvent(link, parentNav)\">{{ link.text }}</a>\n</ng-template>\n" }]
        }], ctorParameters: () => [{ type: i0.ChangeDetectorRef }], propDecorators: { primaryLinkTemplate: [{
                type: ContentChild,
                args: [UsaHeaderPrimaryLinkTemplate]
            }], secondaryLinkTemplate: [{
                type: ContentChild,
                args: [UsaHeaderSecondaryLinkTemplate]
            }], openNavBtn: [{
                type: ViewChild,
                args: ['usaNavOpen']
            }], closeNavBtn: [{
                type: ViewChild,
                args: ['usaNavClose']
            }], title: [{
                type: Input
            }], menuButtonTemplate: [{
                type: Input
            }], navAriaLabel: [{
                type: Input
            }], extended: [{
                type: Input
            }], primaryNavItems: [{
                type: Input
            }], secondaryNavItems: [{
                type: Input
            }], displayOverlayOnMenuOpen: [{
                type: Input
            }], linkEvent: [{
                type: Output
            }], onBrowserResize: [{
                type: HostListener,
                args: ['window:resize', ['$event']]
            }], documentClick: [{
                type: HostListener,
                args: ['document:click', ['$event']]
            }] } });

let submenuId = 0;
class UsaHeaderSubmenuButton {
    el;
    viewContainer;
    submenuTemplate;
    /**
     * Required Input - template reference of content to display within the megamenu
     */
    content;
    /**
     * Defines whether the content should be displayed as a megamenu rather than a menu.
     * A megamenu will open a menu that expands the entire width of the page
     * @default false
     */
    isMegamenu = false;
    /**
     * Whether the megamenu is open initially or not
     * @default - false
     */
    selected = false;
    /**
     * Id for megamenu section
     */
    id = `usa-megamenu-nav-${submenuId++}`;
    /**
     * Output event emitted whenever the state of megamenu (opened or closed) changes.
     */
    selectedChange = new EventEmitter();
    /**
     * Listener for click events anywhere in the DOM. If the click event was outside
     * this submenu element, then close the submeny.
     * @param $event - click event
     */
    onDocumentClick($event) {
        if (!this.selected || this.el.nativeElement.contains($event.target)) {
            return;
        }
        this.selected = false;
        this.detachContent();
        this.selectedChange.emit(this.selected);
    }
    _attachedViewRef;
    constructor(el, viewContainer) {
        this.el = el;
        this.viewContainer = viewContainer;
    }
    /**
     * Toggles selected value when button is clicked. If the item is selected, then we should
     * display the submenu. If the item is un-selected, then we should remove the submenu
     */
    onClick() {
        this.selected = !this.selected;
        this.selected ? this.attachContent() : this.detachContent();
        this.selectedChange.emit(this.selected);
    }
    /**
     * Attaches the submenu div as next sibling to button
     */
    attachContent() {
        this._attachedViewRef = this.viewContainer.createEmbeddedView(this.submenuTemplate);
    }
    /**
     * Removes dropdown content and detaches the created view container
     */
    detachContent() {
        this._attachedViewRef.destroy();
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaHeaderSubmenuButton, deps: [{ token: i0.ElementRef }, { token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.2", type: UsaHeaderSubmenuButton, selector: "button[usaHeaderSubmenu]", inputs: { content: "content", isMegamenu: "isMegamenu", selected: "selected", id: "id" }, outputs: { selectedChange: "selectedChange" }, host: { listeners: { "click": "onClick()", "document:click": "onDocumentClick($event)" }, properties: { "attr.aria-expanded": "selected", "attr.aria-controls": "id" }, classAttribute: "usa-accordion__button usa-nav__link" }, viewQueries: [{ propertyName: "submenuTemplate", first: true, predicate: ["submenuView"], descendants: true }], ngImport: i0, template: `
    <span><ng-content></ng-content></span>
    <ng-template #submenuView>
      <div class="usa-nav__submenu" [ngClass]="{'usa-megamenu': isMegamenu}">
        <ng-container [ngTemplateOutlet]="content"></ng-container>
      </div>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaHeaderSubmenuButton, decorators: [{
            type: Component,
            args: [{
                    selector: `button[usaHeaderSubmenu]`,
                    host: {
                        class: `usa-accordion__button usa-nav__link`,
                        '[attr.aria-expanded]': 'selected',
                        '[attr.aria-controls]': 'id',
                        '(click)': 'onClick()',
                    },
                    template: `
    <span><ng-content></ng-content></span>
    <ng-template #submenuView>
      <div class="usa-nav__submenu" [ngClass]="{'usa-megamenu': isMegamenu}">
        <ng-container [ngTemplateOutlet]="content"></ng-container>
      </div>
    </ng-template>
  `
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i0.ViewContainerRef }], propDecorators: { submenuTemplate: [{
                type: ViewChild,
                args: ['submenuView']
            }], content: [{
                type: Input
            }], isMegamenu: [{
                type: Input
            }], selected: [{
                type: Input
            }], id: [{
                type: Input
            }], selectedChange: [{
                type: Output
            }], onDocumentClick: [{
                type: HostListener,
                args: ['document:click', ['$event']]
            }] } });

class UsaHeaderModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaHeaderModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.2", ngImport: i0, type: UsaHeaderModule, declarations: [UsaHeaderComponent,
            UsaHeaderPrimaryLinks,
            UsaHeaderSecondaryLinks,
            UsaHeaderSubmenuButton,
            UsaHeaderPrimaryExtra,
            UsaHeaderSecondaryExtra,
            UsaHeaderPrimaryLinkTemplate,
            UsaHeaderSecondaryLinkTemplate], imports: [CommonModule,
            RouterModule], exports: [UsaHeaderComponent,
            UsaHeaderPrimaryLinks,
            UsaHeaderSecondaryLinks,
            UsaHeaderSubmenuButton,
            UsaHeaderPrimaryExtra,
            UsaHeaderSecondaryExtra,
            UsaHeaderPrimaryLinkTemplate,
            UsaHeaderSecondaryLinkTemplate] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaHeaderModule, imports: [CommonModule,
            RouterModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaHeaderModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        UsaHeaderComponent,
                        UsaHeaderPrimaryLinks,
                        UsaHeaderSecondaryLinks,
                        UsaHeaderSubmenuButton,
                        UsaHeaderPrimaryExtra,
                        UsaHeaderSecondaryExtra,
                        UsaHeaderPrimaryLinkTemplate,
                        UsaHeaderSecondaryLinkTemplate,
                    ],
                    imports: [
                        CommonModule,
                        RouterModule,
                    ],
                    exports: [
                        UsaHeaderComponent,
                        UsaHeaderPrimaryLinks,
                        UsaHeaderSecondaryLinks,
                        UsaHeaderSubmenuButton,
                        UsaHeaderPrimaryExtra,
                        UsaHeaderSecondaryExtra,
                        UsaHeaderPrimaryLinkTemplate,
                        UsaHeaderSecondaryLinkTemplate,
                    ]
                }]
        }] });

class UsaTimePicker {
    hostComboBox;
    MAX_TIME = 60 * 24 - 1;
    MIN_TIME = 0;
    LABEL_FIELD = 'label';
    VALUE_FIELD = 'value';
    /**
     * Defines minimum selectable time within a 24 hour window.
     * This can be a date object or a string in hh:mm in 24-hour format.
     * The default min time is 00:00
     */
    minTime = '00:00';
    /**
     * Defines the maximum selectable time within a 24 hour window.
     * This can be a date object or a string in hh:mm in 24-hour format.
     * The default max time is 23:59
     */
    maxTime = '23:59';
    /**
     * The number of minutes between options. The minimum value is 1.
     * The default value is 30
     */
    timeStep = 30;
    /**
     * Filter function for when user types in input. This function
     * takes two parameters, current user input, and list of time
     * to parse input over. It should return a number which represents
     * the index within the values to select based on user input.
     * Index of -1 indicates no selection. A default filter function
     * is provided by the component, but a custom one can be passed in
     * if desired.
     */
    filterBy;
    _inputChangeSubscription;
    constructor(hostComboBox) {
        this.hostComboBox = hostComboBox;
        this._inputChangeSubscription = new Subscription();
    }
    ngOnChanges() {
        if (!this.hostComboBox)
            return;
        this.initializeDropdownItems();
    }
    ngOnInit() {
        const wrapperDiv = this.hostComboBox.el.nativeElement.querySelector('.usa-combo-box');
        wrapperDiv.classList.add('usa-time-picker');
        this.initializeDropdownItems();
        const subscription = this.hostComboBox.changeEvent.subscribe(((value) => {
            if (!this.hostComboBox.comboBoxDropdown)
                return;
            const mappedItems = this.hostComboBox.items.map(item => item[this.LABEL_FIELD]);
            let index = -1;
            if (this.filterBy) {
                index = this.filterBy(value, mappedItems);
            }
            else {
                index = this.defaultFilter(value, mappedItems);
            }
            this.hostComboBox.comboBoxDropdown.highlightItem(index);
        }).bind(this));
        this._inputChangeSubscription.add(subscription);
    }
    ngOnDestroy() {
        this._inputChangeSubscription.unsubscribe();
    }
    /**
     * Initializes dropdown values for timepixker as well as filter function
     * to use
     */
    initializeDropdownItems() {
        this.hostComboBox.items = this.genetateItems();
        this.hostComboBox.labelField = this.LABEL_FIELD;
        this.hostComboBox.valueField = this.VALUE_FIELD;
    }
    /**
     * Generates list of times to display to the user.
     * This list is created based on user's min/max inputs
     * as well as time step
     * @returns - list of {label, value} pair of time to display in dropdown
     */
    genetateItems() {
        const items = [];
        const minTime = Math.max(this.MIN_TIME, this.parseTimeString(this.minTime) || this.MIN_TIME);
        const maxTime = Math.min(this.MAX_TIME, this.parseTimeString(this.maxTime) || this.MAX_TIME);
        for (let time = minTime; time <= maxTime; time += this.timeStep) {
            const { minute, hour24, hour12, ampm } = this.getTimeContext(time);
            const option = {};
            option[this.VALUE_FIELD] = `${this.padZeros(hour24, 2)}:${this.padZeros(minute, 2)}`;
            option[this.LABEL_FIELD] = `${hour12}:${this.padZeros(minute, 2)}${ampm}`;
            items.push(option);
        }
        return items;
    }
    /**
     * Adds additional zeros if needed
     * @param value
     * @param length
     * @returns
     */
    padZeros(value, length) {
        return `0000${value}`.slice(-length);
    }
    /**
     * Given minuutes, parses number of hours and minutes to represent that time.
     * IE - 0 minutes would be 0:00 AM, 60 minutes would be 1:00 AM, etc
     * @param minutes
     */
    getTimeContext(minutes) {
        const minute = minutes % 60;
        const hour24 = Math.floor(minutes / 60);
        const hour12 = hour24 % 12 || 12;
        const ampm = hour24 < 12 ? "am" : "pm";
        return {
            minute,
            hour24,
            hour12,
            ampm,
        };
    }
    ;
    /**
     * Parse a string of hh:mm into minutes
     *
     * @param {string} timeStr the time string to parse
     * @returns {number} the number of minutes
     */
    parseTimeString(timeStr) {
        let minutes;
        if (timeStr) {
            const [hours, mins] = timeStr.split(":").map((str) => {
                let value;
                const parsed = parseInt(str, 10);
                if (!Number.isNaN(parsed))
                    value = parsed;
                return value;
            });
            if (hours != null && mins != null) {
                minutes = hours * 60 + mins;
            }
        }
        return minutes;
    }
    ;
    /**
     * Default filter search if one is not provided. Used to find
     * time within dropdown values that best matches user input
     * @param input - user input
     * @param values - list of values to search
     * @returns - index in values list if match is found, -1 otherwise
     */
    defaultFilter(input, values) {
        if (!input || !input.length)
            return -1;
        return values.findIndex(value => value.includes(input));
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaTimePicker, deps: [{ token: UsaComboBoxComponent }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.2", type: UsaTimePicker, selector: "[usa-time-picker]", inputs: { minTime: "minTime", maxTime: "maxTime", timeStep: "timeStep", filterBy: "filterBy" }, exportAs: ["usaTimePicker"], usesOnChanges: true, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaTimePicker, decorators: [{
            type: Directive,
            args: [{
                    selector: '[usa-time-picker]',
                    exportAs: 'usaTimePicker'
                }]
        }], ctorParameters: () => [{ type: UsaComboBoxComponent }], propDecorators: { minTime: [{
                type: Input
            }], maxTime: [{
                type: Input
            }], timeStep: [{
                type: Input
            }], filterBy: [{
                type: Input
            }] } });

class UsaTimePickerModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaTimePickerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.2", ngImport: i0, type: UsaTimePickerModule, declarations: [UsaTimePicker], imports: [CommonModule, UsaComboboxModule], exports: [UsaTimePicker, UsaComboboxModule] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaTimePickerModule, imports: [CommonModule, UsaComboboxModule, UsaComboboxModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaTimePickerModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, UsaComboboxModule],
                    declarations: [UsaTimePicker],
                    exports: [UsaTimePicker, UsaComboboxModule]
                }]
        }] });

class UsaInputAffixDirective {
    el;
    renderer;
    viewContainer;
    prefix;
    suffix;
    constructor(el, renderer, viewContainer) {
        this.el = el;
        this.renderer = renderer;
        this.viewContainer = viewContainer;
    }
    ngAfterViewInit() {
        const parent = this.renderer.parentNode(this.el.nativeElement);
        //Need next sibling to ensure generated usa-input-group is inserted into the same place on the page and input is expected to be
        const nextSibling = this.renderer.nextSibling(this.el.nativeElement);
        let prefixElement, suffixElement;
        if (this.prefix) {
            prefixElement = this.handleAffix(this.prefix, 'usa-input-prefix');
        }
        if (this.suffix) {
            suffixElement = this.handleAffix(this.suffix, 'usa-input-suffix');
        }
        // Return early if neither prefix nor suffix provided
        if (!this.prefix && !this.suffix) {
            return;
        }
        const inputGroupDiv = document.createElement('div');
        this.renderer.addClass(inputGroupDiv, 'usa-input-group');
        // Apply input class in case only directive was applied
        this.renderer.addClass(this.el.nativeElement, 'usa-input');
        if (this.prefix) {
            this.renderer.appendChild(inputGroupDiv, prefixElement);
        }
        this.renderer.appendChild(inputGroupDiv, this.el.nativeElement);
        if (this.suffix) {
            this.renderer.appendChild(inputGroupDiv, suffixElement);
        }
        this.renderer.insertBefore(parent, inputGroupDiv, nextSibling);
    }
    /**
     *
     * @param affix Template or string to be displayed as prefix or suffix.
     * @param affixClass USWDS class to apply to element
     */
    handleAffix(affix, affixClass) {
        let affixView, affixElement;
        if (affix instanceof TemplateRef) {
            affixView = this.viewContainer.createEmbeddedView(affix);
            affixElement = affixView.rootNodes[0];
        }
        // If text passed into template, need to wrap in element for USWDS CSS to kick in.
        if (affixView?.rootNodes[0].nodeName === '#text') {
            const div = document.createElement('div');
            this.renderer.appendChild(div, affixElement);
            affixElement = div;
            // If string passed in, insert into element for CSS to apply to
        }
        else if (typeof affix === 'string') {
            const div = document.createElement('div');
            div.innerText = affix;
            affixElement = div;
        }
        this.renderer.addClass(affixElement, affixClass);
        return affixElement;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaInputAffixDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.2", type: UsaInputAffixDirective, selector: "input[prefix], input[suffix]", inputs: { prefix: "prefix", suffix: "suffix" }, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaInputAffixDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'input[prefix], input[suffix]'
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: i0.ViewContainerRef }], propDecorators: { prefix: [{
                type: Input
            }], suffix: [{
                type: Input
            }] } });

class UsaAffixModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaAffixModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.2", ngImport: i0, type: UsaAffixModule, declarations: [UsaInputAffixDirective], imports: [CommonModule], exports: [UsaInputAffixDirective] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaAffixModule, imports: [CommonModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: UsaAffixModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        UsaInputAffixDirective
                    ],
                    imports: [
                        CommonModule,
                    ],
                    exports: [
                        UsaInputAffixDirective
                    ]
                }]
        }] });

/*
 * Public API Surface of usa-components
 */
// Accordion

/**
 * Generated bundle index. Do not edit.
 */

export { DateAdapter, FileInputConfig, FormFieldComponent, HighlightOnHoverDirective, ModalDismissReasons, NativeDateAdapter, USA_DATEPICKER_VALIDATORS, USA_DATEPICKER_VALUE_ACCESSOR, USA_DATE_FORMATS, USA_DATE_LOCALE, USA_DATE_LOCALE_FACTORY, USA_NATIVE_DATE_FORMATS, USWDSButtonGroupComponent, USWDSButtonGroupItemComponent, USWDSButtonGroupModule, USWDSCardBodyComponent, USWDSCardComponent, USWDSCardFooterComponent, USWDSCardGroupComponent, USWDSCardHeaderComponent, USWDSCardMediaComponent, USWDSCardModule, USWDSFormFieldModule, UsaAccordionComponent, UsaAccordionContent, UsaAccordionHeader, UsaAccordionItem, UsaAccordionModule, UsaAccordionToggle, UsaActiveModal, UsaAffixModule, UsaBreadcrumbComponent, UsaBreadcrumbLinkTemplate, UsaBreadcrumbModule, UsaCalendar, UsaCalendarBody, UsaCalendarCell, UsaCalendarHeader, UsaCharacterCountDirective, UsaCharacterCountModule, UsaCheckboxComponent, UsaCheckboxLabelDescription, UsaCheckboxModule, UsaColumnDef, UsaComboBoxComponent, UsaComboBoxItemTemplate, UsaComboBoxListModule, UsaComboboxList, UsaComboboxModule, UsaDataRowDef, UsaDatePicker, UsaDatePickerBase, UsaDatePickerButton, UsaDatePickerButtonIcon, UsaDatePickerContent, UsaDatePickerInput, UsaDatePickerModule, UsaDatePickerWrapper, UsaDropdownComponent, UsaDropdownModule, UsaFileInputComponent, UsaFileInputModule, UsaFilePreviewDirective, UsaHeaderComponent, UsaHeaderModule, UsaHeaderPrimaryExtra, UsaHeaderPrimaryLinkTemplate, UsaHeaderPrimaryLinks, UsaHeaderRowDef, UsaHeaderSecondaryExtra, UsaHeaderSecondaryLinkTemplate, UsaHeaderSecondaryLinks, UsaHeaderSubmenuButton, UsaInputAffixDirective, UsaModalConfig, UsaModalModule, UsaModalRef, UsaModalService, UsaModalWindow, UsaModalWrapper, UsaNavigationMode, UsaRadioComponent, UsaRadioGroupComponent, UsaRadioGroupLabel, UsaRadioLabelDescription, UsaRadioModule, UsaSearchComponent, UsaSearchModule, UsaSidenavComponent, UsaSidenavModule, UsaSort, UsaStepIndicatorComponent, UsaStepIndicatorConfig, UsaStepIndicatorHeaderComponent, UsaStepIndicatorModule, UsaTableComponent, UsaTableData, UsaTableDataDef, UsaTableHeader, UsaTableHeaderDef, UsaTableModule, UsaTextareaComponent, UsaTextareaModule, UsaTimePicker, UsaTimePickerModule, UsaTooltipDirective, UsaTooltipModule };
